// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%237fdd85%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2301041b%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ef9fc4%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ef9fc4%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,900;1,200;1,300;1,400;1,500;1,600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
*
* Template: Prox - Responsive Bootstrap 4 Admin Dashboard Template
* Author: iqonic.design
* Design and Developed by: iqonic.design
* NOTE: This file contains the styling for responsive Template.
*
*/
:root {
  --iq-primary: #c6c8f7;
  --iq-secondary: #ccced2;
  --iq-success: #b7e1ba;
  --iq-info: #ffe6de;
  --iq-warning: #ffebdf;
  --iq-danger: #ffdaeb;
  --iq-light: #FAFAFA;
  --iq-dark: rgba(199, 203, 211, 0.1);
  --iq-orange: #ffdcd8;
  --iq-purple: #cbc0ff;
  --iq-pink: #fff1f1;
  --iq-primary: rgba(71, 136, 255, 0.1);
  --iq-secondary: rgba(108, 117, 125, 0.1);
  --iq-success: rgba(55, 230, 178, 0.1);
  --iq-info: rgba(135, 108, 254, 0.1);
  --iq-warning: rgba(254, 114, 28, 0.1);
  --iq-danger: rgba(255, 75, 75, 0.1);
  --iq-light: rgba(199, 203, 211, 0.1);
  --iq-dark: rgba(1, 4, 27, 0.1);
  --iq-orange: rgba(253, 126, 20, 0.1);
  --iq-purple: rgba(71, 49, 182, 0.1);
  --blue: #8f93f6;
  --indigo: #6610f2;
  --red: #ef9fc4;
  --yellow: #fad263;
  --green: #7fdd85;
  --teal: #20c997;
  --cyan: #fcbba5;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #01041b;
  --primary: #8f93f6;
  --secondary: #6c757d;
  --success: #7fdd85;
  --info: #fcbba5;
  --warning: #fad263;
  --danger: #ef9fc4;
  --light: #FAFAFA;
  --dark: #01041b;
  --orange: #fd7e14;
  --purple: #4731b6;
  --pink: #FFE0E0;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

*,
*::before,
*::after {
  box-sizing: border-box; }

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block; }

body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #535f6b;
  text-align: left;
  background-color: #fafbfe; }

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important; }

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible; }

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small {
  font-size: 80%; }

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: #8f93f6;
  text-decoration: none;
  background-color: transparent; }
  a:hover {
    color: #484ff0;
    text-decoration: none; }

a:not([href]) {
  color: inherit;
  text-decoration: none; }
  a:not([href]):hover {
    color: inherit;
    text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em; }

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar; }

figure {
  margin: 0 0 1rem; }

img {
  vertical-align: middle;
  border-style: none; }

svg {
  overflow: hidden;
  vertical-align: middle; }

table {
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom; }

th {
  text-align: inherit; }

label {
  display: inline-block;
  margin-bottom: 0.5rem; }

button {
  border-radius: 0; }

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
input {
  overflow: visible; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer; }

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none; }

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0; }

textarea {
  overflow: auto;
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal; }
  @media (max-width: 1200px) {
    legend {
      font-size: calc(1.275rem + 0.3vw) ; } }

progress {
  vertical-align: baseline; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none; }

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

summary {
  display: list-item;
  cursor: pointer; }

template {
  display: none; }

[hidden] {
  display: none !important; }

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2; }

h1, .h1 {
  font-size: 2.488rem; }
  @media (max-width: 1200px) {
    h1, .h1 {
      font-size: calc(1.3738rem + 1.4856vw) ; } }

h2, .h2 {
  font-size: 2.074rem; }
  @media (max-width: 1200px) {
    h2, .h2 {
      font-size: calc(1.3324rem + 0.9888vw) ; } }

h3, .h3 {
  font-size: 1.728rem; }
  @media (max-width: 1200px) {
    h3, .h3 {
      font-size: calc(1.2978rem + 0.5736vw) ; } }

h4, .h4 {
  font-size: 1.44rem; }
  @media (max-width: 1200px) {
    h4, .h4 {
      font-size: calc(1.269rem + 0.228vw) ; } }

h5, .h5 {
  font-size: 1.2rem; }

h6, .h6 {
  font-size: 1rem; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2; }
  @media (max-width: 1200px) {
    .display-1 {
      font-size: calc(1.725rem + 5.7vw) ; } }

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2; }
  @media (max-width: 1200px) {
    .display-2 {
      font-size: calc(1.675rem + 5.1vw) ; } }

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2; }
  @media (max-width: 1200px) {
    .display-3 {
      font-size: calc(1.575rem + 3.9vw) ; } }

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2; }
  @media (max-width: 1200px) {
    .display-4 {
      font-size: calc(1.475rem + 2.7vw) ; } }

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1); }

small,
.small {
  font-size: 80%;
  font-weight: 400; }

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3; }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 90%;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fafbfe;
  border: 1px solid #ccced2;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 90%;
  color: #6c757d; }

code {
  font-size: 87.5%;
  color: #FFE0E0;
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 8px;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25); }
  kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700;
    box-shadow: none; }

pre {
  display: block;
  font-size: 87.5%;
  color: #212529; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll; }

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }
  @media (min-width: 576px) {
    .container {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .container {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .container {
      max-width: 960px; } }
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px; } }

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px; }

.no-gutters {
  margin-right: 0;
  margin-left: 0; }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0; }

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px; }

.col {
  flex-basis: 0;
  flex-grow: 1;
  min-width: 0;
  max-width: 100%; }

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%; }

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%; }

.row-cols-3 > * {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%; }

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%; }

.row-cols-6 > * {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%; }

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%; }

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%; }

.col-3 {
  flex: 0 0 25%;
  max-width: 25%; }

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%; }

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%; }

.col-6 {
  flex: 0 0 50%;
  max-width: 50%; }

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%; }

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%; }

.col-9 {
  flex: 0 0 75%;
  max-width: 75%; }

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%; }

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%; }

.col-12 {
  flex: 0 0 100%;
  max-width: 100%; }

.order-first {
  order: -1; }

.order-last {
  order: 13; }

.order-0 {
  order: 0; }

.order-1 {
  order: 1; }

.order-2 {
  order: 2; }

.order-3 {
  order: 3; }

.order-4 {
  order: 4; }

.order-5 {
  order: 5; }

.order-6 {
  order: 6; }

.order-7 {
  order: 7; }

.order-8 {
  order: 8; }

.order-9 {
  order: 9; }

.order-10 {
  order: 10; }

.order-11 {
  order: 11; }

.order-12 {
  order: 12; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-sm-first {
    order: -1; }
  .order-sm-last {
    order: 13; }
  .order-sm-0 {
    order: 0; }
  .order-sm-1 {
    order: 1; }
  .order-sm-2 {
    order: 2; }
  .order-sm-3 {
    order: 3; }
  .order-sm-4 {
    order: 4; }
  .order-sm-5 {
    order: 5; }
  .order-sm-6 {
    order: 6; }
  .order-sm-7 {
    order: 7; }
  .order-sm-8 {
    order: 8; }
  .order-sm-9 {
    order: 9; }
  .order-sm-10 {
    order: 10; }
  .order-sm-11 {
    order: 11; }
  .order-sm-12 {
    order: 12; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; } }

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-md-first {
    order: -1; }
  .order-md-last {
    order: 13; }
  .order-md-0 {
    order: 0; }
  .order-md-1 {
    order: 1; }
  .order-md-2 {
    order: 2; }
  .order-md-3 {
    order: 3; }
  .order-md-4 {
    order: 4; }
  .order-md-5 {
    order: 5; }
  .order-md-6 {
    order: 6; }
  .order-md-7 {
    order: 7; }
  .order-md-8 {
    order: 8; }
  .order-md-9 {
    order: 9; }
  .order-md-10 {
    order: 10; }
  .order-md-11 {
    order: 11; }
  .order-md-12 {
    order: 12; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; } }

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-lg-first {
    order: -1; }
  .order-lg-last {
    order: 13; }
  .order-lg-0 {
    order: 0; }
  .order-lg-1 {
    order: 1; }
  .order-lg-2 {
    order: 2; }
  .order-lg-3 {
    order: 3; }
  .order-lg-4 {
    order: 4; }
  .order-lg-5 {
    order: 5; }
  .order-lg-6 {
    order: 6; }
  .order-lg-7 {
    order: 7; }
  .order-lg-8 {
    order: 8; }
  .order-lg-9 {
    order: 9; }
  .order-lg-10 {
    order: 10; }
  .order-lg-11 {
    order: 11; }
  .order-lg-12 {
    order: 12; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; } }

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    min-width: 0;
    max-width: 100%; }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%; }
  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%; }
  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%; }
  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%; }
  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%; }
  .order-xl-first {
    order: -1; }
  .order-xl-last {
    order: 13; }
  .order-xl-0 {
    order: 0; }
  .order-xl-1 {
    order: 1; }
  .order-xl-2 {
    order: 2; }
  .order-xl-3 {
    order: 3; }
  .order-xl-4 {
    order: 4; }
  .order-xl-5 {
    order: 5; }
  .order-xl-6 {
    order: 6; }
  .order-xl-7 {
    order: 7; }
  .order-xl-8 {
    order: 8; }
  .order-xl-9 {
    order: 9; }
  .order-xl-10 {
    order: 10; }
  .order-xl-11 {
    order: 11; }
  .order-xl-12 {
    order: 12; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; } }

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #535f6b; }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #f1f1f1; }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #f1f1f1; }
  .table tbody + tbody {
    border-top: 2px solid #f1f1f1; }

.table-sm th,
.table-sm td {
  padding: 0.3rem; }

.table-bordered {
  border: 1px solid #f1f1f1; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #f1f1f1; }
  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px; }

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05); }

.table-hover tbody tr:hover {
  color: #535f6b;
  background-color: rgba(0, 0, 0, 0.075); }

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #e0e1fc; }

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #c5c7fa; }

.table-hover .table-primary:hover {
  background-color: #c9cbfa; }
  .table-hover .table-primary:hover > td,
  .table-hover .table-primary:hover > th {
    background-color: #c9cbfa; }

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db; }

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb; }

.table-hover .table-secondary:hover {
  background-color: #c8cbcf; }
  .table-hover .table-secondary:hover > td,
  .table-hover .table-secondary:hover > th {
    background-color: #c8cbcf; }

.table-success,
.table-success > th,
.table-success > td {
  background-color: #dbf5dd; }

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #bcedc0; }

.table-hover .table-success:hover {
  background-color: #c7efca; }
  .table-hover .table-success:hover > td,
  .table-hover .table-success:hover > th {
    background-color: #c7efca; }

.table-info,
.table-info > th,
.table-info > td {
  background-color: #feece6; }

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #fddcd0; }

.table-hover .table-info:hover {
  background-color: #fdd9cd; }
  .table-hover .table-info:hover > td,
  .table-hover .table-info:hover > th {
    background-color: #fdd9cd; }

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fef2d3; }

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fce8ae; }

.table-hover .table-warning:hover {
  background-color: #fdebba; }
  .table-hover .table-warning:hover > td,
  .table-hover .table-warning:hover > th {
    background-color: #fdebba; }

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #fbe4ee; }

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #f7cde0; }

.table-hover .table-danger:hover {
  background-color: #f8cee0; }
  .table-hover .table-danger:hover > td,
  .table-hover .table-danger:hover > th {
    background-color: #f8cee0; }

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fefefe; }

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fcfcfc; }

.table-hover .table-light:hover {
  background-color: #f1f1f1; }
  .table-hover .table-light:hover > td,
  .table-hover .table-light:hover > th {
    background-color: #f1f1f1; }

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #b8b9bf; }

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #7b7c88; }

.table-hover .table-dark:hover {
  background-color: #abacb3; }
  .table-hover .table-dark:hover > td,
  .table-hover .table-dark:hover > th {
    background-color: #abacb3; }

.table-orange,
.table-orange > th,
.table-orange > td {
  background-color: #fedbbd; }

.table-orange th,
.table-orange td,
.table-orange thead th,
.table-orange tbody + tbody {
  border-color: #febc85; }

.table-hover .table-orange:hover {
  background-color: #fecda4; }
  .table-hover .table-orange:hover > td,
  .table-hover .table-orange:hover > th {
    background-color: #fecda4; }

.table-purple,
.table-purple > th,
.table-purple > td {
  background-color: #cbc5eb; }

.table-purple th,
.table-purple td,
.table-purple thead th,
.table-purple tbody + tbody {
  border-color: #9f94d9; }

.table-hover .table-purple:hover {
  background-color: #bab2e4; }
  .table-hover .table-purple:hover > td,
  .table-hover .table-purple:hover > th {
    background-color: #bab2e4; }

.table-pink,
.table-pink > th,
.table-pink > td {
  background-color: #fff6f6; }

.table-pink th,
.table-pink td,
.table-pink thead th,
.table-pink tbody + tbody {
  border-color: #ffefef; }

.table-hover .table-pink:hover {
  background-color: #ffdddd; }
  .table-hover .table-pink:hover > td,
  .table-hover .table-pink:hover > th {
    background-color: #ffdddd; }

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075); }

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075); }
  .table-hover .table-active:hover > td,
  .table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075); }

.table .thead-dark th {
  color: #fff;
  background-color: #01041b;
  border-color: #020940; }

.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #f1f1f1; }

.table-dark {
  color: #fff;
  background-color: #01041b; }
  .table-dark th,
  .table-dark td,
  .table-dark thead th {
    border-color: #020940; }
  .table-dark.table-bordered {
    border: 0; }
  .table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05); }
  .table-dark.table-hover tbody tr:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.075); }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-sm > .table-bordered {
      border: 0; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-md > .table-bordered {
      border: 0; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-lg > .table-bordered {
      border: 0; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; }
    .table-responsive-xl > .table-bordered {
      border: 0; } }

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }
  .table-responsive > .table-bordered {
    border: 0; }

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 8px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control::-ms-expand {
    background-color: transparent;
    border: 0; }
  .form-control:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #495057; }
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: white;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
  .form-control::placeholder {
    color: #6c757d;
    opacity: 1; }
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1; }

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  appearance: none; }

select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff; }

.form-control-file,
.form-control-range {
  display: block;
  width: 100%; }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5; }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #535f6b;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

select.form-control[size], select.form-control[multiple] {
  height: auto; }

textarea.form-control {
  height: auto; }

.form-group {
  margin-bottom: 1rem; }

.form-text {
  display: block;
  margin-top: 0.25rem; }

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px; }
  .form-row > .col,
  .form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px; }

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem; }

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem; }
  .form-check-input[disabled] ~ .form-check-label,
  .form-check-input:disabled ~ .form-check-label {
    color: #6c757d; }

.form-check-label {
  margin-bottom: 0; }

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem; }
  .form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #7fdd85; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(127, 221, 133, 0.9);
  border-radius: 8px; }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #7fdd85;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #7fdd85;
    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #7fdd85;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
    border-color: #7fdd85;
    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #7fdd85; }

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #7fdd85; }
  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    border-color: #7fdd85; }

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #a7e8ab;
  background-color: #a7e8ab; }

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }

.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #7fdd85; }

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #7fdd85; }

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #7fdd85;
  box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ef9fc4; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(239, 159, 196, 0.9);
  border-radius: 8px; }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ef9fc4;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #ef9fc4;
    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #ef9fc4;
  padding-right: calc(0.75em + 2.3125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
    border-color: #ef9fc4;
    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ef9fc4; }

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ef9fc4; }
  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #ef9fc4; }

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #f6cbdf;
  background-color: #f6cbdf; }

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }

.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #ef9fc4; }

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ef9fc4; }

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #ef9fc4;
  box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center; }
  .form-inline .form-check {
    width: 100%; }
  @media (min-width: 576px) {
    .form-inline label {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0; }
    .form-inline .form-group {
      display: flex;
      flex: 0 0 auto;
      flex-flow: row wrap;
      align-items: center;
      margin-bottom: 0; }
    .form-inline .form-control {
      display: inline-block;
      width: auto;
      vertical-align: middle; }
    .form-inline .form-control-plaintext {
      display: inline-block; }
    .form-inline .input-group,
    .form-inline .custom-select {
      width: auto; }
    .form-inline .form-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: auto;
      padding-left: 0; }
    .form-inline .form-check-input {
      position: relative;
      flex-shrink: 0;
      margin-top: 0;
      margin-right: 0.25rem;
      margin-left: 0; }
    .form-inline .custom-control {
      align-items: center;
      justify-content: center; }
    .form-inline .custom-control-label {
      margin-bottom: 0; } }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }
  .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent; }
  .dropdown-toggle:empty::after {
    margin-left: 0; }

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #535f6b;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175); }

.dropdown-menu-left {
  right: auto;
  left: 0; }

.dropdown-menu-right {
  right: 0;
  left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0; }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0; }
  .dropdown-menu-md-right {
    right: 0;
    left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0; }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0; }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto; } }

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem; }

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }

.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem; }

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }

.dropright .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropright .dropdown-toggle::after {
  vertical-align: 0; }

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem; }

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  display: none; }

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropleft .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-menu[x-placement^="top"], .dropdown-menu[x-placement^="right"], .dropdown-menu[x-placement^="bottom"], .dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto; }

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa; }
  .dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #8f93f6; }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
    .btn-group > .btn:hover,
    .btn-group-vertical > .btn:hover {
      z-index: 1; }
    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
    .btn-group-vertical > .btn:focus,
    .btn-group-vertical > .btn:active,
    .btn-group-vertical > .btn.active {
      z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px; }

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropright .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropleft .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
  .btn-group.show .dropdown-toggle.btn-link {
    box-shadow: none; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: -1px; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0; }
  .btn-group-toggle > .btn input[type="radio"],
  .btn-group-toggle > .btn input[type="checkbox"],
  .btn-group-toggle > .btn-group > .btn input[type="radio"],
  .btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-control-plaintext,
  .input-group > .custom-select,
  .input-group > .custom-file {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0; }
    .input-group > .form-control + .form-control,
    .input-group > .form-control + .custom-select,
    .input-group > .form-control + .custom-file,
    .input-group > .form-control-plaintext + .form-control,
    .input-group > .form-control-plaintext + .custom-select,
    .input-group > .form-control-plaintext + .custom-file,
    .input-group > .custom-select + .form-control,
    .input-group > .custom-select + .custom-select,
    .input-group > .custom-select + .custom-file,
    .input-group > .custom-file + .form-control,
    .input-group > .custom-file + .custom-select,
    .input-group > .custom-file + .custom-file {
      margin-left: -1px; }
  .input-group > .form-control:focus,
  .input-group > .custom-select:focus,
  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
    z-index: 3; }
  .input-group > .custom-file .custom-file-input:focus {
    z-index: 4; }
  .input-group > .form-control:not(:last-child),
  .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .input-group > .form-control:not(:first-child),
  .input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }
  .input-group > .custom-file {
    display: flex;
    align-items: center; }
    .input-group > .custom-file:not(:last-child) .custom-file-label,
    .input-group > .custom-file:not(:last-child) .custom-file-label::after {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .input-group > .custom-file:not(:first-child) .custom-file-label {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }

.input-group-prepend,
.input-group-append {
  display: flex; }
  .input-group-prepend .btn,
  .input-group-append .btn {
    position: relative;
    z-index: 2; }
    .input-group-prepend .btn:focus,
    .input-group-append .btn:focus {
      z-index: 3; }
  .input-group-prepend .btn + .btn,
  .input-group-prepend .btn + .input-group-text,
  .input-group-prepend .input-group-text + .input-group-text,
  .input-group-prepend .input-group-text + .btn,
  .input-group-append .btn + .btn,
  .input-group-append .btn + .input-group-text,
  .input-group-append .input-group-text + .input-group-text,
  .input-group-append .input-group-text + .btn {
    margin-left: -1px; }

.input-group-prepend {
  margin-right: -1px; }

.input-group-append {
  margin-left: -1px; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 8px; }
  .input-group-text input[type="radio"],
  .input-group-text input[type="checkbox"] {
    margin-top: 0; }

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px); }

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px); }

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem; }

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem; }

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0; }
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #8f93f6;
    background-color: #8f93f6;
    box-shadow: none; }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: white; }
  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    color: #fff;
    background-color: white;
    border-color: white;
    box-shadow: none; }
  .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d; }
    .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #e9ecef; }

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top; }
  .custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #adb5bd solid 1px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: -1.5rem;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background: no-repeat 50% / 50% 50%; }

.custom-checkbox .custom-control-label::before {
  border-radius: 8px; }

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #8f93f6;
  background-color: #8f93f6;
  box-shadow: none; }

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(143, 147, 246, 0.5); }

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(143, 147, 246, 0.5); }

.custom-radio .custom-control-label::before {
  border-radius: 50%; }

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(143, 147, 246, 0.5); }

.custom-switch {
  padding-left: 2.25rem; }
  .custom-switch .custom-control-label::before {
    left: -2.25rem;
    width: 1.75rem;
    pointer-events: all;
    border-radius: 0.5rem; }
  .custom-switch .custom-control-label::after {
    top: calc(0.25rem + 2px);
    left: calc(-2.25rem + 2px);
    width: calc(1rem - 4px);
    height: calc(1rem - 4px);
    background-color: #adb5bd;
    border-radius: 0.5rem;
    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .custom-switch .custom-control-label::after {
        transition: none; } }
  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #fff;
    transform: translateX(0.75rem); }
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: rgba(143, 147, 246, 0.5); }

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  appearance: none; }
  .custom-select:focus {
    border-color: white;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
    .custom-select:focus::-ms-value {
      color: #495057;
      background-color: #fff; }
  .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: 0.75rem;
    background-image: none; }
  .custom-select:disabled {
    color: #6c757d;
    background-color: #e9ecef; }
  .custom-select::-ms-expand {
    display: none; }
  .custom-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #495057; }

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem; }

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.75rem; }

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0; }

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0; }
  .custom-file-input:focus ~ .custom-file-label {
    border-color: white;
    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
  .custom-file-input[disabled] ~ .custom-file-label,
  .custom-file-input:disabled ~ .custom-file-label {
    background-color: #e9ecef; }
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse"; }
  .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: attr(data-browse); }

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }
  .custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(1.5em + 0.75rem);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: inherit;
    border-radius: 0 8px 8px 0; }

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none; }
  .custom-range:focus {
    outline: none; }
    .custom-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
    .custom-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
    .custom-range:focus::-ms-thumb {
      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }
  .custom-range::-moz-focus-outer {
    border: 0; }
  .custom-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #8f93f6;
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .custom-range::-webkit-slider-thumb:active {
      background-color: white; }
  .custom-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #ccced2;
    border-color: transparent;
    border-radius: 1rem;
    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }
  .custom-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #8f93f6;
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .custom-range::-moz-range-thumb:active {
      background-color: white; }
  .custom-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #ccced2;
    border-color: transparent;
    border-radius: 1rem;
    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }
  .custom-range::-ms-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: 0;
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    background-color: #8f93f6;
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
    -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .custom-range::-ms-thumb {
        -ms-transition: none;
        transition: none; } }
    .custom-range::-ms-thumb:active {
      background-color: white; }
  .custom-range::-ms-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem;
    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }
  .custom-range::-ms-fill-lower {
    background-color: #ccced2;
    border-radius: 1rem; }
  .custom-range::-ms-fill-upper {
    margin-right: 15px;
    background-color: #ccced2;
    border-radius: 1rem; }
  .custom-range:disabled::-webkit-slider-thumb {
    background-color: #adb5bd; }
  .custom-range:disabled::-webkit-slider-runnable-track {
    cursor: default; }
  .custom-range:disabled::-moz-range-thumb {
    background-color: #adb5bd; }
  .custom-range:disabled::-moz-range-track {
    cursor: default; }
  .custom-range:disabled::-ms-thumb {
    background-color: #adb5bd; }

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .custom-control-label::before,
    .custom-file-label,
    .custom-select {
      transition: none; } }

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: 0.5rem 1rem; }
  .nav-link:hover, .nav-link:focus {
    text-decoration: none; }
  .nav-link.disabled {
    color: #6c757d;
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  border-bottom: 1px solid #ccced2; }
  .nav-tabs .nav-item {
    margin-bottom: -1px; }
  .nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px; }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      border-color: #e9ecef #e9ecef #ccced2; }
    .nav-tabs .nav-link.disabled {
      color: #6c757d;
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fafbfe;
    border-color: #ccced2 #ccced2 #fafbfe; }
  .nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills .nav-link {
  border-radius: 8px; }

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #8f93f6; }

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem; }
  .navbar .container,
  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  display: inline-block;
  padding-top: -7.75rem;
  padding-bottom: -7.75rem;
  margin-right: 1rem;
  font-size: 0.75rem;
  line-height: inherit;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none; }

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0; }
  .navbar-nav .dropdown-menu {
    position: static;
    float: none; }

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem; }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 8px; }
  .navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none; }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%; }

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; } }

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; } }

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; } }

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem; }
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
      flex-wrap: nowrap; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; } }

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
    padding-right: 0;
    padding-left: 0; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: 0.5rem;
      padding-left: 0.5rem; }
  .navbar-expand > .container,
  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
    flex-wrap: nowrap; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9); }
  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7); }
  .navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, 0.3); }

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9); }

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1); }

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5); }
  .navbar-light .navbar-text a {
    color: rgba(0, 0, 0, 0.9); }
    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
      color: rgba(0, 0, 0, 0.9); }

.navbar-dark .navbar-brand {
  color: #fff; }
  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
    color: #fff; }

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75); }
  .navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25); }

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff; }

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1); }

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5); }
  .navbar-dark .navbar-text a {
    color: #fff; }
    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
      color: #fff; }

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 8px; }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px; }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: 7px;
      border-bottom-left-radius: 7px; }

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem; }

.card-title {
  margin-bottom: 0.75rem; }

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link:hover {
  text-decoration: none; }

.card-link + .card-link {
  margin-left: 1.25rem; }

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }
  .card-header:first-child {
    border-radius: 7px 7px 0 0; }
  .card-header + .list-group .list-group-item:first-child {
    border-top: 0; }

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125); }
  .card-footer:last-child {
    border-radius: 0 0 7px 7px; }

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0; }

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem; }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem; }

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px; }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: 7px;
  border-bottom-left-radius: 7px; }

.card-deck .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px; }
    .card-deck .card {
      flex: 1 0;
      margin-right: 15px;
      margin-bottom: 0;
      margin-left: 15px; } }

.card-group > .card {
  margin-bottom: 15px; }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.card-columns .card {
  margin-bottom: 0.75rem; }

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1; }
    .card-columns .card {
      display: inline-block;
      width: 100%; } }

.accordion > .card {
  overflow: hidden; }
  .accordion > .card:not(:last-of-type) {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .accordion > .card:not(:first-of-type) {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }
  .accordion > .card > .card-header {
    border-radius: 0;
    margin-bottom: -1px; }

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 8px; }

.breadcrumb-item {
  display: flex; }
  .breadcrumb-item + .breadcrumb-item {
    padding-left: 0.5rem; }
    .breadcrumb-item + .breadcrumb-item::before {
      display: inline-block;
      padding-right: 0.5rem;
      color: #6c757d;
      content: "/"; }
  .breadcrumb-item + .breadcrumb-item:hover::before {
    text-decoration: underline;
    text-decoration: none; }
  .breadcrumb-item.active {
    color: #6c757d; }

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 8px; }

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #8f93f6;
  background-color: #fff;
  border: 1px solid #ccced2; }
  .page-link:hover {
    z-index: 2;
    color: #484ff0;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #ccced2; }
  .page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px; }

.page-item:last-child .page-link {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px; }

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #8f93f6;
  border-color: #8f93f6; }

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #ccced2; }

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 0.75rem;
  line-height: 1.5; }

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px; }

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px; }

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5; }

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px; }

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px; }

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 8px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .badge {
      transition: none; } }
  a.badge:hover, a.badge:focus {
    text-decoration: none; }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem; }

.badge-primary {
  color: #fff;
  background-color: #8f93f6; }
  a.badge-primary:hover, a.badge-primary:focus {
    color: #fff;
    background-color: #6065f2; }
  a.badge-primary:focus, a.badge-primary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }

.badge-secondary {
  color: #fff;
  background-color: #6c757d; }
  a.badge-secondary:hover, a.badge-secondary:focus {
    color: #fff;
    background-color: #545b62; }
  a.badge-secondary:focus, a.badge-secondary.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.badge-success {
  color: #fff;
  background-color: #7fdd85; }
  a.badge-success:hover, a.badge-success:focus {
    color: #fff;
    background-color: #57d25f; }
  a.badge-success:focus, a.badge-success.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }

.badge-info {
  color: #fff;
  background-color: #fcbba5; }
  a.badge-info:hover, a.badge-info:focus {
    color: #fff;
    background-color: #fa9674; }
  a.badge-info:focus, a.badge-info.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }

.badge-warning {
  color: #fff;
  background-color: #fad263; }
  a.badge-warning:hover, a.badge-warning:focus {
    color: #fff;
    background-color: #f8c432; }
  a.badge-warning:focus, a.badge-warning.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }

.badge-danger {
  color: #fff;
  background-color: #ef9fc4; }
  a.badge-danger:hover, a.badge-danger:focus {
    color: #fff;
    background-color: #e873a9; }
  a.badge-danger:focus, a.badge-danger.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }

.badge-light {
  color: #212529;
  background-color: #FAFAFA; }
  a.badge-light:hover, a.badge-light:focus {
    color: #212529;
    background-color: #e1e1e1; }
  a.badge-light:focus, a.badge-light.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }

.badge-dark {
  color: #fff;
  background-color: #01041b; }
  a.badge-dark:hover, a.badge-dark:focus {
    color: #fff;
    background-color: black; }
  a.badge-dark:focus, a.badge-dark.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }

.badge-orange {
  color: #fff;
  background-color: #fd7e14; }
  a.badge-orange:hover, a.badge-orange:focus {
    color: #fff;
    background-color: #dc6502; }
  a.badge-orange:focus, a.badge-orange.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }

.badge-purple {
  color: #fff;
  background-color: #4731b6; }
  a.badge-purple:hover, a.badge-purple:focus {
    color: #fff;
    background-color: #37268e; }
  a.badge-purple:focus, a.badge-purple.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }

.badge-pink {
  color: #212529;
  background-color: #FFE0E0; }
  a.badge-pink:hover, a.badge-pink:focus {
    color: #212529;
    background-color: #ffadad; }
  a.badge-pink:focus, a.badge-pink.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 8px; }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700; }

.alert-dismissible {
  padding-right: 4rem; }
  .alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    color: inherit; }

.alert-primary {
  color: #4a4c80;
  background-color: #e9e9fd;
  border-color: #e0e1fc; }
  .alert-primary hr {
    border-top-color: #c9cbfa; }
  .alert-primary .alert-link {
    color: #373960; }

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db; }
  .alert-secondary hr {
    border-top-color: #c8cbcf; }
  .alert-secondary .alert-link {
    color: #202326; }

.alert-success {
  color: #427345;
  background-color: #e5f8e7;
  border-color: #dbf5dd; }
  .alert-success hr {
    border-top-color: #c7efca; }
  .alert-success .alert-link {
    color: #2f5332; }

.alert-info {
  color: #836156;
  background-color: #fef1ed;
  border-color: #feece6; }
  .alert-info hr {
    border-top-color: #fdd9cd; }
  .alert-info .alert-link {
    color: #644a42; }

.alert-warning {
  color: #826d33;
  background-color: #fef6e0;
  border-color: #fef2d3; }
  .alert-warning hr {
    border-top-color: #fdebba; }
  .alert-warning .alert-link {
    color: #5d4e25; }

.alert-danger {
  color: #7c5366;
  background-color: #fcecf3;
  border-color: #fbe4ee; }
  .alert-danger hr {
    border-top-color: #f8cee0; }
  .alert-danger .alert-link {
    color: #5d3f4d; }

.alert-light {
  color: #828282;
  background-color: #fefefe;
  border-color: #fefefe; }
  .alert-light hr {
    border-top-color: #f1f1f1; }
  .alert-light .alert-link {
    color: dimgray; }

.alert-dark {
  color: #01020e;
  background-color: #cccdd1;
  border-color: #b8b9bf; }
  .alert-dark hr {
    border-top-color: #abacb3; }
  .alert-dark .alert-link {
    color: black; }

.alert-orange {
  color: #84420a;
  background-color: #ffe5d0;
  border-color: #fedbbd; }
  .alert-orange hr {
    border-top-color: #fecda4; }
  .alert-orange .alert-link {
    color: #552a06; }

.alert-purple {
  color: #25195f;
  background-color: #dad6f0;
  border-color: #cbc5eb; }
  .alert-purple hr {
    border-top-color: #bab2e4; }
  .alert-purple .alert-link {
    color: #150e37; }

.alert-pink {
  color: #857474;
  background-color: #fff9f9;
  border-color: #fff6f6; }
  .alert-pink hr {
    border-top-color: #ffdddd; }
  .alert-pink .alert-link {
    color: #6a5c5c; }

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0; }
  to {
    background-position: 0 0; } }

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 8px;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #8f93f6;
  transition: width 0.6s ease; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem; }

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.media {
  display: flex;
  align-items: flex-start; }

.media-body {
  flex: 1 1; }

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 8px; }

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa; }
  .list-group-item-action:active {
    color: #535f6b;
    background-color: #e9ecef; }

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: #6c757d;
    pointer-events: none;
    background-color: #fff; }
  .list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #8f93f6;
    border-color: #8f93f6; }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: -1px;
      border-top-width: 1px; }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child {
    border-bottom-left-radius: 8px;
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child {
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: -1px;
      border-left-width: 1px; }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child {
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child {
      border-top-right-radius: 8px;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child {
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child {
      border-top-right-radius: 8px;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child {
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child {
      border-top-right-radius: 8px;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child {
      border-bottom-left-radius: 8px;
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child {
      border-top-right-radius: 8px;
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: 1px;
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: -1px;
        border-left-width: 1px; } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 1px; }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  color: #4a4c80;
  background-color: #e0e1fc; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #4a4c80;
    background-color: #c9cbfa; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #4a4c80;
    border-color: #4a4c80; }

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #383d41;
    background-color: #c8cbcf; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #383d41;
    border-color: #383d41; }

.list-group-item-success {
  color: #427345;
  background-color: #dbf5dd; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #427345;
    background-color: #c7efca; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #427345;
    border-color: #427345; }

.list-group-item-info {
  color: #836156;
  background-color: #feece6; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #836156;
    background-color: #fdd9cd; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #836156;
    border-color: #836156; }

.list-group-item-warning {
  color: #826d33;
  background-color: #fef2d3; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #826d33;
    background-color: #fdebba; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #826d33;
    border-color: #826d33; }

.list-group-item-danger {
  color: #7c5366;
  background-color: #fbe4ee; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #7c5366;
    background-color: #f8cee0; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #7c5366;
    border-color: #7c5366; }

.list-group-item-light {
  color: #828282;
  background-color: #fefefe; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #828282;
    background-color: #f1f1f1; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #828282;
    border-color: #828282; }

.list-group-item-dark {
  color: #01020e;
  background-color: #b8b9bf; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #01020e;
    background-color: #abacb3; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #01020e;
    border-color: #01020e; }

.list-group-item-orange {
  color: #84420a;
  background-color: #fedbbd; }
  .list-group-item-orange.list-group-item-action:hover, .list-group-item-orange.list-group-item-action:focus {
    color: #84420a;
    background-color: #fecda4; }
  .list-group-item-orange.list-group-item-action.active {
    color: #fff;
    background-color: #84420a;
    border-color: #84420a; }

.list-group-item-purple {
  color: #25195f;
  background-color: #cbc5eb; }
  .list-group-item-purple.list-group-item-action:hover, .list-group-item-purple.list-group-item-action:focus {
    color: #25195f;
    background-color: #bab2e4; }
  .list-group-item-purple.list-group-item-action.active {
    color: #fff;
    background-color: #25195f;
    border-color: #25195f; }

.list-group-item-pink {
  color: #857474;
  background-color: #fff6f6; }
  .list-group-item-pink.list-group-item-action:hover, .list-group-item-pink.list-group-item-action:focus {
    color: #857474;
    background-color: #ffdddd; }
  .list-group-item-pink.list-group-item-action.active {
    color: #fff;
    background-color: #857474;
    border-color: #857474; }

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5; }
  @media (max-width: 1200px) {
    .close {
      font-size: calc(1.275rem + 0.3vw) ; } }
  .close:hover {
    color: #000;
    text-decoration: none; }
  .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
    opacity: .75; }

button.close {
  padding: 0;
  background-color: transparent;
  border: 0; }

a.close.disabled {
  pointer-events: none; }

.modal-open {
  overflow: hidden; }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto; }

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem); }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
    overflow: hidden; }
  .modal-dialog-scrollable .modal-header,
  .modal-dialog-scrollable .modal-footer {
    flex-shrink: 0; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem); }
  .modal-dialog-centered::before {
    display: block;
    height: calc(100vh - 1rem);
    height: min-content;
    content: ""; }
  .modal-dialog-centered.modal-dialog-scrollable {
    flex-direction: column;
    justify-content: center;
    height: 100%; }
    .modal-dialog-centered.modal-dialog-scrollable .modal-content {
      max-height: none; }
    .modal-dialog-centered.modal-dialog-scrollable::before {
      content: none; }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);
  outline: 0; }

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: 0.5; }

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #f1f1f1;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px; }
  .modal-header .close {
    padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto; }

.modal-title {
  margin-bottom: 0;
  line-height: 1.5; }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem; }

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #f1f1f1;
  border-bottom-right-radius: 7px;
  border-bottom-left-radius: 7px; }
  .modal-footer > * {
    margin: 0.25rem; }

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto; }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem); }
    .modal-dialog-scrollable .modal-content {
      max-height: calc(100vh - 3.5rem); }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem); }
    .modal-dialog-centered::before {
      height: calc(100vh - 3.5rem);
      height: min-content; }
  .modal-content {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5); }
  .modal-sm {
    max-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px; } }

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: 0.9; }
  .tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem; }
    .tooltip .arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0; }
  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0; }
    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
      top: 0;
      border-width: 0.4rem 0.4rem 0;
      border-top-color: #000; }

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem; }
  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
      right: 0;
      border-width: 0.4rem 0.4rem 0.4rem 0;
      border-right-color: #000; }

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0; }
  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0; }
    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
      bottom: 0;
      border-width: 0 0.4rem 0.4rem;
      border-bottom-color: #000; }

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem; }
  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem; }
    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
      left: 0;
      border-width: 0.4rem 0 0.4rem 0.4rem;
      border-left-color: #000; }

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 8px; }

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2); }
  .popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 8px; }
    .popover .arrow::before, .popover .arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem; }
  .bs-popover-top > .arrow, .bs-popover-auto[x-placement^="top"] > .arrow {
    bottom: calc(-0.5rem - 1px); }
    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^="top"] > .arrow::before {
      bottom: 0;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^="top"] > .arrow::after {
      bottom: 1px;
      border-width: 0.5rem 0.5rem 0;
      border-top-color: #fff; }

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem; }
  .bs-popover-right > .arrow, .bs-popover-auto[x-placement^="right"] > .arrow {
    left: calc(-0.5rem - 1px);
    width: 0.5rem;
    height: 1rem;
    margin: 8px 0; }
    .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^="right"] > .arrow::before {
      left: 0;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^="right"] > .arrow::after {
      left: 1px;
      border-width: 0.5rem 0.5rem 0.5rem 0;
      border-right-color: #fff; }

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem; }
  .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^="bottom"] > .arrow {
    top: calc(-0.5rem - 1px); }
    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^="bottom"] > .arrow::before {
      top: 0;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^="bottom"] > .arrow::after {
      top: 1px;
      border-width: 0 0.5rem 0.5rem 0.5rem;
      border-bottom-color: #fff; }
  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7; }

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem; }
  .bs-popover-left > .arrow, .bs-popover-auto[x-placement^="left"] > .arrow {
    right: calc(-0.5rem - 1px);
    width: 0.5rem;
    height: 1rem;
    margin: 8px 0; }
    .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^="left"] > .arrow::before {
      right: 0;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: rgba(0, 0, 0, 0.25); }
    .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^="left"] > .arrow::after {
      right: 1px;
      border-width: 0.5rem 0 0.5rem 0.5rem;
      border-left-color: #fff; }

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px; }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #535f6b; }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-left,
    .carousel-fade .active.carousel-item-right {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators li {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators li {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.bg-primary {
  color: #0a0e7c !important;
  background-color: #8f93f6 !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  color: #0a0e7c !important;
  background-color: #6065f2 !important; }

.bg-secondary {
  color: black !important;
  background-color: #6c757d !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  color: black !important;
  background-color: #545b62 !important; }

.bg-success {
  color: #144917 !important;
  background-color: #7fdd85 !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  color: #144917 !important;
  background-color: #57d25f !important; }

.bg-info {
  color: #9d2c05 !important;
  background-color: #fcbba5 !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  color: #9d2c05 !important;
  background-color: #fa9674 !important; }

.bg-warning {
  color: #5b4403 !important;
  background-color: #fad263 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  color: #5b4403 !important;
  background-color: #f8c432 !important; }

.bg-danger {
  color: #7b1444 !important;
  background-color: #ef9fc4 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  color: #7b1444 !important;
  background-color: #e873a9 !important; }

.bg-light {
  color: #7b7b7b !important;
  background-color: #FAFAFA !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  color: #7b7b7b !important;
  background-color: #e1e1e1 !important; }

.bg-dark {
  color: black !important;
  background-color: #01041b !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  color: black !important;
  background-color: black !important; }

.bg-orange {
  color: #120800 !important;
  background-color: #fd7e14 !important; }

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  color: #120800 !important;
  background-color: #dc6502 !important; }

.bg-purple {
  color: black !important;
  background-color: #4731b6 !important; }

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  color: black !important;
  background-color: #37268e !important; }

.bg-pink {
  color: #e00000 !important;
  background-color: #FFE0E0 !important; }

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  color: #e00000 !important;
  background-color: #ffadad !important; }

.bg-white {
  background-color: #fff !important; }

.bg-transparent {
  background-color: transparent !important; }

.border {
  border: 1px solid #f1f1f1 !important; }

.border-top {
  border-top: 1px solid #f1f1f1 !important; }

.border-right {
  border-right: 1px solid #f1f1f1 !important; }

.border-bottom {
  border-bottom: 1px solid #f1f1f1 !important; }

.border-left {
  border-left: 1px solid #f1f1f1 !important; }

.border-0 {
  border: 0 !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-right-0 {
  border-right: 0 !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-left-0 {
  border-left: 0 !important; }

.border-primary {
  border-color: #8f93f6 !important; }

.border-secondary {
  border-color: #6c757d !important; }

.border-success {
  border-color: #7fdd85 !important; }

.border-info {
  border-color: #fcbba5 !important; }

.border-warning {
  border-color: #fad263 !important; }

.border-danger {
  border-color: #ef9fc4 !important; }

.border-light {
  border-color: #FAFAFA !important; }

.border-dark {
  border-color: #01041b !important; }

.border-orange {
  border-color: #fd7e14 !important; }

.border-purple {
  border-color: #4731b6 !important; }

.border-pink {
  border-color: #FFE0E0 !important; }

.border-white {
  border-color: #fff !important; }

.rounded-sm {
  border-radius: 8px !important; }

.rounded {
  border-radius: 8px !important; }

.rounded-top {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important; }

.rounded-right {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important; }

.rounded-bottom {
  border-bottom-right-radius: 8px !important;
  border-bottom-left-radius: 8px !important; }

.rounded-left {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important; }

.rounded-lg {
  border-radius: 8px !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: 50px !important; }

.rounded-0 {
  border-radius: 0 !important; }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.d-none {
  display: none !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 768px) {
  .d-md-none {
    display: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; } }

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; } }

@media print {
  .d-print-none {
    display: none !important; }
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; } }

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden; }
  .embed-responsive::before {
    display: block;
    content: ""; }
  .embed-responsive .embed-responsive-item,
  .embed-responsive iframe,
  .embed-responsive embed,
  .embed-responsive object,
  .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0; }

.embed-responsive-21by9::before {
  padding-top: 42.85714%; }

.embed-responsive-16by9::before {
  padding-top: 56.25%; }

.embed-responsive-4by3::before {
  padding-top: 75%; }

.embed-responsive-1by1::before {
  padding-top: 100%; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; } }

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; } }

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; } }

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; } }

.float-left {
  float: left !important; }

.float-right {
  float: right !important; }

.float-none {
  float: none !important; }

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important; }
  .float-sm-right {
    float: right !important; }
  .float-sm-none {
    float: none !important; } }

@media (min-width: 768px) {
  .float-md-left {
    float: left !important; }
  .float-md-right {
    float: right !important; }
  .float-md-none {
    float: none !important; } }

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important; }
  .float-lg-right {
    float: right !important; }
  .float-lg-none {
    float: none !important; } }

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important; }
  .float-xl-right {
    float: right !important; }
  .float-xl-none {
    float: none !important; } }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020; } }

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal; }

.shadow-sm {
  box-shadow: 0px 16px 40px 0px #0000000A !important; }

.shadow {
  box-shadow: 0px 16px 40px 0px #0000000A !important; }

.shadow-lg {
  box-shadow: 0px 16px 40px 0px #0000000A !important; }

.shadow-none {
  box-shadow: none !important; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-100 {
  max-height: 100% !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.vw-100 {
  width: 100vw !important; }

.vh-100 {
  height: 100vh !important; }

.m-0 {
  margin: 0 !important; }

.mt-0,
.my-0 {
  margin-top: 0 !important; }

.mr-0,
.mx-0 {
  margin-right: 0 !important; }

.mb-0,
.my-0 {
  margin-bottom: 0 !important; }

.ml-0,
.mx-0 {
  margin-left: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.mt-1,
.my-1 {
  margin-top: 0.25rem !important; }

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important; }

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important; }

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.mt-2,
.my-2 {
  margin-top: 0.5rem !important; }

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important; }

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important; }

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.mt-3,
.my-3 {
  margin-top: 1rem !important; }

.mr-3,
.mx-3 {
  margin-right: 1rem !important; }

.mb-3,
.my-3 {
  margin-bottom: 1rem !important; }

.ml-3,
.mx-3 {
  margin-left: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.mt-4,
.my-4 {
  margin-top: 1.5rem !important; }

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important; }

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important; }

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.mt-5,
.my-5 {
  margin-top: 3rem !important; }

.mr-5,
.mx-5 {
  margin-right: 3rem !important; }

.mb-5,
.my-5 {
  margin-bottom: 3rem !important; }

.ml-5,
.mx-5 {
  margin-left: 3rem !important; }

.p-0 {
  padding: 0 !important; }

.pt-0,
.py-0 {
  padding-top: 0 !important; }

.pr-0,
.px-0 {
  padding-right: 0 !important; }

.pb-0,
.py-0 {
  padding-bottom: 0 !important; }

.pl-0,
.px-0 {
  padding-left: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.pt-1,
.py-1 {
  padding-top: 0.25rem !important; }

.pr-1,
.px-1 {
  padding-right: 0.25rem !important; }

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important; }

.pl-1,
.px-1 {
  padding-left: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.pt-2,
.py-2 {
  padding-top: 0.5rem !important; }

.pr-2,
.px-2 {
  padding-right: 0.5rem !important; }

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important; }

.pl-2,
.px-2 {
  padding-left: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.pt-3,
.py-3 {
  padding-top: 1rem !important; }

.pr-3,
.px-3 {
  padding-right: 1rem !important; }

.pb-3,
.py-3 {
  padding-bottom: 1rem !important; }

.pl-3,
.px-3 {
  padding-left: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.pt-4,
.py-4 {
  padding-top: 1.5rem !important; }

.pr-4,
.px-4 {
  padding-right: 1.5rem !important; }

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important; }

.pl-4,
.px-4 {
  padding-left: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.pt-5,
.py-5 {
  padding-top: 3rem !important; }

.pr-5,
.px-5 {
  padding-right: 3rem !important; }

.pb-5,
.py-5 {
  padding-bottom: 3rem !important; }

.pl-5,
.px-5 {
  padding-left: 3rem !important; }

.m-n1 {
  margin: -0.25rem !important; }

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important; }

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important; }

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important; }

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important; }

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important; }

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important; }

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.mt-n3,
.my-n3 {
  margin-top: -1rem !important; }

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important; }

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important; }

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important; }

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important; }

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important; }

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mt-n5,
.my-n5 {
  margin-top: -3rem !important; }

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important; }

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important; }

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important; }

.m-auto {
  margin: auto !important; }

.mt-auto,
.my-auto {
  margin-top: auto !important; }

.mr-auto,
.mx-auto {
  margin-right: auto !important; }

.mb-auto,
.my-auto {
  margin-bottom: auto !important; }

.ml-auto,
.mx-auto {
  margin-left: auto !important; }

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important; }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important; }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important; }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important; }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important; }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important; }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important; }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important; }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important; }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important; }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important; }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important; }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important; }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important; }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important; }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important; }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important; }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important; }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important; }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important; }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important; }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important; }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important; }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important; }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important; }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important; }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important; }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important; }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important; }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important; }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important; }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important; }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important; }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important; }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important; }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important; }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important; }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important; }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important; }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important; }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important; }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important; }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important; }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important; }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important; }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important; }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important; }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important; } }

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important; }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important; }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important; }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important; }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important; }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important; }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important; }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important; }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important; }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important; }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important; }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important; }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important; }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important; }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important; }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important; }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important; }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important; }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important; }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important; }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important; }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important; }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important; }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important; }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important; }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important; }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important; }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important; }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important; }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important; }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important; }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important; }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important; }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important; }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important; }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important; }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important; }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important; }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important; }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important; }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important; }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important; }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important; }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important; }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important; }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important; }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important; }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important; }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important; }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important; }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important; }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important; } }

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important; }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important; }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important; }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important; }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important; }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important; }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important; }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important; }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important; }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important; }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important; }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important; }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important; }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important; }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important; }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important; }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important; }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important; }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important; }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important; }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important; }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important; }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important; }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important; }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important; }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important; }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important; }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important; }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important; }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important; }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important; }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important; }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important; }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important; }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important; }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important; }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important; }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important; }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important; }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important; }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important; }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important; }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important; }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important; }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important; }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important; }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important; }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important; } }

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important; }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important; }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important; }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important; }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important; }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important; }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important; }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important; }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important; }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important; }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important; }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important; }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important; }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important; }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important; }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important; }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important; }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important; }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important; }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important; }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important; }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important; }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important; }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important; }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important; }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important; }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important; }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important; }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important; }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important; }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important; }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important; }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important; }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important; }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important; }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important; }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important; }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important; }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important; }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important; }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important; }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important; }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important; }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important; }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important; }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important; }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important; }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important; } }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0); }

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; }

.text-justify {
  text-align: justify !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-left {
  text-align: left !important; }

.text-right {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important; }
  .text-sm-right {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important; }
  .text-md-right {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important; }
  .text-lg-right {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important; }
  .text-xl-right {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.font-weight-light {
  font-weight: 300 !important; }

.font-weight-lighter {
  font-weight: lighter !important; }

.font-weight-normal {
  font-weight: 400 !important; }

.font-weight-bold {
  font-weight: 700 !important; }

.font-weight-bolder {
  font-weight: bolder !important; }

.font-italic {
  font-style: italic !important; }

.text-white {
  color: #fff !important; }

.text-primary {
  color: #8f93f6 !important; }

a.text-primary:hover, a.text-primary:focus {
  color: #484ff0 !important; }

.text-secondary {
  color: #6c757d !important; }

a.text-secondary:hover, a.text-secondary:focus {
  color: #494f54 !important; }

.text-success {
  color: #7fdd85 !important; }

a.text-success:hover, a.text-success:focus {
  color: #43cd4b !important; }

.text-info {
  color: #fcbba5 !important; }

a.text-info:hover, a.text-info:focus {
  color: #fa835b !important; }

.text-warning {
  color: #fad263 !important; }

a.text-warning:hover, a.text-warning:focus {
  color: #f8bd19 !important; }

.text-danger {
  color: #ef9fc4 !important; }

a.text-danger:hover, a.text-danger:focus {
  color: #e45d9c !important; }

.text-light {
  color: #FAFAFA !important; }

a.text-light:hover, a.text-light:focus {
  color: #d4d4d4 !important; }

.text-dark {
  color: #01041b !important; }

a.text-dark:hover, a.text-dark:focus {
  color: black !important; }

.text-orange {
  color: #fd7e14 !important; }

a.text-orange:hover, a.text-orange:focus {
  color: #c35a02 !important; }

.text-purple {
  color: #4731b6 !important; }

a.text-purple:hover, a.text-purple:focus {
  color: #2f217a !important; }

.text-pink {
  color: #FFE0E0 !important; }

a.text-pink:hover, a.text-pink:focus {
  color: #ff9494 !important; }

.text-body {
  color: #535f6b !important; }

.text-muted {
  color: #6c757d !important; }

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important; }

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0; }

.text-decoration-none {
  text-decoration: none !important; }

.text-break {
  word-wrap: break-word !important; }

.text-reset {
  color: inherit !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important; }
  a:not(.btn) {
    text-decoration: underline; }
  abbr[title]::after {
    content: " (" attr(title) ")"; }
  pre {
    white-space: pre-wrap !important; }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid; }
  thead {
    display: table-header-group; }
  tr,
  img {
    page-break-inside: avoid; }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3; }
  h2,
  h3 {
    page-break-after: avoid; }
  @page {
    size: a3; }
  body {
    min-width: 992px !important; }
  .container {
    min-width: 992px !important; }
  .navbar {
    display: none; }
  .badge {
    border: 1px solid #000; }
  .table {
    border-collapse: collapse !important; }
    .table td,
    .table th {
      background-color: #fff !important; }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ccced2 !important; }
  .table-dark {
    color: inherit; }
    .table-dark th,
    .table-dark td,
    .table-dark thead th,
    .table-dark tbody + tbody {
      border-color: #f1f1f1; }
  .table .thead-dark th {
    color: inherit;
    border-color: #f1f1f1; } }

/*----------------- Grid Boxes -----------------*/
.card {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 30px;
  border: none;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A; }
  .card .card-header {
    background: transparent;
    border-radius: 0;
    padding: 20px;
    margin-bottom: 0;
    align-items: center !important;
    border-bottom: 0; }
    .card .card-header .header-title .card-title {
      margin-bottom: 0; }

.card-transparent {
  background: transparent;
  border-radius: 8px;
  margin-bottom: 30px;
  border: none;
  box-shadow: none; }
  .card-transparent .card-header {
    background: transparent;
    border-radius: 0;
    padding: 0 0 15px;
    margin-bottom: 0;
    align-items: center !important;
    border: none; }
    .card-transparent .card-header .header-title .card-title {
      margin-bottom: 0; }

.card-body {
  padding: 20px; }

.card-header-toolbar .nav-item a {
  color: #535f6b;
  padding: 4px 12px;
  font-size: 14px; }

.card-header-toolbar .dropdown-toggle i {
  font-size: 20px;
  line-height: normal;
  vertical-align: text-bottom; }

.card-header-toolbar .dropdown-toggle::after {
  display: none; }

.card-header .dropdown-bg {
  border-radius: 8px; }

.card-block.card-stretch {
  align-items: stretch; }

.card-block.card-height-third {
  height: calc(33.33% - 30px); }

.card-block.card-height-half {
  height: calc(50% - 30px); }

.card-block.card-height {
  height: calc(100% - 30px); }

.card-block {
  display: flex;
  flex-grow: 1;
  flex-direction: column; }


#sidebar-scrollbar {
  height: 100vh; }

.offcanvas-header {
  padding: 0
}  

.scroll-content div.p-3 {
  height: 100px; }

.iq-sidebar-menu {
  position: relative; }
  .iq-sidebar-menu .iq-menu {
    margin: 0;
    padding: 0;
    list-style-type: none; }
    .iq-sidebar-menu .iq-menu .iq-menu-title {
      display: block;
      color: #535f6b;
      font-size: 15px;
      position: relative;
      padding: 15px;
      font-weight: 500;
      line-height: 18px; }
      .iq-sidebar-menu .iq-menu .iq-menu-title i {
        display: none; }
    .iq-sidebar-menu .iq-menu li {
      list-style-type: none;
      position: relative;
      white-space: nowrap; }
      .iq-sidebar-menu .iq-menu li li {
        margin: 0;
        background: transparent !important; }
        .iq-sidebar-menu .iq-menu li li a {
          font-size: 16px; }
      .iq-sidebar-menu .iq-menu li a {
        font-size: 16px;
        white-space: nowrap;
        display: block;
        color: #535f6b;
        position: relative;
        padding: 15px 20px;
        line-height: 18px;
        display: flex;
        align-items: center;
        overflow: hidden;
        border-radius: 0px;
        text-transform: capitalize; }
        .iq-sidebar-menu .iq-menu li a i {
          font-size: 20px;
          margin-right: 10px;
          vertical-align: middle;
          width: 20px;
          display: inline-block; }
        .iq-sidebar-menu .iq-menu li a span {
          white-space: nowrap;
          padding: 0;
          display: inline-block;
          transition: none; }
        .iq-sidebar-menu .iq-menu li a .iq-arrow-right {
          margin-right: 0px;
          margin-left: auto;
          font-size: 15px;
          width: 15px;
          transition: all 0.6s ease-in-out; }
        .iq-sidebar-menu .iq-menu li a .badge {
          position: absolute;
          right: 15px;
          transition: all 0.6s ease-in-out; }
      .iq-sidebar-menu .iq-menu li a[aria-expanded="true"] .iq-arrow-right {
        transition: all 0.6s ease-in-out; }
      .iq-sidebar-menu .iq-menu li ul {
        padding-left: 0;
        position: relative; }
      .iq-sidebar-menu .iq-menu li .iq-submenu li a[aria-expanded="true"] {
        box-shadow: none; }
    .iq-sidebar-menu .iq-menu li.active-menu > a {
      color: #8f93f6;
      text-decoration: none;
      border-radius: 0;
      transition: none; }
    .iq-sidebar-menu .iq-menu li.active .iq-submenu li > a {
      background: transparent; }

.sidebar-default .iq-sidebar-menu .iq-menu li a:hover {
  color: #8f93f6; }

.sidebar-default .iq-sidebar-menu .iq-menu li a[aria-expanded="true"] {
  color: #8f93f6;
  text-decoration: none;
  border-radius: 0;
  transition: none; }
  .sidebar-default .iq-sidebar-menu .iq-menu li a[aria-expanded="true"] i.iq-arrow-left {
    color: #8f93f6; }

.sidebar-default .iq-sidebar-menu .iq-menu li .iq-submenu li a:hover {
  background: transparent; }

.sidebar-default .iq-sidebar-menu .iq-menu li ul a:hover {
  color: #8f93f6;
  text-decoration: none;
  background: transparent; }

.sidebar-default .iq-sidebar-menu .iq-menu li ul li a {
  padding-left: 30px; }

.sidebar-default .iq-sidebar-menu .iq-menu li ul ul li > a {
  padding-left: 50px; }

.sidebar-default .iq-sidebar-menu .iq-menu li ul ul ul li > a {
  padding-left: 80px; }

.sidebar-default .iq-sidebar-menu .iq-menu li ul.iq-submenu-data li {
  margin: 0; }

.sidebar-default .iq-sidebar-menu .iq-menu > li.active > a {
  color: #8f93f6;
  text-decoration: none; }

.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li.active > a {
  color: #8f93f6;
  border-radius: 0; }

.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li:last-child > a {
  border-radius: 0 0 8px 8px; }

.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li a[aria-expanded="true"] {
  box-shadow: none; }

.sidebar-default .iq-sidebar-menu .iq-menu .iq-submenu .iq-submenu-data {
  box-shadow: none; }

.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu .iq-submenu li:before {
  content: '';
  width: 3px;
  height: 35px;
  background: #8f93f6;
  position: absolute;
  left: 30px;
  top: 8px;
  border-radius: 8px;
  -webkit-opacity: 0;
  -moz-opacity: 0;
  -ms-opacity: 0;
  -o-opacity: 0;
  opacity: 0; }

.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu .iq-submenu li.active:before {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1; }

.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu li.active ul.iq-submenu .iq-submenu:before {
  left: 48px;
  width: 2px; }

.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu li.active ul.iq-submenu .iq-submenu li::before {
  left: 48px;
  width: 2px; }

.sidebar-default .sidebar-main .iq-sidebar-menu .iq-menu li ul {
  padding-left: 0; }

.iq-sidebar-menu {
  margin: 10px 0px; }
  .iq-sidebar-menu .iq-menu li a .iq-arrow-right.arrow-hover {
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    display: none; }
  .iq-sidebar-menu .iq-menu li a[aria-expanded="true"] .iq-arrow-right.arrow-active {
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    display: none; }
  .iq-sidebar-menu .iq-menu li a[aria-expanded="true"] .iq-arrow-right.arrow-hover {
    -webkit-opacity: 1;
    -moz-opacity: 1;
    -ms-opacity: 1;
    -o-opacity: 1;
    opacity: 1;
    display: block; }

.sidebar-bottom {
  margin: 0 15px;
  padding: 20px 15px 0;
  border-top: 1px solid #f1f1f1; }
  .sidebar-bottom h4 i {
    font-size: 1.2em;
    font-weight: 700; }

.iq-sidebar-logo {
  padding: 15px;
  width: auto;
  position: relative;
  transition: all 0.6s ease-in-out; }
  .iq-sidebar-logo a {
    display: flex;
    align-items: flex-start; }
    .iq-sidebar-logo a span {
      margin-left: 10px;
      font-size: 19px;
      line-height: 42px;
      padding-left: 1px;
      letter-spacing: 1.5px;
      font-weight: 600;
      flex: 1 1;
      transition: all 0.6s ease-in-out; }
    .iq-sidebar-logo a span.logo-text {
      font-size: 10px;
      letter-spacing: 5px; }
    .iq-sidebar-logo a:hover {
      text-decoration: none; }
    .iq-sidebar-logo a:focus {
      text-decoration: none; }
  .iq-sidebar-logo img {
    height: 50px; }

.iq-saidbar-logo img {
  width: 60%; }

.logo-text {
  color: #535f6b;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 5px; }

.iq-top-navbar .wrapper-menu {
  margin: 0 15px 0 0; }

.wrapper-menu {
  font-size: 30px;
  text-align: center;
  color: #8f93f6;
  position: relative;
  transition: all 0.6s ease-in-out; }

@media (min-width: 1300px) {
  .iq-top-navbar .iq-navbar-custom .wrapper-menu {
    display: none; }
  body.sidebar-main .iq-sidebar {
    width: 80px; }
    body.sidebar-main .iq-sidebar .iq-sidebar-menu .iq-menu li a span {
      -webkit-opacity: 0;
      -moz-opacity: 0;
      -ms-opacity: 0;
      -o-opacity: 0;
      opacity: 0;
      display: none;
      transition: all 0.6s ease-in-out; }
    body.sidebar-main .iq-sidebar .iq-sidebar-menu .iq-menu li a .iq-arrow-right {
      display: none; }
  body.sidebar-main .iq-sidebar-logo a {
    display: none; }
    body.sidebar-main .iq-sidebar-logo a span {
      -webkit-opacity: 0;
      -moz-opacity: 0;
      -ms-opacity: 0;
      -o-opacity: 0;
      opacity: 0;
      display: none;
      transition: all 0.6s ease-in-out; }
  body.sidebar-main .iq-sidebar-menu .iq-menu li a .badge {
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    display: none;
    transition: all 0.6s ease-in-out; }
  body.sidebar-main .iq-sidebar-menu .iq-menu li a .iq-arrow-right {
    margin-right: 0;
    display: none; }
  body.sidebar-main .iq-sidebar-menu .iq-menu li a i.iq-arrow-left {
    margin: 0 auto; }
  body.sidebar-main .iq-sidebar-menu .iq-menu li li a i {
    margin: 0 auto;
    text-align: center; }
  body.sidebar-main .sidebar-default .iq-sidebar-menu .iq-menu li ul li a {
    padding-left: 20px; }
  .sidebar-main .iq-sidebar .iq-submenu li a {
    font-size: 0; } }

@media (max-width: 1299px) {
  .iq-sidebar {
    display: inline-block;
    z-index: 99;
    left: -300px;
    top: 0px; }
  body.sidebar-main .iq-sidebar {
    width: 260px;
    left: 0;
    z-index: 999; } }

@media (min-width: 1300px) {
  .iq-menu-bt-sidebar {
    display: none; } }

@keyframes shadowDots {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 177, 255, 0.2); }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 177, 255, 0); } }

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 177, 255, 0.2); }
  100% {
    box-shadow: 0 0 0 15px rgba(0, 177, 255, 0); } }

@keyframes shadow-pulse-dots-danger {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 155, 138, 0.2); }
  100% {
    box-shadow: 0 0 0 15px rgba(255, 155, 138, 0); } }

@keyframes shadow-pulse-danger {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 155, 138, 0.2); }
  100% {
    box-shadow: 0 0 0 15px rgba(255, 155, 138, 0); } }

@keyframes fade-in-bottom {
  0% {
    transform: translateY(50px);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0; }
  100% {
    transform: translateY(0);
    -webkit-opacity: 1;
    -moz-opacity: 1;
    -ms-opacity: 1;
    -o-opacity: 1;
    opacity: 1; } }

.iq-top-navbar {
  background: #fff;
  padding: 0 30px 0 30px;
  min-height: 80px;
  position: fixed;
  top: 0;
  left: auto;
  right: 0;
  width: calc(100% - 260px);
  display: inline-block;
  z-index: 99;
  margin: 0;
  transition: all 0.3s ease-in-out;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A; }
  .iq-top-navbar .iq-navbar-custom .navbar-breadcrumb {
    display: block;
    margin-left: 0px;
    padding: 20px 0; }
  .iq-top-navbar .breadcrumb {
    background: transparent;
    padding: 0;
    margin: 0; }
    .iq-top-navbar .breadcrumb .breadcrumb-item.active {
      color: #535f6b; }
    .iq-top-navbar .breadcrumb li {
      list-style-type: none;
      font-size: 14px; }
      .iq-top-navbar .breadcrumb li a {
        text-decoration: none; }
        .iq-top-navbar .breadcrumb li a:hover {
          text-decoration: none; }
  .iq-top-navbar .navbar-expand-lg {
    justify-content: space-between !important; }
  .iq-top-navbar .iq-sub-dropdown {
    width: 300px;
    height: auto;
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    border: none;
    animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    transform: translateY(100%);
    background-color: #fff;
    padding: 0;
    border-radius: 8px;
    -ms-box-shadow: 0px 16px 40px 0px #0000000A;
    -o-box-shadow: 0px 16px 40px 0px #0000000A;
    box-shadow: 0px 16px 40px 0px #0000000A;
    transition: all 0.3s ease-in-out; }
    .iq-top-navbar .iq-sub-dropdown .iq-card-body div {
      border-radius: 8px 8px 0 0; }
  .iq-top-navbar .lang .iq-sub-dropdown {
    width: auto; }
  .iq-top-navbar .iq-user-dropdown {
    position: fixed;
    left: auto;
    right: 0;
    width: 350px;
    top: 0;
    bottom: 0;
    height: 100vh;
    background: #fff;
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    visibility: hidden;
    transform: translateX(100%);
    transition: all 0.3s ease-in-out; }
  .iq-top-navbar .navbar-brand {
    padding: 0; }

body.sidebar-main .iq-top-navbar {
  width: calc(100% - 80px); }

.iq-top-navbar.fixed-header {
  margin: 0;
  right: 0;
  width: calc(100% - 330px);
  border-radius: 0;
  transition: all 0.3s ease-in-out; }

.navbar-breadcrumb .breadcrumb {
  padding: 0;
  background: none;
  margin-top: 5px; }

.breadcrumb-item + .breadcrumb-item::before {
  content: "\\ea5f";
  font-family: 'remixicon';
  font-size: 14px;
  vertical-align: sub;
  color: #535f6b; }

.navbar-list {
  margin: 0;
  padding: 0;
  float: right; }
  .navbar-list li {
    float: left;
    list-style-type: none;
    position: relative; }
    .navbar-list li > .dropdown {
      line-height: 73px;
      cursor: pointer; }
      .navbar-list li > .dropdown .dropdown-menu {
        animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
        transform: translateY(100%); }
    .navbar-list li .dropdown-toggle::after {
      display: none; }
    .navbar-list li > a.language-title {
      font-size: 16px; }
    .navbar-list li > a {
      color: #535f6b;
      font-size: 22px;
      padding: 0 12px;
      display: block;
      line-height: 73px; }
      .navbar-list li > a > img {
        width: 50px;
        height: 50px;
        min-width: 50px; }
    .navbar-list li a:hover {
      text-decoration: none; }
    .navbar-list li .caption {
      line-height: 26px;
      font-size: 18px;
      height: 25px;
      width: 25px;
      text-align: center;
      border-radius: 50%; }
      .navbar-list li .caption p {
        color: #535f6b;
        font-size: 12px; }
    .navbar-list li .iq-sub-dropdown .iq-sub-card {
      font-size: inherit;
      padding: 10px 0px;
      border-bottom: 1px solid #f1f1f1;
      line-height: normal;
      color: inherit;
      display: inline-block;
      width: 100%; }
      .navbar-list li .iq-sub-dropdown .iq-sub-card:last-child {
        padding-bottom: 0;
        border: 0; }
      .navbar-list li .iq-sub-dropdown .iq-sub-card i {
        font-size: 18px;
        vertical-align: middle;
        padding-right: 12px; }
    .navbar-list li .iq-sub-dropdown .iq-sub-card.iq-sub-card-big {
      width: auto; }
  .navbar-list li.iq-nav-user {
    display: flex;
    align-items: flex-start; }
    .navbar-list li.iq-nav-user span {
      flex: 1 1;
      font-size: 14px; }
  .navbar-list .caption-content {
    line-height: normal; }

.menu-tag {
  position: absolute;
  background: #535f6b;
  color: #fff;
  top: 18px;
  left: 18px;
  font-size: 12px;
  border-radius: 90px;
  line-height: normal;
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  display: inline-block; }

.iq-breadcrumb {
  display: none; }

.toggle-cart-info img {
  width: 50px; }

.nav-item span.dots {
  height: 6px;
  width: 6px;
  font-size: 0;
  text-align: center;
  padding: 0;
  position: absolute;
  top: 18px;
  right: 3px;
  border: 0;
  animation: shadowDots 1s infinite;
  border-radius: 50%; }

.nav-item span.count-mail {
  height: 6px;
  width: 5px;
  font-size: 10px;
  text-align: center;
  line-height: 15px;
  padding: 0;
  position: absolute;
  top: 18px;
  right: 3px;
  border: 0;
  animation: shadow-pulse 1s infinite;
  border-radius: 50%; }

.nav-item .badge.count-cart {
  height: 15px;
  width: 15px;
  font-size: 10px;
  text-align: center;
  line-height: 15px;
  padding: 0;
  position: absolute;
  top: 13px;
  right: 0px; }

.top-nav-bottom {
  margin-left: 260px;
  border-top: 1px solid #c6c8f7; }

.topnav-toolbar li a {
  display: block;
  padding: 10px 15px;
  text-transform: capitalize;
  color: #6c757d;
  border-radius: 8px; }

.topnav-toolbar li.date-today {
  background: #FAFAFA; }

.topnav-toolbar li.active a {
  background: #c6c8f7;
  color: #8f93f6; }

.topnav-toolbar ul li {
  list-style: none;
  padding: 13px 0; }

.iq-search-bar .dropdown-toggle {
  width: 450px;
  position: relative;
  margin: 0;
  box-shadow: none !important; }
  .iq-search-bar .dropdown-toggle.searchbox:after {
    position: absolute;
    right: 15px;
    top: 17px; }
  .iq-search-bar .dropdown-toggle .select-dropdown > li > .item {
    padding: 12px 20px; }
    .iq-search-bar .dropdown-toggle .select-dropdown > li > .item i {
      font-size: 16px;
      vertical-align: middle;
      margin-right: 12px;
      padding: 5px;
      border-radius: 3px; }

.iq-search-bar .btn-group .dropdown-menu {
  position: absolute;
  background: #fff;
  width: 100%;
  border: 0;
  z-index: 9;
  padding: 0;
  height: auto;
  text-align: left !important;
  -ms-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1); }

.iq-search-bar .btn-group li:last-child .item {
  border: 0; }

.iq-search-bar .btn-group li .item {
  padding: 10px 20px;
  border-bottom: 1px solid #f1f1f1;
  color: #535f6b; }
  .iq-search-bar .btn-group li .item i {
    padding: 8px 10px;
    font-size: "Poppins", sans-serif;
    line-height: 20px;
    margin-right: 15px;
    border-radius: 8px; }

.iq-search-bar .btn-group .search-replace .item {
  display: none; }

.iq-search-bar .search-input {
  width: 100%;
  height: 40px !important;
  padding: 5px 5px 5px 42px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #f1f1f1; }

.iq-search-bar .search-link {
  position: absolute;
  right: auto;
  left: 15px;
  top: 10px;
  color: #535f6b; }

.iq-search-bar .search-dropdown {
  position: absolute;
  top: 10px;
  right: 0; }

.search-dropdown .dropdown-toggle i {
  font-size: 20px; }

.search-dropdown .dropdown-toggle:after {
  display: none; }

.iq-navbar-logo {
  padding: 0;
  width: auto;
  position: relative;
  background: #fff;
  transition: all 0.3s ease-in-out;
  background: transparent; }
  .iq-navbar-logo a {
    display: flex;
    align-items: center; }
    .iq-navbar-logo a span {
      margin-left: 10px;
      font-size: 28px;
      line-height: 26px;
      font-weight: 500;
      color: #01041b;
      text-transform: capitalize;
      flex: 1 1;
      transition: all 0.3s ease-in-out; }
    .iq-navbar-logo a:hover {
      text-decoration: none; }
    .iq-navbar-logo a:focus {
      text-decoration: none; }
  .iq-navbar-logo img {
    height: 50px; }

.iq-sub-dropdown.iq-sub-dropdown-large {
  width: 500px; }

.cust-title {
  border-bottom: 1px solid #f1f1f1; }

.crt-img {
  background: #fafbfe;
  padding: 10px;
  border-radius: 8px; }

.cust-dd .btn {
  border-radius: 0 0 8px 8px; }

.dd-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 40px;
  height: 40px;
  background: #6c71e3;
  color: #fff;
  border-radius: 0 0 0 10px;
  text-align: center;
  line-height: 40px;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center; }

.right-ic {
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  border: none !important; }
  .right-ic:hover .dd-icon {
    background: #8f93f6; }

.iq-show .iq-sub-dropdown {
  display: inline-block; }

.iq-sub-dropdown .iq-card-icon {
  width: 45px;
  height: 45px;
  line-height: 40px;
  font-size: 22px; }

.show-data .iq-user-dropdown {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  transition: all 0.3s ease-in-out; }

.iq-card-icon-small {
  height: 40px;
  width: 40px;
  min-width: 40px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
  font-size: 22px; }

.profile-details > a {
  margin-bottom: 15px;
  display: block;
  border-radius: 8px; }

.data-scrollbar {
  height: 100vh;
  overflow-x: scroll;
 }

.navbar-toggler {
  outline: none; }

.profile-icon {
  height: 60px;
  width: 60px;
  line-height: 60px;
  font-size: 26px; }

@media (min-width: 1300px) {
  .iq-navbar-logo {
    display: none !important; }
    .iq-navbar-logo > a {
      display: none; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a.collapsed {
    pointer-events: none; } }

@media (max-width: 1199px) {
  .iq-search-bar .searchbox {
    width: 320px; } }

@media (max-width: 1299px) {
  .iq-top-navbar {
    width: 100%; }
    .iq-top-navbar .iq-search-bar.device-search {
      margin-left: 20px; }
  body.sidebar-main .iq-top-navbar {
    width: 100%; } }

@media (min-width: 992px) {
  .search-content {
    display: none; }
  .navbar-list li:last-child > a {
    padding: 0 0 0 12px; } }

@media (max-width: 991px) {
  .device-search {
    display: none; }
  .navbar-collapse {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 8px;
    -ms-box-shadow: 0px 16px 40px 0px #0000000A;
    -o-box-shadow: 0px 16px 40px 0px #0000000A;
    box-shadow: 0px 16px 40px 0px #0000000A; }
  .navbar-nav.navbar-list {
    float: right;
    display: inline-block; }
  .iq-top-navbar {
    padding: 16px 15px !important;
    line-height: normal;
    min-height: unset; }
    .iq-top-navbar .navbar-toggler {
      color: #8f93f6;
      background: #c6c8f7;
      border: none;
      padding: 7px 10px 3px;
      border-radius: 5px;
      font-size: 24px; }
    .iq-top-navbar .iq-navbar-logo img {
      height: 40px; }
    .iq-top-navbar .iq-search-bar {
      line-height: normal; }
  .iq-search-bar .searchbox {
    width: 100%; }
  .caption-content {
    padding-top: 22px; } }

@media (max-width: 767px) {
  .iq-top-navbar .lang .iq-sub-dropdown {
    width: 150px; } }

@media (max-width: 575px) {
  .search-toggle {
    position: relative; }
  .iq-top-navbar .iq-sub-dropdown {
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 270px; }
  .iq-top-navbar .iq-search-bar {
    width: 100%; }
  .iq-top-navbar .iq-user-dropdown {
    width: 300px; }
  .navbar-list li {
    position: static; }
    .navbar-list li > a.language-title {
      font-size: 0; } }

@media (max-width: 479px) {
  .navbar-list li > a {
    padding: 0 10px; }
    .navbar-list li > a > img {
      width: 40px;
      height: 40px;
      min-width: 40px; } }

.iq-right-fixed {
  margin: 0 15px; }

.right-sidebar-mini {
  top: 75px;
  z-index: 100;
  position: fixed;
  width: 260px;
  right: 0;
  transform: translateX(calc(111% + -2em));
  transition: all 0.3s ease-in-out; }
  .right-sidebar-mini .side-left-icon {
    display: none; }

.right-sidebar-toggle {
  position: absolute;
  margin-left: -44px;
  background: #fff;
  padding: 15px;
  display: inline;
  top: 0;
  z-index: 99;
  border-radius: 50px 0 0 50px;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A;
  cursor: pointer; }
  .right-sidebar-toggle span {
    display: none !important; }

.right-sidebar-panel {
  background-color: #fff;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A;
  height: 91vh;
  padding: 15px;
  overflow-y: scroll; }

.right-sidebar {
  transform: translateX(calc(10% + -1em)); }
  .right-sidebar .side-right-icon {
    display: none; }
  .right-sidebar .side-left-icon {
    display: block; }

@media (min-width: 1500px) {
  .right-sidebar-mini {
    transform: translateX(calc(10% + -1em)); }
    .right-sidebar-mini:hover .right-sidebar-toggle {
      -webkit-opacity: 1;
      -moz-opacity: 1;
      -ms-opacity: 1;
      -o-opacity: 1;
      opacity: 1;
      margin-left: -44px;
      transition: all 0.3s ease-in-out; }
  .right-sidebar-toggle {
    z-index: -1;
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    margin-left: 0;
    transition: all 0.3s ease-in-out; }
  .right-sidebar-mini.right-sidebar {
    transform: translateX(calc(111% + -2em)); }
    .right-sidebar-mini.right-sidebar .right-sidebar-toggle {
      margin-left: -44px;
      -webkit-opacity: 1;
      -moz-opacity: 1;
      -ms-opacity: 1;
      -o-opacity: 1;
      opacity: 1; }
  body.right-sidebar-close footer {
    width: calc(100vw - 260px); } }

@media (min-width: 1300px) and (max-width: 1499px) {
  .right-sidebar-mini {
    transform: translateX(calc(111% + -8em)); }
    .right-sidebar-mini .media-body {
      -webkit-opacity: 0;
      -moz-opacity: 0;
      -ms-opacity: 0;
      -o-opacity: 0;
      opacity: 0; }
  .right-sidebar-mini.right-sidebar {
    transform: translateX(calc(10% + -1em)); }
    .right-sidebar-mini.right-sidebar .media-body {
      -webkit-opacity: 1;
      -moz-opacity: 1;
      -ms-opacity: 1;
      -o-opacity: 1;
      opacity: 1; } }

.basic-drop-shadow {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15); }

.bottom-left {
  box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.15); }

.bottom-right {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15); }

.top-left {
  box-shadow: -5px -5px 10px rgba(0, 0, 0, 0.15); }

.top-right {
  box-shadow: 5px -5px 10px rgba(0, 0, 0, 0.15); }

.shadow-bottom {
  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.15); }

.inner-shadow {
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.15); }

.blur-shadow {
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.15); }

@keyframes rippleDrop {
  100% {
    transform: scale(2);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0; } }

.ripple {
  width: 0;
  height: 0;
  border-radius: 50%;
  background: #c6c8f7;
  transform: scale(0);
  position: absolute;
  -webkit-opacity: 1;
  -moz-opacity: 1;
  -ms-opacity: 1;
  -o-opacity: 1;
  opacity: 1; }

.rippleEffect {
  animation: rippleDrop .6s linear; }

.media-support {
  display: inline-block;
  width: 100%; }

.media-support-user-img img {
  height: 60px; }

.media-support-header {
  display: flex;
  align-items: flex-start; }

.media-support-info {
  flex: 1 1; }

.projects-media img {
  height: 60px; }

.iq-media-group .iq-media {
  margin-left: -20px;
  position: relative;
  z-index: 0;
  transition: all 0.3s ease-in-out; }
  .iq-media-group .iq-media:hover {
    z-index: 9; }
  .iq-media-group .iq-media img {
    border: 2px solid #f1f1f1; }
  .iq-media-group .iq-media:first-child {
    margin-left: 0; }

.iq-media-group .iq-media.border {
  border: 2px solid #f1f1f1; }

.iq-media {
  display: inline-flex;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover; }
  .iq-media:hover {
    text-decoration: none; }

.media-pl {
  text-align: center; }

.badge {
  padding: .3em .6em;
  line-height: 1.3;
  text-transform: capitalize;
  border-radius: 8px; }

.breadcrumb.bg-primary .breadcrumb-item + .breadcrumb-item::before {
  color: #fff; }

.alert-primary {
  color: #6065f2;
  border-color: #6065f2;
  background-color: rgba(198, 200, 247, 0.1); }
  .alert-primary .alert-link {
    color: #3138ee; }

.alert-secondary {
  color: #545b62;
  border-color: #545b62;
  background-color: rgba(204, 206, 210, 0.1); }
  .alert-secondary .alert-link {
    color: #3d4246; }

.dark .alert-secondary {
  color: #868e96;
  border-color: #545b62;
  background-color: rgba(204, 206, 210, 0.1); }
  .dark .alert-secondary .alert-link {
    color: #a1a8ae; }

.alert-success {
  color: #57d25f;
  border-color: #57d25f;
  background-color: rgba(183, 225, 186, 0.1); }
  .alert-success .alert-link {
    color: #34c23d; }

.alert-danger {
  color: #e873a9;
  border-color: #e873a9;
  background-color: rgba(255, 218, 235, 0.1); }
  .alert-danger .alert-link {
    color: #e0488e; }

.alert-warning {
  color: #f8c432;
  border-color: #f8c432;
  background-color: rgba(255, 235, 223, 0.1); }
  .alert-warning .alert-link {
    color: #efb208; }

.alert-info {
  color: #fa9674;
  border-color: #fa9674;
  background-color: rgba(255, 230, 222, 0.1); }
  .alert-info .alert-link {
    color: #f97042; }

.alert-light {
  color: #545b62;
  border-color: #545b62;
  background-color: rgba(250, 250, 250, 0.1); }
  .alert-light .alert-link {
    color: #c7c7c7; }

.dark .alert-light {
  color: #868e96;
  border-color: #545b62;
  background-color: rgba(250, 250, 250, 0.1); }
  .dark .alert-light .alert-link {
    color: #c7c7c7; }

.alert {
  display: flex;
  align-items: stretch; }
  .alert .iq-alert-icon {
    display: flex;
    align-items: center;
    padding: 0 1.30rem 0 0; }
    .alert .iq-alert-icon i {
      font-size: 2.441em;
      line-height: normal; }
  .alert .iq-alert-text {
    align-self: center;
    flex-grow: 1; }
  .alert .close {
    float: right;
    font-size: 20px;
    font-weight: 400;
    line-height: 1;
    color: #fff;
    text-shadow: none;
    opacity: 1; }

.close:not(:disabled):not(.disabled):focus {
  outline: none; }

.close:not(:disabled):not(.disabled):hover {
  outline: none; }

.iq-example-row .row > .col {
  padding-top: .75rem;
  color: #535f6b;
  padding-bottom: .75rem;
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2); }

.iq-example-row .row > [class^=col-] {
  padding-top: .75rem;
  color: #535f6b;
  padding-bottom: .75rem;
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2); }

.iq-example-row-flex-cols .row {
  margin-bottom: 15px;
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1); }

.nav-pills .nav-item a {
  color: #535f6b; }

.nav-pills .nav-link.active {
  color: #8f93f6;
  background: #c6c8f7; }

.nav-pills .show > .nav-link {
  color: #8f93f6;
  background: #c6c8f7; }

.nav-pills .nav-link:hover {
  color: #8f93f6; }

.nav-tabs {
  border-bottom: 2px solid #c6c8f7;
  margin-bottom: 15px; }
  .nav-tabs .nav-item {
    margin-bottom: -2px; }
    .nav-tabs .nav-item a {
      color: #535f6b;
      border: none;
      border-bottom: 2px solid transparent; }
  .nav-tabs .nav-item.show .nav-link {
    border-bottom: 2px solid #8f93f6;
    color: #8f93f6; }
  .nav-tabs .nav-link.active {
    border-bottom: 2px solid #8f93f6;
    color: #8f93f6; }

.custom-checkbox.custom-checkbox-color input.bg-primary ~ label::before {
  background-color: #8f93f6 !important;
  border-color: #8f93f6 !important; }

.custom-checkbox.custom-checkbox-color input.bg-success ~ label::before {
  background-color: #7fdd85 !important;
  border-color: #7fdd85 !important; }

.custom-checkbox.custom-checkbox-color input.bg-danger ~ label::before {
  background-color: #ef9fc4 !important;
  border-color: #ef9fc4 !important; }

.custom-checkbox.custom-checkbox-color input.bg-warning ~ label::before {
  background-color: #fad263 !important;
  border-color: #fad263 !important; }

.custom-checkbox.custom-checkbox-color input.bg-dark ~ label::before {
  background-color: #535f6b !important;
  border-color: #535f6b !important; }

.custom-checkbox.custom-checkbox-color input.bg-info ~ label::before {
  background-color: #fcbba5 !important;
  border-color: #fcbba5 !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-primary ~ label::before {
  background-color: #8f93f6 !important;
  border-color: #8f93f6 !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-success ~ label::before {
  background-color: #7fdd85 !important;
  border-color: #7fdd85 !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-danger ~ label::before {
  background-color: #ef9fc4 !important;
  border-color: #ef9fc4 !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-warning ~ label::before {
  background-color: #fad263 !important;
  border-color: #fad263 !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-dark ~ label::before {
  background-color: #535f6b !important;
  border-color: #535f6b !important; }

.custom-checkbox.custom-checkbox-color-check input:checked.bg-info ~ label::before {
  background-color: #fcbba5 !important;
  border-color: #fcbba5 !important; }

.custom-radio.custom-radio-color input.bg-primary ~ label::before {
  background-color: #8f93f6 !important;
  border-color: #8f93f6 !important; }

.custom-radio.custom-radio-color input.bg-success ~ label::before {
  background-color: #7fdd85 !important;
  border-color: #7fdd85 !important; }

.custom-radio.custom-radio-color input.bg-danger ~ label::before {
  background-color: #ef9fc4 !important;
  border-color: #ef9fc4 !important; }

.custom-radio.custom-radio-color input.bg-warning ~ label::before {
  background-color: #fad263 !important;
  border-color: #fad263 !important; }

.custom-radio.custom-radio-color input.bg-dark ~ label::before {
  background-color: #535f6b !important;
  border-color: #535f6b !important; }

.custom-radio.custom-radio-color input.bg-info ~ label::before {
  background-color: #fcbba5 !important;
  border-color: #fcbba5 !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-primary ~ label::before {
  background-color: #8f93f6 !important;
  border-color: #8f93f6 !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-success ~ label::before {
  background-color: #7fdd85 !important;
  border-color: #7fdd85 !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-danger ~ label::before {
  background-color: #ef9fc4 !important;
  border-color: #ef9fc4 !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-warning ~ label::before {
  background-color: #fad263 !important;
  border-color: #fad263 !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-dark ~ label::before {
  background-color: #535f6b !important;
  border-color: #535f6b !important; }

.custom-radio.custom-radio-color-checked input:checked.bg-info ~ label::before {
  background-color: #fcbba5 !important;
  border-color: #fcbba5 !important; }

.custom-switch.custom-switch-color input:checked.bg-primary ~ label::before {
  background-color: #8f93f6 !important;
  border-color: #8f93f6 !important; }

.custom-switch.custom-switch-color input:checked.bg-success ~ label::before {
  background-color: #7fdd85 !important;
  border-color: #7fdd85 !important; }

.custom-switch.custom-switch-color input:checked.bg-danger ~ label::before {
  background-color: #ef9fc4 !important;
  border-color: #ef9fc4 !important; }

.custom-switch.custom-switch-color input:checked.bg-warning ~ label::before {
  background-color: #fad263 !important;
  border-color: #fad263 !important; }

.custom-switch.custom-switch-color input:checked.bg-dark ~ label::before {
  background-color: #535f6b !important;
  border-color: #535f6b !important; }

.custom-switch.custom-switch-color input:checked.bg-info ~ label::before {
  background-color: #fcbba5 !important;
  border-color: #fcbba5 !important; }

.custom-checkbox.checkbox-icon label i {
  position: absolute;
  top: 6px;
  left: -21px;
  font-size: 10px;
  transform: scale(0);
  transition: all 0.3s ease-in-out; }

.custom-checkbox.checkbox-icon input:checked ~ label i {
  transform: scale(1);
  color: #fff; }

.custom-checkbox.checkbox-icon input:checked ~ label::after {
  display: none; }

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #8f93f6;
  border-color: #8f93f6; }

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #c6c8f7;
  color: #8f93f6; }

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #c6c8f7;
  color: #8f93f6; }

.custom-select:focus {
  box-shadow: none; }

.custom-switch.custom-switch-icon {
  padding-left: 0; }
  .custom-switch.custom-switch-icon label .switch-icon-left {
    position: absolute;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    top: -3px;
    left: 8px;
    right: auto;
    color: #fff; }
    .custom-switch.custom-switch-icon label .switch-icon-left i {
      font-size: 10px; }
  .custom-switch.custom-switch-icon label .switch-icon-right {
    position: absolute;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    top: -3px;
    right: 5px;
    left: auto; }
    .custom-switch.custom-switch-icon label .switch-icon-right i {
      font-size: 10px; }
  .custom-switch.custom-switch-icon .custom-control-label {
    height: 20px;
    width: 42px;
    padding: 0; }
    .custom-switch.custom-switch-icon .custom-control-label::before {
      height: 20px;
      transition: all 0.3s ease-in-out;
      -webkit-user-select: none;
              user-select: none;
      top: 0;
      left: 1px;
      width: 2.75rem; }
    .custom-switch.custom-switch-icon .custom-control-label:after {
      position: absolute;
      top: 1px;
      left: 2px;
      transition: all 0.3s ease-in-out;
      -webkit-user-select: none;
              user-select: none;
      height: 18px;
      width: 18px; }
  .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(1.4rem); }

.custom-switch.custom-switch-text {
  padding-left: 0; }
  .custom-switch.custom-switch-text label .switch-icon-left {
    position: absolute;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    top: -3px;
    left: 8px;
    right: auto;
    color: #fff; }
  .custom-switch.custom-switch-text label .switch-icon-right {
    position: absolute;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    top: -3px;
    right: 5px;
    left: auto; }
  .custom-switch.custom-switch-text label::before {
    color: #000;
    content: attr(data-off-label);
    width: 2.85rem;
    height: 20px;
    padding: 0 4px;
    font-size: 11px;
    line-height: 18px;
    text-align: right; }
  .custom-switch.custom-switch-text label:after {
    position: absolute;
    transition: all 0.3s ease-in-out;
    -webkit-user-select: none;
            user-select: none;
    height: 16px;
    width: 16px; }
  .custom-switch.custom-switch-text .custom-control-label {
    width: 46px; }
    .custom-switch.custom-switch-text .custom-control-label::before {
      height: 20px;
      transition: all 0.3s ease-in-out;
      -webkit-user-select: none;
              user-select: none;
      top: 0;
      left: 1px;
      width: 2.75rem;
      width: 100%; }
    .custom-switch.custom-switch-text .custom-control-label:after {
      position: absolute;
      top: 1px;
      left: 2px;
      transition: all 0.3s ease-in-out;
      -webkit-user-select: none;
              user-select: none;
      height: 18px;
      width: 18px; }
  .custom-switch.custom-switch-text .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(1.6rem); }
  .custom-switch.custom-switch-text input:checked ~ label::before {
    color: #fff;
    content: attr(data-on-label);
    text-align: left; }
  .custom-switch.custom-switch-text input:checked ~ label.custom-control-label::after {
    transform: translateX(1.6rem); }

.custom-switch-inner {
  display: block;
  text-align: center; }

.form-label-group {
  position: relative;
  margin-bottom: 1.5rem; }
  .form-label-group > label {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    transition: all 0.3s ease-in-out;
    padding: .6rem;
    color: #475F7B;
    font-size: .85rem;
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0; }

.counter-value {
  color: #fff;
  padding: 1px 6px;
  font-size: .6rem;
  border-radius: 0 0 8px 8px;
  margin-right: 1rem; }

.vector-map.h-500 {
  width: 100%;
  height: 500px; }

.countdown {
  margin: 60px 0 0;
  padding: 0; }
  .countdown li span {
    font-size: 60px;
    display: inline-block;
    width: 100%;
    color: #8f93f6; }
  .countdown li:last-child {
    margin-right: 0; }

.iq-comingsoon-form {
  position: relative; }
  .iq-comingsoon-form button {
    position: absolute;
    right: 0;
    top: 0;
    padding: 11px 30px; }

.navbar-breadcrumb .breadcrumb {
  margin-bottom: 0px; }

.btn {
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: #535f6b;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 8px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: #535f6b;
    text-decoration: none; }
  .btn:focus, .btn.focus {
    outline: none;
    box-shadow: none; }
  .btn.disabled, .btn:disabled {
    opacity: 0.65;
    box-shadow: none; }
  .btn:not(:disabled):not(.disabled) {
    cursor: pointer; }
    .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
      box-shadow: none; }
      .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
        box-shadow: none; }

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none; }

.btn-primary {
  color: #fff;
  background-color: #8f93f6;
  border-color: #8f93f6;
  box-shadow: unset; }
  .btn-primary:hover {
    color: #fff;
    background-color: #6c71f3;
    border-color: #6065f2; }
  .btn-primary:focus, .btn-primary.focus {
    color: #fff;
    background-color: #6c71f3;
    border-color: #6065f2;
    box-shadow: unset, 0 0 0 0.2rem rgba(160, 163, 247, 0.5); }
  .btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #8f93f6;
    border-color: #8f93f6; }
  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #6065f2;
    border-color: #545af1; }
    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(160, 163, 247, 0.5); }

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  box-shadow: unset; }
  .btn-secondary:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62; }
  .btn-secondary:focus, .btn-secondary.focus {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
    box-shadow: unset, 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }
  .btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #545b62;
    border-color: #4e555b; }
    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-secondary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }

.btn-success {
  color: #fff;
  background-color: #7fdd85;
  border-color: #7fdd85;
  box-shadow: unset; }
  .btn-success:hover {
    color: #fff;
    background-color: #61d568;
    border-color: #57d25f; }
  .btn-success:focus, .btn-success.focus {
    color: #fff;
    background-color: #61d568;
    border-color: #57d25f;
    box-shadow: unset, 0 0 0 0.2rem rgba(146, 226, 151, 0.5); }
  .btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #7fdd85;
    border-color: #7fdd85; }
  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
  .show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #57d25f;
    border-color: #4dd055; }
    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-success.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(146, 226, 151, 0.5); }

.btn-info {
  color: #fff;
  background-color: #fcbba5;
  border-color: #fcbba5;
  box-shadow: unset; }
  .btn-info:hover {
    color: #fff;
    background-color: #fb9f80;
    border-color: #fa9674; }
  .btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #fb9f80;
    border-color: #fa9674;
    box-shadow: unset, 0 0 0 0.2rem rgba(252, 197, 179, 0.5); }
  .btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #fcbba5;
    border-color: #fcbba5; }
  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
  .show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #fa9674;
    border-color: #fa8c67; }
    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-info.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(252, 197, 179, 0.5); }

.btn-warning {
  color: #fff;
  background-color: #fad263;
  border-color: #fad263;
  box-shadow: unset; }
  .btn-warning:hover {
    color: #fff;
    background-color: #f9c73e;
    border-color: #f8c432; }
  .btn-warning:focus, .btn-warning.focus {
    color: #fff;
    background-color: #f9c73e;
    border-color: #f8c432;
    box-shadow: unset, 0 0 0 0.2rem rgba(251, 217, 122, 0.5); }
  .btn-warning.disabled, .btn-warning:disabled {
    color: #fff;
    background-color: #fad263;
    border-color: #fad263; }
  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
  .show > .btn-warning.dropdown-toggle {
    color: #fff;
    background-color: #f8c432;
    border-color: #f8c025; }
    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-warning.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(251, 217, 122, 0.5); }

.btn-danger {
  color: #fff;
  background-color: #ef9fc4;
  border-color: #ef9fc4;
  box-shadow: unset; }
  .btn-danger:hover {
    color: #fff;
    background-color: #ea7eb0;
    border-color: #e873a9; }
  .btn-danger:focus, .btn-danger.focus {
    color: #fff;
    background-color: #ea7eb0;
    border-color: #e873a9;
    box-shadow: unset, 0 0 0 0.2rem rgba(241, 173, 205, 0.5); }
  .btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #ef9fc4;
    border-color: #ef9fc4; }
  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
  .show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #e873a9;
    border-color: #e668a2; }
    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-danger.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(241, 173, 205, 0.5); }

.btn-light {
  color: #212529;
  background-color: #FAFAFA;
  border-color: #FAFAFA;
  box-shadow: unset; }
  .btn-light:hover {
    color: #212529;
    background-color: #e7e7e7;
    border-color: #e1e1e1; }
  .btn-light:focus, .btn-light.focus {
    color: #212529;
    background-color: #e7e7e7;
    border-color: #e1e1e1;
    box-shadow: unset, 0 0 0 0.2rem rgba(217, 218, 219, 0.5); }
  .btn-light.disabled, .btn-light:disabled {
    color: #212529;
    background-color: #FAFAFA;
    border-color: #FAFAFA; }
  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
  .show > .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #e1e1e1;
    border-color: #dadada; }
    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-light.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(217, 218, 219, 0.5); }

.btn-dark {
  color: #fff;
  background-color: #01041b;
  border-color: #01041b;
  box-shadow: unset; }
  .btn-dark:hover {
    color: #fff;
    background-color: black;
    border-color: black; }
  .btn-dark:focus, .btn-dark.focus {
    color: #fff;
    background-color: black;
    border-color: black;
    box-shadow: unset, 0 0 0 0.2rem rgba(39, 42, 61, 0.5); }
  .btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #01041b;
    border-color: #01041b; }
  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
  .show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: black;
    border-color: black; }
    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-dark.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(39, 42, 61, 0.5); }

.btn-orange {
  color: #fff;
  background-color: #fd7e14;
  border-color: #fd7e14;
  box-shadow: unset; }
  .btn-orange:hover {
    color: #fff;
    background-color: #e96b02;
    border-color: #dc6502; }
  .btn-orange:focus, .btn-orange.focus {
    color: #fff;
    background-color: #e96b02;
    border-color: #dc6502;
    box-shadow: unset, 0 0 0 0.2rem rgba(253, 145, 55, 0.5); }
  .btn-orange.disabled, .btn-orange:disabled {
    color: #fff;
    background-color: #fd7e14;
    border-color: #fd7e14; }
  .btn-orange:not(:disabled):not(.disabled):active, .btn-orange:not(:disabled):not(.disabled).active,
  .show > .btn-orange.dropdown-toggle {
    color: #fff;
    background-color: #dc6502;
    border-color: #cf5f02; }
    .btn-orange:not(:disabled):not(.disabled):active:focus, .btn-orange:not(:disabled):not(.disabled).active:focus,
    .show > .btn-orange.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(253, 145, 55, 0.5); }

.btn-purple {
  color: #fff;
  background-color: #4731b6;
  border-color: #4731b6;
  box-shadow: unset; }
  .btn-purple:hover {
    color: #fff;
    background-color: #3b2998;
    border-color: #37268e; }
  .btn-purple:focus, .btn-purple.focus {
    color: #fff;
    background-color: #3b2998;
    border-color: #37268e;
    box-shadow: unset, 0 0 0 0.2rem rgba(99, 80, 193, 0.5); }
  .btn-purple.disabled, .btn-purple:disabled {
    color: #fff;
    background-color: #4731b6;
    border-color: #4731b6; }
  .btn-purple:not(:disabled):not(.disabled):active, .btn-purple:not(:disabled):not(.disabled).active,
  .show > .btn-purple.dropdown-toggle {
    color: #fff;
    background-color: #37268e;
    border-color: #332384; }
    .btn-purple:not(:disabled):not(.disabled):active:focus, .btn-purple:not(:disabled):not(.disabled).active:focus,
    .show > .btn-purple.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 80, 193, 0.5); }

.btn-pink {
  color: #212529;
  background-color: #FFE0E0;
  border-color: #FFE0E0;
  box-shadow: unset; }
  .btn-pink:hover {
    color: #fff;
    background-color: #ffbaba;
    border-color: #ffadad; }
  .btn-pink:focus, .btn-pink.focus {
    color: #fff;
    background-color: #ffbaba;
    border-color: #ffadad;
    box-shadow: unset, 0 0 0 0.2rem rgba(222, 196, 197, 0.5); }
  .btn-pink.disabled, .btn-pink:disabled {
    color: #212529;
    background-color: #FFE0E0;
    border-color: #FFE0E0; }
  .btn-pink:not(:disabled):not(.disabled):active, .btn-pink:not(:disabled):not(.disabled).active,
  .show > .btn-pink.dropdown-toggle {
    color: #fff;
    background-color: #ffadad;
    border-color: #ffa0a0; }
    .btn-pink:not(:disabled):not(.disabled):active:focus, .btn-pink:not(:disabled):not(.disabled).active:focus,
    .show > .btn-pink.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(222, 196, 197, 0.5); }

.btn-outline-primary {
  color: #8f93f6;
  border-color: #8f93f6; }
  .btn-outline-primary:hover {
    color: #fff;
    background-color: #8f93f6;
    border-color: #8f93f6; }
  .btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }
  .btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #8f93f6;
    background-color: transparent; }
  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #8f93f6;
    border-color: #8f93f6; }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-primary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d; }
  .btn-outline-secondary:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
  .btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }
  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent; }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
  .show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d; }
    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-secondary.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }

.btn-outline-success {
  color: #7fdd85;
  border-color: #7fdd85; }
  .btn-outline-success:hover {
    color: #fff;
    background-color: #7fdd85;
    border-color: #7fdd85; }
  .btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }
  .btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #7fdd85;
    background-color: transparent; }
  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
  .show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #7fdd85;
    border-color: #7fdd85; }
    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-success.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }

.btn-outline-info {
  color: #fcbba5;
  border-color: #fcbba5; }
  .btn-outline-info:hover {
    color: #fff;
    background-color: #fcbba5;
    border-color: #fcbba5; }
  .btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }
  .btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #fcbba5;
    background-color: transparent; }
  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
  .show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #fcbba5;
    border-color: #fcbba5; }
    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-info.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }

.btn-outline-warning {
  color: #fad263;
  border-color: #fad263; }
  .btn-outline-warning:hover {
    color: #fff;
    background-color: #fad263;
    border-color: #fad263; }
  .btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }
  .btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #fad263;
    background-color: transparent; }
  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
  .show > .btn-outline-warning.dropdown-toggle {
    color: #fff;
    background-color: #fad263;
    border-color: #fad263; }
    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-warning.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }

.btn-outline-danger {
  color: #ef9fc4;
  border-color: #ef9fc4; }
  .btn-outline-danger:hover {
    color: #fff;
    background-color: #ef9fc4;
    border-color: #ef9fc4; }
  .btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }
  .btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #ef9fc4;
    background-color: transparent; }
  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
  .show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #ef9fc4;
    border-color: #ef9fc4; }
    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-danger.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }

.btn-outline-light {
  color: #FAFAFA;
  border-color: #FAFAFA; }
  .btn-outline-light:hover {
    color: #212529;
    background-color: #FAFAFA;
    border-color: #FAFAFA; }
  .btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }
  .btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #FAFAFA;
    background-color: transparent; }
  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
  .show > .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #FAFAFA;
    border-color: #FAFAFA; }
    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-light.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }

.btn-outline-dark {
  color: #01041b;
  border-color: #01041b; }
  .btn-outline-dark:hover {
    color: #fff;
    background-color: #01041b;
    border-color: #01041b; }
  .btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }
  .btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #01041b;
    background-color: transparent; }
  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
  .show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #01041b;
    border-color: #01041b; }
    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-dark.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }

.btn-outline-orange {
  color: #fd7e14;
  border-color: #fd7e14; }
  .btn-outline-orange:hover {
    color: #fff;
    background-color: #fd7e14;
    border-color: #fd7e14; }
  .btn-outline-orange:focus, .btn-outline-orange.focus {
    box-shadow: 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }
  .btn-outline-orange.disabled, .btn-outline-orange:disabled {
    color: #fd7e14;
    background-color: transparent; }
  .btn-outline-orange:not(:disabled):not(.disabled):active, .btn-outline-orange:not(:disabled):not(.disabled).active,
  .show > .btn-outline-orange.dropdown-toggle {
    color: #fff;
    background-color: #fd7e14;
    border-color: #fd7e14; }
    .btn-outline-orange:not(:disabled):not(.disabled):active:focus, .btn-outline-orange:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-orange.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }

.btn-outline-purple {
  color: #4731b6;
  border-color: #4731b6; }
  .btn-outline-purple:hover {
    color: #fff;
    background-color: #4731b6;
    border-color: #4731b6; }
  .btn-outline-purple:focus, .btn-outline-purple.focus {
    box-shadow: 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }
  .btn-outline-purple.disabled, .btn-outline-purple:disabled {
    color: #4731b6;
    background-color: transparent; }
  .btn-outline-purple:not(:disabled):not(.disabled):active, .btn-outline-purple:not(:disabled):not(.disabled).active,
  .show > .btn-outline-purple.dropdown-toggle {
    color: #fff;
    background-color: #4731b6;
    border-color: #4731b6; }
    .btn-outline-purple:not(:disabled):not(.disabled):active:focus, .btn-outline-purple:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-purple.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }

.btn-outline-pink {
  color: #FFE0E0;
  border-color: #FFE0E0; }
  .btn-outline-pink:hover {
    color: #212529;
    background-color: #FFE0E0;
    border-color: #FFE0E0; }
  .btn-outline-pink:focus, .btn-outline-pink.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }
  .btn-outline-pink.disabled, .btn-outline-pink:disabled {
    color: #FFE0E0;
    background-color: transparent; }
  .btn-outline-pink:not(:disabled):not(.disabled):active, .btn-outline-pink:not(:disabled):not(.disabled).active,
  .show > .btn-outline-pink.dropdown-toggle {
    color: #212529;
    background-color: #FFE0E0;
    border-color: #FFE0E0; }
    .btn-outline-pink:not(:disabled):not(.disabled):active:focus, .btn-outline-pink:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-pink.dropdown-toggle:focus {
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }

.btn-link {
  font-weight: 400;
  color: #8f93f6;
  text-decoration: none; }
  .btn-link:hover {
    color: #484ff0;
    text-decoration: none; }
  .btn-link:focus, .btn-link.focus {
    text-decoration: none; }
  .btn-link:disabled, .btn-link.disabled {
    color: #6c757d;
    pointer-events: none; }

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 8px; }

.btn-block {
  display: block;
  width: 100%; }
  .btn-block + .btn-block {
    margin-top: 0.5rem; }

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%; }

.iq-progress-bar {
  background: #FAFAFA;
  box-shadow: 0 0 0;
  height: 6px;
  margin: 0;
  position: relative;
  width: 100%;
  border-radius: 8px; }
  .iq-progress-bar > span {
    background: #8f93f6 none repeat scroll 0 0;
    position: relative;
    display: block;
    height: 100%;
    width: 0;
    border-radius: 8px; }
  .iq-progress-bar .progress-text {
    position: absolute;
    right: -10px;
    top: -25px;
    font-size: 13px;
    font-weight: 500; }

.iq-progress-bar.iq-progress-bar-icon > span:after {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid transparent;
  position: absolute;
  bottom: -3px;
  right: 0;
  z-index: 1; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-primary:after {
  border-color: #8f93f6; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-danger:after {
  border-color: #ef9fc4; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-success:after {
  border-color: #7fdd85; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-warning:after {
  border-color: #fad263; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-info:after {
  border-color: #fcbba5; }

.iq-progress-bar.iq-progress-bar-icon > span.bg-dark:after {
  border-color: #01041b; }

.progress-round.heatmap-progress {
  height: 97px;
  width: 97px; }
  .progress-round.heatmap-progress .progress-bar {
    border-width: 10px; }
  .progress-round.heatmap-progress::after {
    border: 10px solid #ff9273; }

.progress-round.income-progress .progress-bar {
  border-width: 10px; }

.progress-round.income-progress::after {
  border: 10px solid #ff9273; }

.progress-round.alarams-progress {
  height: 110px;
  width: 110px; }

.iq-progress-bar .progress-text-one {
  position: absolute;
  right: -20px;
  top: -33px;
  font-size: 13px;
  font-weight: 500;
  background: #ef9fc4;
  color: #fff;
  padding: 0px 5px; }

.iq-progress-bar > span.bg-primary .progress-text-one:after {
  border-color: #8f93f6 transparent transparent transparent; }

.iq-progress-bar > span.bg-success .progress-text-one:after {
  border-color: #7fdd85 transparent transparent transparent; }

.iq-progress-bar > span.bg-warning .progress-text-one:after {
  border-color: #fad263 transparent transparent transparent; }

.iq-progress-bar > span.bg-danger .progress-text-one:after {
  border-color: #ef9fc4 transparent transparent transparent; }

.iq-progress-bar > span.bg-dark .progress-text-one:after {
  border-color: #01041b transparent transparent transparent; }

.iq-progress-bar > span.bg-info .progress-text-one:after {
  border-color: #fcbba5 transparent transparent transparent; }

.progress-text-one {
  position: relative; }
  .progress-text-one:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid; }

.iq-circle-progressbar {
  margin: 0 auto;
  width: 100px !important;
  height: 100px !important; }
  .iq-circle-progressbar .percent {
    font-size: 1.3rem !important; }
  .iq-circle-progressbar svg {
    width: 100px !important;
    height: 100px !important; }

.progress-round {
  width: 50px;
  height: 50px;
  background: none;
  position: relative; }
  .progress-round::after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #f1f1f1;
    position: absolute;
    top: 0;
    left: 0; }
  .progress-round > span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1; }
  .progress-round .progress-left {
    left: 0; }
    .progress-round .progress-left .progress-bar {
      left: 100%;
      border-top-right-radius: 80px;
      border-bottom-right-radius: 80px;
      border-left: 0;
      transform-origin: center left; }
  .progress-round .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 3px;
    border-style: solid;
    position: absolute;
    top: 0; }
  .progress-round .progress-right {
    right: 0; }
    .progress-round .progress-right .progress-bar {
      left: -100%;
      border-top-left-radius: 80px;
      border-bottom-left-radius: 80px;
      border-right: 0;
      transform-origin: center right; }
  .progress-round .progress-value {
    position: absolute;
    top: 0;
    left: 0; }

.progress-round.income-progress {
  height: 78px;
  width: 78px; }
  .progress-round.income-progress .progress-bar {
    border-width: 10px; }
  .progress-round.income-progress::after {
    border: 10px solid #ff9273; }

.progress-round.alarams-progress {
  height: 110px;
  width: 110px; }

.progress-round.goal-progress {
  width: 130px;
  height: 130px; }

.progress-round.goal-progress .progress-bar {
  border-width: 10px; }

.progress-round.goal-progress::after {
  border: 10px solid #f4f4f4; }

@keyframes progress-loading-1 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(180deg); } }

@keyframes progress-loading-2 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(80deg); } }

.progress.progress-round {
  width: 60px;
  height: 60px;
  line-height: 60px;
  background: none;
  margin: 0 auto;
  box-shadow: none;
  position: relative; }
  .progress.progress-round > span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1; }
  .progress.progress-round .progress-left {
    left: 0; }
    .progress.progress-round .progress-left .progress-bar {
      left: 100%;
      border-top-right-radius: 80px;
      border-bottom-right-radius: 80px;
      border-left: 0;
      transform-origin: center left;
      animation: progress-loading-2 1.5s linear forwards 1.8s; }
  .progress.progress-round .progress-bar {
    border-width: 5px; }
  .progress.progress-round .progress-right {
    right: 0; }
    .progress.progress-round .progress-right .progress-bar {
      left: -100%;
      border-top-left-radius: 80px;
      border-bottom-left-radius: 80px;
      border-right: 0;
      transform-origin: center right;
      animation: progress-loading-1 1.8s linear forwards; }
  .progress.progress-round:after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 5px solid #FAFAFA;
    position: absolute;
    top: 0;
    left: 0; }
  .progress.progress-round .progress-value {
    font-size: 16px;
    left: 18px; }

.progress.danger .progress-bar {
  border-color: #ef9fc4; }

.progress.warning .progress-bar {
  border-color: #fad263; }

.progress.success .progress-bar {
  border-color: #7fdd85; }

.progress.info .progress-bar {
  border-color: #fcbba5; }

.progress.primary .progress-bar {
  border-color: #8f93f6; }

.fc-unthemed .fc-toolbar .fc-button {
  background: #c6c8f7;
  color: #8f93f6;
  border: none;
  text-transform: capitalize;
  border-radius: 8px; }
  .fc-unthemed .fc-toolbar .fc-button:active {
    color: #fff;
    background-color: #8f93f6; }
  .fc-unthemed .fc-toolbar .fc-button:focus {
    color: #fff;
    background-color: #8f93f6; }

.fc-unthemed .fc-toolbar .fc-button.fc-button-active {
  color: #fff;
  background-color: #8f93f6; }

.job-classification li {
  list-style-type: none;
  margin-bottom: 10px; }
  .job-classification li > i {
    margin-right: 10px;
    border-radius: 50%;
    color: #fff; }

.today-schedule li {
  list-style-type: none;
  margin-bottom: 10px; }
  .today-schedule li i {
    margin-right: 10px;
    border-radius: 50%;
    color: #fff; }

.schedule-text span {
  display: block; }

.calender-small .flatpickr-calendar.animate.inline {
  width: 100%;
  box-shadow: none; }

.calender-small .dayContainer {
  width: 100%;
  min-width: auto; }

.calender-small .flatpickr-days {
  width: 100%; }

.calender-small .flatpickr-day.today {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }
  .calender-small .flatpickr-day.today:hover {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }
  .calender-small .flatpickr-day.today:focus {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }

.calender-small .flatpickr-months {
  margin-bottom: 10px; }
  .calender-small .flatpickr-months .flatpickr-prev-month {
    padding: 7px 10px; }
  .calender-small .flatpickr-months .flatpickr-next-month {
    padding: 7px 10px; }

.calender-small .flatpickr-current-month .flatpickr-monthDropdown-months {
  font-size: 12px; }
  .calender-small .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
    background: transparent;
    color: #8f93f6; }

.calender-small .flatpickr-current-month input.cur-year {
  font-size: 12px; }

.calender-small .numInputWrapper:hover {
  background: transparent; }

.calender-small .flatpickr-day.selected {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }
  .calender-small .flatpickr-day.selected:focus {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }
  .calender-small .flatpickr-day.selected:hover {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }

.calender-small .flatpickr-day.startRange {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }
  .calender-small .flatpickr-day.startRange:focus {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }
  .calender-small .flatpickr-day.startRange:hover {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }

.calender-small .flatpickr-day.endRange {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }
  .calender-small .flatpickr-day.endRange:focus {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }
  .calender-small .flatpickr-day.endRange:hover {
    color: #fff;
    border-color: #8f93f6;
    background: #8f93f6; }

.calender-small .flatpickr-day.selected.inRange {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.startRange.inRange {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.endRange.inRange {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.selected.prevMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.startRange.prevMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.endRange.prevMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.selected.nextMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.startRange.nextMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.endRange.nextMonthDay {
  color: #fff;
  border-color: #8f93f6;
  background: #8f93f6; }

.calender-small .flatpickr-day.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.prevMonthDay.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.nextMonthDay.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.today.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.prevMonthDay.today.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.nextMonthDay.today.inRange {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day:hover {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day:focus {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.prevMonthDay:hover {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.prevMonthDay:focus {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.nextMonthDay:hover {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-day.nextMonthDay:focus {
  background: #c6c8f7;
  color: #8f93f6;
  border-color: transparent; }

.calender-small .flatpickr-current-month .numInputWrapper {
  width: 3ch; }

.smaill-calender-home .flatpickr-calendar.animate.inline {
  margin: 0 auto;
  width: 100%;
  box-shadow: none;
  border: none;
  border-radius: 8px; }

.smaill-calender-home .flatpickr-day.selected {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.selected:focus {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.selected:hover {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.startRange {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.startRange:focus {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.startRange:hover {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.endRange {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.endRange:focus {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }
  .smaill-calender-home .flatpickr-day.endRange:hover {
    color: #fff;
    background: #8f93f6;
    text-decoration: none;
    border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.selected.inRange {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.startRange.inRange {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.endRange.inRange {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.selected.prevMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.startRange.prevMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.endRange.prevMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.selected.nextMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.startRange.nextMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-day.endRange.nextMonthDay {
  color: #fff;
  background: #8f93f6;
  text-decoration: none;
  border-color: #8f93f6; }

.smaill-calender-home .flatpickr-days {
  width: 100%; }

.smaill-calender-home .dayContainer {
  width: 100%; }

.smaill-calender-home .flatpickr-innerContainer {
  justify-content: space-around; }

@media (max-width: 479px) {
  .fc-toolbar.fc-header-toolbar {
    overflow-x: scroll; } }

.page-link {
  border-color: #8f93f6; }

.br-theme-bars-1to10 .br-widget {
  height: 50px;
  white-space: nowrap; }
  .br-theme-bars-1to10 .br-widget a {
    display: block;
    width: 12px;
    padding: 5px 0;
    height: 28px;
    float: left;
    background-color: #ddd;
    margin: 1px;
    text-align: center; }
  .br-theme-bars-1to10 .br-widget a.br-active {
    background-color: #8f93f6; }
  .br-theme-bars-1to10 .br-widget a.br-selected {
    background-color: #8f93f6; }
  .br-theme-bars-1to10 .br-widget .br-current-rating {
    font-size: 20px;
    line-height: 2;
    float: right;
    color: #8f93f6;
    font-weight: 400; }

.br-theme-bars-1to10 .br-readonly a {
  cursor: default; }

.br-theme-bars-1to10 .br-readonly a.br-active {
  background-color: #f2cd95; }

.br-theme-bars-1to10 .br-readonly a.br-selected {
  background-color: #f2cd95; }

.br-theme-bars-1to10 .br-readonly .br-current-rating {
  color: #f2cd95; }

.br-theme-bars-pill .br-widget {
  white-space: nowrap; }
  .br-theme-bars-pill .br-widget a {
    padding: 7px 15px;
    background-color: #ddd;
    color: #535f6b;
    text-decoration: none;
    font-size: 13px;
    line-height: 3;
    text-align: center;
    font-weight: 400; }
    .br-theme-bars-pill .br-widget a:first-child {
      -webkit-border-top-left-radius: 999px;
      -webkit-border-bottom-left-radius: 999px;
      -moz-border-radius-topleft: 999px;
      -moz-border-radius-bottomleft: 999px;
      border-top-left-radius: 999px;
      border-bottom-left-radius: 999px; }
    .br-theme-bars-pill .br-widget a:last-child {
      -webkit-border-top-right-radius: 999px;
      -webkit-border-bottom-right-radius: 999px;
      -moz-border-radius-top-right: 999px;
      -moz-border-radius-bottom-right: 999px;
      border-top-right-radius: 999px !important;
      border-bottom-right-radius: 999px !important; }
  .br-theme-bars-pill .br-widget a.br-active {
    background-color: #8f93f6;
    color: white; }
  .br-theme-bars-pill .br-widget a.br-selected {
    background-color: #8f93f6;
    color: white; }

.br-theme-bars-pill .br-readonly a {
  cursor: default; }

.br-theme-bars-pill .br-readonly a.br-active {
  background-color: #7cead1; }

.br-theme-bars-pill .br-readonly a.br-selected {
  background-color: #7cead1; }

.br-theme-fontawesome-stars .br-widget a {
  margin-right: 8px !important; }
  .br-theme-fontawesome-stars .br-widget a:after {
    font-family: "Font Awesome 5 Free";
    font-weight: 900; }

i.amber-text {
  color: #8f93f6 !important; }

#rateMe1 i {
  font-size: 18px; }

.mdb-rating .rate-popover {
  color: #808080; }

.mdb-rating .live {
  color: #000; }

.mdb-rating .oneStar {
  color: #44370f; }

.mdb-rating .twoStars {
  color: #96781e; }

.mdb-rating .threeStars {
  color: #e2b52e; }

.mdb-rating .fourStars {
  color: #f1ba12; }

.mdb-rating .fiveStars {
  color: #f3cb06; }

.mdb-rating .amber-text {
  color: #ffc107; }

.rating-faces i {
  font-size: 21px; }

.br-theme-bars-movie .br-widget {
  white-space: nowrap; }
  .br-theme-bars-movie .br-widget a {
    display: block;
    width: 60px;
    height: 10px;
    float: left;
    background-color: transparent;
    border: 1px solid #8f93f6;
    margin: 1px; }
  .br-theme-bars-movie .br-widget a.br-active {
    background-color: #8f93f6; }
  .br-theme-bars-movie .br-widget a.br-selected {
    background-color: #8f93f6; }
  .br-theme-bars-movie .br-widget .br-current-rating {
    clear: both;
    width: 240px;
    text-align: center;
    display: block;
    padding-top: .5em;
    color: #8f93f6;
    font-weight: 400; }

.br-theme-bars-movie .br-readonly a {
  cursor: default; }

.br-theme-bars-movie .br-readonly a.br-active {
  background-color: #729bf8; }

.br-theme-bars-movie .br-readonly a.br-selected {
  background-color: #729bf8; }

.br-theme-bars-movie .br-readonly .br-current-rating {
  color: #729bf8; }

.br-theme-fontawesome-stars .br-widget {
  height: 28px;
  white-space: nowrap; }
  .br-theme-fontawesome-stars .br-widget a {
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    text-decoration: none;
    margin-right: 2px; }
    .br-theme-fontawesome-stars .br-widget a:after {
      content: '\\f005';
      color: #d2d2d2; }
  .br-theme-fontawesome-stars .br-widget a.br-active:after {
    color: #edb867; }
  .br-theme-fontawesome-stars .br-widget a.br-selected:after {
    color: #edb867; }
  .br-theme-fontawesome-stars .br-widget .br-current-rating {
    display: none; }

.br-theme-fontawesome-stars .br-readonly a {
  cursor: default; }

/*------------ Basic Tree -------------------------------------*/
/*-------------------- Checkbox Tree ----------------------------*/
.basic-tree li {
  list-style-type: none;
  margin: 0;
  padding: 10px 5px 0 5px;
  position: relative;
  color: #303030; }
  .basic-tree li::before {
    content: '';
    left: -20px;
    position: absolute;
    right: auto;
    border-left: 1px solid #999;
    bottom: 50px;
    height: 100%;
    top: 0;
    width: 1px; }
  .basic-tree li::after {
    content: '';
    left: -20px;
    position: absolute;
    right: auto;
    border-top: 1px solid #999;
    height: 20px;
    top: 25px;
    width: 25px; }
  .basic-tree li:last-child::before {
    height: 30px; }

.basic-tree li.t-parent > span {
  cursor: pointer; }
  .basic-tree li.t-parent > span:hover {
    color: #8f93f6; }

.basic-tree > ul > li::before {
  border: 0; }

.basic-tree > ul > li::after {
  border: 0; }

.flex-tree li {
  position: relative;
  list-style: none;
  margin: 0; }
  .flex-tree li::before {
    content: '';
    position: absolute;
    right: auto;
    border-left: 1px solid #999;
    bottom: 50px;
    height: 100%;
    top: 0;
    width: 1px;
    left: -25px; }
  .flex-tree li::after {
    content: '';
    position: absolute;
    right: auto;
    border-top: 1px solid #999;
    height: 20px;
    width: 25px;
    top: 12px;
    left: -25px; }
  .flex-tree li:last-child::before {
    height: 25px; }
  .flex-tree li label {
    cursor: pointer; }
  .flex-tree li span {
    cursor: pointer; }
    .flex-tree li span label {
      cursor: pointer; }
  .flex-tree li span.open:after {
    content: "\\025BE";
    display: inline-block;
    font: 400 16px/1 Arial, "Helvetica Neue", Helvetica, sans-serif;
    width: 20px;
    margin-top: 4px;
    padding-left: 3px;
    color: #ababab; }
  .flex-tree li span.closed:after {
    content: "\\025BE";
    display: inline-block;
    font: 400 16px/1 Arial, "Helvetica Neue", Helvetica, sans-serif;
    width: 20px;
    margin-top: 4px;
    padding-left: 3px;
    color: #ababab;
    content: "\\025B4"; }

.flex-tree > ul > li::before {
  border: 0; }

.flex-tree > ul > li::after {
  border: 0; }

.flex-tree label {
  font-weight: normal; }

.flex-tree label.node {
  font-weight: bold; }

.flex-tree input[type="checkbox"] {
  border: 1px solid #b4b9be;
  background: #fff;
  color: #555;
  clear: none;
  cursor: pointer;
  display: inline-block;
  line-height: 0;
  height: 16px;
  margin: -4px 4px 0 0;
  outline: 0;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  width: 16px;
  min-width: 16px;
  -webkit-appearance: none;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: 0.05s border-color ease-in-out; }
  .flex-tree input[type="checkbox"]:focus {
    border-color: #5b9dd9;
    box-shadow: 0 0 2px rgba(30, 140, 190, 0.8); }
  .flex-tree input[type="checkbox"]:checked {
    background: #8f93f6;
    border: none; }
    .flex-tree input[type="checkbox"]:checked:before {
      float: left;
      display: inline-block;
      vertical-align: middle;
      width: 16px;
      font: 400 20px/1 Arial, "Helvetica Neue", Helvetica, sans-serif;
      -webkit-font-smoothing: antialiased;
      content: "\\02713";
      color: var(--white);
      margin: 1px 0 0 0;
      font-size: 17px !important; }
  .flex-tree input[type="checkbox"]:indeterminate:before {
    float: left;
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    font: 400 20px/1 Arial, "Helvetica Neue", Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    content: "\\02043";
    color: #8f93f6;
    margin: -4px 0 0 -1px; }

.flex-tree input[type="checkbox"].indeterminate {
  background-color: #eee; }

.ic-square {
  width: 20px;
  height: 20px;
  background: transparent;
  border: 1px solid #535f6b;
  text-align: center;
  line-height: 19px;
  font-size: 12px; }

.tree-box {
  margin: 0; }

.iq-footer {
  padding: 15px;
  margin-left: 260px;
  width: calc(100vw - 264px);
  background: #fff;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A;
  transition: all 0.3s ease-in-out; }
  .iq-footer ul li a {
    color: #535f6b; }
    .iq-footer ul li a:hover {
      color: #8f93f6;
      text-decoration: none; }

body.tab-horizontal .iq-footer {
  margin-left: 0;
  width: 100%; }

.iq-mt--70 {
  margin-top: -70px; }

.banner-main-text {
  position: absolute;
  left: 15%;
  bottom: 13%; }

.nav.nav-pills.style-three {
  margin-top: 10px; }
  .nav.nav-pills.style-three .nav-link.active:before {
    display: inline-block;
    width: 100%;
    height: 3px;
    background: #8f93f6;
    content: "";
    position: absolute;
    left: 0;
    bottom: 0px; }
  .nav.nav-pills.style-three .nav-link:hover:before {
    display: inline-block;
    width: 100%;
    height: 3px;
    background: #8f93f6;
    content: "";
    position: absolute;
    left: 0;
    bottom: 0px; }
  .nav.nav-pills.style-three .nav-link:before {
    width: 0;
    transition: all 0.3s ease-in-out;
    height: 3px;
    background: #8f93f6;
    content: "";
    position: absolute;
    right: 0;
    bottom: 0px; }
  .nav.nav-pills.style-three a {
    background: transparent;
    position: relative;
    margin-right: 30px;
    padding: 10px 0px; }
    .nav.nav-pills.style-three a:last-child {
      margin-right: 0px; }

.iq-card-body.banner-box {
  padding-bottom: 0; }

@media (min-width: 1300px) {
  body.sidebar-main .iq-footer {
    margin-left: 80px;
    width: calc(100vw - 85px); } }

@media (max-width: 1299px) {
  .iq-footer {
    padding: 15px 10px;
    margin-left: 0;
    width: 100%; }
  body.sidebar-main .iq-footer {
    padding: 15px 10px;
    margin-left: 0;
    width: 100%; }
  .without-right-sidebar .iq-footer {
    width: 100%; } }

@media (max-width: 991px) {
  .iq-footer {
    text-align: center !important; }
    .iq-footer .col-lg-6.text-right {
      text-align: center !important; } }

.clear {
  clear: both; }

@media (min-width: 1300px) {
  .iq-menu-horizontal .iq-sidebar-menu li .iq-submenu.iq-submenu-data {
    position: static; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-sidebar-logo {
    display: none !important; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:first-child a {
    padding-left: 0px; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a:hover {
    color: #8f93f6; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li .iq-arrow-right {
    transform: rotate(0deg); }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li ul {
    display: block;
    position: absolute;
    top: 100%;
    padding: 10px 0px;
    min-width: 200px;
    background: #fff;
    z-index: 9;
    transition: all 0.3s ease-in-out;
    display: none;
    animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    transform: translateY(100%);
    border-radius: 8px;
    -ms-box-shadow: 0px 16px 40px 0px #0000000A;
    -o-box-shadow: 0px 16px 40px 0px #0000000A;
    box-shadow: 0px 16px 40px 0px #0000000A; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu .iq-submenu li a {
    padding: 12px 13px 12px 15px; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li:hover > a {
    color: #8f93f6; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li.menu-open .iq-arrow-right {
    transform: rotate(90deg); }
  .iq-menu-horizontal .iq-sidebar-menu li:hover > .iq-submenu {
    display: block;
    transition: all 0.3s ease-in-out; }
  .iq-menu-horizontal .iq-sidebar-menu li:hover > .iq-submenu.iq-submenu-data {
    -webkit-opacity: 1;
    -moz-opacity: 1;
    -ms-opacity: 1;
    -o-opacity: 1;
    opacity: 1;
    transition: all 0.3s ease-in-out; }
  .iq-menu-horizontal .iq-sidebar-menu li > .iq-submenu.iq-submenu-data {
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    visibility: visible;
    left: 100%;
    top: 0;
    transform-origin: left center 0; }
  .iq-menu-horizontal .iq-sidebar-menu li > .iq-submenu .iq-arrow-right {
    margin-right: 0px; }
  .iq-menu-horizontal .sub-scrll {
    max-height: 315px;
    overflow-y: scroll;
    overflow-x: hidden; }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:hover .iq-arrow-right {
    transform: rotate(90deg); }
  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:hover li .iq-arrow-right {
    transform: rotate(0deg); } }

@media (max-width: 1299px) {
  .iq-menu-horizontal {
    position: fixed;
    left: 0;
    right: 0;
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0;
    top: 0;
    width: 0;
    background: #fff;
    height: 100vh;
    z-index: 9;
    overflow-y: scroll;
    overflow-x: hidden;
    transition: all 0.3s ease-in-out; }
    .iq-menu-horizontal ul.iq-menu {
      display: block !important;
      background: #fff; }
    .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a {
      padding: 15px 20px 15px 30px; }
      .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a:hover {
        color: #8f93f6; }
    .iq-menu-horizontal .iq-sidebar-menu .iq-menu li ul {
      position: static;
      box-shadow: none; }
  .iq-menu-horizontal ul.iq-menu li a[aria-expanded=true] .iq-arrow-right {
    transform: rotate(90deg); }
  .sidebar-main .iq-menu-horizontal {
    -webkit-opacity: 1;
    -moz-opacity: 1;
    -ms-opacity: 1;
    -o-opacity: 1;
    opacity: 1;
    width: 260px;
    transition: all 0.3s ease-in-out; } }

.tab-container .nav-pills .nav-item a {
  padding: 20px 10px;
  font-size: 14px;
  color: #fff;
  border-radius: 8px;
  margin-bottom: 0;
  margin-left: 1px; }

.tab-container .nav-pills .nav-item a.nav-link.active {
  color: #fff;
  background: #6c71e3; }

.tab-container .nav-pills .nav-item:hover a {
  color: #fff; }

.tab-details .tab-pane.fade {
  display: none; }

.tab-details .tab-pane.fade.active.show {
  display: block; }

.tab-scrollbar-data {
  width: 270px;
  height: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  background: #fff;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A;
  transition: all 0.3s ease-in-out;
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  flex-direction: column;
  -moz-flex-direction: column; }

.tab-scrollbar-data.tab-sidebar-close {
  right: -270px; }

a.iq-tab-toggle {
  height: 40px;
  width: 40px;
  line-height: 35px;
  font-size: 18px;
  color: #fff;
  padding: 2px 12px;
  padding-right: 10px;
  display: block !important;
  background: #8f93f6;
  -ms-box-shadow: 0px 16px 40px 0px #0000000A;
  -o-box-shadow: 0px 16px 40px 0px #0000000A;
  box-shadow: 0px 16px 40px 0px #0000000A;
  position: absolute;
  border-radius: 8px 0 0 8px;
  top: 50%;
  left: -40px; }
  a.iq-tab-toggle .aerrow-icon-right {
    display: none; }
  a.iq-tab-toggle .arr-next {
    position: relative;
    transition: all 0.3s ease-in-out; }
    a.iq-tab-toggle .arr-next:before {
      content: '\\f053';
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      position: absolute;
      left: 0;
      top: 0;
      color: #fff;
      transform: rotate(0deg);
      animation-name: bounceArrowLeft;
      animation-duration: 1.4s;
      animation-iteration-count: infinite;
      animation-timing-function: linear; }
  a.iq-tab-toggle .arr-next.arr-two:before {
    left: 10px;
    animation-delay: 0.2s; }

a.iq-tab-toggle.active .aerrow-icon-left {
  display: none; }

a.iq-tab-toggle.active .aerrow-icon-right {
  display: inline-block; }

a.iq-tab-toggle.active .arr-next:before {
  transform: rotate(180deg);
  animation-name: bounceArrow; }

.tab-scrollbar-data .setting-info .setting-title {
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 10px;
  margin-top: 25px; }
  .tab-scrollbar-data .setting-info .setting-title:first-child {
    margin-top: 0px; }
  .tab-scrollbar-data .setting-info .setting-title h5 i {
    font-size: 20px; }

.tab-scrollbar-data .setting-info .set-swtich {
  margin-top: 15px; }
  .tab-scrollbar-data .setting-info .set-swtich h6 {
    font-weight: 400; }
  .tab-scrollbar-data .setting-info .set-swtich .custom-control-input:focus ~ .custom-control-label:before {
    box-shadow: none; }

@keyframes bounceArrow {
  0% {
    opacity: 1;
    transform: translateX(0px) scale(1) rotate(-180deg); }
  25% {
    opacity: 0;
    transform: translateX(10px) scale(0.9) rotate(-180deg); }
  26% {
    opacity: 0;
    transform: translateX(-10px) scale(0.9) rotate(-180deg); }
  55% {
    opacity: 1;
    transform: translateX(0px) scale(1) rotate(-180deg); } }

@keyframes bounceArrowLeft {
  0% {
    opacity: 1;
    transform: translateX(10px) scale(0.9) rotate(0deg); }
  25% {
    opacity: 0;
    transform: translateX(0px) scale(1) rotate(0deg); }
  26% {
    opacity: 0;
    transform: translateX(0px) scale(1) rotate(0deg); }
  55% {
    opacity: 1;
    transform: translateX(-10px) scale(0.9) rotate(0deg); } }

/*
 * Background color 
 */
.bg-blue {
  color: #fff !important;
  background-color: #8f93f6 !important; }

a.bg-blue:hover, a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  color: #fff !important;
  background-color: #6065f2 !important; }

.bg-indigo {
  color: #fff !important;
  background-color: #6610f2 !important; }

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  color: #fff !important;
  background-color: #510bc4 !important; }

.bg-purple {
  color: #fff !important;
  background-color: #4731b6 !important; }

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  color: #fff !important;
  background-color: #37268e !important; }

.bg-pink {
  color: #212529 !important;
  background-color: #FFE0E0 !important; }

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  color: #fff !important;
  background-color: #ffadad !important; }

.bg-red {
  color: #fff !important;
  background-color: #ef9fc4 !important; }

a.bg-red:hover, a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  color: #fff !important;
  background-color: #e873a9 !important; }

.bg-orange {
  color: #fff !important;
  background-color: #fd7e14 !important; }

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  color: #fff !important;
  background-color: #dc6502 !important; }

.bg-yellow {
  color: #fff !important;
  background-color: #fad263 !important; }

a.bg-yellow:hover, a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  color: #fff !important;
  background-color: #f8c432 !important; }

.bg-green {
  color: #fff !important;
  background-color: #7fdd85 !important; }

a.bg-green:hover, a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  color: #fff !important;
  background-color: #57d25f !important; }

.bg-teal {
  color: #fff !important;
  background-color: #20c997 !important; }

a.bg-teal:hover, a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  color: #fff !important;
  background-color: #199d76 !important; }

.bg-cyan {
  color: #fff !important;
  background-color: #fcbba5 !important; }

a.bg-cyan:hover, a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  color: #fff !important;
  background-color: #fa9674 !important; }

.bg-white {
  color: #212529 !important;
  background-color: #fff !important; }

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  color: #fff !important;
  background-color: #e6e6e6 !important; }

.bg-gray {
  color: #fff !important;
  background-color: #6c757d !important; }

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  color: #fff !important;
  background-color: #545b62 !important; }

.bg-gray-dark {
  color: #fff !important;
  background-color: #01041b !important; }

a.bg-gray-dark:hover, a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  color: #fff !important;
  background-color: black !important; }

.bg-gradient-blue {
  background: #8f93f6 linear-gradient(180deg, #9fa3f7, #8f93f6) repeat-x !important; }

.bg-gradient-indigo {
  background: #6610f2 linear-gradient(180deg, #7c33f4, #6610f2) repeat-x !important; }

.bg-gradient-purple {
  background: #4731b6 linear-gradient(180deg, #624fc1, #4731b6) repeat-x !important; }

.bg-gradient-pink {
  background: #FFE0E0 linear-gradient(180deg, #fee4e5, #FFE0E0) repeat-x !important; }

.bg-gradient-red {
  background: #ef9fc4 linear-gradient(180deg, #f1adcd, #ef9fc4) repeat-x !important; }

.bg-gradient-orange {
  background: #fd7e14 linear-gradient(180deg, #fd9137, #fd7e14) repeat-x !important; }

.bg-gradient-yellow {
  background: #fad263 linear-gradient(180deg, #fad87a, #fad263) repeat-x !important; }

.bg-gradient-green {
  background: #7fdd85 linear-gradient(180deg, #91e297, #7fdd85) repeat-x !important; }

.bg-gradient-teal {
  background: #20c997 linear-gradient(180deg, #41d1a6, #20c997) repeat-x !important; }

.bg-gradient-cyan {
  background: #fcbba5 linear-gradient(180deg, #fcc5b2, #fcbba5) repeat-x !important; }

.bg-gradient-white {
  background: #fff linear-gradient(180deg, #fefeff, #fff) repeat-x !important; }

.bg-gradient-gray {
  background: #6c757d linear-gradient(180deg, #818990, #6c757d) repeat-x !important; }

.bg-gradient-gray-dark {
  background: #01041b linear-gradient(180deg, #26293d, #01041b) repeat-x !important; }

.bg-gradient-primary {
  background: #8f93f6 linear-gradient(180deg, #9fa3f7, #8f93f6) repeat-x !important; }

.bg-gradient-secondary {
  background: #6c757d linear-gradient(180deg, #818990, #6c757d) repeat-x !important; }

.bg-gradient-success {
  background: #7fdd85 linear-gradient(180deg, #91e297, #7fdd85) repeat-x !important; }

.bg-gradient-info {
  background: #fcbba5 linear-gradient(180deg, #fcc5b2, #fcbba5) repeat-x !important; }

.bg-gradient-warning {
  background: #fad263 linear-gradient(180deg, #fad87a, #fad263) repeat-x !important; }

.bg-gradient-danger {
  background: #ef9fc4 linear-gradient(180deg, #f1adcd, #ef9fc4) repeat-x !important; }

.bg-gradient-light {
  background: #FAFAFA linear-gradient(180deg, #fafafb, #FAFAFA) repeat-x !important; }

.bg-gradient-dark {
  background: #01041b linear-gradient(180deg, #26293d, #01041b) repeat-x !important; }

.bg-gradient-orange {
  background: #fd7e14 linear-gradient(180deg, #fd9137, #fd7e14) repeat-x !important; }

.bg-gradient-purple {
  background: #4731b6 linear-gradient(180deg, #624fc1, #4731b6) repeat-x !important; }

.bg-gradient-pink {
  background: #FFE0E0 linear-gradient(180deg, #fee4e5, #FFE0E0) repeat-x !important; }

.bg-primary {
  color: #fff !important;
  background-color: #8f93f6 !important; }

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  color: #fff !important;
  background-color: #6065f2 !important; }

.badge-primary {
  color: #fff !important;
  background-color: #8f93f6 !important; }

a.badge-primary:hover, a.badge-primary:focus,
button.badge-primary:hover,
button.badge-primary:focus {
  color: #fff !important;
  background-color: #6065f2 !important; }

.bg-secondary {
  color: #fff !important;
  background-color: #6c757d !important; }

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  color: #fff !important;
  background-color: #545b62 !important; }

.badge-secondary {
  color: #fff !important;
  background-color: #6c757d !important; }

a.badge-secondary:hover, a.badge-secondary:focus,
button.badge-secondary:hover,
button.badge-secondary:focus {
  color: #fff !important;
  background-color: #545b62 !important; }

.bg-success {
  color: #fff !important;
  background-color: #7fdd85 !important; }

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  color: #fff !important;
  background-color: #57d25f !important; }

.badge-success {
  color: #fff !important;
  background-color: #7fdd85 !important; }

a.badge-success:hover, a.badge-success:focus,
button.badge-success:hover,
button.badge-success:focus {
  color: #fff !important;
  background-color: #57d25f !important; }

.bg-info {
  color: #fff !important;
  background-color: #fcbba5 !important; }

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  color: #fff !important;
  background-color: #fa9674 !important; }

.badge-info {
  color: #fff !important;
  background-color: #fcbba5 !important; }

a.badge-info:hover, a.badge-info:focus,
button.badge-info:hover,
button.badge-info:focus {
  color: #fff !important;
  background-color: #fa9674 !important; }

.bg-warning {
  color: #fff !important;
  background-color: #fad263 !important; }

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  color: #fff !important;
  background-color: #f8c432 !important; }

.badge-warning {
  color: #fff !important;
  background-color: #fad263 !important; }

a.badge-warning:hover, a.badge-warning:focus,
button.badge-warning:hover,
button.badge-warning:focus {
  color: #fff !important;
  background-color: #f8c432 !important; }

.bg-danger {
  color: #fff !important;
  background-color: #ef9fc4 !important; }

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  color: #fff !important;
  background-color: #e873a9 !important; }

.badge-danger {
  color: #fff !important;
  background-color: #ef9fc4 !important; }

a.badge-danger:hover, a.badge-danger:focus,
button.badge-danger:hover,
button.badge-danger:focus {
  color: #fff !important;
  background-color: #e873a9 !important; }

.bg-light {
  color: #212529 !important;
  background-color: #FAFAFA !important; }

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  color: #fff !important;
  background-color: #e1e1e1 !important; }

.badge-light {
  color: #212529 !important;
  background-color: #FAFAFA !important; }

a.badge-light:hover, a.badge-light:focus,
button.badge-light:hover,
button.badge-light:focus {
  color: #fff !important;
  background-color: #e1e1e1 !important; }

.bg-dark {
  color: #fff !important;
  background-color: #01041b !important; }

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  color: #fff !important;
  background-color: black !important; }

.badge-dark {
  color: #fff !important;
  background-color: #01041b !important; }

a.badge-dark:hover, a.badge-dark:focus,
button.badge-dark:hover,
button.badge-dark:focus {
  color: #fff !important;
  background-color: black !important; }

.bg-orange {
  color: #fff !important;
  background-color: #fd7e14 !important; }

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  color: #fff !important;
  background-color: #dc6502 !important; }

.badge-orange {
  color: #fff !important;
  background-color: #fd7e14 !important; }

a.badge-orange:hover, a.badge-orange:focus,
button.badge-orange:hover,
button.badge-orange:focus {
  color: #fff !important;
  background-color: #dc6502 !important; }

.bg-purple {
  color: #fff !important;
  background-color: #4731b6 !important; }

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  color: #fff !important;
  background-color: #37268e !important; }

.badge-purple {
  color: #fff !important;
  background-color: #4731b6 !important; }

a.badge-purple:hover, a.badge-purple:focus,
button.badge-purple:hover,
button.badge-purple:focus {
  color: #fff !important;
  background-color: #37268e !important; }

.bg-pink {
  color: #212529 !important;
  background-color: #FFE0E0 !important; }

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  color: #fff !important;
  background-color: #ffadad !important; }

.badge-pink {
  color: #212529 !important;
  background-color: #FFE0E0 !important; }

a.badge-pink:hover, a.badge-pink:focus,
button.badge-pink:hover,
button.badge-pink:focus {
  color: #fff !important;
  background-color: #ffadad !important; }

.bg-primary-light {
  color: #171da7 !important;
  background-color: #c6c8f7 !important; }

a.bg-primary-light:hover, a.bg-primary-light:focus,
button.bg-primary-light:hover,
button.bg-primary-light:focus {
  color: #171da7 !important;
  background-color: #999df1 !important; }

.bg-secondary-light {
  color: #4b4e54 !important;
  background-color: #ccced2 !important; }

a.bg-secondary-light:hover, a.bg-secondary-light:focus,
button.bg-secondary-light:hover,
button.bg-secondary-light:focus {
  color: #4b4e54 !important;
  background-color: #b1b4ba !important; }

.bg-success-light {
  color: #2d6c32 !important;
  background-color: #b7e1ba !important; }

a.bg-success-light:hover, a.bg-success-light:focus,
button.bg-success-light:hover,
button.bg-success-light:focus {
  color: #2d6c32 !important;
  background-color: #93d298 !important; }

.bg-info-light {
  color: #de3600 !important;
  background-color: #ffe6de !important; }

a.bg-info-light:hover, a.bg-info-light:focus,
button.bg-info-light:hover,
button.bg-info-light:focus {
  color: #de3600 !important;
  background-color: #ffbfab !important; }

.bg-warning-light {
  color: #df5400 !important;
  background-color: #ffebdf !important; }

a.bg-warning-light:hover, a.bg-warning-light:focus,
button.bg-warning-light:hover,
button.bg-warning-light:focus {
  color: #df5400 !important;
  background-color: #ffcbac !important; }

.bg-danger-light {
  color: #da0064 !important;
  background-color: #ffdaeb !important; }

a.bg-danger-light:hover, a.bg-danger-light:focus,
button.bg-danger-light:hover,
button.bg-danger-light:focus {
  color: #da0064 !important;
  background-color: #ffa7cf !important; }

.bg-light-light {
  color: #7b7b7b !important;
  background-color: #FAFAFA !important; }

a.bg-light-light:hover, a.bg-light-light:focus,
button.bg-light-light:hover,
button.bg-light-light:focus {
  color: #7b7b7b !important;
  background-color: #e1e1e1 !important; }

.bg-dark-light {
  color: rgba(68, 74, 87, 0.1) !important;
  background-color: rgba(199, 203, 211, 0.1) !important; }

a.bg-dark-light:hover, a.bg-dark-light:focus,
button.bg-dark-light:hover,
button.bg-dark-light:focus {
  color: rgba(68, 74, 87, 0.1) !important;
  background-color: rgba(170, 176, 189, 0.1) !important; }

.bg-orange-light {
  color: #d81600 !important;
  background-color: #ffdcd8 !important; }

a.bg-orange-light:hover, a.bg-orange-light:focus,
button.bg-orange-light:hover,
button.bg-orange-light:focus {
  color: #d81600 !important;
  background-color: #ffaea5 !important; }

.bg-purple-light {
  color: #2200c0 !important;
  background-color: #cbc0ff !important; }

a.bg-purple-light:hover, a.bg-purple-light:focus,
button.bg-purple-light:hover,
button.bg-purple-light:focus {
  color: #2200c0 !important;
  background-color: #a18dff !important; }

.bg-pink-light {
  color: #f10000 !important;
  background-color: #fff1f1 !important; }

a.bg-pink-light:hover, a.bg-pink-light:focus,
button.bg-pink-light:hover,
button.bg-pink-light:focus {
  color: #f10000 !important;
  background-color: #ffbebe !important; }

/*** Sections backgrounds ***/
/*** Background colors with transparency ***/
.avatar-30 {
  height: 30px;
  width: 30px;
  line-height: 30px;
  min-width: 30px; }

.avatar-35 {
  height: 35px;
  width: 35px;
  line-height: 35px;
  min-width: 35px; }

.avatar-40 {
  height: 40px;
  width: 40px;
  line-height: 40px;
  min-width: 40px; }

.avatar-45 {
  height: 45px;
  width: 45px;
  line-height: 45px;
  min-width: 45px; }

.avatar-50 {
  height: 50px;
  width: 50px;
  line-height: 50px;
  min-width: 50px; }

.avatar-60 {
  height: 60px;
  width: 60px;
  line-height: 60px;
  min-width: 60px; }

.avatar-70 {
  height: 70px;
  width: 70px;
  line-height: 70px;
  min-width: 70px; }

.avatar-80 {
  height: 80px;
  width: 80px;
  line-height: 80px;
  min-width: 80px; }

.avatar-90 {
  height: 90px;
  width: 90px;
  line-height: 90px;
  min-width: 90px; }

.avatar-100 {
  height: 100px;
  width: 100px;
  line-height: 100px;
  min-width: 100px; }

.avatar-110 {
  height: 110px;
  width: 110px;
  line-height: 110px;
  min-width: 110px; }

.avatar-120 {
  height: 120px;
  width: 120px;
  line-height: 120px;
  min-width: 120px; }

.avatar-130 {
  height: 130px;
  width: 130px;
  line-height: 130px;
  min-width: 130px; }

.avatar-155 {
  height: 155px;
  width: 155px;
  line-height: 155px;
  min-width: 155px; }

.avatar-235 {
  height: 235px;
  width: 235px;
  line-height: 235px;
  min-width: 235px; }

/*
 * Font Helper
 */
.font-size-12 {
  font-size: 12px !important; }

.font-size-14 {
  font-size: 14px !important; }

.font-size-16 {
  font-size: 16px !important; }

.font-size-18 {
  font-size: 18px !important; }

.font-size-20 {
  font-size: 20px !important; }

.font-size-32 {
  font-size: 32px !important; }

.font-size-40 {
  font-size: 40px !important; }

/*** Weight and italics ***/
.font-weight-300 {
  font-weight: 300 !important; }

.font-weight-400 {
  font-weight: 400 !important; }

.font-weight-500 {
  font-weight: 500 !important; }

.font-weight-600 {
  font-weight: 600 !important; }

.font-weight-700 {
  font-weight: 700 !important; }

.font-weight-800 {
  font-weight: 800 !important; }

.font-weight-900 {
  font-weight: 900 !important; }

/*** Text decorations ***/
.text-underline {
  text-decoration: underline; }

.text-through {
  text-decoration: line-through; }

/*** Text size ***/
.text-sm {
  font-size: 12 !important; }

.text-lg {
  font-size: 12 !important; }

.text-xl {
  font-size: 12 !important; }

/*** Line heights ***/
.line-height-100 {
  line-height: 1; }

.line-height-110 {
  line-height: 1.1; }

.line-height-120 {
  line-height: 1.2; }

.line-height-130 {
  line-height: 1.3; }

.line-height-140 {
  line-height: 1.4; }

.line-height-150 {
  line-height: 1.5; }

.line-height-160 {
  line-height: 1.6; }

.line-height-170 {
  line-height: 1.7; }

.line-height-180 {
  line-height: 1.8; }

/*** Letter spacings ***/
.letter-spacing-1 {
  letter-spacing: .0625rem; }

.letter-spacing-15 {
  letter-spacing: .09375rem; }

.letter-spacing-2 {
  letter-spacing: 0.125rem; }

/*** Text color variations ***/
.text-blue {
  color: #8f93f6 !important; }

a.text-blue:hover, a.text-blue:focus {
  color: #484ff0 !important; }

.text-indigo {
  color: #6610f2 !important; }

a.text-indigo:hover, a.text-indigo:focus {
  color: #4709ac !important; }

.text-purple {
  color: #4731b6 !important; }

a.text-purple:hover, a.text-purple:focus {
  color: #2f217a !important; }

.text-pink {
  color: #FFE0E0 !important; }

a.text-pink:hover, a.text-pink:focus {
  color: #ff9494 !important; }

.text-red {
  color: #ef9fc4 !important; }

a.text-red:hover, a.text-red:focus {
  color: #e45d9c !important; }

.text-orange {
  color: #fd7e14 !important; }

a.text-orange:hover, a.text-orange:focus {
  color: #c35a02 !important; }

.text-yellow {
  color: #fad263 !important; }

a.text-yellow:hover, a.text-yellow:focus {
  color: #f8bd19 !important; }

.text-green {
  color: #7fdd85 !important; }

a.text-green:hover, a.text-green:focus {
  color: #43cd4b !important; }

.text-teal {
  color: #20c997 !important; }

a.text-teal:hover, a.text-teal:focus {
  color: #158765 !important; }

.text-cyan {
  color: #fcbba5 !important; }

a.text-cyan:hover, a.text-cyan:focus {
  color: #fa835b !important; }

.text-white {
  color: #fff !important; }

a.text-white:hover, a.text-white:focus {
  color: #d9d9d9 !important; }

.text-gray {
  color: #6c757d !important; }

a.text-gray:hover, a.text-gray:focus {
  color: #494f54 !important; }

.text-gray-dark {
  color: #01041b !important; }

a.text-gray-dark:hover, a.text-gray-dark:focus {
  color: black !important; }

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license

Copyright (c) 2013 Daniel Eden

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both; }

.animated.hinge {
  animation-duration: 2s; }

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0); }
  40% {
    transform: translateY(-30px); }
  60% {
    transform: translateY(-15px); } }

.bounce {
  animation-name: bounce; }

@keyframes flash {
  0%, 50%, 100% {
    opacity: 1; }
  25%, 75% {
    opacity: 0; } }

.flash {
  animation-name: flash; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@keyframes pulse {
  0% {
    transform: scale(1); }
  50% {
    transform: scale(1.1); }
  100% {
    transform: scale(1); } }

.pulse {
  animation-name: pulse; }

@keyframes shake {
  0%, 100% {
    transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-10px); }
  20%, 40%, 60%, 80% {
    transform: translateX(10px); } }

.shake {
  animation-name: shake; }

@keyframes swing {
  20% {
    transform: rotate(15deg); }
  40% {
    transform: rotate(-10deg); }
  60% {
    transform: rotate(5deg); }
  80% {
    transform: rotate(-5deg); }
  100% {
    transform: rotate(0deg); } }

.swing {
  transform-origin: top center;
  animation-name: swing; }

@keyframes tada {
  0% {
    transform: scale(1); }
  10%, 20% {
    transform: scale(0.9) rotate(-3deg); }
  30%, 50%, 70%, 90% {
    transform: scale(1.1) rotate(3deg); }
  40%, 60%, 80% {
    transform: scale(1.1) rotate(-3deg); }
  100% {
    transform: scale(1) rotate(0); } }

.tada {
  animation-name: tada; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@keyframes wobble {
  0% {
    transform: translateX(0%); }
  15% {
    transform: translateX(-25%) rotate(-5deg); }
  30% {
    transform: translateX(20%) rotate(3deg); }
  45% {
    transform: translateX(-15%) rotate(-3deg); }
  60% {
    transform: translateX(10%) rotate(2deg); }
  75% {
    transform: translateX(-5%) rotate(-1deg); }
  100% {
    transform: translateX(0%); } }

.wobble {
  animation-name: wobble; }

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3); }
  50% {
    opacity: 1;
    transform: scale(1.05); }
  70% {
    transform: scale(0.9); }
  100% {
    transform: scale(1); } }

.bounceIn {
  animation-name: bounceIn; }

@keyframes bounceInDown {
  0% {
    opacity: 0;
    transform: translateY(-2000px); }
  60% {
    opacity: 1;
    transform: translateY(30px); }
  80% {
    transform: translateY(-10px); }
  100% {
    transform: translateY(0); } }

.bounceInDown {
  animation-name: bounceInDown; }

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translateX(-2000px); }
  60% {
    opacity: 1;
    transform: translateX(30px); }
  80% {
    transform: translateX(-10px); }
  100% {
    transform: translateX(0); } }

.bounceInLeft {
  animation-name: bounceInLeft; }

@keyframes bounceInRight {
  0% {
    opacity: 0;
    transform: translateX(2000px); }
  60% {
    opacity: 1;
    transform: translateX(-30px); }
  80% {
    transform: translateX(10px); }
  100% {
    transform: translateX(0); } }

.bounceInRight {
  animation-name: bounceInRight; }

@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(2000px); }
  60% {
    opacity: 1;
    transform: translateY(-30px); }
  80% {
    transform: translateY(10px); }
  100% {
    transform: translateY(0); } }

.bounceInUp {
  animation-name: bounceInUp; }

@keyframes bounceOut {
  0% {
    transform: scale(1); }
  25% {
    transform: scale(0.95); }
  50% {
    opacity: 1;
    transform: scale(1.1); }
  100% {
    opacity: 0;
    transform: scale(0.3); } }

.bounceOut {
  animation-name: bounceOut; }

@keyframes bounceOutDown {
  0% {
    transform: translateY(0); }
  20% {
    opacity: 1;
    transform: translateY(-20px); }
  100% {
    opacity: 0;
    transform: translateY(2000px); } }

.bounceOutDown {
  animation-name: bounceOutDown; }

@keyframes bounceOutLeft {
  0% {
    transform: translateX(0); }
  20% {
    opacity: 1;
    transform: translateX(20px); }
  100% {
    opacity: 0;
    transform: translateX(-2000px); } }

.bounceOutLeft {
  animation-name: bounceOutLeft; }

@keyframes bounceOutRight {
  0% {
    transform: translateX(0); }
  20% {
    opacity: 1;
    transform: translateX(-20px); }
  100% {
    opacity: 0;
    transform: translateX(2000px); } }

.bounceOutRight {
  animation-name: bounceOutRight; }

@keyframes bounceOutUp {
  0% {
    transform: translateY(0); }
  20% {
    opacity: 1;
    transform: translateY(20px); }
  100% {
    opacity: 0;
    transform: translateY(-2000px); } }

.bounceOutUp {
  animation-name: bounceOutUp; }

@keyframes fadeIn {
  0% {
    opacity: 0; }
  100% {
    opacity: 1; } }

.fadeIn {
  animation-name: fadeIn; }

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px); }
  100% {
    opacity: 1;
    transform: translateY(0); } }

.fadeInDown {
  animation-name: fadeInDown; }

@keyframes fadeInDownBig {
  0% {
    opacity: 0;
    transform: translateY(-2000px); }
  100% {
    opacity: 1;
    transform: translateY(0); } }

.fadeInDownBig {
  animation-name: fadeInDownBig; }

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-20px); }
  100% {
    opacity: 1;
    transform: translateX(0); } }

.fadeInLeft {
  animation-name: fadeInLeft; }

@keyframes fadeInLeftBig {
  0% {
    opacity: 0;
    transform: translateX(-2000px); }
  100% {
    opacity: 1;
    transform: translateX(0); } }

.fadeInLeftBig {
  animation-name: fadeInLeftBig; }

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(20px); }
  100% {
    opacity: 1;
    transform: translateX(0); } }

.fadeInRight {
  animation-name: fadeInRight; }

@keyframes fadeInRightBig {
  0% {
    opacity: 0;
    transform: translateX(2000px); }
  100% {
    opacity: 1;
    transform: translateX(0); } }

.fadeInRightBig {
  animation-name: fadeInRightBig; }

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px); }
  100% {
    opacity: 1;
    transform: translateY(0); } }

.fadeInUp {
  animation-name: fadeInUp; }

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    transform: translateY(2000px); }
  100% {
    opacity: 1;
    transform: translateY(0); } }

.fadeInUpBig {
  animation-name: fadeInUpBig; }

@keyframes fadeOut {
  0% {
    opacity: 1; }
  100% {
    opacity: 0; } }

.fadeOut {
  animation-name: fadeOut; }

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0); }
  100% {
    opacity: 0;
    transform: translateY(20px); } }

.fadeOutDown {
  animation-name: fadeOutDown; }

@keyframes fadeOutDownBig {
  0% {
    opacity: 1;
    transform: translateY(0); }
  100% {
    opacity: 0;
    transform: translateY(2000px); } }

.fadeOutDownBig {
  animation-name: fadeOutDownBig; }

@keyframes fadeOutLeft {
  0% {
    opacity: 1;
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(-20px); } }

.fadeOutLeft {
  animation-name: fadeOutLeft; }

@keyframes fadeOutLeftBig {
  0% {
    opacity: 1;
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(-2000px); } }

.fadeOutLeftBig {
  animation-name: fadeOutLeftBig; }

@keyframes fadeOutRight {
  0% {
    opacity: 1;
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(20px); } }

.fadeOutRight {
  animation-name: fadeOutRight; }

@keyframes fadeOutRightBig {
  0% {
    opacity: 1;
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(2000px); } }

.fadeOutRightBig {
  animation-name: fadeOutRightBig; }

@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translateY(0); }
  100% {
    opacity: 0;
    transform: translateY(-20px); } }

.fadeOutUp {
  animation-name: fadeOutUp; }

@keyframes fadeOutUpBig {
  0% {
    opacity: 1;
    transform: translateY(0); }
  100% {
    opacity: 0;
    transform: translateY(-2000px); } }

.fadeOutUpBig {
  animation-name: fadeOutUpBig; }

@keyframes flip {
  0% {
    transform: perspective(400px) translateZ(0) rotateY(0) scale(1);
    animation-timing-function: ease-out; }
  40% {
    transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);
    animation-timing-function: ease-out; }
  50% {
    transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);
    animation-timing-function: ease-in; }
  80% {
    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);
    animation-timing-function: ease-in; }
  100% {
    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);
    animation-timing-function: ease-in; } }

.animated.flip {
  backface-visibility: visible;
  animation-name: flip; }

@keyframes flipInX {
  0% {
    transform: perspective(400px) rotateX(90deg);
    opacity: 0; }
  40% {
    transform: perspective(400px) rotateX(-10deg); }
  70% {
    transform: perspective(400px) rotateX(10deg); }
  100% {
    transform: perspective(400px) rotateX(0deg);
    opacity: 1; } }

.flipInX {
  backface-visibility: visible !important;
  animation-name: flipInX; }

@keyframes flipInY {
  0% {
    transform: perspective(400px) rotateY(90deg);
    opacity: 0; }
  40% {
    transform: perspective(400px) rotateY(-10deg); }
  70% {
    transform: perspective(400px) rotateY(10deg); }
  100% {
    transform: perspective(400px) rotateY(0deg);
    opacity: 1; } }

.flipInY {
  backface-visibility: visible !important;
  animation-name: flipInY; }

@keyframes flipOutX {
  0% {
    transform: perspective(400px) rotateX(0deg);
    opacity: 1; }
  100% {
    transform: perspective(400px) rotateX(90deg);
    opacity: 0; } }

.flipOutX {
  animation-name: flipOutX;
  backface-visibility: visible !important; }

@keyframes flipOutY {
  0% {
    transform: perspective(400px) rotateY(0deg);
    opacity: 1; }
  100% {
    transform: perspective(400px) rotateY(90deg);
    opacity: 0; } }

.flipOutY {
  backface-visibility: visible !important;
  animation-name: flipOutY; }

@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0; }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1; }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1; }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1; } }

.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out; }

@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1; }
  100% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0; } }

.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in; }

@keyframes rotateIn {
  0% {
    transform-origin: center center;
    transform: rotate(-200deg);
    opacity: 0; }
  100% {
    transform-origin: center center;
    transform: rotate(0);
    opacity: 1; } }

.rotateIn {
  animation-name: rotateIn; }

@keyframes rotateInDownLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(-90deg);
    opacity: 0; }
  100% {
    transform-origin: left bottom;
    transform: rotate(0);
    opacity: 1; } }

.rotateInDownLeft {
  animation-name: rotateInDownLeft; }

@keyframes rotateInDownRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(90deg);
    opacity: 0; }
  100% {
    transform-origin: right bottom;
    transform: rotate(0);
    opacity: 1; } }

.rotateInDownRight {
  animation-name: rotateInDownRight; }

@keyframes rotateInUpLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(90deg);
    opacity: 0; }
  100% {
    transform-origin: left bottom;
    transform: rotate(0);
    opacity: 1; } }

.rotateInUpLeft {
  animation-name: rotateInUpLeft; }

@keyframes rotateInUpRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(-90deg);
    opacity: 0; }
  100% {
    transform-origin: right bottom;
    transform: rotate(0);
    opacity: 1; } }

.rotateInUpRight {
  animation-name: rotateInUpRight; }

@keyframes rotateOut {
  0% {
    transform-origin: center center;
    transform: rotate(0);
    opacity: 1; }
  100% {
    transform-origin: center center;
    transform: rotate(200deg);
    opacity: 0; } }

.rotateOut {
  animation-name: rotateOut; }

@keyframes rotateOutDownLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(0);
    opacity: 1; }
  100% {
    transform-origin: left bottom;
    transform: rotate(90deg);
    opacity: 0; } }

.rotateOutDownLeft {
  animation-name: rotateOutDownLeft; }

@keyframes rotateOutDownRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(0);
    opacity: 1; }
  100% {
    transform-origin: right bottom;
    transform: rotate(-90deg);
    opacity: 0; } }

.rotateOutDownRight {
  animation-name: rotateOutDownRight; }

@keyframes rotateOutUpLeft {
  0% {
    transform-origin: left bottom;
    transform: rotate(0);
    opacity: 1; }
  100% {
    transform-origin: left bottom;
    transform: rotate(-90deg);
    opacity: 0; } }

.rotateOutUpLeft {
  animation-name: rotateOutUpLeft; }

@keyframes rotateOutUpRight {
  0% {
    transform-origin: right bottom;
    transform: rotate(0);
    opacity: 1; }
  100% {
    transform-origin: right bottom;
    transform: rotate(90deg);
    opacity: 0; } }

.rotateOutUpRight {
  animation-name: rotateOutUpRight; }

@keyframes slideInDown {
  0% {
    opacity: 0;
    transform: translateY(-2000px); }
  100% {
    transform: translateY(0); } }

.slideInDown {
  animation-name: slideInDown; }

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-2000px); }
  100% {
    transform: translateX(0); } }

.slideInLeft {
  animation-name: slideInLeft; }

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(2000px); }
  100% {
    transform: translateX(0); } }

.slideInRight {
  animation-name: slideInRight; }

@keyframes slideOutLeft {
  0% {
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(-2000px); } }

.slideOutLeft {
  animation-name: slideOutLeft; }

@keyframes slideOutRight {
  0% {
    transform: translateX(0); }
  100% {
    opacity: 0;
    transform: translateX(2000px); } }

.slideOutRight {
  animation-name: slideOutRight; }

@keyframes slideOutUp {
  0% {
    transform: translateY(0); }
  100% {
    opacity: 0;
    transform: translateY(-2000px); } }

.slideOutUp {
  animation-name: slideOutUp; }

@keyframes hinge {
  0% {
    transform: rotate(0);
    transform-origin: top left;
    animation-timing-function: ease-in-out; }
  20%, 60% {
    transform: rotate(80deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out; }
  40% {
    transform: rotate(60deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out; }
  80% {
    transform: rotate(60deg) translateY(0);
    opacity: 1;
    transform-origin: top left;
    animation-timing-function: ease-in-out; }
  100% {
    transform: translateY(700px);
    opacity: 0; } }

.hinge {
  animation-name: hinge; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@keyframes rollIn {
  0% {
    opacity: 0;
    transform: translateX(-100%) rotate(-120deg); }
  100% {
    opacity: 1;
    transform: translateX(0px) rotate(0deg); } }

.rollIn {
  animation-name: rollIn; }

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@keyframes rollOut {
  0% {
    opacity: 1;
    transform: translateX(0px) rotate(0deg); }
  100% {
    opacity: 0;
    transform: translateX(100%) rotate(120deg); } }

.rollOut {
  animation-name: rollOut; }

.swal2-popup.swal2-toast {
  flex-direction: column;
  align-items: stretch;
  width: auto;
  padding: 1.25em;
  overflow-y: hidden;
  background: #fff;
  box-shadow: 0 0 0.625em #d9d9d9; }
  .swal2-popup.swal2-toast .swal2-header {
    flex-direction: row;
    padding: 0; }
  .swal2-popup.swal2-toast .swal2-title {
    flex-grow: 1;
    justify-content: flex-start;
    margin: 0 0.625em;
    font-size: 1em; }
  .swal2-popup.swal2-toast .swal2-loading {
    justify-content: center; }
  .swal2-popup.swal2-toast .swal2-input {
    height: 2em;
    margin: .3125em auto;
    font-size: 1em; }
  .swal2-popup.swal2-toast .swal2-validation-message {
    font-size: 1em; }
  .swal2-popup.swal2-toast .swal2-footer {
    margin: 0.5em 0 0;
    padding: 0.5em 0 0;
    font-size: 0.8em; }
  .swal2-popup.swal2-toast .swal2-close {
    position: static;
    width: 0.8em;
    height: 0.8em;
    line-height: 0.8; }
  .swal2-popup.swal2-toast .swal2-content {
    justify-content: flex-start;
    margin: 0 0.625em;
    padding: 0;
    font-size: 1em;
    text-align: initial; }
  .swal2-popup.swal2-toast .swal2-html-container {
    padding: .625em 0 0; }
    .swal2-popup.swal2-toast .swal2-html-container:empty {
      padding: 0; }
  .swal2-popup.swal2-toast .swal2-icon {
    width: 2em;
    min-width: 2em;
    height: 2em;
    margin: 0 .5em 0 0; }
    .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
      display: flex;
      align-items: center;
      font-size: 1.8em;
      font-weight: bold; }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
          font-size: .25em; } }
    .swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
      width: 2em;
      height: 2em; }
    .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
      top: .875em;
      width: 1.375em; }
      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class\$='left'] {
        left: .3125em; }
      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class\$='right'] {
        right: .3125em; }
  .swal2-popup.swal2-toast .swal2-actions {
    flex: 1 1;
    flex-basis: auto !important;
    align-self: stretch;
    width: auto;
    height: 2.2em;
    height: auto;
    margin: 0 .3125em;
    margin-top: .3125em;
    padding: 0; }
  .swal2-popup.swal2-toast .swal2-styled {
    margin: .125em .3125em;
    padding: .3125em .625em;
    font-size: 1em; }
    .swal2-popup.swal2-toast .swal2-styled:focus {
      box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(100, 150, 200, 0.5); }
  .swal2-popup.swal2-toast .swal2-success {
    border-color: #a5dc86; }
    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {
      position: absolute;
      width: 1.6em;
      height: 3em;
      transform: rotate(45deg);
      border-radius: 50%; }
      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class\$='left'] {
        top: -.8em;
        left: -.5em;
        transform: rotate(-45deg);
        transform-origin: 2em 2em;
        border-radius: 4em 0 0 4em; }
      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class\$='right'] {
        top: -.25em;
        left: .9375em;
        transform-origin: 0 1.5em;
        border-radius: 0 4em 4em 0; }
    .swal2-popup.swal2-toast .swal2-success .swal2-success-ring {
      width: 2em;
      height: 2em; }
    .swal2-popup.swal2-toast .swal2-success .swal2-success-fix {
      top: 0;
      left: .4375em;
      width: .4375em;
      height: 2.6875em; }
    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'] {
      height: .3125em; }
      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='tip'] {
        top: 1.125em;
        left: .1875em;
        width: .75em; }
      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class\$='long'] {
        top: .9375em;
        right: .1875em;
        width: 1.375em; }
    .swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip {
      animation: swal2-toast-animate-success-line-tip .75s; }
    .swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long {
      animation: swal2-toast-animate-success-line-long .75s; }
  .swal2-popup.swal2-toast.swal2-show {
    animation: swal2-toast-show 0.5s; }
  .swal2-popup.swal2-toast.swal2-hide {
    animation: swal2-toast-hide 0.1s forwards; }

.swal2-container {
  display: flex;
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.625em;
  overflow-x: hidden;
  transition: background-color 0.1s;
  -webkit-overflow-scrolling: touch; }
  .swal2-container.swal2-backdrop-show, .swal2-container.swal2-noanimation {
    background: rgba(0, 0, 0, 0.4); }
  .swal2-container.swal2-backdrop-hide {
    background: transparent !important; }
  .swal2-container.swal2-top {
    align-items: flex-start; }
  .swal2-container.swal2-top-start, .swal2-container.swal2-top-left {
    align-items: flex-start;
    justify-content: flex-start; }
  .swal2-container.swal2-top-end, .swal2-container.swal2-top-right {
    align-items: flex-start;
    justify-content: flex-end; }
  .swal2-container.swal2-center {
    align-items: center; }
  .swal2-container.swal2-center-start, .swal2-container.swal2-center-left {
    align-items: center;
    justify-content: flex-start; }
  .swal2-container.swal2-center-end, .swal2-container.swal2-center-right {
    align-items: center;
    justify-content: flex-end; }
  .swal2-container.swal2-bottom {
    align-items: flex-end; }
  .swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {
    align-items: flex-end;
    justify-content: flex-start; }
  .swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {
    align-items: flex-end;
    justify-content: flex-end; }
  .swal2-container.swal2-bottom > :first-child,
  .swal2-container.swal2-bottom-start > :first-child,
  .swal2-container.swal2-bottom-left > :first-child,
  .swal2-container.swal2-bottom-end > :first-child,
  .swal2-container.swal2-bottom-right > :first-child {
    margin-top: auto; }
  .swal2-container.swal2-grow-fullscreen > .swal2-modal {
    display: flex !important;
    flex: 1 1;
    align-self: stretch;
    justify-content: center; }
  .swal2-container.swal2-grow-row > .swal2-modal {
    display: flex !important;
    flex: 1 1;
    align-content: center;
    justify-content: center; }
  .swal2-container.swal2-grow-column {
    flex: 1 1;
    flex-direction: column; }
    .swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {
      align-items: center; }
    .swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {
      align-items: flex-start; }
    .swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {
      align-items: flex-end; }
    .swal2-container.swal2-grow-column > .swal2-modal {
      display: flex !important;
      flex: 1 1;
      align-content: center;
      justify-content: center; }
  .swal2-container.swal2-no-transition {
    transition: none !important; }
  .swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen) > .swal2-modal {
    margin: auto; }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .swal2-container .swal2-modal {
      margin: 0 !important; } }

.swal2-popup {
  display: none;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  width: 32em;
  max-width: 100%;
  padding: 1.25em;
  border: none;
  border-radius: 5px;
  background: #fff;
  font-family: inherit;
  font-size: 1rem; }
  .swal2-popup:focus {
    outline: none; }
  .swal2-popup.swal2-loading {
    overflow-y: hidden; }

.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.8em; }

.swal2-title {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word; }

.swal2-actions {
  display: flex;
  z-index: 1;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
  padding: 0; }
  .swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {
    opacity: .4; }
  .swal2-actions:not(.swal2-loading) .swal2-styled:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)); }
  .swal2-actions:not(.swal2-loading) .swal2-styled:active {
    background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)); }

.swal2-loader {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2.2em;
  height: 2.2em;
  margin: 0 1.875em;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border-width: 0.25em;
  border-style: solid;
  border-radius: 100%;
  border-color: #2778c4 transparent #2778c4 transparent; }

.swal2-styled {
  margin: 0.3125em;
  padding: 0.625em 1.1em;
  box-shadow: none;
  font-weight: 500; }
  .swal2-styled:not([disabled]) {
    cursor: pointer; }
  .swal2-styled.swal2-confirm {
    border: 0;
    border-radius: 0.25em;
    background: initial;
    background-color: #2778c4;
    color: #fff;
    font-size: 1em; }
  .swal2-styled.swal2-deny {
    border: 0;
    border-radius: 0.25em;
    background: initial;
    background-color: #d14529;
    color: #fff;
    font-size: 1em; }
  .swal2-styled.swal2-cancel {
    border: 0;
    border-radius: 0.25em;
    background: initial;
    background-color: #757575;
    color: #fff;
    font-size: 1em; }
  .swal2-styled:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(100, 150, 200, 0.5); }
  .swal2-styled::-moz-focus-inner {
    border: 0; }

.swal2-footer {
  justify-content: center;
  margin: 1.25em 0 0;
  padding: 1em 0 0;
  border-top: 1px solid #eee;
  color: #545454;
  font-size: 1em; }

.swal2-timer-progress-bar-container {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 0.25em;
  overflow: hidden;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px; }

.swal2-timer-progress-bar {
  width: 100%;
  height: 0.25em;
  background: rgba(0, 0, 0, 0.2); }

.swal2-image {
  max-width: 100%;
  margin: 1.25em auto; }

.swal2-close {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  width: 1.2em;
  height: 1.2em;
  padding: 0;
  overflow: hidden;
  transition: color 0.1s ease-out;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #cccccc;
  font-family: serif;
  font-size: 2.5em;
  line-height: 1.2;
  cursor: pointer; }
  .swal2-close:hover {
    transform: none;
    background: transparent;
    color: #f27474; }
  .swal2-close:focus {
    outline: none;
    box-shadow: inset 0 0 0 3px rgba(100, 150, 200, 0.5); }
  .swal2-close::-moz-focus-inner {
    border: 0; }

.swal2-content {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0 1.6em;
  color: #545454;
  font-size: 1.125em;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  word-wrap: break-word; }

.swal2-input,
.swal2-file,
.swal2-textarea,
.swal2-select,
.swal2-radio,
.swal2-checkbox {
  margin: 1em auto; }

.swal2-input,
.swal2-file,
.swal2-textarea {
  box-sizing: border-box;
  width: 100%;
  transition: border-color 0.3s, box-shadow 0.3s;
  border: 1px solid #d9d9d9;
  border-radius: 0.1875em;
  background: inherit;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
  color: inherit;
  font-size: 1.125em; }
  .swal2-input.swal2-inputerror,
  .swal2-file.swal2-inputerror,
  .swal2-textarea.swal2-inputerror {
    border-color: #f27474 !important;
    box-shadow: 0 0 2px #f27474 !important; }
  .swal2-input:focus,
  .swal2-file:focus,
  .swal2-textarea:focus {
    border: 1px solid #b4dbed;
    outline: none;
    box-shadow: 0 0 0 3px rgba(100, 150, 200, 0.5); }
  .swal2-input::placeholder,
  .swal2-file::placeholder,
  .swal2-textarea::placeholder {
    color: #cccccc; }

.swal2-range {
  margin: 1em auto;
  background: #fff; }
  .swal2-range input {
    width: 80%; }
  .swal2-range output {
    width: 20%;
    color: inherit;
    font-weight: 600;
    text-align: center; }
  .swal2-range input,
  .swal2-range output {
    height: 2.625em;
    padding: 0;
    font-size: 1.125em;
    line-height: 2.625em; }

.swal2-input {
  height: 2.625em;
  padding: 0 0.75em; }
  .swal2-input[type='number'] {
    max-width: 10em; }

.swal2-file {
  background: inherit;
  font-size: 1.125em; }

.swal2-textarea {
  height: 6.75em;
  padding: 0.75em; }

.swal2-select {
  min-width: 50%;
  max-width: 100%;
  padding: .375em .625em;
  background: inherit;
  color: inherit;
  font-size: 1.125em; }

.swal2-radio,
.swal2-checkbox {
  align-items: center;
  justify-content: center;
  background: #fff;
  color: inherit; }
  .swal2-radio label,
  .swal2-checkbox label {
    margin: 0 .6em;
    font-size: 1.125em; }
  .swal2-radio input,
  .swal2-checkbox input {
    flex-shrink: 0;
    margin: 0 .4em; }

.swal2-input-label {
  display: flex;
  justify-content: center;
  margin: 1em auto; }

.swal2-validation-message {
  align-items: center;
  justify-content: center;
  margin: 0 -2.7em;
  padding: 0.625em;
  overflow: hidden;
  background: #f0f0f0;
  color: #666666;
  font-size: 1em;
  font-weight: 300; }
  .swal2-validation-message::before {
    content: '!';
    display: inline-block;
    width: 1.5em;
    min-width: 1.5em;
    height: 1.5em;
    margin: 0 .625em;
    border-radius: 50%;
    background-color: #f27474;
    color: #fff;
    font-weight: 600;
    line-height: 1.5em;
    text-align: center; }

.swal2-icon {
  position: relative;
  box-sizing: content-box;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 1.25em auto 1.875em;
  border: 0.25em solid transparent;
  border-radius: 50%;
  border-color: #000;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  -webkit-user-select: none;
          user-select: none; }
  .swal2-icon .swal2-icon-content {
    display: flex;
    align-items: center;
    font-size: 3.75em; }
  .swal2-icon.swal2-error {
    border-color: #f27474;
    color: #f27474; }
    .swal2-icon.swal2-error .swal2-x-mark {
      position: relative;
      flex-grow: 1; }
    .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {
      display: block;
      position: absolute;
      top: 2.3125em;
      width: 2.9375em;
      height: .3125em;
      border-radius: .125em;
      background-color: #f27474; }
      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class\$='left'] {
        left: 1.0625em;
        transform: rotate(45deg); }
      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class\$='right'] {
        right: 1em;
        transform: rotate(-45deg); }
    .swal2-icon.swal2-error.swal2-icon-show {
      animation: swal2-animate-error-icon .5s; }
      .swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark {
        animation: swal2-animate-error-x-mark .5s; }
  .swal2-icon.swal2-warning {
    border-color: #facea8;
    color: #f8bb86; }
  .swal2-icon.swal2-info {
    border-color: #9de0f6;
    color: #3fc3ee; }
  .swal2-icon.swal2-question {
    border-color: #c9dae1;
    color: #87adbd; }
  .swal2-icon.swal2-success {
    border-color: #a5dc86;
    color: #a5dc86; }
    .swal2-icon.swal2-success [class^='swal2-success-circular-line'] {
      position: absolute;
      width: 3.75em;
      height: 7.5em;
      transform: rotate(45deg);
      border-radius: 50%; }
      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class\$='left'] {
        top: -.4375em;
        left: -2.0635em;
        transform: rotate(-45deg);
        transform-origin: 3.75em 3.75em;
        border-radius: 7.5em 0 0 7.5em; }
      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class\$='right'] {
        top: -.6875em;
        left: 1.875em;
        transform: rotate(-45deg);
        transform-origin: 0 3.75em;
        border-radius: 0 7.5em 7.5em 0; }
    .swal2-icon.swal2-success .swal2-success-ring {
      position: absolute;
      z-index: 2;
      top: -.25em;
      left: -.25em;
      box-sizing: content-box;
      width: 100%;
      height: 100%;
      border: 0.25em solid rgba(165, 220, 134, 0.3);
      border-radius: 50%; }
    .swal2-icon.swal2-success .swal2-success-fix {
      position: absolute;
      z-index: 1;
      top: .5em;
      left: 1.625em;
      width: .4375em;
      height: 5.625em;
      transform: rotate(-45deg); }
    .swal2-icon.swal2-success [class^='swal2-success-line'] {
      display: block;
      position: absolute;
      z-index: 2;
      height: .3125em;
      border-radius: .125em;
      background-color: #a5dc86; }
      .swal2-icon.swal2-success [class^='swal2-success-line'][class\$='tip'] {
        top: 2.875em;
        left: .8125em;
        width: 1.5625em;
        transform: rotate(45deg); }
      .swal2-icon.swal2-success [class^='swal2-success-line'][class\$='long'] {
        top: 2.375em;
        right: .5em;
        width: 2.9375em;
        transform: rotate(-45deg); }
    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {
      animation: swal2-animate-success-line-tip .75s; }
    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {
      animation: swal2-animate-success-line-long .75s; }
    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {
      animation: swal2-rotate-success-circular-line 4.25s ease-in; }

.swal2-progress-steps {
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  margin: 0 0 1.25em;
  padding: 0;
  background: inherit;
  font-weight: 600; }
  .swal2-progress-steps li {
    display: inline-block;
    position: relative; }
  .swal2-progress-steps .swal2-progress-step {
    z-index: 20;
    flex-shrink: 0;
    width: 2em;
    height: 2em;
    border-radius: 2em;
    background: #2778c4;
    color: #fff;
    line-height: 2em;
    text-align: center; }
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
      background: #2778c4; }
      .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
        background: #add8e6;
        color: #fff; }
      .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
        background: #add8e6; }
  .swal2-progress-steps .swal2-progress-step-line {
    z-index: 10;
    flex-shrink: 0;
    width: 2.5em;
    height: .4em;
    margin: 0 -1px;
    background: #2778c4; }

[class^='swal2'] {
  -webkit-tap-highlight-color: transparent; }

.swal2-show {
  animation: swal2-show 0.3s; }

.swal2-hide {
  animation: swal2-hide 0.15s forwards; }

.swal2-noanimation {
  transition: none; }

.swal2-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll; }

.swal2-rtl .swal2-close {
  right: auto;
  left: 0; }

.swal2-rtl .swal2-timer-progress-bar {
  right: 0;
  left: auto; }

@supports (-ms-accelerator: true) {
  .swal2-range input {
    width: 100% !important; }
  .swal2-range output {
    display: none; } }

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-range input {
    width: 100% !important; }
  .swal2-range output {
    display: none; } }

@keyframes swal2-toast-show {
  0% {
    transform: translateY(-0.625em) rotateZ(2deg); }
  33% {
    transform: translateY(0) rotateZ(-2deg); }
  66% {
    transform: translateY(0.3125em) rotateZ(2deg); }
  100% {
    transform: translateY(0) rotateZ(0deg); } }

@keyframes swal2-toast-hide {
  100% {
    transform: rotateZ(1deg);
    opacity: 0; } }

@keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: .5625em;
    left: .0625em;
    width: 0; }
  54% {
    top: .125em;
    left: .125em;
    width: 0; }
  70% {
    top: .625em;
    left: -.25em;
    width: 1.625em; }
  84% {
    top: 1.0625em;
    left: .75em;
    width: .5em; }
  100% {
    top: 1.125em;
    left: .1875em;
    width: .75em; } }

@keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em;
    right: 1.375em;
    width: 0; }
  65% {
    top: 1.25em;
    right: .9375em;
    width: 0; }
  84% {
    top: .9375em;
    right: 0;
    width: 1.125em; }
  100% {
    top: .9375em;
    right: .1875em;
    width: 1.375em; } }

@keyframes swal2-show {
  0% {
    transform: scale(0.7); }
  45% {
    transform: scale(1.05); }
  80% {
    transform: scale(0.95); }
  100% {
    transform: scale(1); } }

@keyframes swal2-hide {
  0% {
    transform: scale(1);
    opacity: 1; }
  100% {
    transform: scale(0.5);
    opacity: 0; } }

@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: .0625em;
    width: 0; }
  54% {
    top: 1.0625em;
    left: .125em;
    width: 0; }
  70% {
    top: 2.1875em;
    left: -.375em;
    width: 3.125em; }
  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em; }
  100% {
    top: 2.8125em;
    left: .8125em;
    width: 1.5625em; } }

@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0; }
  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0; }
  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em; }
  100% {
    top: 2.375em;
    right: .5em;
    width: 2.9375em; } }

@keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg); }
  5% {
    transform: rotate(-45deg); }
  12% {
    transform: rotate(-405deg); }
  100% {
    transform: rotate(-405deg); } }

@keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0; }
  50% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0; }
  80% {
    margin-top: -.375em;
    transform: scale(1.15); }
  100% {
    margin-top: 0;
    transform: scale(1);
    opacity: 1; } }

@keyframes swal2-animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0; }
  100% {
    transform: rotateX(0deg);
    opacity: 1; } }

@keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  overflow: hidden; }

body.swal2-height-auto {
  height: auto !important; }

body.swal2-no-backdrop .swal2-container {
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  max-width: calc(100% - 0.625em * 2);
  background-color: transparent !important; }
  body.swal2-no-backdrop .swal2-container > .swal2-modal {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4); }
  body.swal2-no-backdrop .swal2-container.swal2-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%); }
  body.swal2-no-backdrop .swal2-container.swal2-top-start, body.swal2-no-backdrop .swal2-container.swal2-top-left {
    top: 0;
    left: 0; }
  body.swal2-no-backdrop .swal2-container.swal2-top-end, body.swal2-no-backdrop .swal2-container.swal2-top-right {
    top: 0;
    right: 0; }
  body.swal2-no-backdrop .swal2-container.swal2-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); }
  body.swal2-no-backdrop .swal2-container.swal2-center-start, body.swal2-no-backdrop .swal2-container.swal2-center-left {
    top: 50%;
    left: 0;
    transform: translateY(-50%); }
  body.swal2-no-backdrop .swal2-container.swal2-center-end, body.swal2-no-backdrop .swal2-container.swal2-center-right {
    top: 50%;
    right: 0;
    transform: translateY(-50%); }
  body.swal2-no-backdrop .swal2-container.swal2-bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%); }
  body.swal2-no-backdrop .swal2-container.swal2-bottom-start, body.swal2-no-backdrop .swal2-container.swal2-bottom-left {
    bottom: 0;
    left: 0; }
  body.swal2-no-backdrop .swal2-container.swal2-bottom-end, body.swal2-no-backdrop .swal2-container.swal2-bottom-right {
    right: 0;
    bottom: 0; }

@media print {
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
    overflow-y: scroll !important; }
    body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) > [aria-hidden='true'] {
      display: none; }
    body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {
      position: static !important; } }

body.swal2-toast-shown .swal2-container {
  background-color: transparent; }
  body.swal2-toast-shown .swal2-container.swal2-top {
    top: 0;
    right: auto;
    bottom: auto;
    left: 50%;
    transform: translateX(-50%); }
  body.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {
    top: 0;
    right: 0;
    bottom: auto;
    left: auto; }
  body.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {
    top: 0;
    right: auto;
    bottom: auto;
    left: 0; }
  body.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {
    top: 50%;
    right: auto;
    bottom: auto;
    left: 0;
    transform: translateY(-50%); }
  body.swal2-toast-shown .swal2-container.swal2-center {
    top: 50%;
    right: auto;
    bottom: auto;
    left: 50%;
    transform: translate(-50%, -50%); }
  body.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {
    top: 50%;
    right: 0;
    bottom: auto;
    left: auto;
    transform: translateY(-50%); }
  body.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {
    top: auto;
    right: auto;
    bottom: 0;
    left: 0; }
  body.swal2-toast-shown .swal2-container.swal2-bottom {
    top: auto;
    right: auto;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%); }
  body.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {
    top: auto;
    right: 0;
    bottom: 0;
    left: auto; }

.scroller {
  overflow-y: auto;
  scrollbar-color: #8f93f6 #c6c8f7;
  scrollbar-width: thin; }
  .scroller::-webkit-scrollbar-thumb {
    background-color: #8f93f6; }
  .scroller::-webkit-scrollbar-track {
    background-color: #c6c8f7; }
  .scroller::-moz-scrollbar-thumb {
    background-color: #8f93f6; }
  .scroller::-moz-scrollbar-track {
    background-color: #c6c8f7; }

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 20px; }

::-moz-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 20px; }

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 20px; }

::-webkit-scrollbar-thumb {
  background: #6c757d;
  border-radius: 20px; }
  ::-webkit-scrollbar-thumb:hover {
    background: #01041b;
    border-radius: 20px; }

::-moz-scrollbar-thumb {
  background: #6c757d;
  border-radius: 20px; }
  ::-moz-scrollbar-thumb:hover {
    background: #01041b;
    border-radius: 20px; }

::-webkit-scrollbar {
  width: 4px;
  height: 8px;
  border-radius: 8px; }

::-moz-scrollbar {
  width: 4px;
  height: 8px;
  border-radius: 8px; }

.scrollbar-thumb {
  width: 4px !important; }

.scrollbar-track-y {
  width: 4px !important; }

body {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: normal;
  padding: 0;
  margin: 0;
  color: #535f6b;
  background: #fafbfe; }

a:hover {
  text-decoration: none; }

.btn i {
  margin-right: 5px; }

.iq-mb-3 {
  margin-bottom: 30px !important; }

h1 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1;
  color: #303030;
  font-size: 2.488rem; }
  h1 a {
    color: inherit; }

h2 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1.5;
  color: #303030;
  font-size: 2.074rem; }
  h2 a {
    color: inherit; }

h3 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1.5;
  color: #303030;
  font-size: 1.728rem a;
    font-size-color: inherit; }

h4 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1;
  color: #303030;
  font-size: 1.44rem; }
  h4 a {
    color: inherit; }

h5 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1.5;
  color: #303030;
  font-size: 1.2rem; }
  h5 a {
    color: inherit; }

h6 {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  margin: 0px;
  line-height: 1.5;
  color: #303030;
  font-size: 1rem; }
  h6 a {
    color: inherit; }

button:focus {
  outline: none; }

.line-height {
  line-height: normal; }

.rounded-normal, .rounded-small {
  border-radius: 8px; }

:focus {
  outline: none; }

.text-break {
  word-break: break-all; }

.border-none {
  border: none !important; }

.breadcrumb-item + .breadcrumb-item::before {
  margin-top: 5px; }

.user-list-files {
  justify-content: flex-end; }
  .user-list-files a {
    padding: 10px 15px;
    margin: 0 0 0 10px;
    border-radius: 5px;
    line-height: normal; }

code {
  color: #ef9fc4; }

.slick-loading .slick-list {
  background: transparent !important; }

ul.iq-edit-profile li a {
  padding: 1rem 1rem !important;
  text-align: center; }

.change-mode {
  margin-right: 9px; }
  .change-mode .custom-switch.custom-switch-icon .custom-control-input {
    height: 100%; }
    .change-mode .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label:after {
      transform: translateX(1.6rem); }
    .change-mode .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label:before {
      background-color: #1D1D1F;
      border-color: #1D1D1F; }
  .change-mode .custom-switch.custom-switch-icon label.custom-control-label {
    height: 21px; }
    .change-mode .custom-switch.custom-switch-icon label.custom-control-label:after {
      top: 3px;
      left: 4px;
      width: 17px;
      height: 17px;
      border-radius: 8px;
      background-color: #535f6b; }
    .change-mode .custom-switch.custom-switch-icon label.custom-control-label:before {
      width: 3.1rem;
      height: 23px;
      top: 0;
      left: 1px;
      background-color: #fff;
      border-color: #535f6b;
      border-radius: 8px; }
    .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-left {
      top: 1px; }
      .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-left i {
        font-size: 12px; }
    .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-right {
      right: -2px;
      top: 2px;
      line-height: 20px; }
      .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-right i {
        font-size: 12px; }

.custom-control-input:focus ~ .custom-control-label:before {
  box-shadow: none !important; }

g[aria-describedby="id-22-description"] {
  stroke: none; }

@media (min-width: 1400px) {
  .container {
    max-width: 1300px; }
  .container-lg {
    max-width: 1300px; }
  .container-md {
    max-width: 1300px; }
  .container-sm {
    max-width: 1300px; }
  .container-xl {
    max-width: 1300px; } }

@media (max-width: 1300px) {
  .flatpickr-rContainer {
    padding-right: 40px; }
  .flatpickr-months .flatpickr-next-month {
    padding-right: 40px; }
  .flatpickr-months .flatpickr-prev-month {
    padding-right: 40px; }
  .flatpickr-current-month {
    left: 7.5%; } }

@media (max-width: 767px) {
  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    display: block;
    overflow-x: auto; }
  .tree {
    display: inline-table; } }

@media (max-width: 575px) {
  .user-list-files {
    justify-content: center;
    margin-top: 15px; } }

.content-page {
  overflow: hidden;
  padding: 110px 15px 0px;
  min-height: 100vh;
  transition: all 0.3s ease-in-out; }

@media (min-width: 1300px) {
  body.sidebar-main .content-page {
    margin-left: 80px; }
  body.sidebar-main .iq-menu-bt-sidebar {
    display: block;
    margin-left: auto;
    margin-right: auto; } }

@media (max-width: 1299px) {
  .content-page {
    margin-left: 0;
    padding: 100px 15px 0; } }

@media (max-width: 991px) {
  .content-page {
    padding: 90px 0 0; } }

label {
  color: #01041b; }

.table td {
  vertical-align: middle; }

.table th {
  vertical-align: middle; }

.form-control {
  height: 45px;
  line-height: 45px;
  background: #fafbfe;
  border: 1px solid #f1f1f1;
  font-size: 14px;
  color: #535f6b;
  border-radius: 8px;
  box-shadow: none; }
  .form-control:focus {
    color: #01041b;
    border-color: #8f93f6;
    box-shadow: none; }

.form-control-sm {
  height: 30px;
  line-height: 30px; }

.form-control-lg {
  height: 50px;
  line-height: 50px; }

.spin {
  animation: spin 2s infinite linear; }

.input-group .input-group-prepend .input-group-text {
  border: 1px solid #bfc9d4;
  background-color: #fafbfe; }

.input-group .input-group-append .input-group-text {
  border: 1px solid #bfc9d4;
  background-color: #fafbfe; }

textarea.form-control {
  background-color: #fafbfe; }

#editor {
  height: 375px; }

.uploader-file {
  display: block;
  clear: both;
  margin: 0 auto;
  width: 100%;
  max-width: 600px; }
  .uploader-file label {
    float: left;
    clear: both;
    width: 100%;
    padding: 2rem 1.5rem;
    text-align: center;
    background: #fff;
    border-radius: 7px;
    border: 3px solid #eee;
    transition: all 0.3s ease-in-out;
    -webkit-user-select: none;
            user-select: none; }
  .uploader-file label.hover {
    border: 3px solid;
    box-shadow: inset 0 0 0 6px #eee; }
    .uploader-file label.hover #start-one i.fa {
      transform: scale(0.8);
      -webkit-opacity: 0.3;
      -moz-opacity: 0.3;
      -ms-opacity: 0.3;
      -o-opacity: 0.3;
      opacity: 0.3; }
  .uploader-file #start-one {
    float: left;
    clear: both;
    width: 100%; }
    .uploader-file #start-one i.fa {
      font-size: 50px;
      margin-bottom: 1rem;
      transition: all 0.3s ease-in-out; }
  .uploader-file #start-one.hidden {
    display: none; }
  .uploader-file #response {
    float: left;
    clear: both;
    width: 100%; }
    .uploader-file #response #messages {
      margin-bottom: 0.5rem; }
  .uploader-file #response.hidden {
    display: none; }
  .uploader-file #file-image {
    display: inline;
    margin: 0 auto 0.5rem auto;
    width: auto;
    height: auto;
    max-width: 180px; }
  .uploader-file #file-image.hidden {
    display: none; }
  .uploader-file #notimage {
    display: block;
    float: left;
    clear: both;
    width: 100%; }
  .uploader-file #notimage.hidden {
    display: none; }
  .uploader-file progress {
    display: inline;
    clear: both;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    height: 8px;
    border: 0;
    border-radius: 4px;
    background-color: #eee;
    overflow: hidden; }
  .uploader-file .progress {
    display: inline;
    clear: both;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    height: 8px;
    border: 0;
    border-radius: 4px;
    background-color: #eee;
    overflow: hidden; }
  .uploader-file input[type="file"] {
    display: none; }
  .uploader-file div {
    margin: 0 0 0.5rem 0;
    color: #5f6982; }

.spin {
  animation: spin 2s infinite linear; }

.input-group .input-group-prepend .input-group-text {
  border: 1px solid #f1f1f1;
  background-color: #fafbfe; }

.input-group .input-group-append .input-group-text {
  border: 1px solid #f1f1f1;
  background-color: #fafbfe; }

.custom-select {
  height: 46px;
  border: 1px solid #f1f1f1; }

.dropone.dropdown-toggle:after {
  display: none; }

.input-group-sm > .custom-select {
  height: 30px; }

.input-group-sm > .form-control:not(textarea) {
  height: 30px; }

.input-group-lg > .custom-select {
  height: 50px; }

.input-group-lg > .form-control:not(textarea) {
  height: 50px; }

.input-group-text.text-area {
  padding: 1.9rem .75rem; }

.custom-file-label::after {
  background-color: #fafbfe;
  color: #535f6b; }

.custom-file-input:focus ~ .custom-file-label {
  border-color: #8f93f6;
  box-shadow: none; }

.btn-outline-primary.disabled {
  color: #8f93f6;
  background-color: transparent; }

.btn-outline-primary:disabled {
  color: #8f93f6;
  background-color: transparent; }

table.dataTable thead td {
  padding: 10px 10px !important; }

table.dataTable thead th {
  padding: 10px 10px !important; }

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fafbfe; }

.table-bordered {
  border: 1px solid #f1f1f1; }
  .table-bordered td {
    border: 1px solid #f1f1f1; }
  .table-bordered th {
    border: 1px solid #f1f1f1; }

.dataTables_wrapper .dataTables_filter {
  color: #535f6b; }

.dataTables_wrapper .dataTables_info {
  color: #535f6b; }

.dataTables_wrapper .dataTables_length {
  color: #535f6b; }

.dataTables_wrapper .dataTables_paginate {
  color: #535f6b; }

.dataTables_wrapper .dataTables_processing {
  color: #535f6b; }

.dataTables_wrapper .dataTables_paginate span .paginate_button.current {
  padding: 3px 10px;
  color: #8f93f6 !important;
  border: 1px solid #8f93f6 !important;
  background: #c6c8f7 !important;
  border-radius: 8px; }
  .dataTables_wrapper .dataTables_paginate span .paginate_button.current:hover {
    color: #8f93f6 !important;
    border: 1px solid #8f93f6 !important;
    background: #c6c8f7 !important; }

.dataTables_wrapper .dataTables_filter input {
  border-color: #f1f1f1;
  background-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px; }

table.dataTable thead td {
  padding: 10px 18px;
  border-bottom: 1px solid #f1f1f1 !important; }

table.dataTable thead th {
  padding: 10px 18px;
  border-bottom: 1px solid #f1f1f1 !important;
  color: #303030 !important; }

table.dataTable.no-footer {
  border-bottom: 1px solid #f1f1f1 !important; }

.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-shadow: none !important;
  outline: none !important; }

.dataTables_wrapper .dataTables_info {
  padding-top: 15px !important; }

.dataTables_wrapper .dataTables_length label {
  border-color: #f1f1f1 !important; }

.dataTables_wrapper .dataTables_length select {
  border-color: #f1f1f1 !important; }

.custom-control-label:after {
  top: .25rem; }

.custom-control-label:before {
  top: .25rem; }

.custom-switch .custom-control-label::after {
  top: calc(.25rem + 2px); }

.select2-container--default .select2-selection--multiple {
  height: 45px;
  line-height: 34px;
  background: #fafbfe;
  border: 1px solid #f1f1f1;
  font-size: 14px;
  color: #535f6b;
  border-radius: 5px; }

.iq-error {
  width: 100%;
  overflow: hidden;
  display: inline-block; }
  .iq-error h1.text-in-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    font-size: 8em;
    font-weight: 700; }

.iq-error-img {
  position: static;
  display: inline-block;
  margin-bottom: 20px; }

.error-500 .iq-error-img {
  width: 100%; }

.height-self-center {
  height: 100vh;
  border-radius: 8px; }

.iq-maintenance img {
  width: 20%; }

@media (max-width: 767px) {
  .iq-error h1.text-in-box {
    font-size: 5em; } }

@media (max-width: 479px) {
  .iq-error h1.text-in-box {
    font-size: 4em; }
  .iq-error h2 {
    font-size: 1.5em; } }

.pricing .table th {
  border-top: none;
  border-bottom: 1px solid #dee2e6; }

.pricing .table td {
  border-top: none !important; }

.pricing .table tr {
  border-bottom: 1px solid #dee2e6; }
  .pricing .table tr:last-child {
    border-bottom: 0; }

.prc-box {
  background: #c6c8f7;
  padding: 15px;
  position: relative;
  border-radius: 8px; }

.type {
  position: absolute;
  background: #8f93f6;
  padding: 9px 25px;
  color: #fff;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500; }
  .type:before {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    right: -15px;
    top: 0px;
    border-left: 15px solid #6c71e3;
    border-top: 15px solid transparent; }
  .type:after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    left: -15px;
    top: 0px;
    border-right: 15px solid #6c71e3;
    border-top: 15px solid transparent; }

.prc-box.active {
  background: #8f93f6; }
  .prc-box.active .h3 {
    color: #fff; }
  .prc-box.active .type {
    background: #c6c8f7;
    color: #01041b; }
    .prc-box.active .type:before {
      border-left: 16px solid #6c71e3;
      right: -16px; }
    .prc-box.active .type:after {
      border-right: 16px solid #6c71e3;
      left: -16px; }

.prc-wrap {
  border-bottom: none !important; }

.i_close {
  font-size: 22px; }

.p-image {
  position: absolute;
  top: auto;
  right: 6px;
  bottom: 10px;
  transition: all .3s ease;
  background: #8f93f6;
  color: #fff;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  line-height: 28px;
  text-align: center;
  font-size: 12px;
  cursor: pointer; }

.upload-button {
  font-size: 1.5em; }

.file-upload {
  display: none; }

.upload_profile {
  position: relative; }

.child-cell.active {
  color: #8f93f6; }

.iq-social ul li a {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 43px; }

.card .pricing-radius-box {
  border-radius: 60px 0 60px 0; }

.pricing-header {
  padding: 20px 0;
  background: #f5f6f9;
  border-radius: 10px 10px 50% 50%;
  transition: all 0.3s ease-in-out;
  margin-bottom: 20px; }

.pricing-details .icon-data {
  font-size: 50px; }

.pricing-custom-tab .tab-pane.fade.active.show {
  display: block; }

.pricing-custom-tab .tab-pane.fade {
  display: none; }

.pricing-custom-tab li.nav-item .nav-link {
  border: 1px solid #f1f1f1;
  color: #01041b;
  font-size: 16px;
  padding: 12px 35px;
  border-radius: 0; }

.pricing-custom-tab li.nav-item .nav-link.active {
  color: #fff;
  background: #8f93f6; }

.pricing-custom-tab li.nav-item .star-circle {
  background-color: #8f93f6;
  border-radius: 50%;
  -ms-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
  -o-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);
  color: #fff;
  display: block;
  font-size: 13px;
  height: 25px;
  padding: 0;
  line-height: 23px;
  text-align: center;
  width: 20px;
  position: absolute;
  top: -14px;
  left: -14px;
  z-index: 1; }

.nav-pills li {
  position: relative; }

ul.pricing-list li {
  line-height: 45px; }

.login-content {
  position: relative;
  height: 100vh;
  z-index: 99; }
  .login-content .floating-label label {
    color: #535f6b;
    font-size: 14px;
    font-weight: 400;
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.3s ease-in-out; }
  .login-content .form-control {
    border-color: #f1f1f1; }
    .login-content .form-control:focus {
      border-width: 2px;
      border-color: #8f93f6; }
  .login-content .custom-control-label::before {
    background-color: #fafbfe; }
  .login-content .sign-user_card {
    padding: 30px;
    border: 1px solid #f1f1f1;
    text-align: center;
    border-radius: 8px; }
    .login-content .sign-user_card .logo {
      max-height: 50px;
      margin: 0 auto 20px; }
    .login-content .sign-user_card .custom-control-label {
      color: #535f6b; }

.floating-label {
  position: relative;
  margin-bottom: 20px; }

.floating-input:focus ~ label {
  color: #8f93f6;
  top: 0;
  left: 6px;
  font-size: 10px;
  background: #fafbfe;
  padding: 5px 8px; }

.floating-input:not(:placeholder-shown) {
  color: #535f6b;
  border: 1px solid #FAFAFA; }
  .floating-input:not(:placeholder-shown) ~ label {
    top: 0;
    font-size: 10px;
    left: 6px;
    background: #fafbfe;
    padding: 5px 8px; }

@media (min-width: 992px) {
  .lb-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 213px; }
  .rb-img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 194px; }
  .cnf-mail {
    width: 80%; } }

@media (max-width: 991px) {
  .lb-img {
    display: none; }
  .rb-img {
    display: none; } }

.profile-icon.iq-icon-box {
  height: 58px;
  width: 58px;
  line-height: 58px;
  text-align: center;
  margin-right: 10px;
  font-size: 26px;
  text-decoration: none; }

.profile-overly {
  position: absolute;
  left: auto;
  bottom: 0;
  right: 0;
  background: #fff;
  padding: 10px 30px;
  text-align: center;
  border-radius: 10px 10px 0 0; }

ul.iq-contact-rest li a p {
  word-break: break-all; }

.crm-profile-img-edit .file-upload {
  display: none; }

.crm-p-image {
  position: absolute;
  top: auto;
  left: 69px;
  bottom: -9px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: 50%;
  height: 35px;
  width: 35px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  border: 5px solid #fff; }
  .crm-p-image .upload-button {
    font-size: 13px;
    line-height: 26px; }

@media (max-width: 479px) {
  .profile-overly h3 {
    font-size: 14px; } }

#loading {
  background-color: #fafbfe;
  height: 100%;
  width: 100%;
  position: fixed;
  margin-top: 0px;
  top: 0px;
  left: 0px;
  bottom: 0px;
  overflow: hidden !important;
  right: 0px;
  z-index: 999999; }

#loading-center {
  background-size: 20%;
  width: 100%;
  height: 100%;
  position: relative; }

.loader {
  width: 3em;
  height: 3em;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute; }

/*------------------*/
@keyframes loader1 {
  0%, 100% {
    box-shadow: 0em -2.6em 0em 0em #4788ff, 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.5), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7); }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.7), 1.8em -1.8em 0 0em #4788ff, 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5); }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.5), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7), 2.5em 0em 0 0em #4788ff, 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5), 2.5em 0em 0 0em rgba(71, 136, 255, 0.7), 1.75em 1.75em 0 0em #4788ff, 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.5), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.7), 0em 2.5em 0 0em #4788ff, -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.5), 0em 2.5em 0 0em rgba(71, 136, 255, 0.7), -1.8em 1.8em 0 0em #4788ff, -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.5), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.7), -2.6em 0em 0 0em #4788ff, -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.5), -2.6em 0em 0 0em rgba(71, 136, 255, 0.7), -1.8em -1.8em 0 0em #4788ff; } }

@keyframes loader2 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader-3-outter {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader-3-inner {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(-360deg); } }

@keyframes loader4 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader5 {
  0%, 100% {
    transform: translateX(0px); }
  75% {
    transform: translateX(30px); } }

@keyframes loader5_1 {
  0%, 100% {
    transform: translateY(0px); }
  75% {
    transform: translateY(30px); } }

@keyframes loader5_2 {
  0%, 100% {
    transform: translate(0px, 0px); }
  75% {
    transform: translate(30px, 30px); } }

@keyframes inner1 {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg); }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg); } }

@keyframes inner2 {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg); }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg); } }

@keyframes inner3 {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg); }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg); } }

@keyframes loader7 {
  0% {
    transform: rotate(0); }
  50% {
    transform: rotateY(180deg); }
  100% {
    transform: rotateY(180deg) rotateX(180deg); } }

@keyframes loader8 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader9 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader10 {
  0%, 100% {
    transform: translate(0, 0) rotate(0); }
  25% {
    transform: translate(40px, 40px) rotate(45deg); }
  50% {
    transform: translate(0px, 80px) rotate(0deg); }
  75% {
    transform: translate(-40px, 40px) rotate(45deg); } }

@keyframes loader11 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes loader12 {
  0% {
    transform: rotate(0deg);
    border-radius: 50%; }
  50% {
    transform: rotate(90deg);
    border-radius: 0%; }
  100% {
    transform: rotate(180deg);
    border-radius: 50%; } }

@keyframes loader13 {
  to {
    transform: rotate(360deg); } }

@keyframes loader14 {
  0% {
    transform: scale(0);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0; }
  50% {
    -webkit-opacity: 1;
    -moz-opacity: 1;
    -ms-opacity: 1;
    -o-opacity: 1;
    opacity: 1; }
  100% {
    transform: scale(1);
    -webkit-opacity: 0;
    -moz-opacity: 0;
    -ms-opacity: 0;
    -o-opacity: 0;
    opacity: 0; } }

@keyframes loader15-inner {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(-360deg); } }

@keyframes loader15 {
  0% {
    border-width: 0px; }
  100% {
    border-width: 10px; } }

@keyframes loader16 {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.iq-loader-box {
  height: 150px;
  text-align: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center; }
  .iq-loader-box [class*="loader-"] {
    display: inline-block;
    width: 60px;
    height: 60px;
    color: inherit;
    vertical-align: middle;
    position: relative;
    border-radius: 50%; }
  .iq-loader-box .iq-loader-1 {
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: loader1 1.1s infinite ease;
    transform: translateZ(0); }
  .iq-loader-box .iq-loader-2 {
    border: 7px double #37e6b0;
    animation: loader2 1s linear infinite; }
    .iq-loader-box .iq-loader-2:before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      background: #37e6b0;
      border-radius: 50%;
      bottom: 0;
      right: 37px; }
    .iq-loader-box .iq-loader-2:after {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      background: #37e6b0;
      border-radius: 50%;
      bottom: 0;
      right: 37px;
      left: 37px;
      top: 0; }
  .iq-loader-box .iq-loader-3 {
    position: relative;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle; }
    .iq-loader-box .iq-loader-3 .loader-outter {
      position: absolute;
      border: 4px solid #f50057;
      border-left-color: transparent;
      border-bottom: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: loader-3-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite; }
    .iq-loader-box .iq-loader-3 .loader-inner {
      position: absolute;
      border: 4px solid #f50057;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      left: calc(50% - 20px);
      top: calc(50% - 20px);
      border-right: 0;
      border-top-color: transparent;
      animation: loader-3-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite; }
  .iq-loader-box .iq-loader-4 {
    border: .2em solid transparent;
    border-top-color: #fe721c;
    border-bottom-color: #fe721c;
    border-radius: 50%;
    position: relative;
    animation: 1s loader4 linear infinite; }
    .iq-loader-box .iq-loader-4:before {
      content: '';
      display: block;
      width: 0;
      height: 0;
      position: absolute;
      border: .2em solid transparent;
      border-bottom-color: #fe721c;
      transform: rotate(135deg);
      right: -.3em;
      top: -.05em; }
    .iq-loader-box .iq-loader-4:after {
      content: '';
      display: block;
      width: 0;
      height: 0;
      position: absolute;
      border: .2em solid transparent;
      border-bottom-color: #fe721c;
      transform: rotate(-45deg);
      left: -.3em;
      bottom: -.05em; }
  .iq-loader-box .iq-loader-5 {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    position: relative;
    margin: 0 auto; }
    .iq-loader-box .iq-loader-5 span {
      display: block;
      position: absolute;
      left: calc(50% - 20px);
      top: calc(50% - 20px);
      width: 20px;
      height: 20px;
      background-color: var(--info); }
      .iq-loader-box .iq-loader-5 span:nth-child(1) {
        animation: loader5 1s ease-in-out infinite; }
      .iq-loader-box .iq-loader-5 span:nth-child(2) {
        animation: loader5_1 1s ease-in-out infinite; }
      .iq-loader-box .iq-loader-5 span:nth-child(3) {
        animation: loader5_2 1s ease-in-out infinite; }
  .iq-loader-box .iq-loader-6 .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%; }
  .iq-loader-box .iq-loader-6 .inner1 {
    left: 0%;
    top: 0%;
    animation: inner1 1s linear infinite;
    border-bottom: 3px solid #ff4b4b; }
  .iq-loader-box .iq-loader-6 .inner2 {
    right: 0%;
    top: 0%;
    animation: inner2 1s linear infinite;
    border-right: 3px solid #ff4b4b; }
  .iq-loader-box .iq-loader-6 .inner3 {
    right: 0%;
    bottom: 0%;
    animation: inner3 1s linear infinite;
    border-top: 3px solid #ff4b4b; }
  .iq-loader-box .iq-loader-7:before {
    content: "";
    position: absolute;
    left: 0px;
    width: 50px;
    height: 50px;
    background-color: #3498db;
    animation: loader7 1s infinite; }
  .iq-loader-box .iq-loader-8 {
    border: 1.2em solid transparent;
    border-left-color: #d0bac2;
    border-right-color: #d0bac2;
    border-radius: 50%;
    animation: 1s loader8 linear infinite; }
  .iq-loader-box .iq-loader-9 {
    border-radius: 50%;
    width: 7em;
    height: 7em;
    margin: 60px auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(255, 107, 208, 0.2);
    border-right: 1.1em solid rgba(255, 107, 208, 0.2);
    border-bottom: 1.1em solid rgba(255, 107, 208, 0.2);
    border-left: 1.1em solid #ff6bd0;
    transform: translateZ(0);
    animation: loader9 1.1s infinite linear; }
    .iq-loader-box .iq-loader-9:after {
      border-radius: 50%;
      width: 7em;
      height: 7em; }
  .iq-loader-box .iq-loader-10:before {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    left: calc(50% - 10px);
    background-color: #3450db;
    animation: loader10 1s ease-in-out infinite; }
  .iq-loader-box .iq-loader-10:after {
    content: "";
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    left: calc(50% - 10px);
    background-color: #3450db;
    animation: loader10 1s ease-in-out infinite;
    bottom: 0;
    animation-delay: 0.5s; }
  .iq-loader-box .iq-loader-11 {
    background: #000000; }
    .iq-loader-box .iq-loader-11:before {
      content: '';
      position: absolute;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      margin: 0 0 0 -12px;
      background-color: white;
      top: auto;
      bottom: 0;
      left: 50%;
      transform-origin: 50% 0%;
      animation: loader11 1s infinite linear; }
  .iq-loader-box .iq-loader-12 {
    animation: loader12 1s infinite linear;
    background: #6dca5c; }
  .iq-loader-box .iq-loader-13 {
    border-top: 0.2em solid #a7a4ca;
    border-right: .2em solid transparent;
    animation: loader13 1s linear infinite;
    border-radius: 100%;
    position: relative; }
  .iq-loader-box .iq-loader-14 {
    border: 0 solid transparent;
    border-radius: 50%;
    position: relative; }
    .iq-loader-box .iq-loader-14:before {
      content: '';
      border: 1em solid #13d7eb;
      border-radius: 50%;
      width: inherit;
      height: inherit;
      position: absolute;
      top: 0;
      left: 0;
      animation: loader14 1s linear infinite;
      -webkit-opacity: 0;
      -moz-opacity: 0;
      -ms-opacity: 0;
      -o-opacity: 0;
      opacity: 0;
      animation-delay: 1s; }
    .iq-loader-box .iq-loader-14:after {
      content: '';
      border: 1em solid #13d7eb;
      border-radius: 50%;
      width: inherit;
      height: inherit;
      position: absolute;
      top: 0;
      left: 0;
      animation: loader14 1s linear infinite;
      -webkit-opacity: 0;
      -moz-opacity: 0;
      -ms-opacity: 0;
      -o-opacity: 0;
      opacity: 0;
      animation-delay: .5s; }
  .iq-loader-box .iq-loader-15 {
    border: 6px groove #7e57c2;
    transform: rotate(360deg);
    transition: all 1s ease;
    animation: loader15-inner 1s ease-out alternate infinite; }
    .iq-loader-box .iq-loader-15 .loader-inner {
      border: 0px inset #9575cd;
      border-radius: 50%;
      width: 100%;
      height: 100%;
      animation: loader15 1s ease-out alternate infinite; }
  .iq-loader-box .iq-loader-16 {
    width: 70px;
    height: 70px;
    border: 5px dashed #b3a57c;
    animation: loader16 2s linear both infinite; }

.iq-avatars .iq-avatar {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  display: inline-block; }

.icon-small {
  height: 40px;
  width: 40px;
  line-height: 40px;
  display: inline-block;
  vertical-align: middle;
  text-align: center; }

.drive-select {
  font: inherit;
  border: 0; }
  .drive-select option {
    font-size: inherit;
    padding: 10px 0;
    border-bottom: 1px solid #f1f1f1;
    line-height: normal;
    color: inherit;
    display: inline-block;
    width: 100%; }

.icon-statistic {
  height: 45px;
  width: 45px;
  line-height: 45px;
  text-align: center; }

.dashboard1-info {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 23px;
  text-align: center;
  padding-bottom: 0 !important;
  background: #fff;
  position: relative;
  border-radius: 8px;
  -ms-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);
  -o-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05); }
  .dashboard1-info a {
    color: #01041b; }
  .dashboard1-info .iq-dropdown {
    opacity: 0;
    position: absolute;
    top: 50px !important;
    right: 0;
    width: 50px;
    padding: 15px 4px !important;
    z-index: 99;
    background: #fff;
    color: #01041b;
    border-radius: 8px;
    transition: all 0.3s ease-in-out;
    -ms-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);
    -o-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);
    box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05); }
    .dashboard1-info .iq-dropdown.show {
      opacity: 1;
      top: 30px; }

.search-query.dropdown-toggle:after {
  border: 0; }

.select-dropdown .btn-group .search-query.dropdown-toggle {
  font-size: 24px;
  font-weight: 500; }

.new-create {
  padding-top: 25px;
  border-top: 1px solid #f1f1f1;
  margin: 0 20px; }
  .new-create.select-dropdown {
    font-size: 15px;
    width: 220px; }
    .new-create.select-dropdown .btn-group .dropdown-menu {
      width: 220px; }
    .new-create.select-dropdown .selet-caption {
      width: 220px;
      display: inline-block;
      padding: 10px 20px;
      text-align: center;
      font-weight: normal !important;
      font-size: inherit;
      color: #01041b;
      border-radius: 8px;
      background: #f3f3f3; }

.select-dropdown {
  position: relative; }
  .select-dropdown .btn-group .dropdown-toggle {
    box-shadow: none !important;
    font-size: 1.2em; }
  .select-dropdown .btn-group .dropdown-menu {
    position: absolute;
    background: #fff;
    width: 220px;
    border: 0;
    z-index: 9;
    padding: 0;
    height: auto;
    text-align: left !important;
    -ms-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
    -o-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1); }
  .select-dropdown .btn-group li:last-child .item {
    border: 0; }
  .select-dropdown .btn-group li .item {
    padding: 10px 20px;
    border-bottom: 1px solid #f1f1f1;
    color: #535f6b; }
    .select-dropdown .btn-group li .item:hover {
      background-color: #f3f3f3; }
    .select-dropdown .btn-group li .item i {
      vertical-align: middle; }
  .select-dropdown .btn-group .search-replace .item {
    display: none; }

.tbl-server-info .dropdown-toggle:after {
  display: none; }

.files-table .table-responsive {
  overflow-x: unset; }

.files-table .tbl-server-info tr {
  transition: all 0.3s ease-in-out; }
  .files-table .tbl-server-info tr:hover {
    -ms-box-shadow: 0 0 13px 10px #fafafa;
    -o-box-shadow: 0 0 13px 10px #fafafa;
    box-shadow: 0 0 13px 10px #fafafa;
    border-radius: 8px; }

.files-table .tbl-server-info tr.active {
  -ms-box-shadow: 0 0 13px 10px #fafafa;
  -o-box-shadow: 0 0 13px 10px #fafafa;
  box-shadow: 0 0 13px 10px #fafafa;
  border-radius: 8px; }

.folder p {
  color: #535f6b; }

.dropdown-menu .dropdown-item {
  color: #535f6b; }
  .dropdown-menu .dropdown-item:active {
    color: #fff; }
  .dropdown-menu .dropdown-item i {
    vertical-align: middle; }

.tbl-server-info th {
  font-weight: 500; }

#layout-1-chart {
  min-height: 280px !important; }

#layout-1-chart2 {
  min-height: 225px !important; }

.go-white {
  margin-top: 70px; }
  .go-white .btn {
    background: #fff; }
    .go-white .btn:hover {
      background: #6c71e3;
      color: #fff; }

.breadcrumb-item + .breadcrumb-item:before {
  content: "\\f104";
  font-family: 'Line Awesome Free';
  font-size: 14px;
  vertical-align: sub;
  color: #535f6b;
  font-weight: 900; }

.welcome-content h4 {
  font-size: 24px; }

.plan-bg {
  background: #8f93f6; }
  .plan-bg p {
    color: #fff; }

@media (max-width: 1366px) {
  .icon-statistic {
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center; } }

@media (max-width: 1300px) {
  .card-block.iq-welcome {
    background-size: 50% !important; } }

@media (max-width: 1299px) {
  .skill-details p {
    font-size: 14px; } }

@media (max-width: 576px) {
  .card-block.iq-welcome {
    background: none !important; } }

.image-thumb .iq-thumb {
  position: relative;
  overflow: hidden;
  z-index: 9; }
  .image-thumb .iq-thumb img {
    max-height: 100px; }
  .image-thumb .iq-thumb .iq-image-overlay {
    background: #fafafa;
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 1;
    z-index: -1;
    transition: all 0.4s ease-in-out; }
  .image-thumb .iq-thumb .overlay-img-icon {
    position: absolute;
    top: 42%;
    left: 42%;
    opacity: 0;
    height: 35px;
    width: 35px;
    background: #fff;
    transition: all 0.4s ease-in-out;
    border-radius: 50%; }
    .image-thumb .iq-thumb .overlay-img-icon i {
      font-size: 24px;
      line-height: 37px;
      color: #000; }

.image-thumb:hover .iq-thumb .overlay-img-icon {
  opacity: 1; }

.list-grid-toggle .icon.i-grid {
  display: none; }

.list-grid-toggle .icon.icon-grid.i-grid {
  display: block;
  height: 20px;
  width: 20px;
  font-size: 20px;
  color: #01041b; }

.list-grid-toggle .icon.icon-grid.i-list {
  display: none; }

.list-grid-toggle .icon.i-list {
  display: block;
  height: 20px;
  width: 20px;
  font-size: 20px;
  color: #01041b; }

.list-grid-toggle .label.label-list {
  display: none; }

.icon.i-grid {
  display: none; }

.icon.icon-grid.i-grid {
  display: block; }

.icon.icon-grid.i-list {
  display: none; }

.icon.i-list {
  display: block; }

.dark {
  background: #1D1D1F;
  color: #A6A6A6;
  transition: all 0.3s ease-in-out; }
  .dark .bg-primary-light {
    background-color: rgba(71, 136, 255, 0.1) !important; }
  .dark a.bg-primary-light:hover, .dark a.bg-primary-light:focus,
  .dark button.bg-primary-light:hover,
  .dark button.bg-primary-light:focus {
    background-color: rgba(20, 103, 255, 0.1) !important; }
  .dark .bg-secondary-light {
    background-color: rgba(108, 117, 125, 0.1) !important; }
  .dark a.bg-secondary-light:hover, .dark a.bg-secondary-light:focus,
  .dark button.bg-secondary-light:hover,
  .dark button.bg-secondary-light:focus {
    background-color: rgba(84, 91, 98, 0.1) !important; }
  .dark .bg-success-light {
    background-color: rgba(55, 230, 178, 0.1) !important; }
  .dark a.bg-success-light:hover, .dark a.bg-success-light:focus,
  .dark button.bg-success-light:hover,
  .dark button.bg-success-light:focus {
    background-color: rgba(26, 208, 154, 0.1) !important; }
  .dark .bg-info-light {
    background-color: rgba(135, 108, 254, 0.1) !important; }
  .dark a.bg-info-light:hover, .dark a.bg-info-light:focus,
  .dark button.bg-info-light:hover,
  .dark button.bg-info-light:focus {
    background-color: rgba(94, 57, 254, 0.1) !important; }
  .dark .bg-warning-light {
    background-color: rgba(254, 114, 28, 0.1) !important; }
  .dark a.bg-warning-light:hover, .dark a.bg-warning-light:focus,
  .dark button.bg-warning-light:hover,
  .dark button.bg-warning-light:focus {
    background-color: rgba(230, 88, 1, 0.1) !important; }
  .dark .bg-danger-light {
    background-color: rgba(255, 75, 75, 0.1) !important; }
  .dark a.bg-danger-light:hover, .dark a.bg-danger-light:focus,
  .dark button.bg-danger-light:hover,
  .dark button.bg-danger-light:focus {
    background-color: rgba(255, 24, 24, 0.1) !important; }
  .dark .bg-light-light {
    background-color: rgba(199, 203, 211, 0.1) !important; }
  .dark a.bg-light-light:hover, .dark a.bg-light-light:focus,
  .dark button.bg-light-light:hover,
  .dark button.bg-light-light:focus {
    background-color: rgba(170, 176, 189, 0.1) !important; }
  .dark .bg-dark-light {
    background-color: rgba(1, 4, 27, 0.1) !important; }
  .dark a.bg-dark-light:hover, .dark a.bg-dark-light:focus,
  .dark button.bg-dark-light:hover,
  .dark button.bg-dark-light:focus {
    background-color: rgba(0, 0, 0, 0.1) !important; }
  .dark .bg-orange-light {
    background-color: rgba(253, 126, 20, 0.1) !important; }
  .dark a.bg-orange-light:hover, .dark a.bg-orange-light:focus,
  .dark button.bg-orange-light:hover,
  .dark button.bg-orange-light:focus {
    background-color: rgba(220, 101, 2, 0.1) !important; }
  .dark .bg-purple-light {
    background-color: rgba(71, 49, 182, 0.1) !important; }
  .dark a.bg-purple-light:hover, .dark a.bg-purple-light:focus,
  .dark button.bg-purple-light:hover,
  .dark button.bg-purple-light:focus {
    background-color: rgba(55, 38, 142, 0.1) !important; }
  
  .dark h1, .dark h2, .dark h3, .dark h4, .dark h5, .dark h6 {
    color: #ffffff; }
  .dark hr {
    border-color: #27272A; }
  .dark span, .dark p, .dark label {
    color: #A6A6A6; }
  .dark .btn {
    color: #A6A6A6; }
    .dark .btn span {
      color: inherit; }
  .dark .prc-box .h3 {
    color: #ffffff; }
  .dark #loading {
    background-color: #1D1D1F; }
  .dark ::-webkit-scrollbar-track {
    background: #27272A; }
  .dark .btn-primary, .dark .btn-success, .dark .btn-danger, .dark .btn-warning, .dark .btn-info {
    color: #fff; }
  .dark span.btn-outline-primary, .dark span.btn-outline-success, .dark span.btn-outline-danger, .dark span.btn-outline-warning, .dark span.btn-outline-info {
    color: #fff; }
  .dark .border.border-primary, .dark .border.border-success, .dark .border.border-danger, .dark .border.border-warning, .dark .border.border-info {
    border-color: inherit !important; }
  .dark .btn-outline-primary.view-more {
    color: #8f93f6; }
    .dark .btn-outline-primary.view-more:hover {
      background: transparent; }
  .dark .bg-primary-light span {
    color: inherit; }
  .dark .bg-warning-light span {
    color: inherit; }
  .dark .bg-danger-light span {
    color: inherit; }
  .dark .bg-success-light span {
    color: inherit; }
  .dark .bg-info-light span {
    color: inherit; }
  .dark span.apexcharts-legend-text {
    color: #A6A6A6 !important; }
  .dark .apexcharts-yaxis text {
    fill: #A6A6A6; }
  .dark .fc-toolbar .fc-button span {
    color: #8f93f6; }
  .dark .fc-toolbar .fc-button:focus span {
    color: #fff; }
  .dark .fc-unthemed td.fc-today {
    background: #1D1D1F; }
  .dark .fc-unthemed .fc-toolbar .fc-button {
    background: rgba(71, 136, 255, 0.1); }
    .dark .fc-unthemed .fc-toolbar .fc-button:hover {
      color: #fff;
      background: #8f93f6; }
      .dark .fc-unthemed .fc-toolbar .fc-button:hover span {
        color: #fff; }
  .dark .fc-unthemed th, .dark .fc-unthemed td, .dark .fc-unthemed thead, .dark .fc-unthemed tbody, .dark .fc-unthemed .fc-divider, .dark .fc-unthemed .fc-row, .dark .fc-unthemed .fc-content, .dark .fc-unthemed .fc-popover, .dark .fc-unthemed .fc-list-view {
    border-color: #27272A; }
  .dark .fc-unthemed .fc-list-heading td {
    border-color: #27272A; }
  .dark span.flatpickr-day:hover {
    color: #8f93f6 !important; }
  .dark .calendar-s td[data-date="2020-11-13"] {
    background: rgba(255, 75, 75, 0.1); }
  .dark .calendar-s td[data-date="2020-11-02"] {
    background: rgba(254, 114, 28, 0.1); }
  .dark .calendar-s td[data-date="2020-11-12"] {
    background: rgba(55, 230, 178, 0.1); }
  .dark .calendar-s td[data-date="2020-12-07"] {
    background: rgba(135, 108, 254, 0.1); }
  .dark .calendar-s td[data-date="2020-12-10"] {
    background: rgba(71, 136, 255, 0.1); }
  .dark .calendar-s td[data-date="2020-11-16"] {
    background: rgba(1, 4, 27, 0.1); }
  .dark .calendar-s td[data-date="2020-11-28"] {
    background: rgba(71, 49, 182, 0.1); }
  .dark .calendar-s td[data-date="2020-12-16"] {
    background: rgba(55, 230, 178, 0.1); }
  .dark .calendar-s .fc-unthemed td.fc-today {
    background: rgba(71, 136, 255, 0.1) !important;
    color: #fff; }
  .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
    cursor: default;
    color: #A6A6A6 !important; }
    .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {
      cursor: default;
      color: #A6A6A6 !important; }
    .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover {
      cursor: default;
      color: #A6A6A6 !important; }
  .dark .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
    background-color: #2b343b !important; }
  .dark .iq-sidebar {
    background: #121212; }
  .dark .iq-sidebar-menu .iq-menu li a {
    color: #A6A6A6; }
    .dark .iq-sidebar-menu .iq-menu li a span {
      color: #A6A6A6; }
  .dark .iq-sidebar-menu .iq-menu li:hover > a {
    color: #8f93f6; }
    .dark .iq-sidebar-menu .iq-menu li:hover > a span {
      color: #8f93f6; }
  .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active > a {
    color: #8f93f6; }
    .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active > a span {
      color: #8f93f6; }
  .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active .iq-submenu li.active > a {
    color: #8f93f6; }
    .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active .iq-submenu li.active > a span {
      color: #8f93f6; }
  .dark .iq-top-navbar {
    background: #121212; }
    .dark .iq-top-navbar .iq-sub-dropdown {
      background: #121212; }
  .dark .navbar-list li .iq-sub-dropdown .iq-sub-card {
    color: #A6A6A6; }
  .dark .navbar-list li > a {
    color: #A6A6A6; }
  .dark .iq-search-bar .search-input {
    border-color: #27272A;
    background: #1D1D1F;
    color: #A6A6A6; }
  .dark .cust-title {
    border-color: #27272A; }
  .dark .iq-footer {
    background: #121212; }
    .dark .iq-footer ul li a {
      color: #A6A6A6; }
      .dark .iq-footer ul li a:hover {
        color: #8f93f6; }
  .dark .card {
    background-color: #121212;
    transition: all 0.3s ease-in-out; }
    .dark .card .card-header {
      border-color: #27272A; }
  .dark .card-transparent {
    background: transparent; }
  .dark .text-dark- {
    color: #fff !important; }
  .dark .text-body {
    color: #A6A6A6 !important; }
  .dark .text-muted {
    color: #A6A6A6 !important; }
  .dark .breadcrumb-item.active {
    color: #A6A6A6; }
  .dark .table {
    color: #A6A6A6; }
  .dark .tab-content .table tbody tr {
    color: #A6A6A6; }
  .dark .table-data .table tbody tr {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_paginate span .paginate_button.current {
    background: rgba(71, 136, 255, 0.1) !important; }
  .dark table.dataTable thead td {
    border-color: #27272A !important; }
  .dark table.dataTable thead th {
    border-color: #27272A !important; }
  .dark table.dataTable.no-footer {
    border-color: #27272A !important; }
  .dark .iq-top-navbar .navbar-toggler {
    background: #1D1D1F; }
  .dark .iq-alert-text p, .dark .iq-alert-text h1, .dark .iq-alert-text h2, .dark .iq-alert-text h3, .dark .iq-alert-text h4, .dark .iq-alert-text h5, .dark .iq-alert-text h6 {
    color: inherit; }
  .dark .border {
    border-color: #27272A !important; }
  .dark .border-bottom {
    border-color: #27272A !important; }
  .dark .breadcrumb {
    background: #1D1D1F; }
  .dark .list-group-item {
    background: #121212; }
  .dark .blockquote-footer {
    color: #A6A6A6; }
  .dark pre {
    color: #A6A6A6; }
  .dark .modal-content {
    background: #121212; }
  .dark .page-link {
    background-color: #121212; }
  .dark .page-item.disabled .page-link {
    background-color: #121212;
    border-color: #8f93f6; }
  .dark .popover {
    background-color: #121212; }
    .dark .popover .popover-header {
      background-color: #121212;
      color: #A6A6A6;
      border-color: #27272A; }
    .dark .popover .popover-body {
      color: #A6A6A6; }
  .dark .dropdown-menu {
    background-color: #1D1D1F; }
    .dark .dropdown-menu .dropdown-item {
      color: #A6A6A6; }
      .dark .dropdown-menu .dropdown-item:hover {
        background-color: #8f93f6;
        color: #fff; }
      .dark .dropdown-menu .dropdown-item:focus {
        background-color: #8f93f6; }
    .dark .dropdown-menu .dropdown-divider {
      border-top-color: #27272A; }
  .dark .nav-tabs .nav-item a {
    color: #A6A6A6; }
  .dark .nav-tabs .nav-item.show .nav-link {
    color: #8f93f6; }
  .dark .nav-tabs .nav-link.active {
    color: #8f93f6; }
  .dark .nav-pills .nav-item a {
    color: #A6A6A6; }
  .dark .nav-pills .nav-link.active {
    color: #8f93f6; }
  .dark .nav-pills .show > .nav-link {
    color: #8f93f6; }
  .dark .table-bordered {
    border-color: #27272A; }
    .dark .table-bordered td {
      border-color: #27272A; }
    .dark .table-bordered th {
      border-color: #27272A; }
  .dark .table-striped tbody tr:nth-of-type(odd) {
    background-color: #1D1D1F; }
  .dark .iq-example-row .row > .col {
    color: #A6A6A6; }
  .dark .iq-example-row .row > [class^=col-] {
    color: #A6A6A6; }
  .dark table.dataTable tbody tr {
    background-color: #121212; }
  .dark table.dataTable thead th {
    color: #ffffff !important; }
  .dark .table-hover tbody tr:hover {
    color: #fff; }
  .dark .dataTables_wrapper .dataTables_filter {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_info {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_length {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_paginate {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_processing {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_filter input {
    color: #A6A6A6; }
  .dark .dataTables_wrapper .dataTables_paginate .paginate_button {
    color: #A6A6A6 !important; }
  .dark .form-control {
    color: #A6A6A6;
    background: #1D1D1F;
    border-color: #27272A; }
  .dark .custom-file-label {
    background: #121212;
    border-color: #27272A; }
  .dark .input-group .input-group-append .input-group-text {
    border-color: #27272A;
    background-color: #1D1D1F; }
  .dark .input-group .input-group-prepend .input-group-text {
    border-color: #27272A;
    background-color: #1D1D1F; }
  .dark .custom-select {
    color: #A6A6A6;
    border-color: #27272A;
    background-color: #1D1D1F; }
  .dark .custom-file-label:after {
    background-color: #1D1D1F;
    color: #A6A6A6; }
  .dark ::placeholder {
    color: #A6A6A6; }
  .dark .form-control::placeholder {
    color: #A6A6A6; }
  .dark .select2-container--default .select2-selection--multiple {
    background-color: #1D1D1F;
    border-color: #27272A; }
  .dark .select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #121212;
    border-color: #27272A; }
  .dark .select2-container--default .select2-results__option[aria-selected=true] {
    background-color: #1D1D1F; }
  .dark .select2-results__options {
    background-color: #121212; }
  .dark .uploader-file label {
    background-color: #1D1D1F;
    border-color: #27272A; }
  .dark .ql-snow .ql-stroke {
    stroke: #fff; }
  .dark form.form-border .form-control {
    border-color: #27272A; }
  .dark .ic-square {
    border-color: #27272A; }
  .dark .swal2-popup {
    background: #121212; }
    .dark .swal2-popup .swal2-content {
      color: #A6A6A6; }
  .dark .flatpickr-calendar.inline {
    background: transparent; }
  .dark .flatpickr-calendar {
    background: #121212; }
  .dark .flatpickr-months .flatpickr-month {
    background: transparent;
    color: #fff;
    fill: #fff; }
  .dark .flatpickr-months .flatpickr-next-month svg {
    color: #fff;
    fill: #fff; }
  .dark .flatpickr-months .flatpickr-prev-month svg {
    color: #fff;
    fill: #fff; }
  .dark span.flatpickr-weekday {
    color: #fff; }
  .dark .stepwizard-row .wizard-step a.btn {
    background: #1D1D1F; }
  .dark #top-tabbar-vertical li a {
    background: #1D1D1F;
    color: #A6A6A6; }
  .dark .g-box {
    background: #1D1D1F; }
  .dark .g-desc {
    border-color: #27272A; }
  .dark .blog-left .blog-description {
    background: #121212; }
  .dark .blog-detail .blog-meta {
    background: #1D1D1F;
    color: #A6A6A6; }
  .dark .profile-box {
    background: #1D1D1F; }
  .dark .pro-content {
    background: #121212; }
  .dark .social-ic {
    background: #1D1D1F; }
    .dark .social-ic a i {
      color: #A6A6A6; }
  .dark .timeline-page .iq-timeline0 li .timeline-dots1 {
    background: #121212; }
  .dark .timeline-page .iq-timeline0 li .timeline-dots {
    background: #121212 !important; }
  .dark .timeline-page .iq-timeline1 li .timeline-dots {
    background: #121212; }
  .dark .prc-box.active .type {
    background: #8f93f6;
    color: #fff; }
  .dark .pricing-header {
    background-color: #1D1D1F; }
  .dark .print .table thead {
    background: #1D1D1F; }
  .dark .or-detail {
    background: #1D1D1F;
    border-color: #27272A; }
    .dark .or-detail .ttl-amt {
      border-color: #27272A; }
  .dark .subscriber-detail .iq-card-btn {
    border-color: #121212; }
  .dark .iq-accordion.career-style .iq-accordion-block .accordion-title span {
    color: #A6A6A6; }
  .dark .iq-accordion.career-style .iq-accordion-block .accordion-title:before {
    color: #A6A6A6; }
  .dark .iq-progress-bar.progress-bar-vertical > span:after {
    background: #121212; }
  .dark .chat-data {
    background: #121212; }
  .dark span.iq-start-icon {
    background: #1D1D1F; }
  .dark .chat-button {
    background: #1D1D1F;
    color: #A6A6A6; }
  .dark .chat-head .bg-white {
    background: #121212 !important;
    color: #A6A6A6 !important; }
  .dark .chat-footer.bg-white {
    background: #121212 !important;
    color: #A6A6A6 !important; }
  .dark .chat-content .chat-left .chat-message {
    background: #1D1D1F; }
  .dark .iq-chat-ui .nav-pills li a.active {
    background-color: #1D1D1F; }
  .dark ul.todo-task-lists li.active-task {
    background: #1D1D1F; }
  .dark ul.todo-task-lists li:hover {
    background: #1D1D1F; }
  .dark .iq-todo-page ul li a {
    color: #A6A6A6; }
  .dark .add-new-project > a {
    color: #A6A6A6; }
  .dark .chat-sidebar-channel h5 {
    border-color: #27272A; }
  .dark .iq-chat-ui li a {
    border-color: #27272A; }
  .dark .iq-email-listbox .iq-email-sender-list > li {
    border-color: #27272A; }
    .dark .iq-email-listbox .iq-email-sender-list > li:hover {
      background: #1D1D1F; }
  .dark .iq-email-listbox .iq-email-sender-list .iq-social-media {
    background: #1D1D1F; }
  .dark .email-app-details {
    background-color: #121212; }
  .dark .profile-overly {
    background: #1D1D1F; }
  .dark .light-title .card-title {
    color: #8f93f6; }
  .dark .view-crm a {
    color: #fff; }
  .dark .crm2 .feature-list {
    background-color: #1D1D1F; }
  .dark .crm2 .title-text {
    color: #fff; }
  .dark .crm2 .card-score {
    background: #1D1D1F; }
  .dark .crm2 .crm-p-image {
    border-color: #121212; }
  .dark .crm3 .calender-box li {
    background: #1D1D1F; }
  .dark .iq-social-icon a {
    color: #A6A6A6; }
  .dark .iq-acivity span {
    background: #121212; }
  .dark .iq-acivity:after {
    border-top-color: #27272A; }
  .dark .search-menu-options .form-control {
    background: #121212; }
  .dark .search-menu-options .iq-search-bar .search-input {
    background: #121212; }
  .dark .floating-input:focus ~ label {
    background: #1D1D1F; }
  .dark .floating-input:not(:placeholder-shown) ~ label {
    background: #1D1D1F;
    color: #A6A6A6; }
  .dark svg tspan {
    fill: #A6A6A6; }
  .dark .highcharts-background {
    fill: #121212; }
  .dark .jvectormap-container {
    background: #121212 !important; }
  .dark .card.iq-welcome {
    background-color: #121212 !important; }
  .dark .image-thumb .iq-thumb .iq-image-overlay {
    background: rgba(255, 255, 255, 0.1); }
  .dark .select-dropdown .btn-group .dropdown-menu {
    background: #1D1D1F; }
  .dark .select-dropdown .btn-group li .item {
    border-color: #27272A; }
    .dark .select-dropdown .btn-group li .item:hover {
      background-color: #1D1D1F; }
  .dark .select-dropdown .selet-caption {
    color: #FAFAFA; }
  .dark .select-dropdown > .selet-caption .arrow-down {
    color: #FAFAFA; }
  .dark .select-dropdown.list-item {
    background: #1D1D1F; }
    .dark .select-dropdown.list-item .item {
      border-color: #27272A; }
      .dark .select-dropdown.list-item .item:hover {
        background-color: #121212; }
  .dark .iq-search-bar .btn-group .dropdown-menu {
    background-color: #121212; }
  .dark .iq-search-bar .btn-group li .item {
    border-color: #27272A; }
  .dark .iq-search-bar .btn-group li:hover .item {
    background: #1D1D1F; }
  .dark .list-grid-toggle .icon.icon-grid.i-grid {
    color: #FAFAFA; }
  .dark .list-grid-toggle .icon.i-list {
    color: #FAFAFA; }
  .dark .new-create {
    border-color: #27272A; }
    .dark .new-create .selet-caption {
      background-color: #1D1D1F; }
  .dark .sidebar-bottom {
    border-color: #27272A; }
  .dark .dashboard1-info {
    background: #121212; }
    .dark .dashboard1-info .iq-dropdown {
      background: #1D1D1F; }
    .dark .dashboard1-info a {
      color: #FAFAFA; }
  .dark .iq-search-bar .searchbox .select-dropdown .selet-caption {
    color: #FAFAFA; }
  .dark .darkmode-logo {
    display: block !important; }
  .dark .profile-details {
    border-color: #27272A !important; }
  .dark .files-table .tbl-server-info tr.active {
    -ms-box-shadow: 0 0 13px 10px #202023;
    -o-box-shadow: 0 0 13px 10px #202023;
    box-shadow: 0 0 13px 10px #202023;
    border-radius: 8px; }
  .dark .files-table .tbl-server-info tr:hover {
    -ms-box-shadow: 0 0 13px 10px #202023;
    -o-box-shadow: 0 0 13px 10px #202023;
    box-shadow: 0 0 13px 10px #202023;
    border-radius: 8px; }
  .dark .plan-bg {
    background: #121212; }
  .dark .dropdown-bg.btn.bg-white {
    background: #121212 !important;
    color: #ffffff !important; }
  .dark .go-white .btn {
    background: #1D1D1F; }
    .dark .go-white .btn:hover {
      background: #6c71e3;
      color: #ffffff; }
  .dark .icon-statistic.bg-light {
    color: #ffffff !important;
    background: #1D1D1F !important; }
  .dark .profile-icon.bg-light {
    color: #ffffff !important;
    background: #1D1D1F !important; }
  .dark .badge-light.iq-number {
    color: #ffffff !important;
    background: #1D1D1F !important; }
  .dark .crm-p-image {
    border: 5px solid #27272A; }

@media (min-width: 1300px) {
  .dark .white-bg-menu {
    background: #121212; }
  .dark .header-style-4 .bg-pay-horizontal {
    background: transparent; }
  .dark .header-style-1 .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li > a {
    color: #fff; }
    .dark .header-style-1 .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li > a > span {
      color: #fff; }
  .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li > a {
    color: #fff; }
    .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li > a > span {
      color: #fff; }
  .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li:hover > a {
    color: #7fdd85; }
    .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li:hover > a > span {
      color: #7fdd85; }
  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li > a {
    color: #fff; }
    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li > a > span {
      color: #fff; }
  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li:hover > a {
    color: #fff; }
    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li:hover > a > span {
      color: #fff; }
  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu li.active > a {
    color: #fff; }
    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu li.active > a > span {
      color: #fff; }
  .login-content .sign-user_card {
    border-color: #27272A; } }

@media (max-width: 1299px) {
  .dark .iq-menu-horizontal {
    background: #121212; }
    .dark .iq-menu-horizontal ul.iq-menu {
      background: #121212; } }

@media (max-width: 991px) {
  .dark .navbar-collapse {
    background: #121212; } }

  .login-content .pf-sign-user_card {
      padding: 30px;
      border: none !important;
      text-align: center;
      border-radius: 8px;
  }

  .pf-shadow {
    -ms-box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);
    -o-box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);
    box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);
}

.header-logo{
  padding: 0px!important
}

.profile-logout{
  border-radius: 28px!important;
}
.profile-logout-tooltip .tooltip-inner, .profile-logout-tooltip .tooltip-arrow, .accordion-button:not(.collapsed){
  background-color: #fff;
  box-shadow: none;
}
#accordionUploadedBills .collapse, #accordionGSTR .collapse {
  visibility: visible;
}

.custom-switch {
  position: relative;
  display: flex;
  align-items: center;
  width: 150px; /* Adjust width for the larger switch */
}

.custom-switch .form-check-input {
  width: 60px; /* Adjust width for the larger switch slider */
  height: 34px; /* Adjust height for the larger switch slider */
  margin-right: 10px;
}

.custom-switch .form-check-label {
  position: absolute;
  width: 100%;
  text-align: center;
}

.custom-switch .form-check-input:checked + .form-check-label::before {
  content: "Approve";
  color: #28a745; /* Green color for 'Approve' */
}

.custom-switch .form-check-input:not(:checked) + .form-check-label::before {
  content: "Reject";
  color: #dc3545; /* Red color for 'Reject' */
}

/*override*/
.collapse{
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;AAED;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;EACpC,mCAAmC;EAGnC,eAAe;EACf,iBAAiB;EAGjB,cAAc;EAEd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,+MAA+M;EAC/M,6GAA6G,EAjCxE;;AAmCvC;;;EAGE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,6CAA6C,EAAE;;AAEjD;EACE,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB,EAAE;;AAE7B;EACE,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;;EAEE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,8BAA8B,EAAE;;AAElC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;;;EAGE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;;;;EAIE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB,EAAE;;AAE5B;EACE,cAAc,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B,EAAE;EAC/B;IACE,cAAc;IACd,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,qBAAqB,EAAE;;AAE3B;;;;EAIE,iGAAiG;EACjG,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,6BAA6B,EAAE;;AAEjC;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB,EAAE;;AAExB;EACE,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,0CAA0C,EAAE;;AAE9C;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;;EAEE,iBAAiB,EAAE;;AAErB;;EAEE,oBAAoB,EAAE;;AAExB;EACE,eAAe,EAAE;;AAEnB;EACE,iBAAiB,EAAE;;AAErB;;;;EAIE,0BAA0B,EAAE;;AAE9B;;;;EAIE,eAAe,EAAE;;AAEnB;;;;EAIE,UAAU;EACV,kBAAkB,EAAE;;AAEtB;;EAEE,sBAAsB;EACtB,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAE;;AAEb;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE;MACE,kCAAkC,EAAE,EAAE;;AAE5C;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,YAAY,EAAE;;AAEhB;EACE,oBAAoB;EACpB,wBAAwB,EAAE;;AAE5B;EACE,wBAAwB,EAAE;;AAE5B;EACE,aAAa;EACb,0BAA0B,EAAE;;AAE9B;EACE,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB,EAAE;EACrB;IACE;MACE,sCAAsC,EAAE,EAAE;;AAEhD;EACE,mBAAmB,EAAE;EACrB;IACE;MACE,sCAAsC,EAAE,EAAE;;AAEhD;EACE,mBAAmB,EAAE;EACrB;IACE;MACE,sCAAsC,EAAE,EAAE;;AAEhD;EACE,kBAAkB,EAAE;EACpB;IACE;MACE,oCAAoC,EAAE,EAAE;;AAE9C;EACE,iBAAiB,EAAE;;AAErB;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,kCAAkC,EAAE,EAAE;;AAE5C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,kCAAkC,EAAE,EAAE;;AAE5C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,kCAAkC,EAAE,EAAE;;AAE5C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE;MACE,kCAAkC,EAAE,EAAE;;AAE5C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,wCAAwC,EAAE;;AAE5C;;EAEE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;;EAEE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB,EAAE;EACvB;IACE,oBAAoB,EAAE;;AAE1B;EACE,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,cAAc;EACd,cAAc,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc,EAAE;;AAEpB;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD,EAAE;EACnD;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAE;EAChB;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB,EAAE;;AAExB;EACE,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAE;EACnB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE;MACE,iBAAiB,EAAE,EAAE;;AAE3B;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,cAAc,EAAE;EAChB;;IAEE,gBAAgB;IAChB,eAAe,EAAE;;AAErB;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,cAAc;EACd,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,aAAa;EACb,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,QAAQ,EAAE;;AAEZ;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,WAAW;IACX,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,mBAAmB;IACnB,oBAAoB,EAAE;EACxB;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,QAAQ,EAAE;EACZ;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,SAAS,EAAE;EACb;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,gBAAgB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc,EAAE;EAChB;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B,EAAE;EACjC;IACE,sBAAsB;IACtB,gCAAgC,EAAE;EACpC;IACE,6BAA6B,EAAE;;AAEnC;;EAEE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,wBAAwB,EAAE;;AAE9B;;;;EAIE,SAAS,EAAE;;AAEb;EACE,qCAAqC,EAAE;;AAEzC;EACE,cAAc;EACd,sCAAsC,EAAE;;AAE1C;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,yBAAyB,EAAE;;AAE7B;;;;EAIE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB,EAAE;EAC3B;;IAEE,yBAAyB,EAAE;;AAE/B;;;EAGE,sCAAsC,EAAE;;AAE1C;EACE,sCAAsC,EAAE;EACxC;;IAEE,sCAAsC,EAAE;;AAE5C;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;;AAEzB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;;;IAGE,qBAAqB,EAAE;EACzB;IACE,SAAS,EAAE;EACb;IACE,2CAA2C,EAAE;EAC/C;IACE,WAAW;IACX,4CAA4C,EAAE;;AAElD;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAE;IACnC;MACE,SAAS,EAAE,EAAE;;AAEnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAE;IACnC;MACE,SAAS,EAAE,EAAE;;AAEnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAE;IACnC;MACE,SAAS,EAAE,EAAE;;AAEnB;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC,EAAE;IACnC;MACE,SAAS,EAAE,EAAE;;AAEnB;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC,EAAE;EACnC;IACE,SAAS,EAAE;;AAEf;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,wEAAwE,EAAE;EAC1E;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,6BAA6B;IAC7B,SAAS,EAAE;EACb;IACE,kBAAkB;IAClB,0BAA0B,EAAE;EAC9B;IACE,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,wFAAwF,EAAE;EAC5F;IACE,cAAc;IACd,UAAU,EAAE;EACd;IACE,yBAAyB;IACzB,UAAU,EAAE;;AAEhB;;;;EAIE,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,sBAAsB,EAAE;;AAE1B;;EAEE,cAAc;EACd,WAAW,EAAE;;AAEf;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB,EAAE;EACrB;IACE,gBAAgB;IAChB,eAAe,EAAE;;AAErB;EACE,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE;EACnB;;IAEE,kBAAkB;IAClB,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAE;EACvB;;IAEE,cAAc,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBAAqB,EAAE;EACvB;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,cAAc,EAAE;;AAEpB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB,EAAE;;AAEtB;;;;EAIE,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,oCAAoC;EACpC,yDAAiR;EACjR,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE,EAAE;EAClE;IACE,qBAAqB;IACrB,kDAAkD,EAAE;;AAExD;EACE,oCAAoC;EACpC,kFAAkF,EAAE;;AAEtF;EACE,qBAAqB;EACrB,uCAAuC;EACvC,wNAAujB,EAAE;EACzjB;IACE,qBAAqB;IACrB,kDAAkD,EAAE;;AAExD;EACE,cAAc,EAAE;;AAElB;;;EAGE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,yBAAyB,EAAE;;AAE7B;EACE,kDAAkD,EAAE;;AAEtD;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,kDAAkD,EAAE;;AAEtD;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB,EAAE;;AAEtB;;;;EAIE,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,oCAAoC;EACpC,yDAA4U;EAC5U,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE,EAAE;EAClE;IACE,qBAAqB;IACrB,kDAAkD,EAAE;;AAExD;EACE,oCAAoC;EACpC,kFAAkF,EAAE;;AAEtF;EACE,qBAAqB;EACrB,uCAAuC;EACvC,wNAAknB,EAAE;EACpnB;IACE,qBAAqB;IACrB,kDAAkD,EAAE;;AAExD;EACE,cAAc,EAAE;;AAElB;;;EAGE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,yBAAyB,EAAE;;AAE7B;EACE,kDAAkD,EAAE;;AAEtD;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,kDAAkD,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE;EACrB;IACE,WAAW,EAAE;EACf;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB,EAAE;IACpB;MACE,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAE;IACpB;MACE,qBAAqB;MACrB,WAAW;MACX,sBAAsB,EAAE;IAC1B;MACE,qBAAqB,EAAE;IACzB;;MAEE,WAAW,EAAE;IACf;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,eAAe,EAAE;IACnB;MACE,kBAAkB;MAClB,cAAc;MACd,aAAa;MACb,qBAAqB;MACrB,cAAc,EAAE;IAClB;MACE,mBAAmB;MACnB,uBAAuB,EAAE;IAC3B;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,gCAAgC,EAAE;EAClC;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,UAAU,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B,EAAE;EAC/B;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;;;;EAIE,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;EACrB;IACE,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;IAChB,oCAAoC,EAAE;EACxC;IACE,cAAc,EAAE;;AAEpB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,8CAA8C,EAAE;;AAElD;EACE,WAAW;EACX,OAAO,EAAE;;AAEX;EACE,QAAQ;EACR,UAAU,EAAE;;AAEd;EACE;IACE,WAAW;IACX,OAAO,EAAE;EACX;IACE,QAAQ;IACR,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,WAAW;IACX,OAAO,EAAE;EACX;IACE,QAAQ;IACR,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,WAAW;IACX,OAAO,EAAE;EACX;IACE,QAAQ;IACR,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,WAAW;IACX,OAAO,EAAE;EACX;IACE,QAAQ;IACR,UAAU,EAAE,EAAE;;AAElB;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC,EAAE;;AAExC;EACE,cAAc,EAAE;;AAElB;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,wBAAwB,EAAE;;AAE5B;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EAGX,aAAa,EAHA;;AAKf;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,sCAAsC,EAAE;;AAE1C;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B,EAAE;;AAEjC;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAE;EACX;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,oBAAoB;IACpB,6BAA6B,EAAE;;AAEnC;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc,EAAE;;AAElB;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAE;EACxB;;IAEE,kBAAkB;IAClB,cAAc,EAAE;IAChB;;MAEE,UAAU,EAAE;IACd;;;;MAIE,UAAU,EAAE;;AAElB;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAE;EAC7B;IACE,WAAW,EAAE;;AAEjB;;EAEE,iBAAiB,EAAE;;AAErB;;EAEE,0BAA0B;EAC1B,6BAA6B,EAAE;;AAEjC;;EAEE,yBAAyB;EACzB,4BAA4B,EAAE;;AAEhC;EACE,wBAAwB;EACxB,uBAAuB,EAAE;EACzB;;;IAGE,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;;AAErB;EACE,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB;EACtB,qBAAqB,EAAE;;AAEzB;EACE,gDAAgD,EAAE;EAClD;IACE,gBAAgB,EAAE;;AAEtB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAE;EACzB;;IAEE,WAAW,EAAE;EACf;;IAEE,gBAAgB,EAAE;EACpB;;IAEE,6BAA6B;IAC7B,4BAA4B,EAAE;EAChC;;IAEE,yBAAyB;IACzB,0BAA0B,EAAE;;AAEhC;;EAEE,gBAAgB,EAAE;EAClB;;;;IAIE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAE;EACb;;;;IAIE,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY;IACZ,gBAAgB,EAAE;IAClB;;;;;;;;;;;;MAYE,iBAAiB,EAAE;EACvB;;;IAGE,UAAU,EAAE;EACd;IACE,UAAU,EAAE;EACd;;IAEE,0BAA0B;IAC1B,6BAA6B,EAAE;EACjC;;IAEE,yBAAyB;IACzB,4BAA4B,EAAE;EAChC;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;;MAEE,0BAA0B;MAC1B,6BAA6B,EAAE;IACjC;MACE,yBAAyB;MACzB,4BAA4B,EAAE;;AAEpC;;EAEE,aAAa,EAAE;EACf;;IAEE,kBAAkB;IAClB,UAAU,EAAE;IACZ;;MAEE,UAAU,EAAE;EAChB;;;;;;;;IAQE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;;IAEE,aAAa,EAAE;;AAEnB;;EAEE,gCAAgC,EAAE;;AAEpC;;;;;;EAME,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;;EAEE,kCAAkC,EAAE;;AAEtC;;;;;;EAME,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;;EAEE,sBAAsB,EAAE;;AAE1B;;;;;;EAME,0BAA0B;EAC1B,6BAA6B,EAAE;;AAEjC;;;;;;EAME,yBAAyB;EACzB,4BAA4B,EAAE;;AAEhC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB,EAAE;;AAExB;EACE,oBAAoB;EACpB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,eAAe;EACf,UAAU,EAAE;EACZ;IACE,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB,EAAE;EACpB;IACE,wFAAwF,EAAE;EAC5F;IACE,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,yBAAyB,EAAE;;AAEjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,gDAAgD,EAAE;EACpD;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mCAAmC,EAAE;;AAEzC;EACE,kBAAkB,EAAE;;AAEtB;EACE,yDAAkO,EAAE;;AAEtO;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB,EAAE;;AAEpB;EACE,yDAA+K,EAAE;;AAEnL;EACE,0CAA0C,EAAE;;AAE9C;EACE,0CAA0C,EAAE;;AAE9C;EACE,kBAAkB,EAAE;;AAEtB;EACE,yDAA8K,EAAE;;AAElL;EACE,0CAA0C,EAAE;;AAE9C;EACE,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,qBAAqB,EAAE;EACzB;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,yIAAyI,EAAE;IAC3I;MACE;QACE,gBAAgB,EAAE,EAAE;EAC1B;IACE,sBAAsB;IACtB,8BAA8B,EAAE;EAClC;IACE,0CAA0C,EAAE;;AAEhD;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gGAAuO;EACvO,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,UAAU;IACV,wFAAwF,EAAE;IAC1F;MACE,cAAc;MACd,sBAAsB,EAAE;EAC5B;IACE,YAAY;IACZ,sBAAsB;IACtB,sBAAsB,EAAE;EAC1B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,0BAA0B,EAAE;;AAEhC;EACE,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB,EAAE;;AAEtB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,UAAU,EAAE;EACZ;IACE,mBAAmB;IACnB,kDAAkD,EAAE;EACtD;;IAEE,yBAAyB,EAAE;EAC7B;IACE,iBAAiB,EAAE;EACrB;IACE,0BAA0B,EAAE;;AAEhC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD,EAAE;EAClD;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B,EAAE;;AAEhC;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,gBAAgB,EAAE;EAClB;IACE,aAAa,EAAE;IACf;MACE,qEAAqE,EAAE;IACzE;MACE,qEAAqE,EAAE;IACzE;MACE,qEAAqE,EAAE;EAC3E;IACE,SAAS,EAAE;EACb;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;IAC/C,oHAA4G;IAA5G,4GAA4G;IAC5G,gBAAgB,EAAE;IAClB;MACE;QACE,wBAAgB;QAAhB,gBAAgB,EAAE,EAAE;IACxB;MACE,uBAAuB,EAAE;EAC7B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,sDAAsD,EAAE;EAC1D;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;IAC/C,iHAA4G;IAA5G,4GAA4G;IAC5G,gBAAgB,EAAE;IAClB;MACE;QACE,qBAAgB;QAAhB,gBAAgB,EAAE,EAAE;IACxB;MACE,uBAAuB,EAAE;EAC7B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,sDAAsD,EAAE;EAC1D;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;IAC/C,gHAA4G;IAA5G,4GAA4G;IAC5G,gBAAgB,EAAE;IAClB;MACE;QACE,oBAAgB;QAAhB,gBAAgB,EAAE,EAAE;IACxB;MACE,uBAAuB,EAAE;EAC7B;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,oBAAoB;IACpB,sDAAsD,EAAE;EAC1D;IACE,yBAAyB;IACzB,mBAAmB,EAAE;EACvB;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,eAAe,EAAE;EACnB;IACE,yBAAyB,EAAE;EAC7B;IACE,eAAe,EAAE;EACnB;IACE,yBAAyB,EAAE;;AAE/B;;;EAGE,4GAA4G,EAAE;EAC9G;IACE;;;MAGE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,oBAAoB,EAAE;EACtB;IACE,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,oBAAoB;IACpB,eAAe,EAAE;;AAErB;EACE,gCAAgC,EAAE;EAClC;IACE,mBAAmB,EAAE;EACvB;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B,EAAE;IAC9B;MACE,qCAAqC,EAAE;IACzC;MACE,cAAc;MACd,6BAA6B;MAC7B,yBAAyB,EAAE;EAC/B;;IAEE,cAAc;IACd,yBAAyB;IACzB,qCAAqC,EAAE;EACzC;IACE,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B,EAAE;;AAEhC;EACE,kBAAkB,EAAE;;AAEtB;;EAEE,WAAW;EACX,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB,EAAE;EACtB;;IAEE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B,EAAE;;AAEpC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB,EAAE;EACrB;IACE,qBAAqB,EAAE;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,gBAAgB;IAChB,WAAW,EAAE;;AAEjB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB,EAAE;;AAE1B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB,EAAE;EACpB;IACE,qBAAqB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B,EAAE;;AAE9B;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE;;IAEE,gBAAgB;IAChB,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,qBAAqB;IACrB,2BAA2B,EAAE;IAC7B;MACE,mBAAmB,EAAE;MACrB;QACE,kBAAkB,EAAE;MACtB;QACE,qBAAqB;QACrB,oBAAoB,EAAE;IAC1B;;MAEE,iBAAiB,EAAE;IACrB;MACE,wBAAwB;MACxB,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE,EAAE;;AAEvB;EACE,qBAAqB;EACrB,2BAA2B,EAAE;EAC7B;;IAEE,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,mBAAmB,EAAE;IACrB;MACE,kBAAkB,EAAE;IACtB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;EAC1B;;IAEE,iBAAiB,EAAE;EACrB;IACE,wBAAwB;IACxB,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;;AAE/B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;;AAE/B;;;;EAIE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB;EACzB,gCAAgC,EAAE;;AAEpC;EACE,yDAAmR,EAAE;;AAEvR;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;IAC3B;MACE,yBAAyB,EAAE;;AAEjC;EACE,WAAW,EAAE;EACb;IACE,WAAW,EAAE;;AAEjB;EACE,+BAA+B,EAAE;EACjC;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE;;AAEtC;;;;EAIE,WAAW,EAAE;;AAEf;EACE,+BAA+B;EAC/B,sCAAsC,EAAE;;AAE1C;EACE,yDAAyR,EAAE;;AAE7R;EACE,+BAA+B,EAAE;EACjC;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;;AAEnB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB,EAAE;EACpB;IACE,eAAe;IACf,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,sBAAsB,EAAE;IACxB;MACE,mBAAmB;MACnB,2BAA2B;MAC3B,4BAA4B,EAAE;IAChC;MACE,sBAAsB;MACtB,+BAA+B;MAC/B,8BAA8B,EAAE;;AAEtC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,qBAAqB,EAAE;;AAEzB;EACE,oBAAoB,EAAE;;AAExB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C,EAAE;EAC/C;IACE,0BAA0B,EAAE;EAC9B;IACE,aAAa,EAAE;;AAEnB;EACE,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C,EAAE;EAC5C;IACE,0BAA0B,EAAE;;AAEhC;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,uBAAuB;EACvB,sBAAsB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB,EAAE;;AAEpB;;;EAGE,cAAc;EACd,WAAW,EAAE;;AAEf;;EAEE,2BAA2B;EAC3B,4BAA4B,EAAE;;AAEhC;;EAEE,+BAA+B;EAC/B,8BAA8B,EAAE;;AAElC;EACE,mBAAmB,EAAE;;AAEvB;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB,EAAE;IACpB;MACE,SAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE,EAAE;;AAE3B;EACE,mBAAmB,EAAE;;AAEvB;EACE;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;MACE,SAAY;MACZ,gBAAgB,EAAE;MAClB;QACE,cAAc;QACd,cAAc,EAAE;MAClB;QACE,0BAA0B;QAC1B,6BAA6B,EAAE;QAC/B;;UAEE,0BAA0B,EAAE;QAC9B;;UAEE,6BAA6B,EAAE;MACnC;QACE,yBAAyB;QACzB,4BAA4B,EAAE;QAC9B;;UAEE,yBAAyB,EAAE;QAC7B;;UAEE,4BAA4B,EAAE,EAAE;;AAE1C;EACE,sBAAsB,EAAE;;AAE1B;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,SAAS,EAAE;IACX;MACE,qBAAqB;MACrB,WAAW,EAAE,EAAE;;AAErB;EACE,gBAAgB,EAAE;EAClB;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B,EAAE;EAChC;IACE,yBAAyB;IACzB,0BAA0B,EAAE;EAC9B;IACE,gBAAgB;IAChB,mBAAmB,EAAE;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;EACf;IACE,oBAAoB,EAAE;IACtB;MACE,qBAAqB;MACrB,qBAAqB;MACrB,cAAc;MACd,YAAY,EAAE;EAClB;IACE,0BAA0B;IAE1B,qBAAqB,EAFO;EAG9B;IACE,cAAc,EAAE;;AAEpB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB,EAAE;EAC3B;IACE,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,UAAU;IACV,UAAU;IACV,kDAAkD,EAAE;;AAExD;EACE,cAAc;EACd,2BAA2B;EAC3B,8BAA8B,EAAE;;AAElC;EACE,4BAA4B;EAC5B,+BAA+B,EAAE;;AAEnC;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB,EAAE;;AAEzB;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B;EAC3B,8BAA8B,EAAE;;AAElC;EACE,4BAA4B;EAC5B,+BAA+B,EAAE;;AAEnC;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B;EAC3B,8BAA8B,EAAE;;AAElC;EACE,4BAA4B;EAC5B,+BAA+B,EAAE;;AAEnC;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,qIAAqI,EAAE;EACvI;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,qBAAqB,EAAE;EACzB;IACE,aAAa,EAAE;;AAEnB;EACE,kBAAkB;EAClB,SAAS,EAAE;;AAEb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,gDAAgD,EAAE;;AAEtD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,uBAAuB,EAAE;EAC3B;IACE,UAAU;IACV,4CAA4C,EAAE;;AAElD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,gDAAgD,EAAE;;AAEtD;EACE,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,+CAA+C,EAAE;;AAErD;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,iDAAiD,EAAE;;AAEvD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB,EAAE;;AAEtB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,wBAAwB;IACxB,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,YAAY,EAAE;;AAElB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,wBAAwB,EAAE,EAAE;;AAEhC;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD,EAAE;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B,EAAE;EAC7B;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,qMAAqM;EACrM,0BAA0B,EAAE;;AAE9B;EACE,kDAAkD,EAAE;EACpD;IACE;MACE,eAAe,EAAE,EAAE;;AAEzB;EACE,aAAa;EACb,uBAAuB,EAAE;;AAE3B;EACE,SAAO,EAAE;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,yBAAyB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,sCAAsC,EAAE;EACxC;IACE,+BAA+B;IAC/B,gCAAgC,EAAE;EACpC;IACE,mCAAmC;IACnC,kCAAkC,EAAE;EACtC;IACE,cAAc;IACd,oBAAoB;IACpB,sBAAsB,EAAE;EAC1B;IACE,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;IACrB;MACE,gBAAgB;MAChB,qBAAqB,EAAE;;AAE7B;EACE,mBAAmB,EAAE;EACrB;IACE,8BAA8B;IAC9B,0BAA0B,EAAE;EAC9B;IACE,4BAA4B;IAC5B,4BAA4B,EAAE;EAChC;IACE,aAAa,EAAE;EACjB;IACE,qBAAqB;IACrB,oBAAoB,EAAE;IACtB;MACE,iBAAiB;MACjB,sBAAsB,EAAE;;AAE9B;EACE;IACE,mBAAmB,EAAE;IACrB;MACE,8BAA8B;MAC9B,0BAA0B,EAAE;IAC9B;MACE,4BAA4B;MAC5B,4BAA4B,EAAE;IAChC;MACE,aAAa,EAAE;IACjB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;MACtB;QACE,iBAAiB;QACjB,sBAAsB,EAAE,EAAE;;AAElC;EACE;IACE,mBAAmB,EAAE;IACrB;MACE,8BAA8B;MAC9B,0BAA0B,EAAE;IAC9B;MACE,4BAA4B;MAC5B,4BAA4B,EAAE;IAChC;MACE,aAAa,EAAE;IACjB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;MACtB;QACE,iBAAiB;QACjB,sBAAsB,EAAE,EAAE;;AAElC;EACE;IACE,mBAAmB,EAAE;IACrB;MACE,8BAA8B;MAC9B,0BAA0B,EAAE;IAC9B;MACE,4BAA4B;MAC5B,4BAA4B,EAAE;IAChC;MACE,aAAa,EAAE;IACjB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;MACtB;QACE,iBAAiB;QACjB,sBAAsB,EAAE,EAAE;;AAElC;EACE;IACE,mBAAmB,EAAE;IACrB;MACE,8BAA8B;MAC9B,0BAA0B,EAAE;IAC9B;MACE,4BAA4B;MAC5B,4BAA4B,EAAE;IAChC;MACE,aAAa,EAAE;IACjB;MACE,qBAAqB;MACrB,oBAAoB,EAAE;MACtB;QACE,iBAAiB;QACjB,sBAAsB,EAAE,EAAE;;AAElC;EACE,gBAAgB,EAAE;EAClB;IACE,qBAAqB,EAAE;IACvB;MACE,sBAAsB,EAAE;;AAE9B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,cAAc;IACd,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,WAAW,EAAE;EACb;IACE;MACE,kCAAkC,EAAE,EAAE;EAC1C;IACE,WAAW;IACX,qBAAqB,EAAE;EACzB;IACE,YAAY,EAAE;;AAElB;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS,EAAE;;AAEb;EACE,oBAAoB,EAAE;;AAExB;EACE,gBAAgB,EAAE;EAClB;IACE,kBAAkB;IAClB,gBAAgB,EAAE;;AAEtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB,EAAE;EACtB;IACE,mCAAmC;IACnC,8BAA8B,EAAE;IAChC;MACE;QACE,gBAAgB,EAAE,EAAE;EAC1B;IACE,eAAe,EAAE;EACnB;IACE,sBAAsB,EAAE;;AAE5B;EACE,aAAa;EACb,6BAA6B,EAAE;EAC/B;IACE,8BAA8B;IAC9B,gBAAgB,EAAE;EACpB;;IAEE,cAAc,EAAE;EAClB;IACE,gBAAgB,EAAE;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B,EAAE;EAC/B;IACE,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAE;IACd;MACE,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C;EAC/C,UAAU,EAAE;;AAEd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAE;EACxB;IACE,UAAU,EAAE;EACd;IACE,YAAY,EAAE;;AAElB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B,EAAE;EAC9B;IACE,kBAAkB;IAClB,8BAA8B,EAAE;;AAEpC;EACE,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAE;;AAEjB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B,EAAE;EAChC;IACE,eAAe,EAAE;;AAErB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE;IACE,gBAAgB;IAChB,oBAAoB,EAAE;EACxB;IACE,+BAA+B,EAAE;IACjC;MACE,gCAAgC,EAAE;EACtC;IACE,+BAA+B,EAAE;IACjC;MACE,4BAA4B;MAC5B,mBAAmB,EAAE;EACzB;IACE,4CAA4C,EAAE;EAChD;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;;IAEE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU,EAAE;EACZ;IACE,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAE;;AAE3B;EACE,iBAAiB,EAAE;EACnB;IACE,SAAS,EAAE;IACX;MACE,MAAM;MACN,6BAA6B;MAC7B,sBAAsB,EAAE;;AAE9B;EACE,iBAAiB,EAAE;EACnB;IACE,OAAO;IACP,aAAa;IACb,cAAc,EAAE;IAChB;MACE,QAAQ;MACR,oCAAoC;MACpC,wBAAwB,EAAE;;AAEhC;EACE,iBAAiB,EAAE;EACnB;IACE,MAAM,EAAE;IACR;MACE,SAAS;MACT,6BAA6B;MAC7B,yBAAyB,EAAE;;AAEjC;EACE,iBAAiB,EAAE;EACnB;IACE,QAAQ;IACR,aAAa;IACb,cAAc,EAAE;IAChB;MACE,OAAO;MACP,oCAAoC;MACpC,uBAAuB,EAAE;;AAE/B;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C,EAAE;EACjD;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,cAAc;IACd,aAAa,EAAE;IACf;MACE,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAE;;AAE3B;EACE,qBAAqB,EAAE;EACvB;IACE,2BAA2B,EAAE;IAC7B;MACE,SAAS;MACT,6BAA6B;MAC7B,qCAAqC,EAAE;IACzC;MACE,WAAW;MACX,6BAA6B;MAC7B,sBAAsB,EAAE;;AAE9B;EACE,mBAAmB,EAAE;EACrB;IACE,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,aAAa,EAAE;IACf;MACE,OAAO;MACP,oCAAoC;MACpC,uCAAuC,EAAE;IAC3C;MACE,SAAS;MACT,oCAAoC;MACpC,wBAAwB,EAAE;;AAEhC;EACE,kBAAkB,EAAE;EACpB;IACE,wBAAwB,EAAE;IAC1B;MACE,MAAM;MACN,oCAAoC;MACpC,wCAAwC,EAAE;IAC5C;MACE,QAAQ;MACR,oCAAoC;MACpC,yBAAyB,EAAE;EAC/B;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gCAAgC,EAAE;;AAEtC;EACE,oBAAoB,EAAE;EACtB;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,aAAa,EAAE;IACf;MACE,QAAQ;MACR,oCAAoC;MACpC,sCAAsC,EAAE;IAC1C;MACE,UAAU;MACV,oCAAoC;MACpC,uBAAuB,EAAE;;AAE/B;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B,EAAE;EAC9B;IACE,aAAa,EAAE;;AAEnB;EACE,uBAAuB;EACvB,cAAc,EAAE;;AAElB;EACE,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAE;;AAEjB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC,EAAE;EACxC;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;;;EAGE,cAAc,EAAE;;AAElB;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,4BAA4B,EAAE;;AAEhC;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAE;;AAEnB;;;EAGE,UAAU;EACV,UAAU,EAAE;;AAEd;;EAEE,UAAU;EACV,UAAU;EACV,2BAA2B,EAAE;EAC7B;IACE;;MAEE,gBAAgB,EAAE,EAAE;;AAE1B;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B,EAAE;EAChC;IACE;;MAEE,gBAAgB,EAAE,EAAE;EACxB;;;IAGE,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY,EAAE;;AAElB;EACE,OAAO,EAAE;;AAEX;EACE,QAAQ,EAAE;;AAEZ;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC,EAAE;;AAEzC;EACE,yDAAsN,EAAE;;AAE1N;EACE,yDAAuN,EAAE;;AAE3N;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX,6BAA6B,EAAE;IAC/B;MACE;QACE,gBAAgB,EAAE,EAAE;EAC1B;IACE,UAAU,EAAE;;AAEhB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB,EAAE;;AAEtB;EACE,mCAAmC,EAAE;;AAEvC;EACE,8BAA8B,EAAE;;AAElC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,sCAAsC,EAAE;;AAE1C;EACE,mCAAmC,EAAE;;AAEvC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,uBAAuB;EACvB,oCAAoC,EAAE;;AAExC;;;EAGE,uBAAuB;EACvB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,uBAAuB;EACvB,oCAAoC,EAAE;;AAExC;;;EAGE,uBAAuB;EACvB,kCAAkC,EAAE;;AAEtC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,uBAAuB;EACvB,oCAAoC,EAAE;;AAExC;;;EAGE,uBAAuB;EACvB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,iCAAiC,EAAE;;AAErC;EACE,wCAAwC,EAAE;;AAE5C;EACE,oCAAoC,EAAE;;AAExC;EACE,wCAAwC,EAAE;;AAE5C;EACE,0CAA0C,EAAE;;AAE9C;EACE,2CAA2C,EAAE;;AAE/C;EACE,yCAAyC,EAAE;;AAE7C;EACE,oBAAoB,EAAE;;AAExB;EACE,wBAAwB,EAAE;;AAE5B;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,yBAAyB,EAAE;;AAE7B;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,sCAAsC;EACtC,uCAAuC,EAAE;;AAE3C;EACE,uCAAuC;EACvC,0CAA0C,EAAE;;AAE9C;EACE,0CAA0C;EAC1C,yCAAyC,EAAE;;AAE7C;EACE,sCAAsC;EACtC,yCAAyC,EAAE;;AAE7C;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,8BAA8B,EAAE;;AAElC;EACE,2BAA2B,EAAE;;AAE/B;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAE;;AAEf;EACE,wBAAwB,EAAE;;AAE5B;EACE,0BAA0B,EAAE;;AAE9B;EACE,gCAAgC,EAAE;;AAEpC;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,6BAA6B,EAAE;;AAEjC;EACE,8BAA8B,EAAE;;AAElC;EACE,wBAAwB,EAAE;;AAE5B;EACE,+BAA+B,EAAE;;AAEnC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,6BAA6B,EAAE;EACjC;IACE,8BAA8B,EAAE;EAClC;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,6BAA6B,EAAE;EACjC;IACE,8BAA8B,EAAE;EAClC;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,6BAA6B,EAAE;EACjC;IACE,8BAA8B,EAAE;EAClC;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,6BAA6B,EAAE;EACjC;IACE,8BAA8B,EAAE;EAClC;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,0BAA0B,EAAE;EAC9B;IACE,gCAAgC,EAAE;EACpC;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,6BAA6B,EAAE;EACjC;IACE,8BAA8B,EAAE;EAClC;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,WAAW,EAAE;EACf;;;;;IAKE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS,EAAE;;AAEf;EACE,sBAAsB,EAAE;;AAE1B;EACE,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB,EAAE;;AAErB;EACE,8BAA8B,EAAE;;AAElC;EACE,iCAAiC,EAAE;;AAErC;EACE,sCAAsC,EAAE;;AAE1C;EACE,yCAAyC,EAAE;;AAE7C;EACE,0BAA0B,EAAE;;AAE9B;EACE,4BAA4B,EAAE;;AAEhC;EACE,kCAAkC,EAAE;;AAEtC;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB,EAAE;;AAE3B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,sCAAsC,EAAE;;AAE1C;EACE,oCAAoC,EAAE;;AAExC;EACE,kCAAkC,EAAE;;AAEtC;EACE,yCAAyC,EAAE;;AAE7C;EACE,wCAAwC,EAAE;;AAE5C;EACE,kCAAkC,EAAE;;AAEtC;EACE,gCAAgC,EAAE;;AAEpC;EACE,8BAA8B,EAAE;;AAElC;EACE,gCAAgC,EAAE;;AAEpC;EACE,+BAA+B,EAAE;;AAEnC;EACE,oCAAoC,EAAE;;AAExC;EACE,kCAAkC,EAAE;;AAEtC;EACE,gCAAgC,EAAE;;AAEpC;EACE,uCAAuC,EAAE;;AAE3C;EACE,sCAAsC,EAAE;;AAE1C;EACE,iCAAiC,EAAE;;AAErC;EACE,2BAA2B,EAAE;;AAE/B;EACE,iCAAiC,EAAE;;AAErC;EACE,+BAA+B,EAAE;;AAEnC;EACE,6BAA6B,EAAE;;AAEjC;EACE,+BAA+B,EAAE;;AAEnC;EACE,8BAA8B,EAAE;;AAElC;EACE;IACE,8BAA8B,EAAE;EAClC;IACE,iCAAiC,EAAE;EACrC;IACE,sCAAsC,EAAE;EAC1C;IACE,yCAAyC,EAAE;EAC7C;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,kCAAkC,EAAE;EACtC;IACE,yBAAyB,EAAE;EAC7B;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,sCAAsC,EAAE;EAC1C;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,yCAAyC,EAAE;EAC7C;IACE,wCAAwC,EAAE;EAC5C;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,8BAA8B,EAAE;EAClC;IACE,gCAAgC,EAAE;EACpC;IACE,+BAA+B,EAAE;EACnC;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,uCAAuC,EAAE;EAC3C;IACE,sCAAsC,EAAE;EAC1C;IACE,iCAAiC,EAAE;EACrC;IACE,2BAA2B,EAAE;EAC/B;IACE,iCAAiC,EAAE;EACrC;IACE,+BAA+B,EAAE;EACnC;IACE,6BAA6B,EAAE;EACjC;IACE,+BAA+B,EAAE;EACnC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,8BAA8B,EAAE;EAClC;IACE,iCAAiC,EAAE;EACrC;IACE,sCAAsC,EAAE;EAC1C;IACE,yCAAyC,EAAE;EAC7C;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,kCAAkC,EAAE;EACtC;IACE,yBAAyB,EAAE;EAC7B;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,sCAAsC,EAAE;EAC1C;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,yCAAyC,EAAE;EAC7C;IACE,wCAAwC,EAAE;EAC5C;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,8BAA8B,EAAE;EAClC;IACE,gCAAgC,EAAE;EACpC;IACE,+BAA+B,EAAE;EACnC;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,uCAAuC,EAAE;EAC3C;IACE,sCAAsC,EAAE;EAC1C;IACE,iCAAiC,EAAE;EACrC;IACE,2BAA2B,EAAE;EAC/B;IACE,iCAAiC,EAAE;EACrC;IACE,+BAA+B,EAAE;EACnC;IACE,6BAA6B,EAAE;EACjC;IACE,+BAA+B,EAAE;EACnC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,8BAA8B,EAAE;EAClC;IACE,iCAAiC,EAAE;EACrC;IACE,sCAAsC,EAAE;EAC1C;IACE,yCAAyC,EAAE;EAC7C;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,kCAAkC,EAAE;EACtC;IACE,yBAAyB,EAAE;EAC7B;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,sCAAsC,EAAE;EAC1C;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,yCAAyC,EAAE;EAC7C;IACE,wCAAwC,EAAE;EAC5C;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,8BAA8B,EAAE;EAClC;IACE,gCAAgC,EAAE;EACpC;IACE,+BAA+B,EAAE;EACnC;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,uCAAuC,EAAE;EAC3C;IACE,sCAAsC,EAAE;EAC1C;IACE,iCAAiC,EAAE;EACrC;IACE,2BAA2B,EAAE;EAC/B;IACE,iCAAiC,EAAE;EACrC;IACE,+BAA+B,EAAE;EACnC;IACE,6BAA6B,EAAE;EACjC;IACE,+BAA+B,EAAE;EACnC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE;IACE,8BAA8B,EAAE;EAClC;IACE,iCAAiC,EAAE;EACrC;IACE,sCAAsC,EAAE;EAC1C;IACE,yCAAyC,EAAE;EAC7C;IACE,0BAA0B,EAAE;EAC9B;IACE,4BAA4B,EAAE;EAChC;IACE,kCAAkC,EAAE;EACtC;IACE,yBAAyB,EAAE;EAC7B;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,sCAAsC,EAAE;EAC1C;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,yCAAyC,EAAE;EAC7C;IACE,wCAAwC,EAAE;EAC5C;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,8BAA8B,EAAE;EAClC;IACE,gCAAgC,EAAE;EACpC;IACE,+BAA+B,EAAE;EACnC;IACE,oCAAoC,EAAE;EACxC;IACE,kCAAkC,EAAE;EACtC;IACE,gCAAgC,EAAE;EACpC;IACE,uCAAuC,EAAE;EAC3C;IACE,sCAAsC,EAAE;EAC1C;IACE,iCAAiC,EAAE;EACrC;IACE,2BAA2B,EAAE;EAC/B;IACE,iCAAiC,EAAE;EACrC;IACE,+BAA+B,EAAE;EACnC;IACE,6BAA6B,EAAE;EACjC;IACE,+BAA+B,EAAE;EACnC;IACE,8BAA8B,EAAE,EAAE;;AAEtC;EACE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB,EAAE;;AAE1B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE,EAAE;;AAE9B;EACE,mCAA2B;UAA3B,2BAA2B,EAAE;;AAE/B;EACE,oCAA4B;UAA5B,4BAA4B,EAAE;;AAEhC;EACE,oCAA4B;UAA5B,4BAA4B,EAAE;;AAEhC;EACE,yBAAyB,EAAE;;AAE7B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa,EAAE;;AAEjB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa,EAAE;;AAEjB;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa,EAAE,EAAE;;AAErB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAE;;AAEb;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB,EAAE;;AAEvB;EACE,kDAAkD,EAAE;;AAEtD;EACE,kDAAkD,EAAE;;AAEtD;EACE,kDAAkD,EAAE;;AAEtD;EACE,2BAA2B,EAAE;;AAE/B;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE;;AAE3B;EACE,uBAAuB,EAAE;;AAE3B;EACE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,4BAA4B,EAAE;;AAEhC;EACE,uBAAuB,EAAE;;AAE3B;EACE,wBAAwB,EAAE;;AAE5B;EACE,oBAAoB,EAAE;;AAExB;;EAEE,wBAAwB,EAAE;;AAE5B;;EAEE,0BAA0B,EAAE;;AAE9B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,yBAAyB,EAAE;;AAE7B;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,8BAA8B,EAAE;;AAElC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE,yBAAyB,EAAE;;AAE7B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,8BAA8B,EAAE;;AAElC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE,qBAAqB,EAAE;;AAEzB;;EAEE,yBAAyB,EAAE;;AAE7B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,0BAA0B,EAAE;;AAE9B;EACE,2BAA2B,EAAE;;AAE/B;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,kCAAkC,EAAE;;AAEtC;;EAEE,gCAAgC,EAAE;;AAEpC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,2BAA2B,EAAE;;AAE/B;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,kCAAkC,EAAE;;AAEtC;;EAEE,gCAAgC,EAAE;;AAEpC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,0BAA0B,EAAE;;AAE9B;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,gCAAgC,EAAE;;AAEpC;;EAEE,iCAAiC,EAAE;;AAErC;;EAEE,+BAA+B,EAAE;;AAEnC;EACE,wBAAwB,EAAE;;AAE5B;;EAEE,4BAA4B,EAAE;;AAEhC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,+BAA+B,EAAE;;AAEnC;;EAEE,6BAA6B,EAAE;;AAEjC;EACE,uBAAuB,EAAE;;AAE3B;;EAEE,2BAA2B,EAAE;;AAE/B;;EAEE,6BAA6B,EAAE;;AAEjC;;EAEE,8BAA8B,EAAE;;AAElC;;EAEE,4BAA4B,EAAE;;AAEhC;EACE;IACE,oBAAoB,EAAE;EACxB;;IAEE,wBAAwB,EAAE;EAC5B;;IAEE,0BAA0B,EAAE;EAC9B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,yBAAyB,EAAE;EAC7B;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,qBAAqB,EAAE;EACzB;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,0BAA0B,EAAE;EAC9B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,oBAAoB,EAAE;EACxB;;IAEE,wBAAwB,EAAE;EAC5B;;IAEE,0BAA0B,EAAE;EAC9B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,yBAAyB,EAAE;EAC7B;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,qBAAqB,EAAE;EACzB;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,0BAA0B,EAAE;EAC9B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,oBAAoB,EAAE;EACxB;;IAEE,wBAAwB,EAAE;EAC5B;;IAEE,0BAA0B,EAAE;EAC9B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,yBAAyB,EAAE;EAC7B;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,qBAAqB,EAAE;EACzB;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,0BAA0B,EAAE;EAC9B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE,EAAE;;AAEpC;EACE;IACE,oBAAoB,EAAE;EACxB;;IAEE,wBAAwB,EAAE;EAC5B;;IAEE,0BAA0B,EAAE;EAC9B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,yBAAyB,EAAE;EAC7B;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,yBAAyB,EAAE;EAC7B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,8BAA8B,EAAE;EAClC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE;EAChC;IACE,qBAAqB,EAAE;EACzB;;IAEE,yBAAyB,EAAE;EAC7B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,0BAA0B,EAAE;EAC9B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,2BAA2B,EAAE;EAC/B;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,kCAAkC,EAAE;EACtC;;IAEE,gCAAgC,EAAE;EACpC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,0BAA0B,EAAE;EAC9B;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,gCAAgC,EAAE;EACpC;;IAEE,iCAAiC,EAAE;EACrC;;IAEE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE;EAC5B;;IAEE,4BAA4B,EAAE;EAChC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,+BAA+B,EAAE;EACnC;;IAEE,6BAA6B,EAAE;EACjC;IACE,uBAAuB,EAAE;EAC3B;;IAEE,2BAA2B,EAAE;EAC/B;;IAEE,6BAA6B,EAAE;EACjC;;IAEE,8BAA8B,EAAE;EAClC;;IAEE,4BAA4B,EAAE,EAAE;;AAEpC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,kCAAkC,EAAE;;AAEtC;EACE,4GAA4G,EAAE;;AAEhH;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAE;;AAEvB;EACE,2BAA2B,EAAE;;AAE/B;EACE,4BAA4B,EAAE;;AAEhC;EACE,6BAA6B,EAAE;;AAEjC;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,4BAA4B,EAAE;EAChC;IACE,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,4BAA4B,EAAE;EAChC;IACE,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,4BAA4B,EAAE;EAChC;IACE,6BAA6B,EAAE,EAAE;;AAErC;EACE;IACE,2BAA2B,EAAE;EAC/B;IACE,4BAA4B,EAAE;EAChC;IACE,6BAA6B,EAAE,EAAE;;AAErC;EACE,oCAAoC,EAAE;;AAExC;EACE,oCAAoC,EAAE;;AAExC;EACE,qCAAqC,EAAE;;AAEzC;EACE,2BAA2B,EAAE;;AAE/B;EACE,+BAA+B,EAAE;;AAEnC;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,8BAA8B,EAAE;;AAElC;EACE,6BAA6B,EAAE;;AAEjC;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,oCAAoC,EAAE;;AAExC;EACE,0CAA0C,EAAE;;AAE9C;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS,EAAE;;AAEb;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,yBAAyB,EAAE;;AAE7B;EACE,8BAA8B,EAAE;;AAElC;EACE,6BAA6B,EAAE;;AAEjC;EACE;;;IAGE,4BAA4B;IAC5B,2BAA2B,EAAE;EAC/B;IACE,0BAA0B,EAAE;EAC9B;IACE,6BAA6B,EAAE;EACjC;IACE,gCAAgC,EAAE;EACpC;;IAEE,yBAAyB;IACzB,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE;EAC/B;;IAEE,wBAAwB,EAAE;EAC5B;;;IAGE,UAAU;IACV,SAAS,EAAE;EACb;;IAEE,uBAAuB,EAAE;EAC3B;IACE,QAAQ,EAAE;EACZ;IACE,2BAA2B,EAAE;EAC/B;IACE,2BAA2B,EAAE;EAC/B;IACE,aAAa,EAAE;EACjB;IACE,sBAAsB,EAAE;EAC1B;IACE,oCAAoC,EAAE;IACtC;;MAEE,iCAAiC,EAAE;EACvC;;IAEE,oCAAoC,EAAE;EACxC;IACE,cAAc,EAAE;IAChB;;;;MAIE,qBAAqB,EAAE;EAC3B;IACE,cAAc;IACd,qBAAqB,EAAE,EAAE;;AAE7B,iDAAiD;AACjD;EACE,gBAAgB;EAKhB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EAGZ,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC,EAAE;EACzC;IACE,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAEhB,8BAA8B;IAC9B,gBAAgB,EAAE;IAClB;MACE,gBAAgB,EAAE;;AAExB;EACE,uBAAuB;EAKvB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB,EAAE;EAClB;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAEhB,8BAA8B;IAC9B,YAAY,EAAE;IACd;MACE,gBAAgB,EAAE;;AAExB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B,EAAE;;AAE/B;EACE,aAAa,EAAE;;AAEjB;EAKE,kBAAkB,EAAE;;AAEtB;EAGE,oBAAoB,EAAE;;AAExB;EACE,2BAA2B,EAAE;;AAE/B;EACE,wBAAwB,EAAE;;AAE5B;EACE,yBAAyB,EAAE;;AAE7B;EAGE,aAAa;EAGb,YAAY;EAIZ,sBAAsB,EAAE;;;AAG1B;EACE,aAAa,EAAE;;AAEjB;EACE;AACF;;AAEA;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB,EAAE;EACpB;IACE,SAAS;IACT,UAAU;IACV,qBAAqB,EAAE;IACvB;MACE,cAAc;MACd,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,gBAAgB;MAChB,iBAAiB,EAAE;MACnB;QACE,aAAa,EAAE;IACnB;MACE,qBAAqB;MACrB,kBAAkB;MAClB,mBAAmB,EAAE;MACrB;QACE,SAAS;QACT,kCAAkC,EAAE;QACpC;UACE,eAAe,EAAE;MACrB;QACE,eAAe;QACf,mBAAmB;QACnB,cAAc;QACd,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QAGjB,aAAa;QAGb,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,0BAA0B,EAAE;QAC5B;UACE,eAAe;UACf,kBAAkB;UAClB,sBAAsB;UACtB,WAAW;UACX,qBAAqB,EAAE;QACzB;UACE,mBAAmB;UACnB,UAAU;UACV,qBAAqB;UAKrB,gBAAgB,EAAE;QACpB;UACE,iBAAiB;UACjB,iBAAiB;UACjB,eAAe;UACf,WAAW;UAKX,gCAAgC,EAAE;QACpC;UACE,kBAAkB;UAClB,WAAW;UAKX,gCAAgC,EAAE;MACtC;QAKE,gCAAgC,EAAE;MACpC;QACE,eAAe;QACf,kBAAkB,EAAE;MACtB;QACE,gBAAgB,EAAE;IACtB;MACE,cAAc;MACd,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB,EAAE;IACpB;MACE,uBAAuB,EAAE;;AAE/B;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;EACE,uBAAuB,EAAE;;AAE3B;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB,EAAE;;AAEtB;EACE,SAAS,EAAE;;AAEb;EACE,cAAc;EACd,qBAAqB,EAAE;;AAEzB;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EAKE,0BAA0B,EAAE;;AAE9B;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EAKR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU,EAAE;;AAEd;EACE,UAAU;EACV,UAAU,EAAE;;AAEd;EACE,UAAU;EACV,UAAU,EAAE;;AAEd;EACE,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;EAClB;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,oBAAoB;EACpB,6BAA6B,EAAE;EAC/B;IACE,gBAAgB;IAChB,gBAAgB,EAAE;;AAEtB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAKlB,gCAAgC,EAAE;EAClC;IACE,aAAa;IACb,uBAAuB,EAAE;IACzB;MACE,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,iBAAiB;MACjB,qBAAqB;MACrB,gBAAgB;MAChB,SAAO;MAKP,gCAAgC,EAAE;IACpC;MACE,eAAe;MACf,mBAAmB,EAAE;IACvB;MACE,qBAAqB,EAAE;IACzB;MACE,qBAAqB,EAAE;EAC3B;IACE,YAAY,EAAE;;AAElB;EACE,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;;AAEtB;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAKlB,gCAAgC,EAAE;;AAEpC;EACE;IACE,aAAa,EAAE;EACjB;IACE,WAAW,EAAE;IACb;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU;MACV,aAAa;MAKb,gCAAgC,EAAE;IACpC;MACE,aAAa,EAAE;EACnB;IACE,aAAa,EAAE;IACf;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU;MACV,aAAa;MAKb,gCAAgC,EAAE;EACtC;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,aAAa;IAKb,gCAAgC,EAAE;EACpC;IACE,eAAe;IACf,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;EAClB;IACE,cAAc;IACd,kBAAkB,EAAE;EACtB;IACE,kBAAkB,EAAE;EACtB;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,QAAQ,EAAE;EACZ;IACE,YAAY;IACZ,OAAO;IACP,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,aAAa,EAAE,EAAE;;AAErB;EACE;IACE,4CAA4C,EAAE;EAChD;IACE,2CAA2C,EAAE,EAAE;;AAEnD;EACE;IACE,4CAA4C,EAAE;EAChD;IACE,2CAA2C,EAAE,EAAE;;AAEnD;EACE;IACE,8CAA8C,EAAE;EAClD;IACE,6CAA6C,EAAE,EAAE;;AAErD;EACE;IACE,8CAA8C,EAAE;EAClD;IACE,6CAA6C,EAAE,EAAE;;AAoBrD;EACE;IAEE,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE;EACd;IAEE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE,EAAE;;AAElB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,SAAS;EAKT,gCAAgC;EAGhC,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC,EAAE;EACzC;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe,EAAE;EACnB;IACE,uBAAuB;IACvB,UAAU;IACV,SAAS,EAAE;IACX;MACE,cAAc,EAAE;IAClB;MACE,qBAAqB;MACrB,eAAe,EAAE;MACjB;QACE,qBAAqB,EAAE;QACvB;UACE,qBAAqB,EAAE;EAC/B;IACE,yCAAyC,EAAE;EAC7C;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IAEZ,uEAAuE;IAEvE,2BAA2B;IAC3B,sBAAsB;IAMtB,UAAU;IAKV,kBAAkB;IAGlB,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC;IAKvC,gCAAgC,EAAE;IAClC;MAKE,0BAA0B,EAAE;EAChC;IACE,WAAW,EAAE;EACf;IACE,eAAe;IACf,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,MAAM;IACN,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAKlB,2BAA2B;IAK3B,gCAAgC,EAAE;EACpC;IACE,UAAU,EAAE;;AAEhB;EACE,wBAAwB,EAAE;;AAE5B;EACE,SAAS;EACT,QAAQ;EACR,yBAAyB;EAKzB,gBAAgB;EAKhB,gCAAgC,EAAE;;AAEpC;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,UAAU;EACV,YAAY,EAAE;EACd;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB,EAAE;IACpB;MACE,iBAAiB;MACjB,eAAe,EAAE;MACjB;QAEE,uEAAuE;QAKvE,2BAA2B,EAAE;IACjC;MACE,aAAa,EAAE;IACjB;MACE,eAAe,EAAE;IACnB;MACE,cAAc;MACd,eAAe;MACf,eAAe;MACf,cAAc;MACd,iBAAiB,EAAE;MACnB;QACE,WAAW;QACX,YAAY;QACZ,eAAe,EAAE;IACrB;MACE,qBAAqB,EAAE;IACzB;MACE,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,WAAW;MACX,kBAAkB;MAKlB,kBAAkB,EAAE;MACpB;QACE,cAAc;QACd,eAAe,EAAE;IACrB;MACE,kBAAkB;MAClB,iBAAiB;MACjB,gCAAgC;MAChC,mBAAmB;MACnB,cAAc;MACd,qBAAqB;MACrB,WAAW,EAAE;MACb;QACE,iBAAiB;QACjB,SAAS,EAAE;MACb;QACE,eAAe;QACf,sBAAsB;QACtB,mBAAmB,EAAE;IACzB;MACE,WAAW,EAAE;EACjB;IACE,aAAa;IACb,uBAAuB,EAAE;IACzB;MACE,SAAO;MACP,eAAe,EAAE;EACrB;IACE,mBAAmB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EAEX,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,iCAAiC;EAKjC,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,mCAAmC;EAKnC,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,kBAAkB;EAClB,6BAA6B,EAAE;;AAEjC;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EAKd,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B,EAAE;EAC7B;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS,EAAE;EACb;IACE,kBAAkB,EAAE;IACpB;MACE,eAAe;MACf,sBAAsB;MACtB,kBAAkB;MAClB,YAAY;MAKZ,kBAAkB,EAAE;;AAE1B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,2BAA2B;EAG3B,+CAA+C;EAC/C,8CAA8C;EAC9C,2CAA2C,EAAE;;AAE/C;EACE,SAAS,EAAE;;AAEb;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc,EAAE;EAChB;IACE,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,EAAE;;AAExB;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EAKf,kBAAkB;EAClB,yBAAyB,EAAE;;AAE7B;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAE;;AAEZ;EACE,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAKhB,gCAAgC;EAChC,uBAAuB,EAAE;EACzB;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;MACE,iBAAiB;MACjB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,0BAA0B;MAC1B,SAAO;MAKP,gCAAgC,EAAE;IACpC;MACE,qBAAqB,EAAE;IACzB;MACE,qBAAqB,EAAE;EAC3B;IACE,YAAY,EAAE;;AAElB;EACE,YAAY,EAAE;;AAEhB;EACE,gCAAgC,EAAE;;AAEpC;EACE,mBAAmB;EACnB,aAAa;EAKb,kBAAkB,EAAE;;AAEtB;EAKE,0BAA0B,EAAE;;AAE9B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EAKjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EAKE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB,EAAE;EACzB;IACE,mBAAmB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU;EACV,mBAAmB;EAKnB,wBAAwB;EAKxB,gCAAgC,EAAE;;AAEpC;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAE;;AAEnB;EACE,mBAAmB;EACnB,cAAc;EAKd,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,kBAAkB;CACnB;;AAED;EACE,aAAa,EAAE;;AAEjB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE;IACE,wBAAwB,EAAE;IAC1B;MACE,aAAa,EAAE;EACnB;IACE,oBAAoB,EAAE,EAAE;;AAE5B;EACE;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,WAAW,EAAE;IACb;MACE,iBAAiB,EAAE;EACvB;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,aAAa,EAAE;EACjB;IACE,mBAAmB,EAAE,EAAE;;AAE3B;EACE;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAKhB,kBAAkB;IAGlB,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC,EAAE;EAC3C;IACE,YAAY;IACZ,qBAAqB,EAAE;EACzB;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB,EAAE;IACnB;MACE,cAAc;MACd,mBAAmB;MACnB,YAAY;MACZ,qBAAqB;MACrB,kBAAkB;MAClB,eAAe,EAAE;IACnB;MACE,YAAY,EAAE;IAChB;MACE,mBAAmB,EAAE;EACzB;IACE,WAAW,EAAE;EACf;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,kBAAkB,EAAE;EACtB;IACE,OAAO;IACP,QAAQ;IACR,cAAc;IACd,YAAY,EAAE;EAChB;IACE,WAAW,EAAE;EACf;IACE,YAAY,EAAE;EAChB;IACE,gBAAgB,EAAE;IAClB;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE;IACE,eAAe,EAAE;IACjB;MACE,WAAW;MACX,YAAY;MACZ,eAAe,EAAE,EAAE;;AAEzB;EACE,cAAc,EAAE;;AAElB;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,wCAAwC;EAKxC,gCAAgC,EAAE;EAClC;IACE,aAAa,EAAE;;AAEnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,MAAM;EACN,WAAW;EAKX,4BAA4B;EAG5B,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe,EAAE;EACjB;IACE,wBAAwB,EAAE;;AAE9B;EACE,sBAAsB;EAGtB,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE;;AAEtB;EACE,uCAAuC,EAAE;EACzC;IACE,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE;IACE,uCAAuC,EAAE;IACzC;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU;MACV,kBAAkB;MAKlB,gCAAgC,EAAE;EACtC;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,cAAc;IAKd,gCAAgC,EAAE;EACpC;IACE,wCAAwC,EAAE;IAC1C;MACE,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU,EAAE;EAChB;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,wCAAwC,EAAE;IAC1C;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU,EAAE;EAChB;IACE,uCAAuC,EAAE;IACzC;MACE,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU,EAAE,EAAE;;AAEpB;EACE,wCAAwC,EAAE;;AAE5C;EACE,6CAA6C,EAAE;;AAEjD;EACE,4CAA4C,EAAE;;AAEhD;EACE,8CAA8C,EAAE;;AAElD;EACE,6CAA6C,EAAE;;AAEjD;EACE,gDAAgD,EAAE;;AAEpD;EACE,8CAA8C,EAAE;;AAElD;EACE,4CAA4C,EAAE;;AAEhD;EACE;IAKE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE,EAAE;;AAElB;EACE,QAAQ;EACR,SAAS;EAKT,kBAAkB;EAClB,mBAAmB;EAKnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU,EAAE;;AAEd;EACE,gCAAgC,EAAE;;AAEpC;EACE,qBAAqB;EACrB,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,uBAAuB,EAAE;;AAE3B;EACE,SAAO,EAAE;;AAEX;EACE,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EAKV,gCAAgC,EAAE;EAClC;IACE,UAAU,EAAE;EACd;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;;AAEpB;EACE,yBAAyB,EAAE;;AAE7B;EAGE,oBAAoB;EACpB,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB,EAAE;EACxB;IACE,qBAAqB,EAAE;;AAE3B;EACE,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAK1B,kBAAkB,EAAE;;AAEtB;EACE,WAAW,EAAE;;AAEf;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C,EAAE;EAC5C;IACE,cAAc,EAAE;;AAEpB;EAGE,aAAa;EAGb,oBAAoB,EAAE;EACtB;IAGE,aAAa;IAGb,mBAAmB;IACnB,sBAAsB,EAAE;IACxB;MACE,kBAAkB;MAClB,mBAAmB,EAAE;EACzB;IAEE,kBAAkB;IAGlB,YAAY,EAAE;EAChB;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,UAAU,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,wCAAwC,EAAE;;AAE5C;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,wCAAwC,EAAE;;AAE5C;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC,EAAE;;AAE1C;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,cAAc,EAAE;;AAElB;EACE,gCAAgC;EAChC,mBAAmB,EAAE;EACrB;IACE,mBAAmB,EAAE;IACrB;MACE,cAAc;MACd,YAAY;MACZ,oCAAoC,EAAE;EAC1C;IACE,gCAAgC;IAChC,cAAc,EAAE;EAClB;IACE,gCAAgC;IAChC,cAAc,EAAE;;AAEpB;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,oCAAoC;EACpC,gCAAgC,EAAE;;AAEpC;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EAKf,mBAAmB;EAKnB,gCAAgC,EAAE;;AAEpC;EAKE,mBAAmB;EACnB,WAAW,EAAE;;AAEf;EACE,aAAa,EAAE;;AAEjB;EACE,yBAAyB;EACzB,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB;EACzB,cAAc,EAAE;;AAElB;EACE,yBAAyB;EACzB,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;EACjB;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW,EAAE;IACb;MACE,eAAe,EAAE;EACrB;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,UAAU,EAAE;IACZ;MACE,eAAe,EAAE;EACrB;IACE,YAAY;IACZ,WAAW;IACX,UAAU,EAAE;IACZ;MACE,YAAY;MAKZ,gCAAgC;MAChC,yBAAiB;cAAjB,iBAAiB;MACjB,MAAM;MACN,SAAS;MACT,cAAc,EAAE;IAClB;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MAKT,gCAAgC;MAChC,yBAAiB;cAAjB,iBAAiB;MACjB,YAAY;MACZ,WAAW,EAAE;EACjB;IAKE,6BAA6B,EAAE;;AAEnC;EACE,eAAe,EAAE;EACjB;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW,EAAE;EACf;IACE,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,UAAU,EAAE;EACd;IACE,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB,EAAE;EACrB;IACE,kBAAkB;IAKlB,gCAAgC;IAChC,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,WAAW,EAAE;EACf;IACE,WAAW,EAAE;IACb;MACE,YAAY;MAKZ,gCAAgC;MAChC,yBAAiB;cAAjB,iBAAiB;MACjB,MAAM;MACN,SAAS;MACT,cAAc;MACd,WAAW,EAAE;IACf;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;MAKT,gCAAgC;MAChC,yBAAiB;cAAjB,iBAAiB;MACjB,YAAY;MACZ,WAAW,EAAE;EACjB;IAKE,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,4BAA4B;IAC5B,gBAAgB,EAAE;EACpB;IAKE,6BAA6B,EAAE;;AAEnC;EACE,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,qBAAqB,EAAE;EACvB;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IAKd,gCAAgC;IAChC,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE;;AAEhB;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAKhB,0BAA0B;EAC1B,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,aAAa,EAAE;;AAEjB;EACE,gBAAgB;EAChB,UAAU,EAAE;EACZ;IACE,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,cAAc,EAAE;EAClB;IACE,eAAe,EAAE;;AAErB;EACE,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,kBAAkB,EAAE;;AAExB;EACE,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qIAAqI,EAAE;EACvI;IACE;MACE,gBAAgB,EAAE,EAAE;EACxB;IACE,cAAc;IACd,qBAAqB,EAAE;EACzB;IACE,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,eAAe,EAAE;IACjB;MACE,gBAAgB,EAAE;MAClB;QACE,gBAAgB,EAAE;;AAE1B;;EAEE,oBAAoB,EAAE;;AAExB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD,EAAE;EACzD;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,uBAAuB;IACvB,mBAAmB,EAAE;IACrB;;MAEE,oFAAoF,EAAE;;AAE5F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,uDAAuD,EAAE;EAC3D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,sFAAsF,EAAE;;AAE9F;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,sDAAsD,EAAE;EAC1D;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,qFAAqF,EAAE;;AAE7F;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB,EAAE;EACnB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,wDAAwD,EAAE;EAC5D;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,gDAAgD,EAAE;EACpD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,sFAAsF,EAAE;;AAE9F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,4CAA4C,EAAE;EAChD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,kFAAkF,EAAE;;AAE1F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,gDAAgD,EAAE;EACpD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,sFAAsF,EAAE;;AAE9F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,WAAW;IACX,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,qFAAqF,EAAE;;AAE7F;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,iDAAiD,EAAE;EACrD;IACE,cAAc;IACd,6BAA6B,EAAE;EACjC;;IAEE,cAAc;IACd,yBAAyB;IACzB,qBAAqB,EAAE;IACvB;;MAEE,uFAAuF,EAAE;;AAE/F;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,cAAc;IACd,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,oBAAoB,EAAE;;AAE1B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;;AAExB;;;EAGE,WAAW,EAAE;;AAEf;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;EAKX,kBAAkB,EAAE;EACpB;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,QAAQ;IAKR,kBAAkB,EAAE;EACtB;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,WAAW;EACX,WAAW;EACX,YAAY;EAKZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU,EAAE;;AAEd;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,YAAY;EACZ,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;EACtB;IACE,0BAA0B,EAAE;;AAEhC;EACE,kBAAkB,EAAE;;AAEtB;EACE,0BAA0B,EAAE;;AAE9B;EACE,aAAa;EACb,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,yDAAyD,EAAE;;AAE7D;EACE,yDAAyD,EAAE;;AAE7D;EACE,yDAAyD,EAAE;;AAE7D;EACE,yDAAyD,EAAE;;AAE7D;EACE,yDAAyD,EAAE;;AAE7D;EACE,yDAAyD,EAAE;;AAE7D;EACE,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB,EAAE;;AAEzB;EACE,cAAc;EACd,uBAAuB;EACvB,wBAAwB,EAAE;EAC1B;IACE,4BAA4B,EAAE;EAChC;IACE,uBAAuB;IACvB,wBAAwB,EAAE;;AAE9B;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,WAAW;IACX,YAAY;IAKZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO,EAAE;EACX;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,UAAU,EAAE;EACd;IACE,OAAO,EAAE;IACT;MACE,UAAU;MACV,6BAA6B;MAC7B,gCAAgC;MAChC,cAAc;MAEd,6BAA6B,EAAE;EACnC;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM,EAAE;EACV;IACE,QAAQ,EAAE;IACV;MACE,WAAW;MACX,4BAA4B;MAC5B,+BAA+B;MAC/B,eAAe;MAEf,8BAA8B,EAAE;EACpC;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO,EAAE;;AAEb;EACE,YAAY;EACZ,WAAW,EAAE;EACb;IACE,kBAAkB,EAAE;EACtB;IACE,0BAA0B,EAAE;;AAEhC;EACE,aAAa;EACb,YAAY,EAAE;;AAEhB;EACE,YAAY;EACZ,aAAa,EAAE;;AAEjB;EACE,kBAAkB,EAAE;;AAEtB;EACE,0BAA0B,EAAE;;AAE9B;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,wBAAwB,EAAE,EAAE;;AAEhC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB,EAAE;EACpB;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,UAAU,EAAE;EACd;IACE,OAAO,EAAE;IACT;MACE,UAAU;MACV,6BAA6B;MAC7B,gCAAgC;MAChC,cAAc;MAEd,6BAA6B;MAC7B,uDAAuD,EAAE;EAC7D;IACE,iBAAiB,EAAE;EACrB;IACE,QAAQ,EAAE;IACV;MACE,WAAW;MACX,4BAA4B;MAC5B,+BAA+B;MAC/B,eAAe;MAEf,8BAA8B;MAC9B,kDAAkD,EAAE;EACxD;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO,EAAE;EACX;IACE,eAAe;IACf,UAAU,EAAE;;AAEhB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,0BAA0B;EAK1B,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,yBAAyB,EAAE;;AAE/B;EACE,WAAW;EACX,yBAAyB,EAAE;;AAE7B;EACE,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAKlB,kBAAkB;IAClB,WAAW,EAAE;;AAEjB;EACE,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,kBAAkB;IAKlB,kBAAkB;IAClB,WAAW,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,eAAe,EAAE;;AAEnB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;;AAEzB;EACE,mBAAmB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;;AAEvB;EACE,eAAe,EAAE;EACjB;IACE,uBAAuB;IACvB,cAAc,EAAE;;AAEpB;EACE,eAAe,EAAE;;AAEnB;EACE,uBAAuB,EAAE;;AAE3B;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;;AAEzB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;;AAEzB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;EACrB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,qBAAqB;IACrB,mBAAmB,EAAE;;AAEzB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB,EAAE;;AAE7B;EACE,UAAU,EAAE;;AAEd;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EAKZ,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;EACvB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;EACzB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;EACvB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;EACzB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;EACvB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;EACzB;IACE,WAAW;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB,EAAE;;AAE3B;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW;EAEX,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB,EAAE;;AAEzB;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,6BAA6B,EAAE;;AAEjC;EACE;IACE,kBAAkB,EAAE,EAAE;;AAE1B;EACE,qBAAqB,EAAE;;AAEzB;EACE,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE,cAAc;IACd,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,kBAAkB,EAAE;EACtB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;IACd,gBAAgB,EAAE;;AAEtB;EACE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;EACE,mBAAmB,EAAE;EACrB;IACE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB,EAAE;IAClB;MACE,qCAAqC;MACrC,wCAAwC;MACxC,iCAAiC;MACjC,oCAAoC;MACpC,6BAA6B;MAC7B,gCAAgC,EAAE;IACpC;MACE,sCAAsC;MACtC,yCAAyC;MACzC,mCAAmC;MACnC,sCAAsC;MACtC,yCAAyC;MACzC,4CAA4C,EAAE;EAClD;IACE,yBAAyB;IACzB,YAAY,EAAE;EAChB;IACE,yBAAyB;IACzB,YAAY,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,4BAA4B,EAAE;EAC9B;IACE,kCAAkC;IAClC,gBAAgB,EAAE;;AAEtB;EACE,yBAAyB,EAAE;;AAE7B;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW,EAAE;;AAEf;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;EACrB;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW,EAAE;EACf;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAElB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,gBAAgB,EAAE;;AAEtB;EACE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,cAAc,EAAE;;AAElB;EACE,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE,oBAAoB;IACpB,mCAAmC;IACnC,qBAAqB;IACrB,iBAAiB,EAAE;IACnB;MACE,gBAAgB;MAChB,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,aAAa,EAAE;;AAEnB;EACE,eAAe,EAAE;;AAEnB,gEAAgE;AAChE,kEAAkE;AAClE;EACE,qBAAqB;EACrB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,cAAc,EAAE;EAChB;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,UAAU,EAAE;EACd;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,YAAY;IACZ,SAAS;IACT,WAAW,EAAE;EACf;IACE,YAAY,EAAE;;AAElB;EACE,eAAe,EAAE;EACjB;IAEE,cAAc,EAAE;;AAEpB;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS,EAAE;EACX;IACE,WAAW;IAEX,kBAAkB;IAClB,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,MAAM;IACN,UAAU;IACV,WAAW,EAAE;EACf;IACE,WAAW;IAEX,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,YAAY;IAEZ,WAAW;IACX,SAAS;IACT,WAAW,EAAE;EACf;IACE,YAAY,EAAE;EAChB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;IACjB;MACE,eAAe,EAAE;EACrB;IACE,iBAAiB;IACjB,qBAAqB;IACrB,+DAA+D;IAC/D,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAE;EAClB;IACE,iBAAiB;IACjB,qBAAqB;IACrB,+DAA+D;IAC/D,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB,EAAE;;AAEvB;EACE,SAAS,EAAE;;AAEb;EACE,SAAS,EAAE;;AAEb;EACE,mBAAmB,EAAE;;AAEvB;EACE,iBAAiB,EAAE;;AAErB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,8CAA8C;EAC9C,0CAA0C,EAAE;EAC5C;IACE,qBAAqB;IACrB,2CAA2C,EAAE;EAC/C;IACE,mBAAmB;IACnB,YAAY,EAAE;IACd;MACE,WAAW;MACX,qBAAqB;MACrB,sBAAsB;MACtB,WAAW;MACX,+DAA+D;MAC/D,mCAAmC;MACnC,iBAAiB;MACjB,mBAAmB;MACnB,iBAAiB;MACjB,0BAA0B,EAAE;EAChC;IACE,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,+DAA+D;IAC/D,mCAAmC;IACnC,iBAAiB;IACjB,cAAc;IACd,qBAAqB,EAAE;;AAE3B;EACE,sBAAsB,EAAE;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,SAAS,EAAE;;AAEb;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAGhB,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EAKvC,gCAAgC,EAAE;EAClC;IACE,cAAc,EAAE;IAChB;MACE,cAAc;MACd,qBAAqB,EAAE;;AAE7B;EACE,cAAc;EACd,WAAW,EAAE;;AAEf;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;EAClB;IACE,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW,EAAE;EACf;IACE,QAAQ;IAKR,gCAAgC;IAChC,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW,EAAE;EACf;IACE,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB,EAAE;IACnB;MACE,iBAAiB,EAAE;;AAEzB;EACE,iBAAiB,EAAE;;AAErB;EACE;IACE,iBAAiB;IACjB,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW,EAAE;EACf;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW,EAAE;EACf;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE;IACE,6BAA6B,EAAE;IAC/B;MACE,6BAA6B,EAAE,EAAE;;AAEvC;EACE,WAAW,EAAE;;AAEf;EACE;IACE,gBAAgB,EAAE;EACpB;IACE,wBAAwB,EAAE;EAC5B;IACE,iBAAiB,EAAE;EACrB;IACE,cAAc,EAAE;EAClB;IAKE,uBAAuB,EAAE;EAC3B;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IAKV,gCAAgC;IAChC,aAAa;IACb,uEAAuE;IAKvE,2BAA2B;IAK3B,kBAAkB;IAGlB,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC,EAAE;EAC3C;IACE,4BAA4B,EAAE;EAChC;IACE,cAAc,EAAE;EAClB;IAKE,wBAAwB,EAAE;EAC5B;IACE,cAAc;IAKd,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IAKV,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,MAAM;IACN,+BAA+B,EAAE;EACnC;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,EAAE;EACtB;IAKE,wBAAwB,EAAE;EAC5B;IAKE,uBAAuB,EAAE,EAAE;;AAE/B;EACE;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,MAAM;IACN,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAKlB,gCAAgC,EAAE;IAClC;MACE,yBAAyB;MACzB,gBAAgB,EAAE;IACpB;MACE,4BAA4B,EAAE;MAC9B;QACE,cAAc,EAAE;IACpB;MACE,gBAAgB;MAChB,gBAAgB,EAAE;EACtB;IAKE,wBAAwB,EAAE;EAC5B;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU;IACV,YAAY;IAKZ,gCAAgC,EAAE,EAAE;;AAExC;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EAKX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,mBAAmB,EAAE;;AAEvB;EACE,WAAW,EAAE;;AAEf;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,MAAM;EACN,QAAQ;EACR,gBAAgB;EAGhB,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EAKvC,gCAAgC;EAChC,aAAa;EAEb,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EAEtB,2BAA2B,EACC;;AAE9B;EACE,aAAa,EAAE;;AAEjB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EAGnB,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAKlB,0BAA0B;EAC1B,QAAQ;EACR,WAAW,EAAE;EACb;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB;IAKlB,gCAAgC,EAAE;IAClC;MACE,gBAAgB;MAChB,kCAAkC;MAClC,gBAAgB;MAChB,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,WAAW;MACX,uBAAuB;MACvB,+BAA+B;MAC/B,wBAAwB;MACxB,mCAAmC;MACnC,iCAAiC,EAAE;EACvC;IACE,UAAU;IACV,qBAAqB,EAAE;;AAE3B;EACE,aAAa,EAAE;;AAEjB;EACE,qBAAqB,EAAE;;AAEzB;EACE,yBAAyB;EACzB,2BAA2B,EAAE;;AAE/B;EACE,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB,EAAE;EAClB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;;AAErB;EACE,gBAAgB,EAAE;EAClB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE;IACE,UAAU;IACV,mDAAmD,EAAE;EACvD;IACE,UAAU;IACV,sDAAsD,EAAE;EAC1D;IACE,UAAU;IACV,uDAAuD,EAAE;EAC3D;IACE,UAAU;IACV,mDAAmD,EAAE,EAAE;;AAE3D;EACE;IACE,UAAU;IACV,mDAAmD,EAAE;EACvD;IACE,UAAU;IACV,gDAAgD,EAAE;EACpD;IACE,UAAU;IACV,gDAAgD,EAAE;EACpD;IACE,UAAU;IACV,oDAAoD,EAAE,EAAE;;AAE5D;;EAEE;AACF;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,iCAAiC,EAAE;;AAErC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,kCAAkC,EAAE;;AAEtC;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,2EAA2E,EAAE;;AAE/E;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,kCAAkC,EAAE;;AAEtC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,kCAAkC,EAAE;;AAEtC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,uCAAuC;EACvC,qDAAqD,EAAE;;AAEzD;;;EAGE,uCAAuC;EACvC,qDAAqD,EAAE;;AAEzD;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;EACE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC;;;EAGE,yBAAyB;EACzB,oCAAoC,EAAE;;AAExC,6BAA6B;AAC7B,4CAA4C;AAC5C;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;;EAEE;AACF;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B;EACE,0BAA0B,EAAE;;AAE9B,2BAA2B;AAC3B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B;EACE,2BAA2B,EAAE;;AAE/B,yBAAyB;AACzB;EACE,0BAA0B,EAAE;;AAE9B;EACE,6BAA6B,EAAE;;AAEjC,kBAAkB;AAClB;EACE,wBAAwB,EAAE;;AAE5B;EACE,wBAAwB,EAAE;;AAE5B;EACE,wBAAwB,EAAE;;AAE5B,qBAAqB;AACrB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB,wBAAwB;AACxB;EACE,wBAAwB,EAAE;;AAE5B;EACE,yBAAyB,EAAE;;AAE7B;EACE,wBAAwB,EAAE;;AAE5B,8BAA8B;AAC9B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,uBAAuB,EAAE;;AAE3B;;;;;;;;;;;CAWC;AACD;EAEE,sBAAsB;EAEtB,yBAAyB,EAAE;;AAE7B;EAEE,sBAAsB,EAAE;;AAa1B;EACE;IAGE,wBAAwB,EAAE;EAC5B;IAGE,4BAA4B,EAAE;EAChC;IAGE,4BAA4B,EAAE,EAAE;;AAEpC;EAEE,sBAAsB,EAAE;;AAQ1B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EAEE,qBAAqB,EAAE;;AAEzB,6EAA6E;;AAY7E;EACE;IAGE,mBAAmB,EAAE;EACvB;IAGE,qBAAqB,EAAE;EACzB;IAGE,mBAAmB,EAAE,EAAE;;AAE3B;EAEE,qBAAqB,EAAE;;AAazB;EACE;IAGE,wBAAwB,EAAE;EAC5B;IAGE,4BAA4B,EAAE;EAChC;IAGE,2BAA2B,EAAE,EAAE;;AAEnC;EAEE,qBAAqB,EAAE;;AAmBzB;EACE;IAGE,wBAAwB,EAAE;EAC5B;IAGE,yBAAyB,EAAE;EAC7B;IAGE,uBAAuB,EAAE;EAC3B;IAGE,wBAAwB,EAAE;EAC5B;IAGE,uBAAuB,EAAE,EAAE;;AAE/B;EAGE,4BAA4B;EAE5B,qBAAqB,EAAE;;AAmBzB;EACE;IAGE,mBAAmB,EAAE;EACvB;IAGE,mCAAmC,EAAE;EACvC;IAGE,kCAAkC,EAAE;EACtC;IAGE,mCAAmC,EAAE;EACvC;IAGE,6BAA6B,EAAE,EAAE;;AAErC;EAEE,oBAAoB,EAAE;;AAExB,6EAA6E;;AAwB7E;EACE;IAGE,yBAAyB,EAAE;EAC7B;IAGE,yCAAyC,EAAE;EAC7C;IAGE,uCAAuC,EAAE;EAC3C;IAGE,yCAAyC,EAAE;EAC7C;IAGE,uCAAuC,EAAE;EAC3C;IAGE,wCAAwC,EAAE;EAC5C;IAGE,yBAAyB,EAAE,EAAE;;AAEjC;EAEE,sBAAsB,EAAE;;AAkB1B;EACE;IACE,UAAU;IAGV,qBAAqB,EAAE;EACzB;IACE,UAAU;IAGV,sBAAsB,EAAE;EAC1B;IAGE,qBAAqB,EAAE;EACzB;IAGE,mBAAmB,EAAE,EAAE;;AAE3B;EAEE,wBAAwB,EAAE;;AAkB5B;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IAGE,4BAA4B,EAAE;EAChC;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,4BAA4B,EAAE;;AAkBhC;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IAGE,4BAA4B,EAAE;EAChC;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,4BAA4B,EAAE;;AAkBhC;EACE;IACE,UAAU;IAGV,6BAA6B,EAAE;EACjC;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IAGE,2BAA2B,EAAE;EAC/B;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,6BAA6B,EAAE;;AAkBjC;EACE;IACE,UAAU;IAGV,6BAA6B,EAAE;EACjC;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IAGE,2BAA2B,EAAE;EAC/B;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,0BAA0B,EAAE;;AAkB9B;EACE;IAGE,mBAAmB,EAAE;EACvB;IAGE,sBAAsB,EAAE;EAC1B;IACE,UAAU;IAGV,qBAAqB,EAAE;EACzB;IACE,UAAU;IAGV,qBAAqB,EAAE,EAAE;;AAE7B;EAEE,yBAAyB,EAAE;;AAe7B;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IACE,UAAU;IAGV,6BAA6B,EAAE,EAAE;;AAErC;EAEE,6BAA6B,EAAE;;AAejC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,6BAA6B,EAAE;;AAejC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IACE,UAAU;IAGV,6BAA6B,EAAE,EAAE;;AAErC;EAEE,8BAA8B,EAAE;;AAelC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,2BAA2B,EAAE;;AAQ/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EAEE,sBAAsB,EAAE;;AAY1B;EACE;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,0BAA0B,EAAE;;AAY9B;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,6BAA6B,EAAE;;AAYjC;EACE;IACE,UAAU;IAGV,4BAA4B,EAAE;EAChC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,0BAA0B,EAAE;;AAY9B;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,6BAA6B,EAAE;;AAYjC;EACE;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,2BAA2B,EAAE;;AAY/B;EACE;IACE,UAAU;IAGV,6BAA6B,EAAE;EACjC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,8BAA8B,EAAE;;AAYlC;EACE;IACE,UAAU;IAGV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,wBAAwB,EAAE;;AAY5B;EACE;IACE,UAAU;IAGV,6BAA6B,EAAE;EACjC;IACE,UAAU;IAGV,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,2BAA2B,EAAE;;AAQ/B;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EAEE,uBAAuB,EAAE;;AAY3B;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,2BAA2B,EAAE,EAAE;;AAEnC;EAEE,2BAA2B,EAAE;;AAY/B;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,6BAA6B,EAAE,EAAE;;AAErC;EAEE,8BAA8B,EAAE;;AAYlC;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,4BAA4B,EAAE,EAAE;;AAEpC;EAEE,2BAA2B,EAAE;;AAY/B;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,8BAA8B,EAAE;;AAYlC;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,2BAA2B,EAAE,EAAE;;AAEnC;EAEE,4BAA4B,EAAE;;AAYhC;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,6BAA6B,EAAE,EAAE;;AAErC;EAEE,+BAA+B,EAAE;;AAYnC;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,4BAA4B,EAAE,EAAE;;AAEpC;EAEE,yBAAyB,EAAE;;AAY7B;EACE;IACE,UAAU;IAGV,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,4BAA4B,EAAE;;AA6BhC;EACE;IAGE,+DAA+D;IAE/D,mCAAmC,EAAE;EACvC;IAGE,wEAAwE;IAExE,mCAAmC,EAAE;EACvC;IAGE,wEAAwE;IAExE,kCAAkC,EAAE;EACtC;IAGE,uEAAuE;IAEvE,kCAAkC,EAAE;EACtC;IAGE,oEAAoE;IAEpE,kCAAkC,EAAE,EAAE;;AAE1C;EAGE,4BAA4B;EAE5B,oBAAoB,EAAE;;AAkBxB;EACE;IAGE,4CAA4C;IAC5C,UAAU,EAAE;EACd;IAGE,6CAA6C,EAAE;EACjD;IAGE,4CAA4C,EAAE;EAChD;IAGE,2CAA2C;IAC3C,UAAU,EAAE,EAAE;;AAElB;EAGE,uCAAuC;EAEvC,uBAAuB,EAAE;;AAkB3B;EACE;IAGE,4CAA4C;IAC5C,UAAU,EAAE;EACd;IAGE,6CAA6C,EAAE;EACjD;IAGE,4CAA4C,EAAE;EAChD;IAGE,2CAA2C;IAC3C,UAAU,EAAE,EAAE;;AAElB;EAGE,uCAAuC;EAEvC,uBAAuB,EAAE;;AAY3B;EACE;IAGE,2CAA2C;IAC3C,UAAU,EAAE;EACd;IAGE,4CAA4C;IAC5C,UAAU,EAAE,EAAE;;AAElB;EAEE,wBAAwB;EAGxB,uCAAuC,EAAE;;AAY3C;EACE;IAGE,2CAA2C;IAC3C,UAAU,EAAE;EACd;IAGE,4CAA4C;IAC5C,UAAU,EAAE,EAAE;;AAElB;EAGE,uCAAuC;EAEvC,wBAAwB,EAAE;;AAoB5B;EACE;IAGE,yCAAyC;IACzC,UAAU,EAAE;EACd;IAGE,wCAAwC;IACxC,UAAU,EAAE;EACd;IAGE,uCAAuC;IACvC,UAAU,EAAE;EACd;IAGE,qCAAqC;IACrC,UAAU,EAAE,EAAE;;AAElB;EAEE,4BAA4B;EAE5B,mCAAmC,EAAE;;AAYvC;EACE;IAGE,qCAAqC;IACrC,UAAU,EAAE;EACd;IAGE,yCAAyC;IACzC,UAAU,EAAE,EAAE;;AAElB;EAEE,6BAA6B;EAE7B,kCAAkC,EAAE;;AAgBtC;EACE;IAGE,+BAA+B;IAG/B,0BAA0B;IAC1B,UAAU,EAAE;EACd;IAGE,+BAA+B;IAG/B,oBAAoB;IACpB,UAAU,EAAE,EAAE;;AAElB;EAEE,wBAAwB,EAAE;;AAgB5B;EACE;IAGE,6BAA6B;IAG7B,yBAAyB;IACzB,UAAU,EAAE;EACd;IAGE,6BAA6B;IAG7B,oBAAoB;IACpB,UAAU,EAAE,EAAE;;AAElB;EAEE,gCAAgC,EAAE;;AAgBpC;EACE;IAGE,8BAA8B;IAG9B,wBAAwB;IACxB,UAAU,EAAE;EACd;IAGE,8BAA8B;IAG9B,oBAAoB;IACpB,UAAU,EAAE,EAAE;;AAElB;EAEE,iCAAiC,EAAE;;AAgBrC;EACE;IAGE,6BAA6B;IAG7B,wBAAwB;IACxB,UAAU,EAAE;EACd;IAGE,6BAA6B;IAG7B,oBAAoB;IACpB,UAAU,EAAE,EAAE;;AAElB;EAEE,8BAA8B,EAAE;;AAgBlC;EACE;IAGE,8BAA8B;IAG9B,yBAAyB;IACzB,UAAU,EAAE;EACd;IAGE,8BAA8B;IAG9B,oBAAoB;IACpB,UAAU,EAAE,EAAE;;AAElB;EAEE,+BAA+B,EAAE;;AAgBnC;EACE;IAGE,+BAA+B;IAG/B,oBAAoB;IACpB,UAAU,EAAE;EACd;IAGE,+BAA+B;IAG/B,yBAAyB;IACzB,UAAU,EAAE,EAAE;;AAElB;EAEE,yBAAyB,EAAE;;AAgB7B;EACE;IAGE,6BAA6B;IAG7B,oBAAoB;IACpB,UAAU,EAAE;EACd;IAGE,6BAA6B;IAG7B,wBAAwB;IACxB,UAAU,EAAE,EAAE;;AAElB;EAEE,iCAAiC,EAAE;;AAgBrC;EACE;IAGE,8BAA8B;IAG9B,oBAAoB;IACpB,UAAU,EAAE;EACd;IAGE,8BAA8B;IAG9B,yBAAyB;IACzB,UAAU,EAAE,EAAE;;AAElB;EAEE,kCAAkC,EAAE;;AAgBtC;EACE;IAGE,6BAA6B;IAG7B,oBAAoB;IACpB,UAAU,EAAE;EACd;IAGE,6BAA6B;IAG7B,yBAAyB;IACzB,UAAU,EAAE,EAAE;;AAElB;EAEE,+BAA+B,EAAE;;AAgBnC;EACE;IAGE,8BAA8B;IAG9B,oBAAoB;IACpB,UAAU,EAAE;EACd;IAGE,8BAA8B;IAG9B,wBAAwB;IACxB,UAAU,EAAE,EAAE;;AAElB;EAEE,gCAAgC,EAAE;;AAWpC;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,2BAA2B,EAAE;;AAW/B;EACE;IACE,UAAU;IAGV,8BAA8B,EAAE;EAClC;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,2BAA2B,EAAE;;AAW/B;EACE;IACE,UAAU;IAGV,6BAA6B,EAAE;EACjC;IAGE,wBAAwB,EAAE,EAAE;;AAEhC;EAEE,4BAA4B,EAAE;;AAWhC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,4BAA4B,EAAE;;AAWhC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,6BAA6B,EAAE,EAAE;;AAErC;EAEE,6BAA6B,EAAE;;AAWjC;EACE;IAGE,wBAAwB,EAAE;EAC5B;IACE,UAAU;IAGV,8BAA8B,EAAE,EAAE;;AAEtC;EAEE,0BAA0B,EAAE;;AAqC9B;EACE;IAGE,oBAAoB;IAGpB,0BAA0B;IAE1B,sCAAsC,EAAE;EAC1C;IAGE,wBAAwB;IAGxB,0BAA0B;IAE1B,sCAAsC,EAAE;EAC1C;IAGE,wBAAwB;IAGxB,0BAA0B;IAE1B,sCAAsC,EAAE;EAC1C;IAGE,sCAAsC;IACtC,UAAU;IAGV,0BAA0B;IAE1B,sCAAsC,EAAE;EAC1C;IAGE,4BAA4B;IAC5B,UAAU,EAAE,EAAE;;AAElB;EAEE,qBAAqB,EAAE;;AAEzB,6EAA6E;;AAW7E;EACE;IACE,UAAU;IAGV,4CAA4C,EAAE;EAChD;IACE,UAAU;IAGV,uCAAuC,EAAE,EAAE;;AAE/C;EAEE,sBAAsB,EAAE;;AAE1B,6EAA6E;;AAW7E;EACE;IACE,UAAU;IAGV,uCAAuC,EAAE;EAC3C;IACE,UAAU;IAGV,0CAA0C,EAAE,EAAE;;AAElD;EAEE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B,EAAE;EACjC;IACE,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,cAAc,EAAE;EAClB;IACE,uBAAuB,EAAE;EAC3B;IACE,WAAW;IACX,oBAAoB;IACpB,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB,EAAE;EACpB;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;IACrB;MACE,UAAU,EAAE;EAChB;IACE,UAAU;IACV,cAAc;IACd,WAAW;IACX,kBAAkB,EAAE;IACpB;MACE,aAAa;MACb,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB,EAAE;MACnB;QACE;UACE,gBAAgB,EAAE,EAAE;IAC1B;MACE,UAAU;MACV,WAAW,EAAE;IACf;MACE,WAAW;MACX,cAAc,EAAE;MAChB;QACE,aAAa,EAAE;MACjB;QACE,cAAc,EAAE;EACtB;IACE,SAAO;IACP,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc,EAAE;IAChB;MACE,8DAA8D,EAAE;EACpE;IACE,qBAAqB,EAAE;IACvB;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,wBAAwB;MACxB,kBAAkB,EAAE;MACpB;QACE,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,yBAAyB;QACzB,0BAA0B,EAAE;MAC9B;QACE,WAAW;QACX,aAAa;QACb,yBAAyB;QACzB,0BAA0B,EAAE;IAChC;MACE,UAAU;MACV,WAAW,EAAE;IACf;MACE,MAAM;MACN,aAAa;MACb,cAAc;MACd,gBAAgB,EAAE;IACpB;MACE,eAAe,EAAE;MACjB;QACE,YAAY;QACZ,aAAa;QACb,YAAY,EAAE;MAChB;QACE,YAAY;QACZ,cAAc;QACd,cAAc,EAAE;IACpB;MACE,oDAAoD,EAAE;IACxD;MACE,qDAAqD,EAAE;EAC3D;IACE,gCAAgC,EAAE;EACpC;IACE,yCAAyC,EAAE;;AAE/C;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC,EAAE;EACnC;IACE,8BAA8B,EAAE;EAClC;IACE,kCAAkC,EAAE;EACtC;IACE,uBAAuB,EAAE;EAC3B;IACE,uBAAuB;IACvB,2BAA2B,EAAE;EAC/B;IACE,uBAAuB;IACvB,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,2BAA2B,EAAE;EAC/B;IACE,mBAAmB;IACnB,yBAAyB,EAAE;EAC7B;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB;IACrB,2BAA2B,EAAE;EAC/B;IACE,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;;;;;IAKE,gBAAgB,EAAE;EACpB;IACE,wBAAwB;IACxB,SAAO;IACP,mBAAmB;IACnB,uBAAuB,EAAE;EAC3B;IACE,wBAAwB;IACxB,SAAO;IACP,qBAAqB;IACrB,uBAAuB,EAAE;EAC3B;IACE,SAAO;IACP,sBAAsB,EAAE;IACxB;MACE,mBAAmB,EAAE;IACvB;MACE,uBAAuB,EAAE;IAC3B;MACE,qBAAqB,EAAE;IACzB;MACE,wBAAwB;MACxB,SAAO;MACP,qBAAqB;MACrB,uBAAuB,EAAE;EAC7B;IACE,2BAA2B,EAAE;EAC/B;IACE,YAAY,EAAE;EAChB;IACE;MACE,oBAAoB,EAAE,EAAE;;AAE9B;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe,EAAE;EACjB;IACE,aAAa,EAAE;EACjB;IACE,kBAAkB,EAAE;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,UAAU,EAAE;EACZ;IACE,WAAW,EAAE;EACf;IACE,yEAAyE,EAAE;EAC7E;IACE,yEAAyE,EAAE;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,8DAA8D;EAC9D,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD,EAAE;;AAEzD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,eAAe,EAAE;EACnB;IACE,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cAAc,EAAE;EAClB;IACE,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cAAc,EAAE;EAClB;IACE,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cAAc,EAAE;EAClB;IACE,aAAa;IACb,8CAA8C,EAAE;EAClD;IACE,SAAS,EAAE;;AAEf;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,cAAc,EAAE;;AAElB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B,EAAE;;AAElC;EACE,WAAW;EACX,cAAc;EACd,8BAA8B,EAAE;;AAElC;EACE,eAAe;EACf,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe,EAAE;EACjB;IACE,eAAe;IACf,uBAAuB;IACvB,cAAc,EAAE;EAClB;IACE,aAAa;IACb,oDAAoD,EAAE;EACxD;IACE,SAAS,EAAE;;AAEf;EACE,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;;;;;;EAME,gBAAgB,EAAE;;AAEpB;;;EAGE,sBAAsB;EACtB,WAAW;EACX,8CAA8C;EAC9C,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB,EAAE;EACpB;;;IAGE,gCAAgC;IAChC,sCAAsC,EAAE;EAC1C;;;IAGE,yBAAyB;IACzB,aAAa;IACb,8CAA8C,EAAE;EAClD;;;IAGE,cAAc,EAAE;;AAEpB;EACE,gBAAgB;EAChB,gBAAgB,EAAE;EAClB;IACE,UAAU,EAAE;EACd;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,kBAAkB,EAAE;EACtB;;IAEE,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,oBAAoB,EAAE;;AAE1B;EACE,eAAe;EACf,iBAAiB,EAAE;EACnB;IACE,eAAe,EAAE;;AAErB;EACE,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB,EAAE;;AAEtB;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc,EAAE;EAChB;;IAEE,cAAc;IACd,kBAAkB,EAAE;EACtB;;IAEE,cAAc;IACd,cAAc,EAAE;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB,EAAE;EAClB;IACE,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB,EAAE;;AAExB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB,EAAE;EACnB;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB,EAAE;EACrB;IACE,qBAAqB;IACrB,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,YAAY,EAAE;IAChB;MACE,cAAc;MACd,kBAAkB;MAClB,aAAa;MACb,eAAe;MACf,eAAe;MACf,qBAAqB;MACrB,yBAAyB,EAAE;MAC3B;QACE,cAAc;QACd,wBAAwB,EAAE;MAC5B;QACE,UAAU;QACV,yBAAyB,EAAE;IAC/B;MACE,uCAAuC,EAAE;MACzC;QACE,yCAAyC,EAAE;EACjD;IACE,qBAAqB;IACrB,cAAc,EAAE;EAClB;IACE,qBAAqB;IACrB,cAAc,EAAE;EAClB;IACE,qBAAqB;IACrB,cAAc,EAAE;EAClB;IACE,qBAAqB;IACrB,cAAc,EAAE;IAChB;MACE,kBAAkB;MAClB,aAAa;MACb,aAAa;MACb,wBAAwB;MACxB,kBAAkB,EAAE;MACpB;QACE,aAAa;QACb,eAAe;QACf,yBAAyB;QACzB,+BAA+B;QAC/B,8BAA8B,EAAE;MAClC;QACE,aAAa;QACb,aAAa;QACb,yBAAyB;QACzB,0BAA0B;QAC1B,8BAA8B,EAAE;IACpC;MACE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,6CAA6C;MAC7C,kBAAkB,EAAE;IACtB;MACE,kBAAkB;MAClB,UAAU;MACV,SAAS;MACT,aAAa;MACb,cAAc;MACd,eAAe;MACf,yBAAyB,EAAE;IAC7B;MACE,cAAc;MACd,kBAAkB;MAClB,UAAU;MACV,eAAe;MACf,qBAAqB;MACrB,yBAAyB,EAAE;MAC3B;QACE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,wBAAwB,EAAE;MAC5B;QACE,YAAY;QACZ,WAAW;QACX,eAAe;QACf,yBAAyB,EAAE;IAC/B;MACE,8CAA8C,EAAE;IAClD;MACE,+CAA+C,EAAE;IACnD;MACE,2DAA2D,EAAE;;AAEnE;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB,EAAE;EAClB;IACE,qBAAqB;IACrB,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAE;IACpB;MACE,mBAAmB,EAAE;MACrB;QACE,mBAAmB;QACnB,WAAW,EAAE;MACf;QACE,mBAAmB,EAAE;EAC3B;IACE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB,EAAE;;AAEzB;EACE,wCAAwC,EAAE;;AAE5C;EACE,0BAA0B,EAAE;;AAE9B;EACE,oCAAoC,EAAE;;AAExC;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,OAAO,EAAE;;AAEX;EACE,QAAQ;EACR,UAAU,EAAE;;AAEd;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,aAAa,EAAE,EAAE;;AAErB;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,aAAa,EAAE,EAAE;;AAErB;EACE;IACE,6CAA6C,EAAE;EACjD;IACE,uCAAuC,EAAE;EAC3C;IACE,6CAA6C,EAAE;EACjD;IACE,sCAAsC,EAAE,EAAE;;AAE9C;EACE;IACE,wBAAwB;IACxB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,YAAY;IACZ,aAAa;IACb,QAAQ,EAAE;EACZ;IACE,WAAW;IACX,YAAY;IACZ,QAAQ,EAAE;EACZ;IACE,WAAW;IACX,YAAY;IACZ,cAAc,EAAE;EAClB;IACE,aAAa;IACb,WAAW;IACX,WAAW,EAAE;EACf;IACE,YAAY;IACZ,aAAa;IACb,YAAY,EAAE,EAAE;;AAEpB;EACE;IACE,YAAY;IACZ,cAAc;IACd,QAAQ,EAAE;EACZ;IACE,WAAW;IACX,cAAc;IACd,QAAQ,EAAE;EACZ;IACE,YAAY;IACZ,QAAQ;IACR,cAAc,EAAE;EAClB;IACE,YAAY;IACZ,cAAc;IACd,cAAc,EAAE,EAAE;;AAEtB;EACE;IACE,qBAAqB,EAAE;EACzB;IACE,sBAAsB,EAAE;EAC1B;IACE,sBAAsB,EAAE;EAC1B;IACE,mBAAmB,EAAE,EAAE;;AAE3B;EACE;IACE,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,qBAAqB;IACrB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,aAAa;IACb,aAAa;IACb,QAAQ,EAAE;EACZ;IACE,aAAa;IACb,YAAY;IACZ,QAAQ,EAAE;EACZ;IACE,aAAa;IACb,aAAa;IACb,cAAc,EAAE;EAClB;IACE,QAAQ;IACR,cAAc;IACd,eAAe,EAAE;EACnB;IACE,aAAa;IACb,aAAa;IACb,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,YAAY;IACZ,cAAc;IACd,QAAQ,EAAE;EACZ;IACE,YAAY;IACZ,cAAc;IACd,QAAQ,EAAE;EACZ;IACE,aAAa;IACb,QAAQ;IACR,eAAe,EAAE;EACnB;IACE,YAAY;IACZ,WAAW;IACX,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,0BAA0B,EAAE;EAC9B;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,sBAAsB,EAAE;EAC1B;IACE,aAAa;IACb,mBAAmB;IACnB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,0BAA0B;IAC1B,UAAU,EAAE;EACd;IACE,wBAAwB;IACxB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE,gBAAgB,EAAE;;AAEpB;EACE,uBAAuB,EAAE;;AAE3B;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,wCAAwC,EAAE;EAC1C;IACE,uCAAuC,EAAE;EAC3C;IACE,MAAM;IACN,SAAS;IACT,2BAA2B,EAAE;EAC/B;IACE,MAAM;IACN,OAAO,EAAE;EACX;IACE,MAAM;IACN,QAAQ,EAAE;EACZ;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC,EAAE;EACpC;IACE,QAAQ;IACR,OAAO;IACP,2BAA2B,EAAE;EAC/B;IACE,QAAQ;IACR,QAAQ;IACR,2BAA2B,EAAE;EAC/B;IACE,SAAS;IACT,SAAS;IACT,2BAA2B,EAAE;EAC/B;IACE,SAAS;IACT,OAAO,EAAE;EACX;IACE,QAAQ;IACR,SAAS,EAAE;;AAEf;EACE;IACE,6BAA6B,EAAE;IAC/B;MACE,aAAa,EAAE;IACjB;MACE,2BAA2B,EAAE,EAAE;;AAErC;EACE,6BAA6B,EAAE;EAC/B;IACE,MAAM;IACN,WAAW;IACX,YAAY;IACZ,SAAS;IACT,2BAA2B,EAAE;EAC/B;IACE,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,UAAU,EAAE;EACd;IACE,MAAM;IACN,WAAW;IACX,YAAY;IACZ,OAAO,EAAE;EACX;IACE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,OAAO;IACP,2BAA2B,EAAE;EAC/B;IACE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gCAAgC,EAAE;EACpC;IACE,QAAQ;IACR,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,SAAS;IACT,WAAW;IACX,SAAS;IACT,OAAO,EAAE;EACX;IACE,SAAS;IACT,WAAW;IACX,SAAS;IACT,SAAS;IACT,2BAA2B,EAAE;EAC/B;IACE,SAAS;IACT,QAAQ;IACR,SAAS;IACT,UAAU,EAAE;;AAEhB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;;AAE/B;EACE,UAAU;EACV,WAAW;EACX,mBAAmB,EAAE;;AAEvB;EACE,UAAU;EACV,WAAW;EACX,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,mBAAmB,EAAE;;AAEzB;EACE,mBAAmB;EACnB,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,mBAAmB,EAAE;;AAEzB;EACE,UAAU;EACV,WAAW;EAKX,kBAAkB,EAAE;;AAEtB;EACE,UAAU;EACV,WAAW;EAKX,kBAAkB,EAAE;;AAEtB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,cAAc;EACd,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB,EAAE;;AAEzB;EACE,iBAAiB,EAAE;;AAErB;EACE,8BAA8B,EAAE;;AAElC;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,cAAc,EAAE;;AAEpB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,cAAc,EAAE;;AAEpB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;IACnB,wBAAwB,EAAE;;AAE9B;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,cAAc,EAAE;;AAEpB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB,EAAE;EACnB;IACE,cAAc,EAAE;;AAEpB;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,mBAAmB,EAAE;;AAEvB;EAKE,kBAAkB,EAAE;;AAEtB;EACE,aAAa,EAAE;;AAEjB;EACE,qBAAqB,EAAE;;AAEzB;EACE,uBAAuB,EAAE;;AAE3B;EACE,eAAe,EAAE;;AAEnB;EACE,yBAAyB,EAAE;EAC3B;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB,EAAE;;AAEzB;EACE,cAAc,EAAE;;AAElB;EACE,kCAAkC,EAAE;;AAEtC;EACE,6BAA6B;EAC7B,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;EACnB;IACE,YAAY,EAAE;IACd;MACE,6BAA6B,EAAE;IACjC;MACE,yBAAyB;MACzB,qBAAqB,EAAE;EAC3B;IACE,YAAY,EAAE;IACd;MACE,QAAQ;MACR,SAAS;MACT,WAAW;MACX,YAAY;MAKZ,kBAAkB;MAClB,yBAAyB,EAAE;IAC7B;MACE,aAAa;MACb,YAAY;MACZ,MAAM;MACN,SAAS;MACT,sBAAsB;MACtB,qBAAqB;MAKrB,kBAAkB,EAAE;IACtB;MACE,QAAQ,EAAE;MACV;QACE,eAAe,EAAE;IACrB;MACE,WAAW;MACX,QAAQ;MACR,iBAAiB,EAAE;MACnB;QACE,eAAe,EAAE;;AAEzB;EACE,2BAA2B,EAAE;;AAE/B;EACE,YAAY,EAAE;;AAEhB;EACE;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE;EACrB;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB,EAAE;EACpB;IACE,qBAAqB,EAAE,EAAE;;AAE7B;EACE;IACE,uBAAuB;IACvB,gBAAgB,EAAE,EAAE;;AAExB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EAKjB,gCAAgC,EAAE;;AAEpC;EACE;IACE,iBAAiB,EAAE;EACrB;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB,EAAE,EAAE;;AAE1B;EACE;IACE,cAAc;IACd,qBAAqB,EAAE,EAAE;;AAE7B;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE,cAAc,EAAE;;AAElB;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EAKd,kBAAkB;EAClB,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB,EAAE;;AAEtB;EACE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EAEE,kCAAkC,EAAE;;AAEtC;EACE,yBAAyB;EACzB,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB;EACzB,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;;AAE7B;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;EACX,gBAAgB,EAAE;EAClB;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IAKtB,gCAAgC;IAChC,yBAAiB;YAAjB,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,gCAAgC,EAAE;IAClC;MAKE,qBAAqB;MACrB,oBAAoB;MACpB,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,YAAY,EAAE;EAClB;IACE,WAAW;IACX,WAAW;IACX,WAAW,EAAE;IACb;MACE,eAAe;MACf,mBAAmB;MAKnB,gCAAgC,EAAE;EACtC;IACE,aAAa,EAAE;EACjB;IACE,WAAW;IACX,WAAW;IACX,WAAW,EAAE;IACb;MACE,qBAAqB,EAAE;EAC3B;IACE,aAAa,EAAE;EACjB;IACE,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,WAAW,EAAE;EACf;IACE,aAAa,EAAE;EACjB;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB,EAAE;EACpB;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,oBAAoB;IACpB,cAAc,EAAE;;AAEpB;EAEE,kCAAkC,EAAE;;AAEtC;EACE,yBAAyB;EACzB,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB;EACzB,yBAAyB,EAAE;;AAE7B;EACE,YAAY;EACZ,yBAAyB,EAAE;;AAE7B;EACE,aAAa,EAAE;;AAEjB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,sBAAsB,EAAE;;AAE1B;EACE,yBAAyB;EACzB,cAAc,EAAE;;AAElB;EACE,qBAAqB;EACrB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,6BAA6B,EAAE;;AAEjC;EACE,cAAc;EACd,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,6BAA6B,EAAE;;AAEjC;EACE,yBAAyB,EAAE;;AAE7B;EACE,yBAAyB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;;AAE/B;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;;AAElB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB,EAAE;EACpB;IACE,yBAAyB;IACzB,oCAAoC;IACpC,8BAA8B,EAAE;;AAEpC;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EAKjB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,2CAA2C,EAAE;;AAE/C;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB,EAAE;;AAE7B;EACE,2CAA2C,EAAE;;AAE/C;EACE,2BAA2B;EAC3B,wBAAwB,EAAE;;AAE5B;EACE,4BAA4B,EAAE;;AAEhC;EACE,gCAAgC,EAAE;;AAEpC;EACE,gCAAgC,EAAE;;AAEpC;EACE,WAAW,EAAE;;AAEf;EACE,WAAW,EAAE;;AAEf;EACE,uBAAuB,EAAE;;AAE3B;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB,EAAE;EACvB;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,cAAc;IACd,gBAAgB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB,EAAE;;AAEvB;EACE,WAAW,EAAE;;AAEf;EACE,aAAa;EAKb,kBAAkB,EAAE;;AAEtB;EACE,UAAU,EAAE;;AAEd;EACE;IACE,cAAc,EAAE,EAAE;;AAEtB;EACE;IACE,cAAc,EAAE;EAClB;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE,gBAAgB;EAChB,gCAAgC,EAAE;;AAEpC;EACE,2BAA2B,EAAE;;AAE/B;EACE,gCAAgC,EAAE;EAClC;IACE,gBAAgB,EAAE;;AAEtB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAKlB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,SAAS;EAKT,2BAA2B;EAC3B,gBAAgB,EAAE;EAClB;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,+BAA+B;IAC/B,kCAAkC,EAAE;EACtC;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,WAAW;IACX,QAAQ;IACR,gCAAgC;IAChC,kCAAkC,EAAE;;AAExC;EACE,mBAAmB,EAAE;EACrB;IACE,WAAW,EAAE;EACf;IACE,mBAAmB;IACnB,cAAc,EAAE;IAChB;MACE,+BAA+B;MAC/B,YAAY,EAAE;IAChB;MACE,gCAAgC;MAChC,WAAW,EAAE;;AAEnB;EACE,8BAA8B,EAAE;;AAElC;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EAKX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB,EAAE;;AAEtB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAE;;AAErB;EAKE,4BAA4B,EAAE;;AAEhC;EACE,eAAe;EACf,mBAAmB;EAKnB,gCAAgC;EAKhC,gCAAgC;EAChC,mBAAmB,EAAE;;AAEvB;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAKlB,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,mBAAmB,EAAE;;AAEvB;EACE,yBAAyB;EAKzB,kBAAkB;EAGlB,kDAAkD;EAClD,iDAAiD;EACjD,8CAA8C;EAC9C,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU,EAAE;;AAEd;EACE,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE;EACb;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,QAAQ;IAKR,2BAA2B;IAK3B,gCAAgC,EAAE;EACpC;IACE,qBAAqB,EAAE;IACvB;MACE,iBAAiB;MACjB,qBAAqB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAKlB,kBAAkB,EAAE;IACpB;MACE,gBAAgB;MAChB,mBAAmB,EAAE;IACvB;MACE,cAAc,EAAE;;AAEtB;EACE,kBAAkB;EAClB,mBAAmB,EAAE;;AAEvB;EACE,cAAc;EACd,MAAM;EACN,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,yBAAyB,EAAE;EAC3B;IACE,MAAM;IACN,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE;;AAEtB;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY,EAAE;EAChB;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY,EAAE;EAChB;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,aAAa,EAAE;EACjB;IACE,aAAa,EAAE,EAAE;;AAErB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B,EAAE;;AAEhC;EACE,qBAAqB,EAAE;;AAEzB;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,4DAA4D;EAK5D,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB,EAAE;EACxB;IACE,eAAe;IACf,iBAAiB,EAAE;;AAEvB;EACE;IACE,eAAe,EAAE,EAAE;;AAEvB;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,eAAe,EAAE;;AAEnB;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,kBAAkB,EAAE;;AAEtB,qBAAqB;AACrB;EACE;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE;EACxV;IACE,oVAAoV,EAAE,EAAE;;AAkC5V;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAgBjC;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAgBjC;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,0BAA0B,EAAE,EAAE;;AAgBlC;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IAKE,0BAA0B,EAAE;EAC9B;IAKE,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IAKE,0BAA0B,EAAE;EAC9B;IAKE,2BAA2B,EAAE,EAAE;;AAEnC;EACE;IAKE,8BAA8B,EAAE;EAClC;IAKE,gCAAgC,EAAE,EAAE;;AAExC;EACE;IAKE,uDAAuD,EAAE;EAC3D;IAKE,yDAAyD,EAAE,EAAE;;AAEjE;EACE;IAKE,sDAAsD,EAAE;EAC1D;IAKE,wDAAwD,EAAE,EAAE;;AAEhE;EACE;IAKE,sDAAsD,EAAE;EAC1D;IAKE,wDAAwD,EAAE,EAAE;;AAEhE;EACE;IAKE,oBAAoB,EAAE;EACxB;IAKE,0BAA0B,EAAE;EAC9B;IAKE,0CAA0C,EAAE,EAAE;;AAgBlD;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAgBjC;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IAKE,oCAAoC,EAAE;EACxC;IAKE,8CAA8C,EAAE;EAClD;IAKE,4CAA4C,EAAE;EAChD;IAKE,+CAA+C,EAAE,EAAE;;AAEvD;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IAKE,uBAAuB;IAKvB,kBAAkB,EAAE;EACtB;IAKE,wBAAwB;IACxB,iBAAiB,EAAE;EACrB;IAKE,yBAAyB;IAKzB,kBAAkB,EAAE,EAAE;;AAU1B;EACE;IAKE,yBAAyB,EAAE,EAAE;;AAgCjC;EACE;IAKE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE;EACd;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE;EACd;IAKE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,UAAU,EAAE,EAAE;;AAgBlB;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,0BAA0B,EAAE,EAAE;;AAQlC;EACE;IACE,iBAAiB,EAAE;EACrB;IACE,kBAAkB,EAAE,EAAE;;AAgB1B;EACE;IAKE,uBAAuB,EAAE;EAC3B;IAKE,yBAAyB,EAAE,EAAE;;AAEjC;EACE,aAAa;EACb,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EACnB,sBAAsB;EAGtB,uBAAuB,EAAE;EACzB;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAKlB,kBAAkB,EAAE;EACtB;IACE,UAAU;IACV,WAAW;IAKX,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IAEpB,qCAAqC;IAKrC,wBAAwB,EAAE;EAC5B;IACE,0BAA0B;IAE1B,qCAAqC,EAAE;IACvC;MACE,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,mBAAmB;MAKnB,kBAAkB;MAClB,SAAS;MACT,WAAW,EAAE;IACf;MACE,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,mBAAmB;MAKnB,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,UAAU;MACV,MAAM,EAAE;EACZ;IACE,kBAAkB;IAKlB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB,EAAE;IACxB;MACE,kBAAkB;MAClB,yBAAyB;MACzB,8BAA8B;MAC9B,gBAAgB;MAChB,WAAW;MACX,YAAY;MAKZ,kBAAkB;MAElB,2EAA2E,EAAE;IAC/E;MACE,kBAAkB;MAClB,yBAAyB;MAKzB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;MACf,6BAA6B;MAE7B,0EAA0E,EAAE;EAChF;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,4BAA4B;IAK5B,kBAAkB;IAClB,kBAAkB;IAElB,qCAAqC,EAAE;IACvC;MACE,WAAW;MACX,cAAc;MACd,QAAQ;MACR,SAAS;MACT,kBAAkB;MAClB,8BAA8B;MAC9B,4BAA4B;MAE5B,yBAAyB;MACzB,YAAY;MACZ,WAAW,EAAE;IACf;MACE,WAAW;MACX,cAAc;MACd,QAAQ;MACR,SAAS;MACT,kBAAkB;MAClB,8BAA8B;MAC9B,4BAA4B;MAE5B,yBAAyB;MACzB,WAAW;MACX,cAAc,EAAE;EACpB;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAE;IAChB;MACE,cAAc;MACd,kBAAkB;MAClB,sBAAsB;MACtB,qBAAqB;MACrB,WAAW;MACX,YAAY;MACZ,6BAA6B,EAAE;MAC/B;QACE,0CAA0C,EAAE;MAC9C;QACE,4CAA4C,EAAE;MAChD;QACE,4CAA4C,EAAE;EACpD;IACE,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IAKZ,kBAAkB,EAAE;EACtB;IACE,QAAQ;IACR,OAAO;IACP,oCAAoC;IACpC,gCAAgC,EAAE;EACpC;IACE,SAAS;IACT,OAAO;IACP,oCAAoC;IACpC,+BAA+B,EAAE;EACnC;IACE,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,6BAA6B,EAAE;EACjC;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,8BAA8B,EAAE;EAClC;IACE,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAK3B,kBAAkB;IAElB,qCAAqC,EAAE;EACzC;IAKE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gDAAgD;IAChD,kDAAkD;IAClD,mDAAmD;IACnD,gCAAgC;IAGhC,wBAAwB;IAExB,uCAAuC,EAAE;IACzC;MAKE,kBAAkB;MAClB,UAAU;MACV,WAAW,EAAE;EACjB;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,2CAA2C,EAAE;EAC/C;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,2CAA2C;IAC3C,SAAS;IACT,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;IACrB;MACE,WAAW;MACX,kBAAkB;MAKlB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,SAAS;MACT,SAAS;MACT,wBAAwB;MACxB,sCAAsC,EAAE;EAC5C;IACE,sCAAsC;IACtC,mBAAmB,EAAE;EACvB;IACE,+BAA+B;IAC/B,oCAAoC;IAEpC,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB,EAAE;EACtB;IACE,2BAA2B;IAK3B,kBAAkB;IAClB,kBAAkB,EAAE;IACpB;MACE,WAAW;MACX,yBAAyB;MAKzB,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,MAAM;MACN,OAAO;MAEP,sCAAsC;MACtC,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU;MAEV,mBAAmB,EAAE;IACvB;MACE,WAAW;MACX,yBAAyB;MAKzB,kBAAkB;MAClB,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,MAAM;MACN,OAAO;MAEP,sCAAsC;MACtC,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,aAAa;MACb,UAAU;MAEV,oBAAoB,EAAE;EAC1B;IACE,0BAA0B;IAE1B,yBAAyB;IAEzB,uBAAuB;IAEvB,wDAAwD,EAAE;IAC1D;MACE,yBAAyB;MAKzB,kBAAkB;MAClB,WAAW;MACX,YAAY;MAEZ,kDAAkD,EAAE;EACxD;IACE,WAAW;IACX,YAAY;IACZ,0BAA0B;IAE1B,2CAA2C,EAAE;;AAEjD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB,EAAE;;AAEtB;EACE,aAAa;EACb,SAAS,EAAE;EACX;IACE,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,WAAW,EAAE;;AAEjB;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAKlB,kBAAkB;EAGlB,gDAAgD;EAChD,+CAA+C;EAC/C,4CAA4C,EAAE;EAC9C;IACE,cAAc,EAAE;EAClB;IACE,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,QAAQ;IACR,WAAW;IACX,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,cAAc;IAKd,kBAAkB;IAKlB,gCAAgC;IAGhC,gDAAgD;IAChD,+CAA+C;IAC/C,4CAA4C,EAAE;IAC9C;MACE,UAAU;MACV,SAAS,EAAE;;AAEjB;EACE,SAAS,EAAE;;AAEb;EACE,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc,EAAE;EAChB;IACE,eAAe;IACf,YAAY,EAAE;IACd;MACE,YAAY,EAAE;IAChB;MACE,YAAY;MACZ,qBAAqB;MACrB,kBAAkB;MAClB,kBAAkB;MAClB,8BAA8B;MAC9B,kBAAkB;MAClB,cAAc;MAKd,kBAAkB;MAClB,mBAAmB,EAAE;;AAE3B;EACE,kBAAkB,EAAE;EACpB;IACE,2BAA2B;IAC3B,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,UAAU;IACV,YAAY;IACZ,2BAA2B;IAG3B,+CAA+C;IAC/C,8CAA8C;IAC9C,2CAA2C,EAAE;EAC/C;IACE,SAAS,EAAE;EACb;IACE,kBAAkB;IAClB,gCAAgC;IAChC,cAAc,EAAE;IAChB;MACE,yBAAyB,EAAE;IAC7B;MACE,sBAAsB,EAAE;EAC5B;IACE,aAAa,EAAE;;AAEnB;EACE,aAAa,EAAE;;AAEjB;EACE,iBAAiB,EAAE;;AAErB;EAKE,gCAAgC,EAAE;EAClC;IAGE,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IAKjC,kBAAkB,EAAE;;AAExB;EAGE,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EAKjC,kBAAkB,EAAE;;AAEtB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc,EAAE;EAChB;IACE,WAAW,EAAE;EACf;IACE,sBAAsB,EAAE;;AAE5B;EACE,gBAAgB,EAAE;;AAEpB;EACE,4BAA4B,EAAE;;AAEhC;EACE,4BAA4B,EAAE;;AAEhC;EACE,gBAAgB,EAAE;EAClB;IACE,gBAAgB,EAAE;IAClB;MACE,mBAAmB;MACnB,WAAW,EAAE;;AAEnB;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;EACrB;IACE,WAAW,EAAE;;AAEjB;EACE;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB,EAAE,EAAE;;AAE1B;EACE;IACE,+BAA+B,EAAE,EAAE;;AAEvC;EACE;IACE,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,2BAA2B,EAAE,EAAE;;AAEnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAE;EACZ;IACE,iBAAiB,EAAE;EACrB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IAKX,gCAAgC,EAAE;EACpC;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAKhB,gCAAgC;IAKhC,kBAAkB,EAAE;IACpB;MACE,eAAe;MACf,iBAAiB;MACjB,WAAW,EAAE;;AAEnB;EACE,UAAU,EAAE;;AAEd;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;EACE,cAAc,EAAE;;AAElB;EACE,mBAAmB;EACnB,cAAc;EAKd,gCAAgC,EAAE;EAClC;IACE,oDAAoD,EAAE;EACxD;;;IAGE,oDAAoD,EAAE;EACxD;IACE,qDAAqD,EAAE;EACzD;;;IAGE,kDAAkD,EAAE;EACtD;IACE,oDAAoD,EAAE;EACxD;;;IAGE,oDAAoD,EAAE;EACxD;IACE,qDAAqD,EAAE;EACzD;;;IAGE,mDAAmD,EAAE;EACvD;IACE,oDAAoD,EAAE;EACxD;;;IAGE,kDAAkD,EAAE;EACtD;IACE,mDAAmD,EAAE;EACvD;;;IAGE,mDAAmD,EAAE;EACvD;IACE,qDAAqD,EAAE;EACzD;;;IAGE,qDAAqD,EAAE;EACzD;IACE,gDAAgD,EAAE;EACpD;;;IAGE,+CAA+C,EAAE;EACnD;IACE,oDAAoD,EAAE;EACxD;;;IAGE,mDAAmD,EAAE;EACvD;IACE,mDAAmD,EAAE;EACvD;;;IAGE,mDAAmD,EAAE;;EAEvD;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,WAAW,EAAE;EACf;IACE,WAAW,EAAE;EACf;IACE,gCAAgC,EAAE;EACpC;IACE,cAAc,EAAE;IAChB;MACE,uBAAuB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB,EAAE;EAC7B;IACE,aAAa,EAAE;EACjB;IACE,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,mBAAmB,EAAE;EACvB;IACE,mCAAmC,EAAE;IACrC;MACE,WAAW;MACX,mBAAmB,EAAE;MACrB;QACE,WAAW,EAAE;EACnB;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;EACzB;IACE,yBAAyB,EAAE;EAC7B;IACE,kCAAkC,EAAE;EACtC;IACE,mCAAmC,EAAE;EACvC;IACE,mCAAmC,EAAE;EACvC;IACE,oCAAoC,EAAE;EACxC;IACE,mCAAmC,EAAE;EACvC;IACE,+BAA+B,EAAE;EACnC;IACE,kCAAkC,EAAE;EACtC;IACE,mCAAmC,EAAE;EACvC;IACE,8CAA8C;IAC9C,WAAW,EAAE;EACf;IACE,eAAe;IACf,yBAAyB,EAAE;IAC3B;MACE,eAAe;MACf,yBAAyB,EAAE;IAC7B;MACE,eAAe;MACf,yBAAyB,EAAE;EAC/B;IACE,oCAAoC,EAAE;EACxC;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB;IACrB,mBAAmB;IACnB,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;IACrB;MACE,cAAc,EAAE;MAChB;QACE,cAAc,EAAE;EACtB;IACE,yBAAyB;IAKzB,gCAAgC,EAAE;IAClC;MACE,qBAAqB,EAAE;EAC3B;IACE,uBAAuB,EAAE;EAC3B;IACE,sBAAsB,EAAE;EAC1B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,8CAA8C,EAAE;EAClD;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE;EACpC;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE;EACpC;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,yBAAyB,EAAE;IAC3B;MACE,yBAAyB;MACzB,cAAc;MACd,qBAAqB,EAAE;IACzB;MACE,cAAc,EAAE;EACpB;IACE,yBAAyB,EAAE;IAC3B;MACE,cAAc,EAAE;MAChB;QACE,yBAAyB;QACzB,WAAW,EAAE;MACf;QACE,yBAAyB,EAAE;IAC/B;MACE,yBAAyB,EAAE;EAC/B;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;IACvB;MACE,qBAAqB,EAAE;IACzB;MACE,qBAAqB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,WAAW,EAAE;EACf;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,mBAAmB;IACnB,qBAAqB,EAAE;EACzB;IACE,mBAAmB;IACnB,qBAAqB,EAAE;EACzB;IACE,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,yBAAyB;IACzB,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB;IACzB,qBAAqB,EAAE;EACzB;IACE,YAAY,EAAE;EAChB;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;IACrB;MACE,cAAc,EAAE;EACpB;IACE,uBAAuB,EAAE;EAC3B;IACE,mBAAmB,EAAE;EACvB;IACE,uBAAuB;IACvB,WAAW;IACX,UAAU,EAAE;EACd;IACE,WAAW;IACX,UAAU,EAAE;EACd;IACE,WAAW;IACX,UAAU,EAAE;EACd;IACE,WAAW,EAAE;EACf;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;IACrB;MACE,cAAc,EAAE;EACpB;IACE,mBAAmB,EAAE;EACvB;IACE,8BAA8B,EAAE;EAClC;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,qBAAqB,EAAE;IACvB;MACE,qBAAqB,EAAE;EAC3B;IACE,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,cAAc,EAAE;EAClB;IACE,8BAA8B;IAC9B,yBAAyB,EAAE;EAC7B;IACE,8BAA8B;IAC9B,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;IACvB;MACE,mBAAmB,EAAE;EACzB;IACE,mBAAmB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,WAAW,EAAE;EACf;IACE,yBAAyB,EAAE;EAC7B;IACE,WAAW,EAAE;EACf;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;EACvB;IACE,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB,EAAE;EACvB;IACE,mBAAmB;IACnB,cAAc,EAAE;EAClB;IACE,aAAa,EAAE;EACjB;IACE,aAAa,EAAE;EACjB;IACE,8BAA8B,EAAE;EAClC;IACE,oCAAoC,EAAE;EACxC;IACE,oCAAoC,EAAE;EACxC;IACE,mBAAmB,EAAE;EACvB;IACE,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;EAC/B;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB,EAAE;IACrB;MACE,qBAAqB,EAAE;MACvB;QACE,yBAAyB,EAAE;EACjC;IACE,yBAAyB,EAAE;EAC7B;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB,EAAE;IACvB;MACE,yBAAyB,EAAE;EAC/B;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE;IACvB;MACE,cAAc,EAAE;EACpB;IACE,cAAc,EAAE;EAClB;IACE,yBAAyB,EAAE;EAC7B;IACE,gCAAgC,EAAE;EACpC;IAGE,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IAKjC,kBAAkB,EAAE;EACtB;IAGE,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IAKjC,kBAAkB,EAAE;EACtB;IACE,mBAAmB,EAAE;EACvB;IACE,8BAA8B;IAC9B,yBAAyB,EAAE;EAC7B;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB;MACnB,cAAc,EAAE;EACpB;IACE,yBAAyB;IACzB,8BAA8B,EAAE;EAClC;IACE,yBAAyB;IACzB,8BAA8B,EAAE;EAClC;IACE,yBAAyB;IACzB,8BAA8B,EAAE;EAClC;IACE,yBAAyB,EAAE;;AAE/B;EACE;IACE,mBAAmB,EAAE;EACvB;IACE,uBAAuB,EAAE;EAC3B;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,cAAc,EAAE;IAChB;MACE,cAAc,EAAE;EACpB;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,WAAW,EAAE;IACb;MACE,WAAW,EAAE;EACjB;IACE,qBAAqB,EAAE,EAAE;;AAE7B;EACE;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE,EAAE;;AAE7B;EACE;IACE,mBAAmB,EAAE,EAAE;;EAEzB;MACI,aAAa;MACb,uBAAuB;MACvB,kBAAkB;MAClB,kBAAkB;EACtB;;EAEA;IACE,qDAAqD;IACrD,oDAAoD;IACpD,iDAAiD;AACrD;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,WAAW,EAAE,8CAA8C;EAC3D,YAAY,EAAE,+CAA+C;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc,EAAE,8BAA8B;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,2BAA2B;AAC7C;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB","sourcesContent":["/*!\n*\n* Template: Prox - Responsive Bootstrap 4 Admin Dashboard Template\n* Author: iqonic.design\n* Design and Developed by: iqonic.design\n* NOTE: This file contains the styling for responsive Template.\n*\n*/\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,900;1,200;1,300;1,400;1,500;1,600&display=swap\");\n:root {\n  --iq-primary: #c6c8f7;\n  --iq-secondary: #ccced2;\n  --iq-success: #b7e1ba;\n  --iq-info: #ffe6de;\n  --iq-warning: #ffebdf;\n  --iq-danger: #ffdaeb;\n  --iq-light: #FAFAFA;\n  --iq-dark: rgba(199, 203, 211, 0.1);\n  --iq-orange: #ffdcd8;\n  --iq-purple: #cbc0ff;\n  --iq-pink: #fff1f1;\n  --iq-primary: rgba(71, 136, 255, 0.1);\n  --iq-secondary: rgba(108, 117, 125, 0.1);\n  --iq-success: rgba(55, 230, 178, 0.1);\n  --iq-info: rgba(135, 108, 254, 0.1);\n  --iq-warning: rgba(254, 114, 28, 0.1);\n  --iq-danger: rgba(255, 75, 75, 0.1);\n  --iq-light: rgba(199, 203, 211, 0.1);\n  --iq-dark: rgba(1, 4, 27, 0.1);\n  --iq-orange: rgba(253, 126, 20, 0.1);\n  --iq-purple: rgba(71, 49, 182, 0.1); }\n\n:root {\n  --blue: #8f93f6;\n  --indigo: #6610f2;\n  --purple: #4731b6;\n  --pink: #FFE0E0;\n  --red: #ef9fc4;\n  --orange: #fd7e14;\n  --yellow: #fad263;\n  --green: #7fdd85;\n  --teal: #20c997;\n  --cyan: #fcbba5;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #01041b;\n  --primary: #8f93f6;\n  --secondary: #6c757d;\n  --success: #7fdd85;\n  --info: #fcbba5;\n  --warning: #fad263;\n  --danger: #ef9fc4;\n  --light: #FAFAFA;\n  --dark: #01041b;\n  --orange: #fd7e14;\n  --purple: #4731b6;\n  --pink: #FFE0E0;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; }\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; }\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block; }\n\nbody {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #535f6b;\n  text-align: left;\n  background-color: #fafbfe; }\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important; }\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem; }\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none; }\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit; }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0; }\n\ndt {\n  font-weight: 700; }\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; }\n\nblockquote {\n  margin: 0 0 1rem; }\n\nb,\nstrong {\n  font-weight: bolder; }\n\nsmall {\n  font-size: 80%; }\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -.25em; }\n\nsup {\n  top: -.5em; }\n\na {\n  color: #8f93f6;\n  text-decoration: none;\n  background-color: transparent; }\n  a:hover {\n    color: #484ff0;\n    text-decoration: none; }\n\na:not([href]) {\n  color: inherit;\n  text-decoration: none; }\n  a:not([href]):hover {\n    color: inherit;\n    text-decoration: none; }\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em; }\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar; }\n\nfigure {\n  margin: 0 0 1rem; }\n\nimg {\n  vertical-align: middle;\n  border-style: none; }\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle; }\n\ntable {\n  border-collapse: collapse; }\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom; }\n\nth {\n  text-align: inherit; }\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem; }\n\nbutton {\n  border-radius: 0; }\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color; }\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\nbutton,\ninput {\n  overflow: visible; }\n\nbutton,\nselect {\n  text-transform: none; }\n\n[role=\"button\"] {\n  cursor: pointer; }\n\nselect {\n  word-wrap: normal; }\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; }\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer; }\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none; }\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0; }\n\ntextarea {\n  overflow: auto;\n  resize: vertical; }\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0; }\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal; }\n  @media (max-width: 1200px) {\n    legend {\n      font-size: calc(1.275rem + 0.3vw) ; } }\n\nprogress {\n  vertical-align: baseline; }\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none; }\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button; }\n\noutput {\n  display: inline-block; }\n\nsummary {\n  display: list-item;\n  cursor: pointer; }\n\ntemplate {\n  display: none; }\n\n[hidden] {\n  display: none !important; }\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2; }\n\nh1, .h1 {\n  font-size: 2.488rem; }\n  @media (max-width: 1200px) {\n    h1, .h1 {\n      font-size: calc(1.3738rem + 1.4856vw) ; } }\n\nh2, .h2 {\n  font-size: 2.074rem; }\n  @media (max-width: 1200px) {\n    h2, .h2 {\n      font-size: calc(1.3324rem + 0.9888vw) ; } }\n\nh3, .h3 {\n  font-size: 1.728rem; }\n  @media (max-width: 1200px) {\n    h3, .h3 {\n      font-size: calc(1.2978rem + 0.5736vw) ; } }\n\nh4, .h4 {\n  font-size: 1.44rem; }\n  @media (max-width: 1200px) {\n    h4, .h4 {\n      font-size: calc(1.269rem + 0.228vw) ; } }\n\nh5, .h5 {\n  font-size: 1.2rem; }\n\nh6, .h6 {\n  font-size: 1rem; }\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300; }\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2; }\n  @media (max-width: 1200px) {\n    .display-1 {\n      font-size: calc(1.725rem + 5.7vw) ; } }\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n  @media (max-width: 1200px) {\n    .display-2 {\n      font-size: calc(1.675rem + 5.1vw) ; } }\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n  @media (max-width: 1200px) {\n    .display-3 {\n      font-size: calc(1.575rem + 3.9vw) ; } }\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n  @media (max-width: 1200px) {\n    .display-4 {\n      font-size: calc(1.475rem + 2.7vw) ; } }\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400; }\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3; }\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline-item {\n  display: inline-block; }\n  .list-inline-item:not(:last-child) {\n    margin-right: 0.5rem; }\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem; }\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d; }\n  .blockquote-footer::before {\n    content: \"\\2014\\00A0\"; }\n\n.img-fluid {\n  max-width: 100%;\n  height: auto; }\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fafbfe;\n  border: 1px solid #ccced2;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);\n  max-width: 100%;\n  height: auto; }\n\n.figure {\n  display: inline-block; }\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1; }\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d; }\n\ncode {\n  font-size: 87.5%;\n  color: #FFE0E0;\n  word-wrap: break-word; }\n  a > code {\n    color: inherit; }\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 8px;\n  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25); }\n  kbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n    box-shadow: none; }\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529; }\n  pre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal; }\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n  @media (min-width: 576px) {\n    .container {\n      max-width: 540px; } }\n  @media (min-width: 768px) {\n    .container {\n      max-width: 720px; } }\n  @media (min-width: 992px) {\n    .container {\n      max-width: 960px; } }\n  @media (min-width: 1200px) {\n    .container {\n      max-width: 1140px; } }\n\n.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 540px; } }\n\n@media (min-width: 768px) {\n  .container, .container-sm, .container-md {\n    max-width: 720px; } }\n\n@media (min-width: 992px) {\n  .container, .container-sm, .container-md, .container-lg {\n    max-width: 960px; } }\n\n@media (min-width: 1200px) {\n  .container, .container-sm, .container-md, .container-lg, .container-xl {\n    max-width: 1140px; } }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  min-width: 0;\n  max-width: 100%; }\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.row-cols-3 > * {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%; }\n\n.row-cols-6 > * {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; }\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%; }\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%; }\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%; }\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.33333%; }\n\n.offset-2 {\n  margin-left: 16.66667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.33333%; }\n\n.offset-5 {\n  margin-left: 41.66667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.33333%; }\n\n.offset-8 {\n  margin-left: 66.66667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.33333%; }\n\n.offset-11 {\n  margin-left: 91.66667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%; }\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-sm-first {\n    order: -1; }\n  .order-sm-last {\n    order: 13; }\n  .order-sm-0 {\n    order: 0; }\n  .order-sm-1 {\n    order: 1; }\n  .order-sm-2 {\n    order: 2; }\n  .order-sm-3 {\n    order: 3; }\n  .order-sm-4 {\n    order: 4; }\n  .order-sm-5 {\n    order: 5; }\n  .order-sm-6 {\n    order: 6; }\n  .order-sm-7 {\n    order: 7; }\n  .order-sm-8 {\n    order: 8; }\n  .order-sm-9 {\n    order: 9; }\n  .order-sm-10 {\n    order: 10; }\n  .order-sm-11 {\n    order: 11; }\n  .order-sm-12 {\n    order: 12; }\n  .offset-sm-0 {\n    margin-left: 0; }\n  .offset-sm-1 {\n    margin-left: 8.33333%; }\n  .offset-sm-2 {\n    margin-left: 16.66667%; }\n  .offset-sm-3 {\n    margin-left: 25%; }\n  .offset-sm-4 {\n    margin-left: 33.33333%; }\n  .offset-sm-5 {\n    margin-left: 41.66667%; }\n  .offset-sm-6 {\n    margin-left: 50%; }\n  .offset-sm-7 {\n    margin-left: 58.33333%; }\n  .offset-sm-8 {\n    margin-left: 66.66667%; }\n  .offset-sm-9 {\n    margin-left: 75%; }\n  .offset-sm-10 {\n    margin-left: 83.33333%; }\n  .offset-sm-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%; }\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-md-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-md-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-md-first {\n    order: -1; }\n  .order-md-last {\n    order: 13; }\n  .order-md-0 {\n    order: 0; }\n  .order-md-1 {\n    order: 1; }\n  .order-md-2 {\n    order: 2; }\n  .order-md-3 {\n    order: 3; }\n  .order-md-4 {\n    order: 4; }\n  .order-md-5 {\n    order: 5; }\n  .order-md-6 {\n    order: 6; }\n  .order-md-7 {\n    order: 7; }\n  .order-md-8 {\n    order: 8; }\n  .order-md-9 {\n    order: 9; }\n  .order-md-10 {\n    order: 10; }\n  .order-md-11 {\n    order: 11; }\n  .order-md-12 {\n    order: 12; }\n  .offset-md-0 {\n    margin-left: 0; }\n  .offset-md-1 {\n    margin-left: 8.33333%; }\n  .offset-md-2 {\n    margin-left: 16.66667%; }\n  .offset-md-3 {\n    margin-left: 25%; }\n  .offset-md-4 {\n    margin-left: 33.33333%; }\n  .offset-md-5 {\n    margin-left: 41.66667%; }\n  .offset-md-6 {\n    margin-left: 50%; }\n  .offset-md-7 {\n    margin-left: 58.33333%; }\n  .offset-md-8 {\n    margin-left: 66.66667%; }\n  .offset-md-9 {\n    margin-left: 75%; }\n  .offset-md-10 {\n    margin-left: 83.33333%; }\n  .offset-md-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%; }\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-lg-first {\n    order: -1; }\n  .order-lg-last {\n    order: 13; }\n  .order-lg-0 {\n    order: 0; }\n  .order-lg-1 {\n    order: 1; }\n  .order-lg-2 {\n    order: 2; }\n  .order-lg-3 {\n    order: 3; }\n  .order-lg-4 {\n    order: 4; }\n  .order-lg-5 {\n    order: 5; }\n  .order-lg-6 {\n    order: 6; }\n  .order-lg-7 {\n    order: 7; }\n  .order-lg-8 {\n    order: 8; }\n  .order-lg-9 {\n    order: 9; }\n  .order-lg-10 {\n    order: 10; }\n  .order-lg-11 {\n    order: 11; }\n  .order-lg-12 {\n    order: 12; }\n  .offset-lg-0 {\n    margin-left: 0; }\n  .offset-lg-1 {\n    margin-left: 8.33333%; }\n  .offset-lg-2 {\n    margin-left: 16.66667%; }\n  .offset-lg-3 {\n    margin-left: 25%; }\n  .offset-lg-4 {\n    margin-left: 33.33333%; }\n  .offset-lg-5 {\n    margin-left: 41.66667%; }\n  .offset-lg-6 {\n    margin-left: 50%; }\n  .offset-lg-7 {\n    margin-left: 58.33333%; }\n  .offset-lg-8 {\n    margin-left: 66.66667%; }\n  .offset-lg-9 {\n    margin-left: 75%; }\n  .offset-lg-10 {\n    margin-left: 83.33333%; }\n  .offset-lg-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    min-width: 0;\n    max-width: 100%; }\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-xl-first {\n    order: -1; }\n  .order-xl-last {\n    order: 13; }\n  .order-xl-0 {\n    order: 0; }\n  .order-xl-1 {\n    order: 1; }\n  .order-xl-2 {\n    order: 2; }\n  .order-xl-3 {\n    order: 3; }\n  .order-xl-4 {\n    order: 4; }\n  .order-xl-5 {\n    order: 5; }\n  .order-xl-6 {\n    order: 6; }\n  .order-xl-7 {\n    order: 7; }\n  .order-xl-8 {\n    order: 8; }\n  .order-xl-9 {\n    order: 9; }\n  .order-xl-10 {\n    order: 10; }\n  .order-xl-11 {\n    order: 11; }\n  .order-xl-12 {\n    order: 12; }\n  .offset-xl-0 {\n    margin-left: 0; }\n  .offset-xl-1 {\n    margin-left: 8.33333%; }\n  .offset-xl-2 {\n    margin-left: 16.66667%; }\n  .offset-xl-3 {\n    margin-left: 25%; }\n  .offset-xl-4 {\n    margin-left: 33.33333%; }\n  .offset-xl-5 {\n    margin-left: 41.66667%; }\n  .offset-xl-6 {\n    margin-left: 50%; }\n  .offset-xl-7 {\n    margin-left: 58.33333%; }\n  .offset-xl-8 {\n    margin-left: 66.66667%; }\n  .offset-xl-9 {\n    margin-left: 75%; }\n  .offset-xl-10 {\n    margin-left: 83.33333%; }\n  .offset-xl-11 {\n    margin-left: 91.66667%; } }\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #535f6b; }\n  .table th,\n  .table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #f1f1f1; }\n  .table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #f1f1f1; }\n  .table tbody + tbody {\n    border-top: 2px solid #f1f1f1; }\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem; }\n\n.table-bordered {\n  border: 1px solid #f1f1f1; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #f1f1f1; }\n  .table-bordered thead th,\n  .table-bordered thead td {\n    border-bottom-width: 2px; }\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0; }\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.table-hover tbody tr:hover {\n  color: #535f6b;\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #e0e1fc; }\n\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #c5c7fa; }\n\n.table-hover .table-primary:hover {\n  background-color: #c9cbfa; }\n  .table-hover .table-primary:hover > td,\n  .table-hover .table-primary:hover > th {\n    background-color: #c9cbfa; }\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #d6d8db; }\n\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #b3b7bb; }\n\n.table-hover .table-secondary:hover {\n  background-color: #c8cbcf; }\n  .table-hover .table-secondary:hover > td,\n  .table-hover .table-secondary:hover > th {\n    background-color: #c8cbcf; }\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #dbf5dd; }\n\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #bcedc0; }\n\n.table-hover .table-success:hover {\n  background-color: #c7efca; }\n  .table-hover .table-success:hover > td,\n  .table-hover .table-success:hover > th {\n    background-color: #c7efca; }\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #feece6; }\n\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #fddcd0; }\n\n.table-hover .table-info:hover {\n  background-color: #fdd9cd; }\n  .table-hover .table-info:hover > td,\n  .table-hover .table-info:hover > th {\n    background-color: #fdd9cd; }\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #fef2d3; }\n\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #fce8ae; }\n\n.table-hover .table-warning:hover {\n  background-color: #fdebba; }\n  .table-hover .table-warning:hover > td,\n  .table-hover .table-warning:hover > th {\n    background-color: #fdebba; }\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #fbe4ee; }\n\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #f7cde0; }\n\n.table-hover .table-danger:hover {\n  background-color: #f8cee0; }\n  .table-hover .table-danger:hover > td,\n  .table-hover .table-danger:hover > th {\n    background-color: #f8cee0; }\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fefefe; }\n\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #fcfcfc; }\n\n.table-hover .table-light:hover {\n  background-color: #f1f1f1; }\n  .table-hover .table-light:hover > td,\n  .table-hover .table-light:hover > th {\n    background-color: #f1f1f1; }\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #b8b9bf; }\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #7b7c88; }\n\n.table-hover .table-dark:hover {\n  background-color: #abacb3; }\n  .table-hover .table-dark:hover > td,\n  .table-hover .table-dark:hover > th {\n    background-color: #abacb3; }\n\n.table-orange,\n.table-orange > th,\n.table-orange > td {\n  background-color: #fedbbd; }\n\n.table-orange th,\n.table-orange td,\n.table-orange thead th,\n.table-orange tbody + tbody {\n  border-color: #febc85; }\n\n.table-hover .table-orange:hover {\n  background-color: #fecda4; }\n  .table-hover .table-orange:hover > td,\n  .table-hover .table-orange:hover > th {\n    background-color: #fecda4; }\n\n.table-purple,\n.table-purple > th,\n.table-purple > td {\n  background-color: #cbc5eb; }\n\n.table-purple th,\n.table-purple td,\n.table-purple thead th,\n.table-purple tbody + tbody {\n  border-color: #9f94d9; }\n\n.table-hover .table-purple:hover {\n  background-color: #bab2e4; }\n  .table-hover .table-purple:hover > td,\n  .table-hover .table-purple:hover > th {\n    background-color: #bab2e4; }\n\n.table-pink,\n.table-pink > th,\n.table-pink > td {\n  background-color: #fff6f6; }\n\n.table-pink th,\n.table-pink td,\n.table-pink thead th,\n.table-pink tbody + tbody {\n  border-color: #ffefef; }\n\n.table-hover .table-pink:hover {\n  background-color: #ffdddd; }\n  .table-hover .table-pink:hover > td,\n  .table-hover .table-pink:hover > th {\n    background-color: #ffdddd; }\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075); }\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075); }\n  .table-hover .table-active:hover > td,\n  .table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075); }\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #01041b;\n  border-color: #020940; }\n\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #f1f1f1; }\n\n.table-dark {\n  color: #fff;\n  background-color: #01041b; }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th {\n    border-color: #020940; }\n  .table-dark.table-bordered {\n    border: 0; }\n  .table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .table-dark.table-hover tbody tr:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.075); }\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-sm > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-md > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-lg > .table-bordered {\n      border: 0; } }\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n    .table-responsive-xl > .table-bordered {\n      border: 0; } }\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch; }\n  .table-responsive > .table-bordered {\n    border: 0; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .form-control {\n      transition: none; } }\n  .form-control::-ms-expand {\n    background-color: transparent;\n    border: 0; }\n  .form-control:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #495057; }\n  .form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: white;\n    outline: 0;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n  .form-control::placeholder {\n    color: #6c757d;\n    opacity: 1; }\n  .form-control:disabled, .form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1; }\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  appearance: none; }\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff; }\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%; }\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5; }\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 0.75rem;\n  line-height: 1.5; }\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.75rem;\n  line-height: 1.5; }\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #535f6b;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0; }\n  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n    padding-right: 0;\n    padding-left: 0; }\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto; }\n\ntextarea.form-control {\n  height: auto; }\n\n.form-group {\n  margin-bottom: 1rem; }\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem; }\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px; }\n  .form-row > .col,\n  .form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px; }\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem; }\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem; }\n  .form-check-input[disabled] ~ .form-check-label,\n  .form-check-input:disabled ~ .form-check-label {\n    color: #6c757d; }\n\n.form-check-label {\n  margin-bottom: 0; }\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem; }\n  .form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0; }\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #7fdd85; }\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(127, 221, 133, 0.9);\n  border-radius: 8px; }\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #7fdd85;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%237fdd85' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n    border-color: #7fdd85;\n    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #7fdd85;\n  padding-right: calc(0.75em + 2.3125rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2301041b' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%237fdd85' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n    border-color: #7fdd85;\n    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #7fdd85; }\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #7fdd85; }\n  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    border-color: #7fdd85; }\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #a7e8ab;\n  background-color: #a7e8ab; }\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }\n\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #7fdd85; }\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #7fdd85; }\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #7fdd85;\n  box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.25); }\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #ef9fc4; }\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(239, 159, 196, 0.9);\n  border-radius: 8px; }\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #ef9fc4;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ef9fc4' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ef9fc4' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n    border-color: #ef9fc4;\n    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #ef9fc4;\n  padding-right: calc(0.75em + 2.3125rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2301041b' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ef9fc4' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ef9fc4' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n    border-color: #ef9fc4;\n    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #ef9fc4; }\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #ef9fc4; }\n  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    border-color: #ef9fc4; }\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #f6cbdf;\n  background-color: #f6cbdf; }\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }\n\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #ef9fc4; }\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #ef9fc4; }\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #ef9fc4;\n  box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.25); }\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; }\n  .form-inline .form-check {\n    width: 100%; }\n  @media (min-width: 576px) {\n    .form-inline label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0; }\n    .form-inline .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0; }\n    .form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle; }\n    .form-inline .form-control-plaintext {\n      display: inline-block; }\n    .form-inline .input-group,\n    .form-inline .custom-select {\n      width: auto; }\n    .form-inline .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0; }\n    .form-inline .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0; }\n    .form-inline .custom-control {\n      align-items: center;\n      justify-content: center; }\n    .form-inline .custom-control-label {\n      margin-bottom: 0; } }\n\n.fade {\n  transition: opacity 0.15s linear; }\n  @media (prefers-reduced-motion: reduce) {\n    .fade {\n      transition: none; } }\n  .fade:not(.show) {\n    opacity: 0; }\n\n.collapse:not(.show) {\n  display: none; }\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .collapsing {\n      transition: none; } }\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative; }\n\n.dropdown-toggle {\n  white-space: nowrap; }\n  .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent; }\n  .dropdown-toggle:empty::after {\n    margin-left: 0; }\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #535f6b;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175); }\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0; }\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto; }\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto; } }\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem; }\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent; }\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem; }\n\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid; }\n\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0; }\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem; }\n\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\"; }\n\n.dropleft .dropdown-toggle::after {\n  display: none; }\n\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent; }\n\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0; }\n\n.dropdown-menu[x-placement^=\"top\"], .dropdown-menu[x-placement^=\"right\"], .dropdown-menu[x-placement^=\"bottom\"], .dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto; }\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef; }\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0; }\n  .dropdown-item:hover, .dropdown-item:focus {\n    color: #16181b;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #8f93f6; }\n  .dropdown-item.disabled, .dropdown-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: transparent; }\n\n.dropdown-menu.show {\n  display: block; }\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.75rem;\n  color: #6c757d;\n  white-space: nowrap; }\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529; }\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; }\n  .btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    flex: 1 1 auto; }\n    .btn-group > .btn:hover,\n    .btn-group-vertical > .btn:hover {\n      z-index: 1; }\n    .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 1; }\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start; }\n  .btn-toolbar .input-group {\n    width: auto; }\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px; }\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem; }\n  .dropdown-toggle-split::after,\n  .dropup .dropdown-toggle-split::after,\n  .dropright .dropdown-toggle-split::after {\n    margin-left: 0; }\n  .dropleft .dropdown-toggle-split::before {\n    margin-right: 0; }\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem; }\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem; }\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n  .btn-group.show .dropdown-toggle.btn-link {\n    box-shadow: none; }\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center; }\n  .btn-group-vertical > .btn,\n  .btn-group-vertical > .btn-group {\n    width: 100%; }\n  .btn-group-vertical > .btn:not(:first-child),\n  .btn-group-vertical > .btn-group:not(:first-child) {\n    margin-top: -1px; }\n  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n  .btn-group-vertical > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .btn-group-vertical > .btn:not(:first-child),\n  .btn-group-vertical > .btn-group:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0; }\n  .btn-group-toggle > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn input[type=\"checkbox\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none; }\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .form-control,\n  .input-group > .form-control-plaintext,\n  .input-group > .custom-select,\n  .input-group > .custom-file {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0;\n    margin-bottom: 0; }\n    .input-group > .form-control + .form-control,\n    .input-group > .form-control + .custom-select,\n    .input-group > .form-control + .custom-file,\n    .input-group > .form-control-plaintext + .form-control,\n    .input-group > .form-control-plaintext + .custom-select,\n    .input-group > .form-control-plaintext + .custom-file,\n    .input-group > .custom-select + .form-control,\n    .input-group > .custom-select + .custom-select,\n    .input-group > .custom-select + .custom-file,\n    .input-group > .custom-file + .form-control,\n    .input-group > .custom-file + .custom-select,\n    .input-group > .custom-file + .custom-file {\n      margin-left: -1px; }\n  .input-group > .form-control:focus,\n  .input-group > .custom-select:focus,\n  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3; }\n  .input-group > .custom-file .custom-file-input:focus {\n    z-index: 4; }\n  .input-group > .form-control:not(:last-child),\n  .input-group > .custom-select:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .input-group > .form-control:not(:first-child),\n  .input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .input-group > .custom-file {\n    display: flex;\n    align-items: center; }\n    .input-group > .custom-file:not(:last-child) .custom-file-label,\n    .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0; }\n    .input-group > .custom-file:not(:first-child) .custom-file-label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0; }\n\n.input-group-prepend,\n.input-group-append {\n  display: flex; }\n  .input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2; }\n    .input-group-prepend .btn:focus,\n    .input-group-append .btn:focus {\n      z-index: 3; }\n  .input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px; }\n\n.input-group-prepend {\n  margin-right: -1px; }\n\n.input-group-append {\n  margin-left: -1px; }\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 8px; }\n  .input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1rem + 2px); }\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px); }\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem; }\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem; }\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem; }\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1rem;\n  height: 1.25rem;\n  opacity: 0; }\n  .custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    border-color: #8f93f6;\n    background-color: #8f93f6;\n    box-shadow: none; }\n  .custom-control-input:focus ~ .custom-control-label::before {\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: white; }\n  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n    color: #fff;\n    background-color: white;\n    border-color: white;\n    box-shadow: none; }\n  .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n    color: #6c757d; }\n    .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n      background-color: #e9ecef; }\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top; }\n  .custom-control-label::before {\n    position: absolute;\n    top: 0.25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    background-color: #fff;\n    border: #adb5bd solid 1px;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .custom-control-label::after {\n    position: absolute;\n    top: 0.25rem;\n    left: -1.5rem;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background: no-repeat 50% / 50% 50%; }\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 8px; }\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\"); }\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #8f93f6;\n  background-color: #8f93f6;\n  box-shadow: none; }\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\"); }\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(143, 147, 246, 0.5); }\n\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(143, 147, 246, 0.5); }\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%; }\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\"); }\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(143, 147, 246, 0.5); }\n\n.custom-switch {\n  padding-left: 2.25rem; }\n  .custom-switch .custom-control-label::before {\n    left: -2.25rem;\n    width: 1.75rem;\n    pointer-events: all;\n    border-radius: 0.5rem; }\n  .custom-switch .custom-control-label::after {\n    top: calc(0.25rem + 2px);\n    left: calc(-2.25rem + 2px);\n    width: calc(1rem - 4px);\n    height: calc(1rem - 4px);\n    background-color: #adb5bd;\n    border-radius: 0.5rem;\n    transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-switch .custom-control-label::after {\n        transition: none; } }\n  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n    background-color: #fff;\n    transform: translateX(0.75rem); }\n  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n    background-color: rgba(143, 147, 246, 0.5); }\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2301041b' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  appearance: none; }\n  .custom-select:focus {\n    border-color: white;\n    outline: 0;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n    .custom-select:focus::-ms-value {\n      color: #495057;\n      background-color: #fff; }\n  .custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 0.75rem;\n    background-image: none; }\n  .custom-select:disabled {\n    color: #6c757d;\n    background-color: #e9ecef; }\n  .custom-select::-ms-expand {\n    display: none; }\n  .custom-select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #495057; }\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.75rem; }\n\n.custom-select-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 0.75rem; }\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin-bottom: 0; }\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  margin: 0;\n  opacity: 0; }\n  .custom-file-input:focus ~ .custom-file-label {\n    border-color: white;\n    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n  .custom-file-input[disabled] ~ .custom-file-label,\n  .custom-file-input:disabled ~ .custom-file-label {\n    background-color: #e9ecef; }\n  .custom-file-input:lang(en) ~ .custom-file-label::after {\n    content: \"Browse\"; }\n  .custom-file-input ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse); }\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 8px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n  .custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(1.5em + 0.75rem);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    content: \"Browse\";\n    background-color: #e9ecef;\n    border-left: inherit;\n    border-radius: 0 8px 8px 0; }\n\n.custom-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none; }\n  .custom-range:focus {\n    outline: none; }\n    .custom-range:focus::-webkit-slider-thumb {\n      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n    .custom-range:focus::-moz-range-thumb {\n      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n    .custom-range:focus::-ms-thumb {\n      box-shadow: 0 0 0 1px #fafbfe, 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n  .custom-range::-moz-focus-outer {\n    border: 0; }\n  .custom-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -0.25rem;\n    background-color: #8f93f6;\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-webkit-slider-thumb {\n        transition: none; } }\n    .custom-range::-webkit-slider-thumb:active {\n      background-color: white; }\n  .custom-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #ccced2;\n    border-color: transparent;\n    border-radius: 1rem;\n    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }\n  .custom-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #8f93f6;\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-moz-range-thumb {\n        transition: none; } }\n    .custom-range::-moz-range-thumb:active {\n      background-color: white; }\n  .custom-range::-moz-range-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #ccced2;\n    border-color: transparent;\n    border-radius: 1rem;\n    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }\n  .custom-range::-ms-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: 0;\n    margin-right: 0.2rem;\n    margin-left: 0.2rem;\n    background-color: #8f93f6;\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    appearance: none; }\n    @media (prefers-reduced-motion: reduce) {\n      .custom-range::-ms-thumb {\n        transition: none; } }\n    .custom-range::-ms-thumb:active {\n      background-color: white; }\n  .custom-range::-ms-track {\n    width: 100%;\n    height: 0.5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: 0.5rem;\n    box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1); }\n  .custom-range::-ms-fill-lower {\n    background-color: #ccced2;\n    border-radius: 1rem; }\n  .custom-range::-ms-fill-upper {\n    margin-right: 15px;\n    background-color: #ccced2;\n    border-radius: 1rem; }\n  .custom-range:disabled::-webkit-slider-thumb {\n    background-color: #adb5bd; }\n  .custom-range:disabled::-webkit-slider-runnable-track {\n    cursor: default; }\n  .custom-range:disabled::-moz-range-thumb {\n    background-color: #adb5bd; }\n  .custom-range:disabled::-moz-range-track {\n    cursor: default; }\n  .custom-range:disabled::-ms-thumb {\n    background-color: #adb5bd; }\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .custom-control-label::before,\n    .custom-file-label,\n    .custom-select {\n      transition: none; } }\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem; }\n  .nav-link:hover, .nav-link:focus {\n    text-decoration: none; }\n  .nav-link.disabled {\n    color: #6c757d;\n    pointer-events: none;\n    cursor: default; }\n\n.nav-tabs {\n  border-bottom: 1px solid #ccced2; }\n  .nav-tabs .nav-item {\n    margin-bottom: -1px; }\n  .nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n      border-color: #e9ecef #e9ecef #ccced2; }\n    .nav-tabs .nav-link.disabled {\n      color: #6c757d;\n      background-color: transparent;\n      border-color: transparent; }\n  .nav-tabs .nav-link.active,\n  .nav-tabs .nav-item.show .nav-link {\n    color: #495057;\n    background-color: #fafbfe;\n    border-color: #ccced2 #ccced2 #fafbfe; }\n  .nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.nav-pills .nav-link {\n  border-radius: 8px; }\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #8f93f6; }\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center; }\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center; }\n\n.tab-content > .tab-pane {\n  display: none; }\n\n.tab-content > .active {\n  display: block; }\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem; }\n  .navbar .container,\n  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between; }\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: -7.75rem;\n  padding-bottom: -7.75rem;\n  margin-right: 1rem;\n  font-size: 0.75rem;\n  line-height: inherit;\n  white-space: nowrap; }\n  .navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none; }\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n  .navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-nav .dropdown-menu {\n    position: static;\n    float: none; }\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem; }\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center; }\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 8px; }\n  .navbar-toggler:hover, .navbar-toggler:focus {\n    text-decoration: none; }\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%; }\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-sm .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-sm .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-sm .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-md .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-md .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-md .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-lg .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-lg .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-lg .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-xl .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-xl .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-xl .navbar-toggler {\n      display: none; } }\n\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-expand .navbar-nav {\n    flex-direction: row; }\n    .navbar-expand .navbar-nav .dropdown-menu {\n      position: absolute; }\n    .navbar-expand .navbar-nav .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n    flex-wrap: nowrap; }\n  .navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto; }\n  .navbar-expand .navbar-toggler {\n    display: none; }\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9); }\n  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n    color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n    color: rgba(0, 0, 0, 0.7); }\n  .navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3); }\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1); }\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9); }\n    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n      color: rgba(0, 0, 0, 0.9); }\n\n.navbar-dark .navbar-brand {\n  color: #fff; }\n  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n    color: #fff; }\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75); }\n  .navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25); }\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff; }\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1); }\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-text a {\n    color: #fff; }\n    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n      color: #fff; }\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #ffffff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 8px; }\n  .card > hr {\n    margin-right: 0;\n    margin-left: 0; }\n  .card > .list-group {\n    border-top: inherit;\n    border-bottom: inherit; }\n    .card > .list-group:first-child {\n      border-top-width: 0;\n      border-top-left-radius: 7px;\n      border-top-right-radius: 7px; }\n    .card > .list-group:last-child {\n      border-bottom-width: 0;\n      border-bottom-right-radius: 7px;\n      border-bottom-left-radius: 7px; }\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.25rem; }\n\n.card-title {\n  margin-bottom: 0.75rem; }\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0; }\n\n.card-text:last-child {\n  margin-bottom: 0; }\n\n.card-link:hover {\n  text-decoration: none; }\n\n.card-link + .card-link {\n  margin-left: 1.25rem; }\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-header:first-child {\n    border-radius: 7px 7px 0 0; }\n  .card-header + .list-group .list-group-item:first-child {\n    border-top: 0; }\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-footer:last-child {\n    border-radius: 0 0 7px 7px; }\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0; }\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem; }\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem; }\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%; }\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px; }\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: 7px;\n  border-bottom-left-radius: 7px; }\n\n.card-deck .card {\n  margin-bottom: 15px; }\n\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px; }\n    .card-deck .card {\n      flex: 1 0 0%;\n      margin-right: 15px;\n      margin-bottom: 0;\n      margin-left: 15px; } }\n\n.card-group > .card {\n  margin-bottom: 15px; }\n\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap; }\n    .card-group > .card {\n      flex: 1 0 0%;\n      margin-bottom: 0; }\n      .card-group > .card + .card {\n        margin-left: 0;\n        border-left: 0; }\n      .card-group > .card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0; }\n        .card-group > .card:not(:last-child) .card-img-top,\n        .card-group > .card:not(:last-child) .card-header {\n          border-top-right-radius: 0; }\n        .card-group > .card:not(:last-child) .card-img-bottom,\n        .card-group > .card:not(:last-child) .card-footer {\n          border-bottom-right-radius: 0; }\n      .card-group > .card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0; }\n        .card-group > .card:not(:first-child) .card-img-top,\n        .card-group > .card:not(:first-child) .card-header {\n          border-top-left-radius: 0; }\n        .card-group > .card:not(:first-child) .card-img-bottom,\n        .card-group > .card:not(:first-child) .card-footer {\n          border-bottom-left-radius: 0; } }\n\n.card-columns .card {\n  margin-bottom: 0.75rem; }\n\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1; }\n    .card-columns .card {\n      display: inline-block;\n      width: 100%; } }\n\n.accordion > .card {\n  overflow: hidden; }\n  .accordion > .card:not(:last-of-type) {\n    border-bottom: 0;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .accordion > .card:not(:first-of-type) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n  .accordion > .card > .card-header {\n    border-radius: 0;\n    margin-bottom: -1px; }\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 8px; }\n\n.breadcrumb-item {\n  display: flex; }\n  .breadcrumb-item + .breadcrumb-item {\n    padding-left: 0.5rem; }\n    .breadcrumb-item + .breadcrumb-item::before {\n      display: inline-block;\n      padding-right: 0.5rem;\n      color: #6c757d;\n      content: \"/\"; }\n  .breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: underline; }\n  .breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: none; }\n  .breadcrumb-item.active {\n    color: #6c757d; }\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 8px; }\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #8f93f6;\n  background-color: #fff;\n  border: 1px solid #ccced2; }\n  .page-link:hover {\n    z-index: 2;\n    color: #484ff0;\n    text-decoration: none;\n    background-color: #e9ecef;\n    border-color: #ccced2; }\n  .page-link:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.25); }\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px; }\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px; }\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #8f93f6;\n  border-color: #8f93f6; }\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #ccced2; }\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5; }\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px; }\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px; }\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5; }\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px; }\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px; }\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 8px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .badge {\n      transition: none; } }\n  a.badge:hover, a.badge:focus {\n    text-decoration: none; }\n  .badge:empty {\n    display: none; }\n\n.btn .badge {\n  position: relative;\n  top: -1px; }\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem; }\n\n.badge-primary {\n  color: #fff;\n  background-color: #8f93f6; }\n  a.badge-primary:hover, a.badge-primary:focus {\n    color: #fff;\n    background-color: #6065f2; }\n  a.badge-primary:focus, a.badge-primary.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }\n\n.badge-secondary {\n  color: #fff;\n  background-color: #6c757d; }\n  a.badge-secondary:hover, a.badge-secondary:focus {\n    color: #fff;\n    background-color: #545b62; }\n  a.badge-secondary:focus, a.badge-secondary.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.badge-success {\n  color: #fff;\n  background-color: #7fdd85; }\n  a.badge-success:hover, a.badge-success:focus {\n    color: #fff;\n    background-color: #57d25f; }\n  a.badge-success:focus, a.badge-success.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }\n\n.badge-info {\n  color: #fff;\n  background-color: #fcbba5; }\n  a.badge-info:hover, a.badge-info:focus {\n    color: #fff;\n    background-color: #fa9674; }\n  a.badge-info:focus, a.badge-info.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }\n\n.badge-warning {\n  color: #fff;\n  background-color: #fad263; }\n  a.badge-warning:hover, a.badge-warning:focus {\n    color: #fff;\n    background-color: #f8c432; }\n  a.badge-warning:focus, a.badge-warning.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }\n\n.badge-danger {\n  color: #fff;\n  background-color: #ef9fc4; }\n  a.badge-danger:hover, a.badge-danger:focus {\n    color: #fff;\n    background-color: #e873a9; }\n  a.badge-danger:focus, a.badge-danger.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }\n\n.badge-light {\n  color: #212529;\n  background-color: #FAFAFA; }\n  a.badge-light:hover, a.badge-light:focus {\n    color: #212529;\n    background-color: #e1e1e1; }\n  a.badge-light:focus, a.badge-light.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }\n\n.badge-dark {\n  color: #fff;\n  background-color: #01041b; }\n  a.badge-dark:hover, a.badge-dark:focus {\n    color: #fff;\n    background-color: black; }\n  a.badge-dark:focus, a.badge-dark.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }\n\n.badge-orange {\n  color: #fff;\n  background-color: #fd7e14; }\n  a.badge-orange:hover, a.badge-orange:focus {\n    color: #fff;\n    background-color: #dc6502; }\n  a.badge-orange:focus, a.badge-orange.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }\n\n.badge-purple {\n  color: #fff;\n  background-color: #4731b6; }\n  a.badge-purple:hover, a.badge-purple:focus {\n    color: #fff;\n    background-color: #37268e; }\n  a.badge-purple:focus, a.badge-purple.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }\n\n.badge-pink {\n  color: #212529;\n  background-color: #FFE0E0; }\n  a.badge-pink:hover, a.badge-pink:focus {\n    color: #212529;\n    background-color: #ffadad; }\n  a.badge-pink:focus, a.badge-pink.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 8px; }\n\n.alert-heading {\n  color: inherit; }\n\n.alert-link {\n  font-weight: 700; }\n\n.alert-dismissible {\n  padding-right: 4rem; }\n  .alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.75rem 1.25rem;\n    color: inherit; }\n\n.alert-primary {\n  color: #4a4c80;\n  background-color: #e9e9fd;\n  border-color: #e0e1fc; }\n  .alert-primary hr {\n    border-top-color: #c9cbfa; }\n  .alert-primary .alert-link {\n    color: #373960; }\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db; }\n  .alert-secondary hr {\n    border-top-color: #c8cbcf; }\n  .alert-secondary .alert-link {\n    color: #202326; }\n\n.alert-success {\n  color: #427345;\n  background-color: #e5f8e7;\n  border-color: #dbf5dd; }\n  .alert-success hr {\n    border-top-color: #c7efca; }\n  .alert-success .alert-link {\n    color: #2f5332; }\n\n.alert-info {\n  color: #836156;\n  background-color: #fef1ed;\n  border-color: #feece6; }\n  .alert-info hr {\n    border-top-color: #fdd9cd; }\n  .alert-info .alert-link {\n    color: #644a42; }\n\n.alert-warning {\n  color: #826d33;\n  background-color: #fef6e0;\n  border-color: #fef2d3; }\n  .alert-warning hr {\n    border-top-color: #fdebba; }\n  .alert-warning .alert-link {\n    color: #5d4e25; }\n\n.alert-danger {\n  color: #7c5366;\n  background-color: #fcecf3;\n  border-color: #fbe4ee; }\n  .alert-danger hr {\n    border-top-color: #f8cee0; }\n  .alert-danger .alert-link {\n    color: #5d3f4d; }\n\n.alert-light {\n  color: #828282;\n  background-color: #fefefe;\n  border-color: #fefefe; }\n  .alert-light hr {\n    border-top-color: #f1f1f1; }\n  .alert-light .alert-link {\n    color: dimgray; }\n\n.alert-dark {\n  color: #01020e;\n  background-color: #cccdd1;\n  border-color: #b8b9bf; }\n  .alert-dark hr {\n    border-top-color: #abacb3; }\n  .alert-dark .alert-link {\n    color: black; }\n\n.alert-orange {\n  color: #84420a;\n  background-color: #ffe5d0;\n  border-color: #fedbbd; }\n  .alert-orange hr {\n    border-top-color: #fecda4; }\n  .alert-orange .alert-link {\n    color: #552a06; }\n\n.alert-purple {\n  color: #25195f;\n  background-color: #dad6f0;\n  border-color: #cbc5eb; }\n  .alert-purple hr {\n    border-top-color: #bab2e4; }\n  .alert-purple .alert-link {\n    color: #150e37; }\n\n.alert-pink {\n  color: #857474;\n  background-color: #fff9f9;\n  border-color: #fff6f6; }\n  .alert-pink hr {\n    border-top-color: #ffdddd; }\n  .alert-pink .alert-link {\n    color: #6a5c5c; }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0; }\n  to {\n    background-position: 0 0; } }\n\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 8px;\n  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1); }\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #8f93f6;\n  transition: width 0.6s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .progress-bar {\n      transition: none; } }\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem; }\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite; }\n  @media (prefers-reduced-motion: reduce) {\n    .progress-bar-animated {\n      animation: none; } }\n\n.media {\n  display: flex;\n  align-items: flex-start; }\n\n.media-body {\n  flex: 1; }\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 8px; }\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit; }\n  .list-group-item-action:hover, .list-group-item-action:focus {\n    z-index: 1;\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .list-group-item-action:active {\n    color: #535f6b;\n    background-color: #e9ecef; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125); }\n  .list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit; }\n  .list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit; }\n  .list-group-item.disabled, .list-group-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: #fff; }\n  .list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #8f93f6;\n    border-color: #8f93f6; }\n  .list-group-item + .list-group-item {\n    border-top-width: 0; }\n    .list-group-item + .list-group-item.active {\n      margin-top: -1px;\n      border-top-width: 1px; }\n\n.list-group-horizontal {\n  flex-direction: row; }\n  .list-group-horizontal > .list-group-item:first-child {\n    border-bottom-left-radius: 8px;\n    border-top-right-radius: 0; }\n  .list-group-horizontal > .list-group-item:last-child {\n    border-top-right-radius: 8px;\n    border-bottom-left-radius: 0; }\n  .list-group-horizontal > .list-group-item.active {\n    margin-top: 0; }\n  .list-group-horizontal > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0; }\n    .list-group-horizontal > .list-group-item + .list-group-item.active {\n      margin-left: -1px;\n      border-left-width: 1px; }\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row; }\n    .list-group-horizontal-sm > .list-group-item:first-child {\n      border-bottom-left-radius: 8px;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-sm > .list-group-item:last-child {\n      border-top-right-radius: 8px;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-sm > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-sm > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row; }\n    .list-group-horizontal-md > .list-group-item:first-child {\n      border-bottom-left-radius: 8px;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-md > .list-group-item:last-child {\n      border-top-right-radius: 8px;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-md > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-md > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row; }\n    .list-group-horizontal-lg > .list-group-item:first-child {\n      border-bottom-left-radius: 8px;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-lg > .list-group-item:last-child {\n      border-top-right-radius: 8px;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-lg > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-lg > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row; }\n    .list-group-horizontal-xl > .list-group-item:first-child {\n      border-bottom-left-radius: 8px;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-xl > .list-group-item:last-child {\n      border-top-right-radius: 8px;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-xl > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-xl > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n.list-group-flush {\n  border-radius: 0; }\n  .list-group-flush > .list-group-item {\n    border-width: 0 0 1px; }\n    .list-group-flush > .list-group-item:last-child {\n      border-bottom-width: 0; }\n\n.list-group-item-primary {\n  color: #4a4c80;\n  background-color: #e0e1fc; }\n  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n    color: #4a4c80;\n    background-color: #c9cbfa; }\n  .list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #4a4c80;\n    border-color: #4a4c80; }\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db; }\n  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n    color: #383d41;\n    background-color: #c8cbcf; }\n  .list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #383d41;\n    border-color: #383d41; }\n\n.list-group-item-success {\n  color: #427345;\n  background-color: #dbf5dd; }\n  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n    color: #427345;\n    background-color: #c7efca; }\n  .list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #427345;\n    border-color: #427345; }\n\n.list-group-item-info {\n  color: #836156;\n  background-color: #feece6; }\n  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n    color: #836156;\n    background-color: #fdd9cd; }\n  .list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #836156;\n    border-color: #836156; }\n\n.list-group-item-warning {\n  color: #826d33;\n  background-color: #fef2d3; }\n  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n    color: #826d33;\n    background-color: #fdebba; }\n  .list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #826d33;\n    border-color: #826d33; }\n\n.list-group-item-danger {\n  color: #7c5366;\n  background-color: #fbe4ee; }\n  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n    color: #7c5366;\n    background-color: #f8cee0; }\n  .list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #7c5366;\n    border-color: #7c5366; }\n\n.list-group-item-light {\n  color: #828282;\n  background-color: #fefefe; }\n  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n    color: #828282;\n    background-color: #f1f1f1; }\n  .list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #828282;\n    border-color: #828282; }\n\n.list-group-item-dark {\n  color: #01020e;\n  background-color: #b8b9bf; }\n  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n    color: #01020e;\n    background-color: #abacb3; }\n  .list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #01020e;\n    border-color: #01020e; }\n\n.list-group-item-orange {\n  color: #84420a;\n  background-color: #fedbbd; }\n  .list-group-item-orange.list-group-item-action:hover, .list-group-item-orange.list-group-item-action:focus {\n    color: #84420a;\n    background-color: #fecda4; }\n  .list-group-item-orange.list-group-item-action.active {\n    color: #fff;\n    background-color: #84420a;\n    border-color: #84420a; }\n\n.list-group-item-purple {\n  color: #25195f;\n  background-color: #cbc5eb; }\n  .list-group-item-purple.list-group-item-action:hover, .list-group-item-purple.list-group-item-action:focus {\n    color: #25195f;\n    background-color: #bab2e4; }\n  .list-group-item-purple.list-group-item-action.active {\n    color: #fff;\n    background-color: #25195f;\n    border-color: #25195f; }\n\n.list-group-item-pink {\n  color: #857474;\n  background-color: #fff6f6; }\n  .list-group-item-pink.list-group-item-action:hover, .list-group-item-pink.list-group-item-action:focus {\n    color: #857474;\n    background-color: #ffdddd; }\n  .list-group-item-pink.list-group-item-action.active {\n    color: #fff;\n    background-color: #857474;\n    border-color: #857474; }\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5; }\n  @media (max-width: 1200px) {\n    .close {\n      font-size: calc(1.275rem + 0.3vw) ; } }\n  .close:hover {\n    color: #000;\n    text-decoration: none; }\n  .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n    opacity: .75; }\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0; }\n\na.close.disabled {\n  pointer-events: none; }\n\n.modal-open {\n  overflow: hidden; }\n  .modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto; }\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0; }\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none; }\n  .modal.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -50px); }\n    @media (prefers-reduced-motion: reduce) {\n      .modal.fade .modal-dialog {\n        transition: none; } }\n  .modal.show .modal-dialog {\n    transform: none; }\n  .modal.modal-static .modal-dialog {\n    transform: scale(1.02); }\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem); }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 1rem);\n    overflow: hidden; }\n  .modal-dialog-scrollable .modal-header,\n  .modal-dialog-scrollable .modal-footer {\n    flex-shrink: 0; }\n  .modal-dialog-scrollable .modal-body {\n    overflow-y: auto; }\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem); }\n  .modal-dialog-centered::before {\n    display: block;\n    height: calc(100vh - 1rem);\n    height: min-content;\n    content: \"\"; }\n  .modal-dialog-centered.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%; }\n    .modal-dialog-centered.modal-dialog-scrollable .modal-content {\n      max-height: none; }\n    .modal-dialog-centered.modal-dialog-scrollable::before {\n      content: none; }\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);\n  outline: 0; }\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0; }\n  .modal-backdrop.show {\n    opacity: 0.5; }\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #f1f1f1;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px; }\n  .modal-header .close {\n    padding: 1rem 1rem;\n    margin: -1rem -1rem -1rem auto; }\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5; }\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem; }\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid #f1f1f1;\n  border-bottom-right-radius: 7px;\n  border-bottom-left-radius: 7px; }\n  .modal-footer > * {\n    margin: 0.25rem; }\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto; }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem); }\n    .modal-dialog-scrollable .modal-content {\n      max-height: calc(100vh - 3.5rem); }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem); }\n    .modal-dialog-centered::before {\n      height: calc(100vh - 3.5rem);\n      height: min-content; }\n  .modal-content {\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5); }\n  .modal-sm {\n    max-width: 300px; } }\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px; } }\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px; } }\n\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.75rem;\n  word-wrap: break-word;\n  opacity: 0; }\n  .tooltip.show {\n    opacity: 0.9; }\n  .tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem; }\n    .tooltip .arrow::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0; }\n    .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n      top: 0;\n      border-width: 0.4rem 0.4rem 0;\n      border-top-color: #000; }\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n      right: 0;\n      border-width: 0.4rem 0.4rem 0.4rem 0;\n      border-right-color: #000; }\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0; }\n  .bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0; }\n    .bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n      bottom: 0;\n      border-width: 0 0.4rem 0.4rem;\n      border-bottom-color: #000; }\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem; }\n  .bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem; }\n    .bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n      left: 0;\n      border-width: 0.4rem 0 0.4rem 0.4rem;\n      border-left-color: #000; }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 8px; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: \"Poppins\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.75rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2); }\n  .popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 8px; }\n    .popover .arrow::before, .popover .arrow::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem; }\n  .bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n    bottom: calc(-0.5rem - 1px); }\n    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n      bottom: 0;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n      bottom: 1px;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: #fff; }\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem; }\n  .bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n    left: calc(-0.5rem - 1px);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 8px 0; }\n    .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n      left: 0;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n      left: 1px;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: #fff; }\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem; }\n  .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n    top: calc(-0.5rem - 1px); }\n    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n      top: 0;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n      top: 1px;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: #fff; }\n  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7; }\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem; }\n  .bs-popover-left > .arrow, .bs-popover-auto[x-placement^=\"left\"] > .arrow {\n    right: calc(-0.5rem - 1px);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 8px 0; }\n    .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n      right: 0;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n      right: 1px;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: #fff; }\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px; }\n  .popover-header:empty {\n    display: none; }\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #535f6b; }\n\n.carousel {\n  position: relative; }\n\n.carousel.pointer-event {\n  touch-action: pan-y; }\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden; }\n  .carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\"; }\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-item {\n      transition: none; } }\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block; }\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%); }\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%); }\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none; }\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1; }\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-fade .active.carousel-item-left,\n    .carousel-fade .active.carousel-item-right {\n      transition: none; } }\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .carousel-control-prev,\n    .carousel-control-next {\n      transition: none; } }\n  .carousel-control-prev:hover, .carousel-control-prev:focus,\n  .carousel-control-next:hover,\n  .carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: 0.9; }\n\n.carousel-control-prev {\n  left: 0; }\n\n.carousel-control-next {\n  right: 0; }\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50% / 100% 100%; }\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\"); }\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\"); }\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none; }\n  .carousel-indicators li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    opacity: .5;\n    transition: opacity 0.6s ease; }\n    @media (prefers-reduced-motion: reduce) {\n      .carousel-indicators li {\n        transition: none; } }\n  .carousel-indicators .active {\n    opacity: 1; }\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center; }\n\n.align-baseline {\n  vertical-align: baseline !important; }\n\n.align-top {\n  vertical-align: top !important; }\n\n.align-middle {\n  vertical-align: middle !important; }\n\n.align-bottom {\n  vertical-align: bottom !important; }\n\n.align-text-bottom {\n  vertical-align: text-bottom !important; }\n\n.align-text-top {\n  vertical-align: text-top !important; }\n\n.bg-primary {\n  color: #0a0e7c !important;\n  background-color: #8f93f6 !important; }\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  color: #0a0e7c !important;\n  background-color: #6065f2 !important; }\n\n.bg-secondary {\n  color: black !important;\n  background-color: #6c757d !important; }\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  color: black !important;\n  background-color: #545b62 !important; }\n\n.bg-success {\n  color: #144917 !important;\n  background-color: #7fdd85 !important; }\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  color: #144917 !important;\n  background-color: #57d25f !important; }\n\n.bg-info {\n  color: #9d2c05 !important;\n  background-color: #fcbba5 !important; }\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  color: #9d2c05 !important;\n  background-color: #fa9674 !important; }\n\n.bg-warning {\n  color: #5b4403 !important;\n  background-color: #fad263 !important; }\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  color: #5b4403 !important;\n  background-color: #f8c432 !important; }\n\n.bg-danger {\n  color: #7b1444 !important;\n  background-color: #ef9fc4 !important; }\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  color: #7b1444 !important;\n  background-color: #e873a9 !important; }\n\n.bg-light {\n  color: #7b7b7b !important;\n  background-color: #FAFAFA !important; }\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  color: #7b7b7b !important;\n  background-color: #e1e1e1 !important; }\n\n.bg-dark {\n  color: black !important;\n  background-color: #01041b !important; }\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  color: black !important;\n  background-color: black !important; }\n\n.bg-orange {\n  color: #120800 !important;\n  background-color: #fd7e14 !important; }\n\na.bg-orange:hover, a.bg-orange:focus,\nbutton.bg-orange:hover,\nbutton.bg-orange:focus {\n  color: #120800 !important;\n  background-color: #dc6502 !important; }\n\n.bg-purple {\n  color: black !important;\n  background-color: #4731b6 !important; }\n\na.bg-purple:hover, a.bg-purple:focus,\nbutton.bg-purple:hover,\nbutton.bg-purple:focus {\n  color: black !important;\n  background-color: #37268e !important; }\n\n.bg-pink {\n  color: #e00000 !important;\n  background-color: #FFE0E0 !important; }\n\na.bg-pink:hover, a.bg-pink:focus,\nbutton.bg-pink:hover,\nbutton.bg-pink:focus {\n  color: #e00000 !important;\n  background-color: #ffadad !important; }\n\n.bg-white {\n  background-color: #fff !important; }\n\n.bg-transparent {\n  background-color: transparent !important; }\n\n.border {\n  border: 1px solid #f1f1f1 !important; }\n\n.border-top {\n  border-top: 1px solid #f1f1f1 !important; }\n\n.border-right {\n  border-right: 1px solid #f1f1f1 !important; }\n\n.border-bottom {\n  border-bottom: 1px solid #f1f1f1 !important; }\n\n.border-left {\n  border-left: 1px solid #f1f1f1 !important; }\n\n.border-0 {\n  border: 0 !important; }\n\n.border-top-0 {\n  border-top: 0 !important; }\n\n.border-right-0 {\n  border-right: 0 !important; }\n\n.border-bottom-0 {\n  border-bottom: 0 !important; }\n\n.border-left-0 {\n  border-left: 0 !important; }\n\n.border-primary {\n  border-color: #8f93f6 !important; }\n\n.border-secondary {\n  border-color: #6c757d !important; }\n\n.border-success {\n  border-color: #7fdd85 !important; }\n\n.border-info {\n  border-color: #fcbba5 !important; }\n\n.border-warning {\n  border-color: #fad263 !important; }\n\n.border-danger {\n  border-color: #ef9fc4 !important; }\n\n.border-light {\n  border-color: #FAFAFA !important; }\n\n.border-dark {\n  border-color: #01041b !important; }\n\n.border-orange {\n  border-color: #fd7e14 !important; }\n\n.border-purple {\n  border-color: #4731b6 !important; }\n\n.border-pink {\n  border-color: #FFE0E0 !important; }\n\n.border-white {\n  border-color: #fff !important; }\n\n.rounded-sm {\n  border-radius: 8px !important; }\n\n.rounded {\n  border-radius: 8px !important; }\n\n.rounded-top {\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important; }\n\n.rounded-right {\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important; }\n\n.rounded-bottom {\n  border-bottom-right-radius: 8px !important;\n  border-bottom-left-radius: 8px !important; }\n\n.rounded-left {\n  border-top-left-radius: 8px !important;\n  border-bottom-left-radius: 8px !important; }\n\n.rounded-lg {\n  border-radius: 8px !important; }\n\n.rounded-circle {\n  border-radius: 50% !important; }\n\n.rounded-pill {\n  border-radius: 50px !important; }\n\n.rounded-0 {\n  border-radius: 0 !important; }\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n  .d-sm-inline {\n    display: inline !important; }\n  .d-sm-inline-block {\n    display: inline-block !important; }\n  .d-sm-block {\n    display: block !important; }\n  .d-sm-table {\n    display: table !important; }\n  .d-sm-table-row {\n    display: table-row !important; }\n  .d-sm-table-cell {\n    display: table-cell !important; }\n  .d-sm-flex {\n    display: flex !important; }\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n  .d-md-inline {\n    display: inline !important; }\n  .d-md-inline-block {\n    display: inline-block !important; }\n  .d-md-block {\n    display: block !important; }\n  .d-md-table {\n    display: table !important; }\n  .d-md-table-row {\n    display: table-row !important; }\n  .d-md-table-cell {\n    display: table-cell !important; }\n  .d-md-flex {\n    display: flex !important; }\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n  .d-lg-inline {\n    display: inline !important; }\n  .d-lg-inline-block {\n    display: inline-block !important; }\n  .d-lg-block {\n    display: block !important; }\n  .d-lg-table {\n    display: table !important; }\n  .d-lg-table-row {\n    display: table-row !important; }\n  .d-lg-table-cell {\n    display: table-cell !important; }\n  .d-lg-flex {\n    display: flex !important; }\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n  .d-xl-inline {\n    display: inline !important; }\n  .d-xl-inline-block {\n    display: inline-block !important; }\n  .d-xl-block {\n    display: block !important; }\n  .d-xl-table {\n    display: table !important; }\n  .d-xl-table-row {\n    display: table-row !important; }\n  .d-xl-table-cell {\n    display: table-cell !important; }\n  .d-xl-flex {\n    display: flex !important; }\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n\n@media print {\n  .d-print-none {\n    display: none !important; }\n  .d-print-inline {\n    display: inline !important; }\n  .d-print-inline-block {\n    display: inline-block !important; }\n  .d-print-block {\n    display: block !important; }\n  .d-print-table {\n    display: table !important; }\n  .d-print-table-row {\n    display: table-row !important; }\n  .d-print-table-cell {\n    display: table-cell !important; }\n  .d-print-flex {\n    display: flex !important; }\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden; }\n  .embed-responsive::before {\n    display: block;\n    content: \"\"; }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0; }\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%; }\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%; }\n\n.embed-responsive-4by3::before {\n  padding-top: 75%; }\n\n.embed-responsive-1by1::before {\n  padding-top: 100%; }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n  .flex-sm-column {\n    flex-direction: column !important; }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n  .justify-content-sm-center {\n    justify-content: center !important; }\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n  .align-items-sm-center {\n    align-items: center !important; }\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n  .align-content-sm-center {\n    align-content: center !important; }\n  .align-content-sm-between {\n    align-content: space-between !important; }\n  .align-content-sm-around {\n    align-content: space-around !important; }\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n  .align-self-sm-auto {\n    align-self: auto !important; }\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n  .align-self-sm-center {\n    align-self: center !important; }\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n  .flex-md-column {\n    flex-direction: column !important; }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n  .justify-content-md-center {\n    justify-content: center !important; }\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n  .align-items-md-start {\n    align-items: flex-start !important; }\n  .align-items-md-end {\n    align-items: flex-end !important; }\n  .align-items-md-center {\n    align-items: center !important; }\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n  .align-content-md-start {\n    align-content: flex-start !important; }\n  .align-content-md-end {\n    align-content: flex-end !important; }\n  .align-content-md-center {\n    align-content: center !important; }\n  .align-content-md-between {\n    align-content: space-between !important; }\n  .align-content-md-around {\n    align-content: space-around !important; }\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n  .align-self-md-auto {\n    align-self: auto !important; }\n  .align-self-md-start {\n    align-self: flex-start !important; }\n  .align-self-md-end {\n    align-self: flex-end !important; }\n  .align-self-md-center {\n    align-self: center !important; }\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n  .flex-lg-column {\n    flex-direction: column !important; }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n  .justify-content-lg-center {\n    justify-content: center !important; }\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n  .align-items-lg-center {\n    align-items: center !important; }\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n  .align-content-lg-center {\n    align-content: center !important; }\n  .align-content-lg-between {\n    align-content: space-between !important; }\n  .align-content-lg-around {\n    align-content: space-around !important; }\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n  .align-self-lg-auto {\n    align-self: auto !important; }\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n  .align-self-lg-center {\n    align-self: center !important; }\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n  .flex-xl-column {\n    flex-direction: column !important; }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n  .justify-content-xl-center {\n    justify-content: center !important; }\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n  .align-items-xl-center {\n    align-items: center !important; }\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n  .align-content-xl-center {\n    align-content: center !important; }\n  .align-content-xl-between {\n    align-content: space-between !important; }\n  .align-content-xl-around {\n    align-content: space-around !important; }\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n  .align-self-xl-auto {\n    align-self: auto !important; }\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n  .align-self-xl-center {\n    align-self: center !important; }\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n\n.float-left {\n  float: left !important; }\n\n.float-right {\n  float: right !important; }\n\n.float-none {\n  float: none !important; }\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important; }\n  .float-sm-right {\n    float: right !important; }\n  .float-sm-none {\n    float: none !important; } }\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important; }\n  .float-md-right {\n    float: right !important; }\n  .float-md-none {\n    float: none !important; } }\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important; }\n  .float-lg-right {\n    float: right !important; }\n  .float-lg-none {\n    float: none !important; } }\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important; }\n  .float-xl-right {\n    float: right !important; }\n  .float-xl-none {\n    float: none !important; } }\n\n.user-select-all {\n  user-select: all !important; }\n\n.user-select-auto {\n  user-select: auto !important; }\n\n.user-select-none {\n  user-select: none !important; }\n\n.overflow-auto {\n  overflow: auto !important; }\n\n.overflow-hidden {\n  overflow: hidden !important; }\n\n.position-static {\n  position: static !important; }\n\n.position-relative {\n  position: relative !important; }\n\n.position-absolute {\n  position: absolute !important; }\n\n.position-fixed {\n  position: fixed !important; }\n\n.position-sticky {\n  position: sticky !important; }\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030; }\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030; }\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020; } }\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal; }\n\n.shadow-sm {\n  box-shadow: 0px 16px 40px 0px #0000000A !important; }\n\n.shadow {\n  box-shadow: 0px 16px 40px 0px #0000000A !important; }\n\n.shadow-lg {\n  box-shadow: 0px 16px 40px 0px #0000000A !important; }\n\n.shadow-none {\n  box-shadow: none !important; }\n\n.w-25 {\n  width: 25% !important; }\n\n.w-50 {\n  width: 50% !important; }\n\n.w-75 {\n  width: 75% !important; }\n\n.w-100 {\n  width: 100% !important; }\n\n.w-auto {\n  width: auto !important; }\n\n.h-25 {\n  height: 25% !important; }\n\n.h-50 {\n  height: 50% !important; }\n\n.h-75 {\n  height: 75% !important; }\n\n.h-100 {\n  height: 100% !important; }\n\n.h-auto {\n  height: auto !important; }\n\n.mw-100 {\n  max-width: 100% !important; }\n\n.mh-100 {\n  max-height: 100% !important; }\n\n.min-vw-100 {\n  min-width: 100vw !important; }\n\n.min-vh-100 {\n  min-height: 100vh !important; }\n\n.vw-100 {\n  width: 100vw !important; }\n\n.vh-100 {\n  height: 100vh !important; }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-n1 {\n  margin: -0.25rem !important; }\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important; }\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important; }\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important; }\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important; }\n\n.m-n2 {\n  margin: -0.5rem !important; }\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important; }\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important; }\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important; }\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important; }\n\n.m-n3 {\n  margin: -1rem !important; }\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important; }\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important; }\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important; }\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important; }\n\n.m-n4 {\n  margin: -1.5rem !important; }\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important; }\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important; }\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important; }\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important; }\n\n.m-n5 {\n  margin: -3rem !important; }\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important; }\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important; }\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important; }\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n  .m-sm-3 {\n    margin: 1rem !important; }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n  .m-sm-5 {\n    margin: 3rem !important; }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n  .p-sm-0 {\n    padding: 0 !important; }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n  .p-sm-3 {\n    padding: 1rem !important; }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n  .p-sm-5 {\n    padding: 3rem !important; }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n  .m-sm-n1 {\n    margin: -0.25rem !important; }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important; }\n  .m-sm-n2 {\n    margin: -0.5rem !important; }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important; }\n  .m-sm-n3 {\n    margin: -1rem !important; }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important; }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important; }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important; }\n  .m-sm-n4 {\n    margin: -1.5rem !important; }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important; }\n  .m-sm-n5 {\n    margin: -3rem !important; }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important; }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important; }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important; }\n  .m-sm-auto {\n    margin: auto !important; }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n  .m-md-1 {\n    margin: 0.25rem !important; }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n  .m-md-2 {\n    margin: 0.5rem !important; }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n  .m-md-3 {\n    margin: 1rem !important; }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n  .m-md-4 {\n    margin: 1.5rem !important; }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n  .m-md-5 {\n    margin: 3rem !important; }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n  .p-md-0 {\n    padding: 0 !important; }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n  .p-md-1 {\n    padding: 0.25rem !important; }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n  .p-md-2 {\n    padding: 0.5rem !important; }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n  .p-md-3 {\n    padding: 1rem !important; }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n  .p-md-4 {\n    padding: 1.5rem !important; }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n  .p-md-5 {\n    padding: 3rem !important; }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n  .m-md-n1 {\n    margin: -0.25rem !important; }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important; }\n  .m-md-n2 {\n    margin: -0.5rem !important; }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important; }\n  .m-md-n3 {\n    margin: -1rem !important; }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important; }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important; }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important; }\n  .m-md-n4 {\n    margin: -1.5rem !important; }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important; }\n  .m-md-n5 {\n    margin: -3rem !important; }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important; }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important; }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important; }\n  .m-md-auto {\n    margin: auto !important; }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n  .m-lg-3 {\n    margin: 1rem !important; }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n  .m-lg-5 {\n    margin: 3rem !important; }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n  .p-lg-0 {\n    padding: 0 !important; }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n  .p-lg-3 {\n    padding: 1rem !important; }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n  .p-lg-5 {\n    padding: 3rem !important; }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n  .m-lg-n1 {\n    margin: -0.25rem !important; }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important; }\n  .m-lg-n2 {\n    margin: -0.5rem !important; }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important; }\n  .m-lg-n3 {\n    margin: -1rem !important; }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important; }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important; }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important; }\n  .m-lg-n4 {\n    margin: -1.5rem !important; }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important; }\n  .m-lg-n5 {\n    margin: -3rem !important; }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important; }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important; }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important; }\n  .m-lg-auto {\n    margin: auto !important; }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n  .m-xl-3 {\n    margin: 1rem !important; }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n  .m-xl-5 {\n    margin: 3rem !important; }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n  .p-xl-0 {\n    padding: 0 !important; }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n  .p-xl-3 {\n    padding: 1rem !important; }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n  .p-xl-5 {\n    padding: 3rem !important; }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n  .m-xl-n1 {\n    margin: -0.25rem !important; }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important; }\n  .m-xl-n2 {\n    margin: -0.5rem !important; }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important; }\n  .m-xl-n3 {\n    margin: -1rem !important; }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important; }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important; }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important; }\n  .m-xl-n4 {\n    margin: -1.5rem !important; }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important; }\n  .m-xl-n5 {\n    margin: -3rem !important; }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important; }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important; }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important; }\n  .m-xl-auto {\n    margin: auto !important; }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0); }\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important; }\n\n.text-justify {\n  text-align: justify !important; }\n\n.text-wrap {\n  white-space: normal !important; }\n\n.text-nowrap {\n  white-space: nowrap !important; }\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.text-left {\n  text-align: left !important; }\n\n.text-right {\n  text-align: right !important; }\n\n.text-center {\n  text-align: center !important; }\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important; }\n  .text-sm-right {\n    text-align: right !important; }\n  .text-sm-center {\n    text-align: center !important; } }\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important; }\n  .text-md-right {\n    text-align: right !important; }\n  .text-md-center {\n    text-align: center !important; } }\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important; }\n  .text-lg-right {\n    text-align: right !important; }\n  .text-lg-center {\n    text-align: center !important; } }\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important; }\n  .text-xl-right {\n    text-align: right !important; }\n  .text-xl-center {\n    text-align: center !important; } }\n\n.text-lowercase {\n  text-transform: lowercase !important; }\n\n.text-uppercase {\n  text-transform: uppercase !important; }\n\n.text-capitalize {\n  text-transform: capitalize !important; }\n\n.font-weight-light {\n  font-weight: 300 !important; }\n\n.font-weight-lighter {\n  font-weight: lighter !important; }\n\n.font-weight-normal {\n  font-weight: 400 !important; }\n\n.font-weight-bold {\n  font-weight: 700 !important; }\n\n.font-weight-bolder {\n  font-weight: bolder !important; }\n\n.font-italic {\n  font-style: italic !important; }\n\n.text-white {\n  color: #fff !important; }\n\n.text-primary {\n  color: #8f93f6 !important; }\n\na.text-primary:hover, a.text-primary:focus {\n  color: #484ff0 !important; }\n\n.text-secondary {\n  color: #6c757d !important; }\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #494f54 !important; }\n\n.text-success {\n  color: #7fdd85 !important; }\n\na.text-success:hover, a.text-success:focus {\n  color: #43cd4b !important; }\n\n.text-info {\n  color: #fcbba5 !important; }\n\na.text-info:hover, a.text-info:focus {\n  color: #fa835b !important; }\n\n.text-warning {\n  color: #fad263 !important; }\n\na.text-warning:hover, a.text-warning:focus {\n  color: #f8bd19 !important; }\n\n.text-danger {\n  color: #ef9fc4 !important; }\n\na.text-danger:hover, a.text-danger:focus {\n  color: #e45d9c !important; }\n\n.text-light {\n  color: #FAFAFA !important; }\n\na.text-light:hover, a.text-light:focus {\n  color: #d4d4d4 !important; }\n\n.text-dark {\n  color: #01041b !important; }\n\na.text-dark:hover, a.text-dark:focus {\n  color: black !important; }\n\n.text-orange {\n  color: #fd7e14 !important; }\n\na.text-orange:hover, a.text-orange:focus {\n  color: #c35a02 !important; }\n\n.text-purple {\n  color: #4731b6 !important; }\n\na.text-purple:hover, a.text-purple:focus {\n  color: #2f217a !important; }\n\n.text-pink {\n  color: #FFE0E0 !important; }\n\na.text-pink:hover, a.text-pink:focus {\n  color: #ff9494 !important; }\n\n.text-body {\n  color: #535f6b !important; }\n\n.text-muted {\n  color: #6c757d !important; }\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important; }\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important; }\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0; }\n\n.text-decoration-none {\n  text-decoration: none !important; }\n\n.text-break {\n  word-wrap: break-word !important; }\n\n.text-reset {\n  color: inherit !important; }\n\n.visible {\n  visibility: visible !important; }\n\n.invisible {\n  visibility: hidden !important; }\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important; }\n  a:not(.btn) {\n    text-decoration: underline; }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\"; }\n  pre {\n    white-space: pre-wrap !important; }\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid; }\n  thead {\n    display: table-header-group; }\n  tr,\n  img {\n    page-break-inside: avoid; }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3; }\n  h2,\n  h3 {\n    page-break-after: avoid; }\n  @page {\n    size: a3; }\n  body {\n    min-width: 992px !important; }\n  .container {\n    min-width: 992px !important; }\n  .navbar {\n    display: none; }\n  .badge {\n    border: 1px solid #000; }\n  .table {\n    border-collapse: collapse !important; }\n    .table td,\n    .table th {\n      background-color: #fff !important; }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ccced2 !important; }\n  .table-dark {\n    color: inherit; }\n    .table-dark th,\n    .table-dark td,\n    .table-dark thead th,\n    .table-dark tbody + tbody {\n      border-color: #f1f1f1; }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #f1f1f1; } }\n\n/*----------------- Grid Boxes -----------------*/\n.card {\n  background: #fff;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  margin-bottom: 30px;\n  border: none;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A; }\n  .card .card-header {\n    background: transparent;\n    border-radius: 0;\n    padding: 20px;\n    margin-bottom: 0;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n    border-bottom: 0; }\n    .card .card-header .header-title .card-title {\n      margin-bottom: 0; }\n\n.card-transparent {\n  background: transparent;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  margin-bottom: 30px;\n  border: none;\n  box-shadow: none; }\n  .card-transparent .card-header {\n    background: transparent;\n    border-radius: 0;\n    padding: 0 0 15px;\n    margin-bottom: 0;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n    border: none; }\n    .card-transparent .card-header .header-title .card-title {\n      margin-bottom: 0; }\n\n.card-body {\n  padding: 20px; }\n\n.card-header-toolbar .nav-item a {\n  color: #535f6b;\n  padding: 4px 12px;\n  font-size: 14px; }\n\n.card-header-toolbar .dropdown-toggle i {\n  font-size: 20px;\n  line-height: normal;\n  vertical-align: text-bottom; }\n\n.card-header-toolbar .dropdown-toggle::after {\n  display: none; }\n\n.card-header .dropdown-bg {\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.card-block.card-stretch {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch; }\n\n.card-block.card-height-third {\n  height: calc(33.33% - 30px); }\n\n.card-block.card-height-half {\n  height: calc(50% - 30px); }\n\n.card-block.card-height {\n  height: calc(100% - 30px); }\n\n.card-block {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column; }\n\n\n#sidebar-scrollbar {\n  height: 100vh; }\n\n.offcanvas-header {\n  padding: 0\n}  \n\n.scroll-content div.p-3 {\n  height: 100px; }\n\n.iq-sidebar-menu {\n  position: relative; }\n  .iq-sidebar-menu .iq-menu {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; }\n    .iq-sidebar-menu .iq-menu .iq-menu-title {\n      display: block;\n      color: #535f6b;\n      font-size: 15px;\n      position: relative;\n      padding: 15px;\n      font-weight: 500;\n      line-height: 18px; }\n      .iq-sidebar-menu .iq-menu .iq-menu-title i {\n        display: none; }\n    .iq-sidebar-menu .iq-menu li {\n      list-style-type: none;\n      position: relative;\n      white-space: nowrap; }\n      .iq-sidebar-menu .iq-menu li li {\n        margin: 0;\n        background: transparent !important; }\n        .iq-sidebar-menu .iq-menu li li a {\n          font-size: 16px; }\n      .iq-sidebar-menu .iq-menu li a {\n        font-size: 16px;\n        white-space: nowrap;\n        display: block;\n        color: #535f6b;\n        position: relative;\n        padding: 15px 20px;\n        line-height: 18px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        overflow: hidden;\n        border-radius: 0px;\n        text-transform: capitalize; }\n        .iq-sidebar-menu .iq-menu li a i {\n          font-size: 20px;\n          margin-right: 10px;\n          vertical-align: middle;\n          width: 20px;\n          display: inline-block; }\n        .iq-sidebar-menu .iq-menu li a span {\n          white-space: nowrap;\n          padding: 0;\n          display: inline-block;\n          -webkit-transition: none;\n          -moz-transition: none;\n          -ms-transition: none;\n          -o-transition: none;\n          transition: none; }\n        .iq-sidebar-menu .iq-menu li a .iq-arrow-right {\n          margin-right: 0px;\n          margin-left: auto;\n          font-size: 15px;\n          width: 15px;\n          -webkit-transition: all 0.6s ease-in-out;\n          -moz-transition: all 0.6s ease-in-out;\n          -ms-transition: all 0.6s ease-in-out;\n          -o-transition: all 0.6s ease-in-out;\n          transition: all 0.6s ease-in-out; }\n        .iq-sidebar-menu .iq-menu li a .badge {\n          position: absolute;\n          right: 15px;\n          -webkit-transition: all 0.6s ease-in-out;\n          -moz-transition: all 0.6s ease-in-out;\n          -ms-transition: all 0.6s ease-in-out;\n          -o-transition: all 0.6s ease-in-out;\n          transition: all 0.6s ease-in-out; }\n      .iq-sidebar-menu .iq-menu li a[aria-expanded=\"true\"] .iq-arrow-right {\n        -webkit-transition: all 0.6s ease-in-out;\n        -moz-transition: all 0.6s ease-in-out;\n        -ms-transition: all 0.6s ease-in-out;\n        -o-transition: all 0.6s ease-in-out;\n        transition: all 0.6s ease-in-out; }\n      .iq-sidebar-menu .iq-menu li ul {\n        padding-left: 0;\n        position: relative; }\n      .iq-sidebar-menu .iq-menu li .iq-submenu li a[aria-expanded=\"true\"] {\n        box-shadow: none; }\n    .iq-sidebar-menu .iq-menu li.active-menu > a {\n      color: #8f93f6;\n      text-decoration: none;\n      border-radius: 0;\n      transition: none; }\n    .iq-sidebar-menu .iq-menu li.active .iq-submenu li > a {\n      background: transparent; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li a:hover {\n  color: #8f93f6; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li a[aria-expanded=\"true\"] {\n  color: #8f93f6;\n  text-decoration: none;\n  border-radius: 0;\n  transition: none; }\n  .sidebar-default .iq-sidebar-menu .iq-menu li a[aria-expanded=\"true\"] i.iq-arrow-left {\n    color: #8f93f6; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li .iq-submenu li a:hover {\n  background: transparent; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li ul a:hover {\n  color: #8f93f6;\n  text-decoration: none;\n  background: transparent; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li ul li a {\n  padding-left: 30px; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li ul ul li > a {\n  padding-left: 50px; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li ul ul ul li > a {\n  padding-left: 80px; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li ul.iq-submenu-data li {\n  margin: 0; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu > li.active > a {\n  color: #8f93f6;\n  text-decoration: none; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li.active > a {\n  color: #8f93f6;\n  border-radius: 0; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li:last-child > a {\n  -webkit-border-radius: 0 0 8px 8px;\n  -moz-border-radius: 0 0 8px 8px;\n  -ms-border-radius: 0 0 8px 8px;\n  -o-border-radius: 0 0 8px 8px;\n  border-radius: 0 0 8px 8px; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu li.active .iq-submenu li a[aria-expanded=\"true\"] {\n  box-shadow: none; }\n\n.sidebar-default .iq-sidebar-menu .iq-menu .iq-submenu .iq-submenu-data {\n  box-shadow: none; }\n\n.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu .iq-submenu li:before {\n  content: '';\n  width: 3px;\n  height: 35px;\n  background: #8f93f6;\n  position: absolute;\n  left: 30px;\n  top: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  -webkit-opacity: 0;\n  -moz-opacity: 0;\n  -ms-opacity: 0;\n  -o-opacity: 0;\n  opacity: 0; }\n\n.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu .iq-submenu li.active:before {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  -ms-opacity: 1;\n  -o-opacity: 1;\n  opacity: 1; }\n\n.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu li.active ul.iq-submenu .iq-submenu:before {\n  left: 48px;\n  width: 2px; }\n\n.sidebar-default .iq-sidebar .iq-sidebar-menu .iq-menu li.active ul.iq-submenu .iq-submenu li::before {\n  left: 48px;\n  width: 2px; }\n\n.sidebar-default .sidebar-main .iq-sidebar-menu .iq-menu li ul {\n  padding-left: 0; }\n\n.iq-sidebar-menu {\n  margin: 10px 0px; }\n  .iq-sidebar-menu .iq-menu li a .iq-arrow-right.arrow-hover {\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    display: none; }\n  .iq-sidebar-menu .iq-menu li a[aria-expanded=\"true\"] .iq-arrow-right.arrow-active {\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    display: none; }\n  .iq-sidebar-menu .iq-menu li a[aria-expanded=\"true\"] .iq-arrow-right.arrow-hover {\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1;\n    display: block; }\n\n.sidebar-bottom {\n  margin: 0 15px;\n  padding: 20px 15px 0;\n  border-top: 1px solid #f1f1f1; }\n  .sidebar-bottom h4 i {\n    font-size: 1.2em;\n    font-weight: 700; }\n\n.iq-sidebar-logo {\n  padding: 15px;\n  width: auto;\n  position: relative;\n  -webkit-transition: all 0.6s ease-in-out;\n  -moz-transition: all 0.6s ease-in-out;\n  -ms-transition: all 0.6s ease-in-out;\n  -o-transition: all 0.6s ease-in-out;\n  transition: all 0.6s ease-in-out; }\n  .iq-sidebar-logo a {\n    display: flex;\n    align-items: flex-start; }\n    .iq-sidebar-logo a span {\n      margin-left: 10px;\n      font-size: 19px;\n      line-height: 42px;\n      padding-left: 1px;\n      letter-spacing: 1.5px;\n      font-weight: 600;\n      flex: 1;\n      -webkit-transition: all 0.6s ease-in-out;\n      -moz-transition: all 0.6s ease-in-out;\n      -ms-transition: all 0.6s ease-in-out;\n      -o-transition: all 0.6s ease-in-out;\n      transition: all 0.6s ease-in-out; }\n    .iq-sidebar-logo a span.logo-text {\n      font-size: 10px;\n      letter-spacing: 5px; }\n    .iq-sidebar-logo a:hover {\n      text-decoration: none; }\n    .iq-sidebar-logo a:focus {\n      text-decoration: none; }\n  .iq-sidebar-logo img {\n    height: 50px; }\n\n.iq-saidbar-logo img {\n  width: 60%; }\n\n.logo-text {\n  color: #535f6b;\n  text-transform: uppercase;\n  font-size: 10px;\n  letter-spacing: 5px; }\n\n.iq-top-navbar .wrapper-menu {\n  margin: 0 15px 0 0; }\n\n.wrapper-menu {\n  font-size: 30px;\n  text-align: center;\n  color: #8f93f6;\n  position: relative;\n  -webkit-transition: all 0.6s ease-in-out;\n  -moz-transition: all 0.6s ease-in-out;\n  -ms-transition: all 0.6s ease-in-out;\n  -o-transition: all 0.6s ease-in-out;\n  transition: all 0.6s ease-in-out; }\n\n@media (min-width: 1300px) {\n  .iq-top-navbar .iq-navbar-custom .wrapper-menu {\n    display: none; }\n  body.sidebar-main .iq-sidebar {\n    width: 80px; }\n    body.sidebar-main .iq-sidebar .iq-sidebar-menu .iq-menu li a span {\n      -webkit-opacity: 0;\n      -moz-opacity: 0;\n      -ms-opacity: 0;\n      -o-opacity: 0;\n      opacity: 0;\n      display: none;\n      -webkit-transition: all 0.6s ease-in-out;\n      -moz-transition: all 0.6s ease-in-out;\n      -ms-transition: all 0.6s ease-in-out;\n      -o-transition: all 0.6s ease-in-out;\n      transition: all 0.6s ease-in-out; }\n    body.sidebar-main .iq-sidebar .iq-sidebar-menu .iq-menu li a .iq-arrow-right {\n      display: none; }\n  body.sidebar-main .iq-sidebar-logo a {\n    display: none; }\n    body.sidebar-main .iq-sidebar-logo a span {\n      -webkit-opacity: 0;\n      -moz-opacity: 0;\n      -ms-opacity: 0;\n      -o-opacity: 0;\n      opacity: 0;\n      display: none;\n      -webkit-transition: all 0.6s ease-in-out;\n      -moz-transition: all 0.6s ease-in-out;\n      -ms-transition: all 0.6s ease-in-out;\n      -o-transition: all 0.6s ease-in-out;\n      transition: all 0.6s ease-in-out; }\n  body.sidebar-main .iq-sidebar-menu .iq-menu li a .badge {\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    display: none;\n    -webkit-transition: all 0.6s ease-in-out;\n    -moz-transition: all 0.6s ease-in-out;\n    -ms-transition: all 0.6s ease-in-out;\n    -o-transition: all 0.6s ease-in-out;\n    transition: all 0.6s ease-in-out; }\n  body.sidebar-main .iq-sidebar-menu .iq-menu li a .iq-arrow-right {\n    margin-right: 0;\n    display: none; }\n  body.sidebar-main .iq-sidebar-menu .iq-menu li a i.iq-arrow-left {\n    margin: 0 auto; }\n  body.sidebar-main .iq-sidebar-menu .iq-menu li li a i {\n    margin: 0 auto;\n    text-align: center; }\n  body.sidebar-main .sidebar-default .iq-sidebar-menu .iq-menu li ul li a {\n    padding-left: 20px; }\n  .sidebar-main .iq-sidebar .iq-submenu li a {\n    font-size: 0; } }\n\n@media (max-width: 1299px) {\n  .iq-sidebar {\n    display: inline-block;\n    z-index: 99;\n    left: -300px;\n    top: 0px; }\n  body.sidebar-main .iq-sidebar {\n    width: 260px;\n    left: 0;\n    z-index: 999; } }\n\n@media (min-width: 1300px) {\n  .iq-menu-bt-sidebar {\n    display: none; } }\n\n@keyframes shadowDots {\n  0% {\n    box-shadow: 0 0 0 0px rgba(0, 177, 255, 0.2); }\n  100% {\n    box-shadow: 0 0 0 15px rgba(0, 177, 255, 0); } }\n\n@keyframes shadow-pulse {\n  0% {\n    box-shadow: 0 0 0 0px rgba(0, 177, 255, 0.2); }\n  100% {\n    box-shadow: 0 0 0 15px rgba(0, 177, 255, 0); } }\n\n@keyframes shadow-pulse-dots-danger {\n  0% {\n    box-shadow: 0 0 0 0px rgba(255, 155, 138, 0.2); }\n  100% {\n    box-shadow: 0 0 0 15px rgba(255, 155, 138, 0); } }\n\n@keyframes shadow-pulse-danger {\n  0% {\n    box-shadow: 0 0 0 0px rgba(255, 155, 138, 0.2); }\n  100% {\n    box-shadow: 0 0 0 15px rgba(255, 155, 138, 0); } }\n\n@-webkit-keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(50px);\n    transform: translateY(50px);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1; } }\n\n@keyframes fade-in-bottom {\n  0% {\n    -webkit-transform: translateY(50px);\n    transform: translateY(50px);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1; } }\n\n.iq-top-navbar {\n  background: #fff;\n  padding: 0 30px 0 30px;\n  min-height: 80px;\n  position: fixed;\n  top: 0;\n  left: auto;\n  right: 0;\n  width: calc(100% - 260px);\n  display: inline-block;\n  z-index: 99;\n  margin: 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A; }\n  .iq-top-navbar .iq-navbar-custom .navbar-breadcrumb {\n    display: block;\n    margin-left: 0px;\n    padding: 20px 0; }\n  .iq-top-navbar .breadcrumb {\n    background: transparent;\n    padding: 0;\n    margin: 0; }\n    .iq-top-navbar .breadcrumb .breadcrumb-item.active {\n      color: #535f6b; }\n    .iq-top-navbar .breadcrumb li {\n      list-style-type: none;\n      font-size: 14px; }\n      .iq-top-navbar .breadcrumb li a {\n        text-decoration: none; }\n        .iq-top-navbar .breadcrumb li a:hover {\n          text-decoration: none; }\n  .iq-top-navbar .navbar-expand-lg {\n    justify-content: space-between !important; }\n  .iq-top-navbar .iq-sub-dropdown {\n    width: 300px;\n    height: auto;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: auto;\n    border: none;\n    -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n    animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%);\n    background-color: #fff;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    padding: 0;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px;\n    -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n    -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n    -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n    -o-box-shadow: 0px 16px 40px 0px #0000000A;\n    box-shadow: 0px 16px 40px 0px #0000000A;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n    .iq-top-navbar .iq-sub-dropdown .iq-card-body div {\n      -webkit-border-radius: 8px 8px 0 0;\n      -moz-border-radius: 8px 8px 0 0;\n      -ms-border-radius: 8px 8px 0 0;\n      -o-border-radius: 8px 8px 0 0;\n      border-radius: 8px 8px 0 0; }\n  .iq-top-navbar .lang .iq-sub-dropdown {\n    width: auto; }\n  .iq-top-navbar .iq-user-dropdown {\n    position: fixed;\n    left: auto;\n    right: 0;\n    width: 350px;\n    top: 0;\n    bottom: 0;\n    height: 100vh;\n    background: #fff;\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    visibility: hidden;\n    -webkit-transform: translateX(100%);\n    -moz-transform: translateX(100%);\n    -ms-transform: translateX(100%);\n    -o-transform: translateX(100%);\n    transform: translateX(100%);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n  .iq-top-navbar .navbar-brand {\n    padding: 0; }\n\nbody.sidebar-main .iq-top-navbar {\n  width: calc(100% - 80px); }\n\n.iq-top-navbar.fixed-header {\n  margin: 0;\n  right: 0;\n  width: calc(100% - 330px);\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  -ms-border-radius: 0;\n  -o-border-radius: 0;\n  border-radius: 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n\n.navbar-breadcrumb .breadcrumb {\n  padding: 0;\n  background: none;\n  margin-top: 5px; }\n\n.breadcrumb-item + .breadcrumb-item::before {\n  content: \"\\ea5f\";\n  font-family: 'remixicon';\n  font-size: 14px;\n  vertical-align: sub;\n  color: #535f6b; }\n\n.navbar-list {\n  margin: 0;\n  padding: 0;\n  float: right; }\n  .navbar-list li {\n    float: left;\n    list-style-type: none;\n    position: relative; }\n    .navbar-list li > .dropdown {\n      line-height: 73px;\n      cursor: pointer; }\n      .navbar-list li > .dropdown .dropdown-menu {\n        -webkit-animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n        animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n        -webkit-transform: translateY(100%);\n        -moz-transform: translateY(100%);\n        -ms-transform: translateY(100%);\n        -o-transform: translateY(100%);\n        transform: translateY(100%); }\n    .navbar-list li .dropdown-toggle::after {\n      display: none; }\n    .navbar-list li > a.language-title {\n      font-size: 16px; }\n    .navbar-list li > a {\n      color: #535f6b;\n      font-size: 22px;\n      padding: 0 12px;\n      display: block;\n      line-height: 73px; }\n      .navbar-list li > a > img {\n        width: 50px;\n        height: 50px;\n        min-width: 50px; }\n    .navbar-list li a:hover {\n      text-decoration: none; }\n    .navbar-list li .caption {\n      line-height: 26px;\n      font-size: 18px;\n      height: 25px;\n      width: 25px;\n      text-align: center;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%; }\n      .navbar-list li .caption p {\n        color: #535f6b;\n        font-size: 12px; }\n    .navbar-list li .iq-sub-dropdown .iq-sub-card {\n      font-size: inherit;\n      padding: 10px 0px;\n      border-bottom: 1px solid #f1f1f1;\n      line-height: normal;\n      color: inherit;\n      display: inline-block;\n      width: 100%; }\n      .navbar-list li .iq-sub-dropdown .iq-sub-card:last-child {\n        padding-bottom: 0;\n        border: 0; }\n      .navbar-list li .iq-sub-dropdown .iq-sub-card i {\n        font-size: 18px;\n        vertical-align: middle;\n        padding-right: 12px; }\n    .navbar-list li .iq-sub-dropdown .iq-sub-card.iq-sub-card-big {\n      width: auto; }\n  .navbar-list li.iq-nav-user {\n    display: flex;\n    align-items: flex-start; }\n    .navbar-list li.iq-nav-user span {\n      flex: 1;\n      font-size: 14px; }\n  .navbar-list .caption-content {\n    line-height: normal; }\n\n.menu-tag {\n  position: absolute;\n  background: #535f6b;\n  color: #fff;\n  display: inline-block;\n  top: 18px;\n  left: 18px;\n  font-size: 12px;\n  border-radius: 90px;\n  line-height: normal;\n  height: 18px;\n  width: 18px;\n  line-height: 18px;\n  text-align: center;\n  display: inline-block; }\n\n.iq-breadcrumb {\n  display: none; }\n\n.toggle-cart-info img {\n  width: 50px; }\n\n.nav-item span.dots {\n  height: 6px;\n  width: 6px;\n  font-size: 0;\n  text-align: center;\n  padding: 0;\n  position: absolute;\n  top: 18px;\n  right: 3px;\n  border: 0;\n  animation: shadowDots 1s infinite;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%; }\n\n.nav-item span.count-mail {\n  height: 6px;\n  width: 5px;\n  font-size: 10px;\n  text-align: center;\n  line-height: 15px;\n  padding: 0;\n  position: absolute;\n  top: 18px;\n  right: 3px;\n  border: 0;\n  animation: shadow-pulse 1s infinite;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%; }\n\n.nav-item .badge.count-cart {\n  height: 15px;\n  width: 15px;\n  font-size: 10px;\n  text-align: center;\n  line-height: 15px;\n  padding: 0;\n  position: absolute;\n  top: 13px;\n  right: 0px; }\n\n.top-nav-bottom {\n  margin-left: 260px;\n  border-top: 1px solid #c6c8f7; }\n\n.topnav-toolbar li a {\n  display: block;\n  padding: 10px 15px;\n  text-transform: capitalize;\n  color: #6c757d;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.topnav-toolbar li.date-today {\n  background: #FAFAFA; }\n\n.topnav-toolbar li.active a {\n  background: #c6c8f7;\n  color: #8f93f6; }\n\n.topnav-toolbar ul li {\n  list-style: none;\n  padding: 13px 0; }\n\n.iq-search-bar .dropdown-toggle {\n  width: 450px;\n  position: relative;\n  margin: 0;\n  box-shadow: none !important; }\n  .iq-search-bar .dropdown-toggle.searchbox:after {\n    position: absolute;\n    right: 15px;\n    top: 17px; }\n  .iq-search-bar .dropdown-toggle .select-dropdown > li > .item {\n    padding: 12px 20px; }\n    .iq-search-bar .dropdown-toggle .select-dropdown > li > .item i {\n      font-size: 16px;\n      vertical-align: middle;\n      margin-right: 12px;\n      padding: 5px;\n      -webkit-border-radius: 3px;\n      -moz-border-radius: 3px;\n      -ms-border-radius: 3px;\n      -o-border-radius: 3px;\n      border-radius: 3px; }\n\n.iq-search-bar .btn-group .dropdown-menu {\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  border: 0;\n  z-index: 9;\n  padding: 0;\n  height: auto;\n  text-align: left !important;\n  -webkit-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n  -ms-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n  -o-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1); }\n\n.iq-search-bar .btn-group li:last-child .item {\n  border: 0; }\n\n.iq-search-bar .btn-group li .item {\n  padding: 10px 20px;\n  border-bottom: 1px solid #f1f1f1;\n  color: #535f6b; }\n  .iq-search-bar .btn-group li .item i {\n    padding: 8px 10px;\n    font-size: \"Poppins\", sans-serif;\n    line-height: 20px;\n    margin-right: 15px;\n    border-radius: 8px; }\n\n.iq-search-bar .btn-group .search-replace .item {\n  display: none; }\n\n.iq-search-bar .search-input {\n  width: 100%;\n  height: 40px !important;\n  padding: 5px 5px 5px 42px;\n  font-size: 14px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  border: 1px solid #f1f1f1; }\n\n.iq-search-bar .search-link {\n  position: absolute;\n  right: auto;\n  left: 15px;\n  top: 10px;\n  color: #535f6b; }\n\n.iq-search-bar .search-dropdown {\n  position: absolute;\n  top: 10px;\n  right: 0; }\n\n.search-dropdown .dropdown-toggle i {\n  font-size: 20px; }\n\n.search-dropdown .dropdown-toggle:after {\n  display: none; }\n\n.iq-navbar-logo {\n  padding: 0;\n  width: auto;\n  position: relative;\n  background: #fff;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: transparent; }\n  .iq-navbar-logo a {\n    display: flex;\n    align-items: center; }\n    .iq-navbar-logo a span {\n      margin-left: 10px;\n      font-size: 28px;\n      line-height: 26px;\n      font-weight: 500;\n      color: #01041b;\n      text-transform: capitalize;\n      flex: 1;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out; }\n    .iq-navbar-logo a:hover {\n      text-decoration: none; }\n    .iq-navbar-logo a:focus {\n      text-decoration: none; }\n  .iq-navbar-logo img {\n    height: 50px; }\n\n.iq-sub-dropdown.iq-sub-dropdown-large {\n  width: 500px; }\n\n.cust-title {\n  border-bottom: 1px solid #f1f1f1; }\n\n.crt-img {\n  background: #fafbfe;\n  padding: 10px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.cust-dd .btn {\n  -webkit-border-radius: 0 0 8px 8px;\n  -moz-border-radius: 0 0 8px 8px;\n  -ms-border-radius: 0 0 8px 8px;\n  -o-border-radius: 0 0 8px 8px;\n  border-radius: 0 0 8px 8px; }\n\n.dd-icon {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 40px;\n  height: 40px;\n  background: #6c71e3;\n  color: #fff;\n  border-radius: 0 0 0 10px;\n  text-align: center;\n  line-height: 40px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.right-ic {\n  -webkit-border-radius: 0 0 8px 8px;\n  -moz-border-radius: 0 0 8px 8px;\n  -ms-border-radius: 0 0 8px 8px;\n  -o-border-radius: 0 0 8px 8px;\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n  border: none !important; }\n  .right-ic:hover .dd-icon {\n    background: #8f93f6; }\n\n.iq-show .iq-sub-dropdown {\n  display: inline-block; }\n\n.iq-sub-dropdown .iq-card-icon {\n  width: 45px;\n  height: 45px;\n  line-height: 40px;\n  font-size: 22px; }\n\n.show-data .iq-user-dropdown {\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  -ms-opacity: 1;\n  -o-opacity: 1;\n  opacity: 1;\n  visibility: visible;\n  -webkit-transform: translateX(0);\n  -moz-transform: translateX(0);\n  -ms-transform: translateX(0);\n  -o-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n\n.iq-card-icon-small {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  display: inline-block;\n  line-height: 40px;\n  text-align: center;\n  font-size: 22px; }\n\n.profile-details > a {\n  margin-bottom: 15px;\n  display: block;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.data-scrollbar {\n  height: 100vh;\n  overflow-x: scroll;\n }\n\n.navbar-toggler {\n  outline: none; }\n\n.profile-icon {\n  height: 60px;\n  width: 60px;\n  line-height: 60px;\n  font-size: 26px; }\n\n@media (min-width: 1300px) {\n  .iq-navbar-logo {\n    display: none !important; }\n    .iq-navbar-logo > a {\n      display: none; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a.collapsed {\n    pointer-events: none; } }\n\n@media (max-width: 1199px) {\n  .iq-search-bar .searchbox {\n    width: 320px; } }\n\n@media (max-width: 1299px) {\n  .iq-top-navbar {\n    width: 100%; }\n    .iq-top-navbar .iq-search-bar.device-search {\n      margin-left: 20px; }\n  body.sidebar-main .iq-top-navbar {\n    width: 100%; } }\n\n@media (min-width: 992px) {\n  .search-content {\n    display: none; }\n  .navbar-list li:last-child > a {\n    padding: 0 0 0 12px; } }\n\n@media (max-width: 991px) {\n  .device-search {\n    display: none; }\n  .navbar-collapse {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background: #fff;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px;\n    -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n    -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n    -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n    -o-box-shadow: 0px 16px 40px 0px #0000000A;\n    box-shadow: 0px 16px 40px 0px #0000000A; }\n  .navbar-nav.navbar-list {\n    float: right;\n    display: inline-block; }\n  .iq-top-navbar {\n    padding: 16px 15px !important;\n    line-height: normal;\n    min-height: unset; }\n    .iq-top-navbar .navbar-toggler {\n      color: #8f93f6;\n      background: #c6c8f7;\n      border: none;\n      padding: 7px 10px 3px;\n      border-radius: 5px;\n      font-size: 24px; }\n    .iq-top-navbar .iq-navbar-logo img {\n      height: 40px; }\n    .iq-top-navbar .iq-search-bar {\n      line-height: normal; }\n  .iq-search-bar .searchbox {\n    width: 100%; }\n  .caption-content {\n    padding-top: 22px; } }\n\n@media (max-width: 767px) {\n  .iq-top-navbar .lang .iq-sub-dropdown {\n    width: 150px; } }\n\n@media (max-width: 575px) {\n  .search-toggle {\n    position: relative; }\n  .iq-top-navbar .iq-sub-dropdown {\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 270px; }\n  .iq-top-navbar .iq-search-bar {\n    width: 100%; }\n  .iq-top-navbar .iq-user-dropdown {\n    width: 300px; }\n  .navbar-list li {\n    position: static; }\n    .navbar-list li > a.language-title {\n      font-size: 0; } }\n\n@media (max-width: 479px) {\n  .navbar-list li > a {\n    padding: 0 10px; }\n    .navbar-list li > a > img {\n      width: 40px;\n      height: 40px;\n      min-width: 40px; } }\n\n.iq-right-fixed {\n  margin: 0 15px; }\n\n.right-sidebar-mini {\n  top: 75px;\n  z-index: 100;\n  position: fixed;\n  width: 260px;\n  right: 0;\n  transform: translateX(calc(111% + -2em));\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n  .right-sidebar-mini .side-left-icon {\n    display: none; }\n\n.right-sidebar-toggle {\n  position: absolute;\n  margin-left: -44px;\n  background: #fff;\n  padding: 15px;\n  display: inline;\n  top: 0;\n  z-index: 99;\n  -webkit-border-radius: 50px 0 0 50px;\n  -moz-border-radius: 50px 0 0 50px;\n  -ms-border-radius: 50px 0 0 50px;\n  -o-border-radius: 50px 0 0 50px;\n  border-radius: 50px 0 0 50px;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A;\n  cursor: pointer; }\n  .right-sidebar-toggle span {\n    display: none !important; }\n\n.right-sidebar-panel {\n  background-color: #fff;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A;\n  height: 91vh;\n  padding: 15px;\n  overflow-y: scroll; }\n\n.right-sidebar {\n  transform: translateX(calc(10% + -1em)); }\n  .right-sidebar .side-right-icon {\n    display: none; }\n  .right-sidebar .side-left-icon {\n    display: block; }\n\n@media (min-width: 1500px) {\n  .right-sidebar-mini {\n    transform: translateX(calc(10% + -1em)); }\n    .right-sidebar-mini:hover .right-sidebar-toggle {\n      -webkit-opacity: 1;\n      -moz-opacity: 1;\n      -ms-opacity: 1;\n      -o-opacity: 1;\n      opacity: 1;\n      margin-left: -44px;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out; }\n  .right-sidebar-toggle {\n    z-index: -1;\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    margin-left: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n  .right-sidebar-mini.right-sidebar {\n    transform: translateX(calc(111% + -2em)); }\n    .right-sidebar-mini.right-sidebar .right-sidebar-toggle {\n      margin-left: -44px;\n      -webkit-opacity: 1;\n      -moz-opacity: 1;\n      -ms-opacity: 1;\n      -o-opacity: 1;\n      opacity: 1; }\n  body.right-sidebar-close footer {\n    width: calc(100vw - 260px); } }\n\n@media (min-width: 1300px) and (max-width: 1499px) {\n  .right-sidebar-mini {\n    transform: translateX(calc(111% + -8em)); }\n    .right-sidebar-mini .media-body {\n      -webkit-opacity: 0;\n      -moz-opacity: 0;\n      -ms-opacity: 0;\n      -o-opacity: 0;\n      opacity: 0; }\n  .right-sidebar-mini.right-sidebar {\n    transform: translateX(calc(10% + -1em)); }\n    .right-sidebar-mini.right-sidebar .media-body {\n      -webkit-opacity: 1;\n      -moz-opacity: 1;\n      -ms-opacity: 1;\n      -o-opacity: 1;\n      opacity: 1; } }\n\n.basic-drop-shadow {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15); }\n\n.bottom-left {\n  box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.15); }\n\n.bottom-right {\n  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15); }\n\n.top-left {\n  box-shadow: -5px -5px 10px rgba(0, 0, 0, 0.15); }\n\n.top-right {\n  box-shadow: 5px -5px 10px rgba(0, 0, 0, 0.15); }\n\n.shadow-bottom {\n  box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.15); }\n\n.inner-shadow {\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.15); }\n\n.blur-shadow {\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.15); }\n\n@keyframes rippleDrop {\n  100% {\n    -webkit-transform: scale(2);\n    -moz-transform: scale(2);\n    -ms-transform: scale(2);\n    -o-transform: scale(2);\n    transform: scale(2);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; } }\n\n.ripple {\n  width: 0;\n  height: 0;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  background: #c6c8f7;\n  -webkit-transform: scale(0);\n  -moz-transform: scale(0);\n  -ms-transform: scale(0);\n  -o-transform: scale(0);\n  transform: scale(0);\n  position: absolute;\n  -webkit-opacity: 1;\n  -moz-opacity: 1;\n  -ms-opacity: 1;\n  -o-opacity: 1;\n  opacity: 1; }\n\n.rippleEffect {\n  animation: rippleDrop .6s linear; }\n\n.media-support {\n  display: inline-block;\n  width: 100%; }\n\n.media-support-user-img img {\n  height: 60px; }\n\n.media-support-header {\n  display: flex;\n  align-items: flex-start; }\n\n.media-support-info {\n  flex: 1; }\n\n.projects-media img {\n  height: 60px; }\n\n.iq-media-group .iq-media {\n  margin-left: -20px;\n  position: relative;\n  z-index: 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n  .iq-media-group .iq-media:hover {\n    z-index: 9; }\n  .iq-media-group .iq-media img {\n    border: 2px solid #f1f1f1; }\n  .iq-media-group .iq-media:first-child {\n    margin-left: 0; }\n\n.iq-media-group .iq-media.border {\n  border: 2px solid #f1f1f1; }\n\n.iq-media {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover; }\n  .iq-media:hover {\n    text-decoration: none; }\n\n.media-pl {\n  text-align: center; }\n\n.badge {\n  padding: .3em .6em;\n  line-height: 1.3;\n  text-transform: capitalize;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.breadcrumb.bg-primary .breadcrumb-item + .breadcrumb-item::before {\n  color: #fff; }\n\n.alert-primary {\n  color: #6065f2;\n  border-color: #6065f2;\n  background-color: rgba(198, 200, 247, 0.1); }\n  .alert-primary .alert-link {\n    color: #3138ee; }\n\n.alert-secondary {\n  color: #545b62;\n  border-color: #545b62;\n  background-color: rgba(204, 206, 210, 0.1); }\n  .alert-secondary .alert-link {\n    color: #3d4246; }\n\n.dark .alert-secondary {\n  color: #868e96;\n  border-color: #545b62;\n  background-color: rgba(204, 206, 210, 0.1); }\n  .dark .alert-secondary .alert-link {\n    color: #a1a8ae; }\n\n.alert-success {\n  color: #57d25f;\n  border-color: #57d25f;\n  background-color: rgba(183, 225, 186, 0.1); }\n  .alert-success .alert-link {\n    color: #34c23d; }\n\n.alert-danger {\n  color: #e873a9;\n  border-color: #e873a9;\n  background-color: rgba(255, 218, 235, 0.1); }\n  .alert-danger .alert-link {\n    color: #e0488e; }\n\n.alert-warning {\n  color: #f8c432;\n  border-color: #f8c432;\n  background-color: rgba(255, 235, 223, 0.1); }\n  .alert-warning .alert-link {\n    color: #efb208; }\n\n.alert-info {\n  color: #fa9674;\n  border-color: #fa9674;\n  background-color: rgba(255, 230, 222, 0.1); }\n  .alert-info .alert-link {\n    color: #f97042; }\n\n.alert-light {\n  color: #545b62;\n  border-color: #545b62;\n  background-color: rgba(250, 250, 250, 0.1); }\n  .alert-light .alert-link {\n    color: #c7c7c7; }\n\n.dark .alert-light {\n  color: #868e96;\n  border-color: #545b62;\n  background-color: rgba(250, 250, 250, 0.1); }\n  .dark .alert-light .alert-link {\n    color: #c7c7c7; }\n\n.alert {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch; }\n  .alert .iq-alert-icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 0 1.30rem 0 0; }\n    .alert .iq-alert-icon i {\n      font-size: 2.441em;\n      line-height: normal; }\n  .alert .iq-alert-text {\n    -ms-flex-item-align: center;\n    align-self: center;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1; }\n  .alert .close {\n    float: right;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1;\n    color: #fff;\n    text-shadow: none;\n    opacity: 1; }\n\n.close:not(:disabled):not(.disabled):focus {\n  outline: none; }\n\n.close:not(:disabled):not(.disabled):hover {\n  outline: none; }\n\n.iq-example-row .row > .col {\n  padding-top: .75rem;\n  color: #535f6b;\n  padding-bottom: .75rem;\n  background-color: rgba(86, 61, 124, 0.15);\n  border: 1px solid rgba(86, 61, 124, 0.2); }\n\n.iq-example-row .row > [class^=col-] {\n  padding-top: .75rem;\n  color: #535f6b;\n  padding-bottom: .75rem;\n  background-color: rgba(86, 61, 124, 0.15);\n  border: 1px solid rgba(86, 61, 124, 0.2); }\n\n.iq-example-row-flex-cols .row {\n  margin-bottom: 15px;\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1); }\n\n.nav-pills .nav-item a {\n  color: #535f6b; }\n\n.nav-pills .nav-link.active {\n  color: #8f93f6;\n  background: #c6c8f7; }\n\n.nav-pills .show > .nav-link {\n  color: #8f93f6;\n  background: #c6c8f7; }\n\n.nav-pills .nav-link:hover {\n  color: #8f93f6; }\n\n.nav-tabs {\n  border-bottom: 2px solid #c6c8f7;\n  margin-bottom: 15px; }\n  .nav-tabs .nav-item {\n    margin-bottom: -2px; }\n    .nav-tabs .nav-item a {\n      color: #535f6b;\n      border: none;\n      border-bottom: 2px solid transparent; }\n  .nav-tabs .nav-item.show .nav-link {\n    border-bottom: 2px solid #8f93f6;\n    color: #8f93f6; }\n  .nav-tabs .nav-link.active {\n    border-bottom: 2px solid #8f93f6;\n    color: #8f93f6; }\n\n.custom-checkbox.custom-checkbox-color input.bg-primary ~ label::before {\n  background-color: #8f93f6 !important;\n  border-color: #8f93f6 !important; }\n\n.custom-checkbox.custom-checkbox-color input.bg-success ~ label::before {\n  background-color: #7fdd85 !important;\n  border-color: #7fdd85 !important; }\n\n.custom-checkbox.custom-checkbox-color input.bg-danger ~ label::before {\n  background-color: #ef9fc4 !important;\n  border-color: #ef9fc4 !important; }\n\n.custom-checkbox.custom-checkbox-color input.bg-warning ~ label::before {\n  background-color: #fad263 !important;\n  border-color: #fad263 !important; }\n\n.custom-checkbox.custom-checkbox-color input.bg-dark ~ label::before {\n  background-color: #535f6b !important;\n  border-color: #535f6b !important; }\n\n.custom-checkbox.custom-checkbox-color input.bg-info ~ label::before {\n  background-color: #fcbba5 !important;\n  border-color: #fcbba5 !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-primary ~ label::before {\n  background-color: #8f93f6 !important;\n  border-color: #8f93f6 !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-success ~ label::before {\n  background-color: #7fdd85 !important;\n  border-color: #7fdd85 !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-danger ~ label::before {\n  background-color: #ef9fc4 !important;\n  border-color: #ef9fc4 !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-warning ~ label::before {\n  background-color: #fad263 !important;\n  border-color: #fad263 !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-dark ~ label::before {\n  background-color: #535f6b !important;\n  border-color: #535f6b !important; }\n\n.custom-checkbox.custom-checkbox-color-check input:checked.bg-info ~ label::before {\n  background-color: #fcbba5 !important;\n  border-color: #fcbba5 !important; }\n\n.custom-radio.custom-radio-color input.bg-primary ~ label::before {\n  background-color: #8f93f6 !important;\n  border-color: #8f93f6 !important; }\n\n.custom-radio.custom-radio-color input.bg-success ~ label::before {\n  background-color: #7fdd85 !important;\n  border-color: #7fdd85 !important; }\n\n.custom-radio.custom-radio-color input.bg-danger ~ label::before {\n  background-color: #ef9fc4 !important;\n  border-color: #ef9fc4 !important; }\n\n.custom-radio.custom-radio-color input.bg-warning ~ label::before {\n  background-color: #fad263 !important;\n  border-color: #fad263 !important; }\n\n.custom-radio.custom-radio-color input.bg-dark ~ label::before {\n  background-color: #535f6b !important;\n  border-color: #535f6b !important; }\n\n.custom-radio.custom-radio-color input.bg-info ~ label::before {\n  background-color: #fcbba5 !important;\n  border-color: #fcbba5 !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-primary ~ label::before {\n  background-color: #8f93f6 !important;\n  border-color: #8f93f6 !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-success ~ label::before {\n  background-color: #7fdd85 !important;\n  border-color: #7fdd85 !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-danger ~ label::before {\n  background-color: #ef9fc4 !important;\n  border-color: #ef9fc4 !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-warning ~ label::before {\n  background-color: #fad263 !important;\n  border-color: #fad263 !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-dark ~ label::before {\n  background-color: #535f6b !important;\n  border-color: #535f6b !important; }\n\n.custom-radio.custom-radio-color-checked input:checked.bg-info ~ label::before {\n  background-color: #fcbba5 !important;\n  border-color: #fcbba5 !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-primary ~ label::before {\n  background-color: #8f93f6 !important;\n  border-color: #8f93f6 !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-success ~ label::before {\n  background-color: #7fdd85 !important;\n  border-color: #7fdd85 !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-danger ~ label::before {\n  background-color: #ef9fc4 !important;\n  border-color: #ef9fc4 !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-warning ~ label::before {\n  background-color: #fad263 !important;\n  border-color: #fad263 !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-dark ~ label::before {\n  background-color: #535f6b !important;\n  border-color: #535f6b !important; }\n\n.custom-switch.custom-switch-color input:checked.bg-info ~ label::before {\n  background-color: #fcbba5 !important;\n  border-color: #fcbba5 !important; }\n\n.custom-checkbox.checkbox-icon label i {\n  position: absolute;\n  top: 6px;\n  left: -21px;\n  font-size: 10px;\n  -webkit-transform: scale(0);\n  -moz-transform: scale(0);\n  -ms-transform: scale(0);\n  -o-transform: scale(0);\n  transform: scale(0);\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n\n.custom-checkbox.checkbox-icon input:checked ~ label i {\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  -ms-transform: scale(1);\n  -o-transform: scale(1);\n  transform: scale(1);\n  color: #fff; }\n\n.custom-checkbox.checkbox-icon input:checked ~ label::after {\n  display: none; }\n\n.custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #8f93f6;\n  border-color: #8f93f6; }\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: #c6c8f7;\n  color: #8f93f6; }\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: #c6c8f7;\n  color: #8f93f6; }\n\n.custom-select:focus {\n  box-shadow: none; }\n\n.custom-switch.custom-switch-icon {\n  padding-left: 0; }\n  .custom-switch.custom-switch-icon label .switch-icon-left {\n    position: absolute;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    top: -3px;\n    left: 8px;\n    right: auto;\n    color: #fff; }\n    .custom-switch.custom-switch-icon label .switch-icon-left i {\n      font-size: 10px; }\n  .custom-switch.custom-switch-icon label .switch-icon-right {\n    position: absolute;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    top: -3px;\n    right: 5px;\n    left: auto; }\n    .custom-switch.custom-switch-icon label .switch-icon-right i {\n      font-size: 10px; }\n  .custom-switch.custom-switch-icon .custom-control-label {\n    height: 20px;\n    width: 42px;\n    padding: 0; }\n    .custom-switch.custom-switch-icon .custom-control-label::before {\n      height: 20px;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out;\n      user-select: none;\n      top: 0;\n      left: 1px;\n      width: 2.75rem; }\n    .custom-switch.custom-switch-icon .custom-control-label:after {\n      position: absolute;\n      top: 1px;\n      left: 2px;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out;\n      user-select: none;\n      height: 18px;\n      width: 18px; }\n  .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label::after {\n    -webkit-transform: translateX(1.4rem);\n    -moz-transform: translateX(1.4rem);\n    -ms-transform: translateX(1.4rem);\n    -o-transform: translateX(1.4rem);\n    transform: translateX(1.4rem); }\n\n.custom-switch.custom-switch-text {\n  padding-left: 0; }\n  .custom-switch.custom-switch-text label .switch-icon-left {\n    position: absolute;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    top: -3px;\n    left: 8px;\n    right: auto;\n    color: #fff; }\n  .custom-switch.custom-switch-text label .switch-icon-right {\n    position: absolute;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    top: -3px;\n    right: 5px;\n    left: auto; }\n  .custom-switch.custom-switch-text label::before {\n    color: #000;\n    content: attr(data-off-label);\n    width: 2.85rem;\n    height: 20px;\n    padding: 0 4px;\n    font-size: 11px;\n    line-height: 18px;\n    text-align: right; }\n  .custom-switch.custom-switch-text label:after {\n    position: absolute;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    user-select: none;\n    height: 16px;\n    width: 16px; }\n  .custom-switch.custom-switch-text .custom-control-label {\n    width: 46px; }\n    .custom-switch.custom-switch-text .custom-control-label::before {\n      height: 20px;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out;\n      user-select: none;\n      top: 0;\n      left: 1px;\n      width: 2.75rem;\n      width: 100%; }\n    .custom-switch.custom-switch-text .custom-control-label:after {\n      position: absolute;\n      top: 1px;\n      left: 2px;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out;\n      user-select: none;\n      height: 18px;\n      width: 18px; }\n  .custom-switch.custom-switch-text .custom-control-input:checked ~ .custom-control-label::after {\n    -webkit-transform: translateX(1.6rem);\n    -moz-transform: translateX(1.6rem);\n    -ms-transform: translateX(1.6rem);\n    -o-transform: translateX(1.6rem);\n    transform: translateX(1.6rem); }\n  .custom-switch.custom-switch-text input:checked ~ label::before {\n    color: #fff;\n    content: attr(data-on-label);\n    text-align: left; }\n  .custom-switch.custom-switch-text input:checked ~ label.custom-control-label::after {\n    -webkit-transform: translateX(1.6rem);\n    -moz-transform: translateX(1.6rem);\n    -ms-transform: translateX(1.6rem);\n    -o-transform: translateX(1.6rem);\n    transform: translateX(1.6rem); }\n\n.custom-switch-inner {\n  display: block;\n  text-align: center; }\n\n.form-label-group {\n  position: relative;\n  margin-bottom: 1.5rem; }\n  .form-label-group > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    padding: .6rem;\n    color: #475F7B;\n    font-size: .85rem;\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; }\n\n.counter-value {\n  color: #fff;\n  padding: 1px 6px;\n  font-size: .6rem;\n  -webkit-border-radius: 0 0 8px 8px;\n  -moz-border-radius: 0 0 8px 8px;\n  -ms-border-radius: 0 0 8px 8px;\n  -o-border-radius: 0 0 8px 8px;\n  border-radius: 0 0 8px 8px;\n  margin-right: 1rem; }\n\n.vector-map.h-500 {\n  width: 100%;\n  height: 500px; }\n\n.countdown {\n  margin: 60px 0 0;\n  padding: 0; }\n  .countdown li span {\n    font-size: 60px;\n    display: inline-block;\n    width: 100%;\n    color: #8f93f6; }\n  .countdown li:last-child {\n    margin-right: 0; }\n\n.iq-comingsoon-form {\n  position: relative; }\n  .iq-comingsoon-form button {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 11px 30px; }\n\n.navbar-breadcrumb .breadcrumb {\n  margin-bottom: 0px; }\n\n.btn {\n  display: inline-block;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  color: #535f6b;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 8px;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .btn {\n      transition: none; } }\n  .btn:hover {\n    color: #535f6b;\n    text-decoration: none; }\n  .btn:focus, .btn.focus {\n    outline: none;\n    box-shadow: none; }\n  .btn.disabled, .btn:disabled {\n    opacity: 0.65;\n    box-shadow: none; }\n  .btn:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n    .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n      box-shadow: none; }\n      .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {\n        box-shadow: none; }\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none; }\n\n.btn-primary {\n  color: #fff;\n  background-color: #8f93f6;\n  border-color: #8f93f6;\n  box-shadow: unset; }\n  .btn-primary:hover {\n    color: #fff;\n    background-color: #6c71f3;\n    border-color: #6065f2; }\n  .btn-primary:focus, .btn-primary.focus {\n    color: #fff;\n    background-color: #6c71f3;\n    border-color: #6065f2;\n    box-shadow: unset, 0 0 0 0.2rem rgba(160, 163, 247, 0.5); }\n  .btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #8f93f6;\n    border-color: #8f93f6; }\n  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #6065f2;\n    border-color: #545af1; }\n    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-primary.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(160, 163, 247, 0.5); }\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n  box-shadow: unset; }\n  .btn-secondary:hover {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62; }\n  .btn-secondary:focus, .btn-secondary.focus {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62;\n    box-shadow: unset, 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n  .btn-secondary.disabled, .btn-secondary:disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #545b62;\n    border-color: #4e555b; }\n    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-secondary.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n\n.btn-success {\n  color: #fff;\n  background-color: #7fdd85;\n  border-color: #7fdd85;\n  box-shadow: unset; }\n  .btn-success:hover {\n    color: #fff;\n    background-color: #61d568;\n    border-color: #57d25f; }\n  .btn-success:focus, .btn-success.focus {\n    color: #fff;\n    background-color: #61d568;\n    border-color: #57d25f;\n    box-shadow: unset, 0 0 0 0.2rem rgba(146, 226, 151, 0.5); }\n  .btn-success.disabled, .btn-success:disabled {\n    color: #fff;\n    background-color: #7fdd85;\n    border-color: #7fdd85; }\n  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n  .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #57d25f;\n    border-color: #4dd055; }\n    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-success.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(146, 226, 151, 0.5); }\n\n.btn-info {\n  color: #fff;\n  background-color: #fcbba5;\n  border-color: #fcbba5;\n  box-shadow: unset; }\n  .btn-info:hover {\n    color: #fff;\n    background-color: #fb9f80;\n    border-color: #fa9674; }\n  .btn-info:focus, .btn-info.focus {\n    color: #fff;\n    background-color: #fb9f80;\n    border-color: #fa9674;\n    box-shadow: unset, 0 0 0 0.2rem rgba(252, 197, 179, 0.5); }\n  .btn-info.disabled, .btn-info:disabled {\n    color: #fff;\n    background-color: #fcbba5;\n    border-color: #fcbba5; }\n  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n  .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #fa9674;\n    border-color: #fa8c67; }\n    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-info.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(252, 197, 179, 0.5); }\n\n.btn-warning {\n  color: #fff;\n  background-color: #fad263;\n  border-color: #fad263;\n  box-shadow: unset; }\n  .btn-warning:hover {\n    color: #fff;\n    background-color: #f9c73e;\n    border-color: #f8c432; }\n  .btn-warning:focus, .btn-warning.focus {\n    color: #fff;\n    background-color: #f9c73e;\n    border-color: #f8c432;\n    box-shadow: unset, 0 0 0 0.2rem rgba(251, 217, 122, 0.5); }\n  .btn-warning.disabled, .btn-warning:disabled {\n    color: #fff;\n    background-color: #fad263;\n    border-color: #fad263; }\n  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #f8c432;\n    border-color: #f8c025; }\n    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-warning.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(251, 217, 122, 0.5); }\n\n.btn-danger {\n  color: #fff;\n  background-color: #ef9fc4;\n  border-color: #ef9fc4;\n  box-shadow: unset; }\n  .btn-danger:hover {\n    color: #fff;\n    background-color: #ea7eb0;\n    border-color: #e873a9; }\n  .btn-danger:focus, .btn-danger.focus {\n    color: #fff;\n    background-color: #ea7eb0;\n    border-color: #e873a9;\n    box-shadow: unset, 0 0 0 0.2rem rgba(241, 173, 205, 0.5); }\n  .btn-danger.disabled, .btn-danger:disabled {\n    color: #fff;\n    background-color: #ef9fc4;\n    border-color: #ef9fc4; }\n  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #e873a9;\n    border-color: #e668a2; }\n    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-danger.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(241, 173, 205, 0.5); }\n\n.btn-light {\n  color: #212529;\n  background-color: #FAFAFA;\n  border-color: #FAFAFA;\n  box-shadow: unset; }\n  .btn-light:hover {\n    color: #212529;\n    background-color: #e7e7e7;\n    border-color: #e1e1e1; }\n  .btn-light:focus, .btn-light.focus {\n    color: #212529;\n    background-color: #e7e7e7;\n    border-color: #e1e1e1;\n    box-shadow: unset, 0 0 0 0.2rem rgba(217, 218, 219, 0.5); }\n  .btn-light.disabled, .btn-light:disabled {\n    color: #212529;\n    background-color: #FAFAFA;\n    border-color: #FAFAFA; }\n  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n  .show > .btn-light.dropdown-toggle {\n    color: #212529;\n    background-color: #e1e1e1;\n    border-color: #dadada; }\n    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-light.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(217, 218, 219, 0.5); }\n\n.btn-dark {\n  color: #fff;\n  background-color: #01041b;\n  border-color: #01041b;\n  box-shadow: unset; }\n  .btn-dark:hover {\n    color: #fff;\n    background-color: black;\n    border-color: black; }\n  .btn-dark:focus, .btn-dark.focus {\n    color: #fff;\n    background-color: black;\n    border-color: black;\n    box-shadow: unset, 0 0 0 0.2rem rgba(39, 42, 61, 0.5); }\n  .btn-dark.disabled, .btn-dark:disabled {\n    color: #fff;\n    background-color: #01041b;\n    border-color: #01041b; }\n  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: black;\n    border-color: black; }\n    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-dark.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(39, 42, 61, 0.5); }\n\n.btn-orange {\n  color: #fff;\n  background-color: #fd7e14;\n  border-color: #fd7e14;\n  box-shadow: unset; }\n  .btn-orange:hover {\n    color: #fff;\n    background-color: #e96b02;\n    border-color: #dc6502; }\n  .btn-orange:focus, .btn-orange.focus {\n    color: #fff;\n    background-color: #e96b02;\n    border-color: #dc6502;\n    box-shadow: unset, 0 0 0 0.2rem rgba(253, 145, 55, 0.5); }\n  .btn-orange.disabled, .btn-orange:disabled {\n    color: #fff;\n    background-color: #fd7e14;\n    border-color: #fd7e14; }\n  .btn-orange:not(:disabled):not(.disabled):active, .btn-orange:not(:disabled):not(.disabled).active,\n  .show > .btn-orange.dropdown-toggle {\n    color: #fff;\n    background-color: #dc6502;\n    border-color: #cf5f02; }\n    .btn-orange:not(:disabled):not(.disabled):active:focus, .btn-orange:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-orange.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(253, 145, 55, 0.5); }\n\n.btn-purple {\n  color: #fff;\n  background-color: #4731b6;\n  border-color: #4731b6;\n  box-shadow: unset; }\n  .btn-purple:hover {\n    color: #fff;\n    background-color: #3b2998;\n    border-color: #37268e; }\n  .btn-purple:focus, .btn-purple.focus {\n    color: #fff;\n    background-color: #3b2998;\n    border-color: #37268e;\n    box-shadow: unset, 0 0 0 0.2rem rgba(99, 80, 193, 0.5); }\n  .btn-purple.disabled, .btn-purple:disabled {\n    color: #fff;\n    background-color: #4731b6;\n    border-color: #4731b6; }\n  .btn-purple:not(:disabled):not(.disabled):active, .btn-purple:not(:disabled):not(.disabled).active,\n  .show > .btn-purple.dropdown-toggle {\n    color: #fff;\n    background-color: #37268e;\n    border-color: #332384; }\n    .btn-purple:not(:disabled):not(.disabled):active:focus, .btn-purple:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-purple.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(99, 80, 193, 0.5); }\n\n.btn-pink {\n  color: #212529;\n  background-color: #FFE0E0;\n  border-color: #FFE0E0;\n  box-shadow: unset; }\n  .btn-pink:hover {\n    color: #fff;\n    background-color: #ffbaba;\n    border-color: #ffadad; }\n  .btn-pink:focus, .btn-pink.focus {\n    color: #fff;\n    background-color: #ffbaba;\n    border-color: #ffadad;\n    box-shadow: unset, 0 0 0 0.2rem rgba(222, 196, 197, 0.5); }\n  .btn-pink.disabled, .btn-pink:disabled {\n    color: #212529;\n    background-color: #FFE0E0;\n    border-color: #FFE0E0; }\n  .btn-pink:not(:disabled):not(.disabled):active, .btn-pink:not(:disabled):not(.disabled).active,\n  .show > .btn-pink.dropdown-toggle {\n    color: #fff;\n    background-color: #ffadad;\n    border-color: #ffa0a0; }\n    .btn-pink:not(:disabled):not(.disabled):active:focus, .btn-pink:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-pink.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(222, 196, 197, 0.5); }\n\n.btn-outline-primary {\n  color: #8f93f6;\n  border-color: #8f93f6; }\n  .btn-outline-primary:hover {\n    color: #fff;\n    background-color: #8f93f6;\n    border-color: #8f93f6; }\n  .btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }\n  .btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #8f93f6;\n    background-color: transparent; }\n  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #8f93f6;\n    border-color: #8f93f6; }\n    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-primary.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(143, 147, 246, 0.5); }\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d; }\n  .btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #6c757d;\n    background-color: transparent; }\n  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-secondary.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.btn-outline-success {\n  color: #7fdd85;\n  border-color: #7fdd85; }\n  .btn-outline-success:hover {\n    color: #fff;\n    background-color: #7fdd85;\n    border-color: #7fdd85; }\n  .btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }\n  .btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #7fdd85;\n    background-color: transparent; }\n  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #7fdd85;\n    border-color: #7fdd85; }\n    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-success.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(127, 221, 133, 0.5); }\n\n.btn-outline-info {\n  color: #fcbba5;\n  border-color: #fcbba5; }\n  .btn-outline-info:hover {\n    color: #fff;\n    background-color: #fcbba5;\n    border-color: #fcbba5; }\n  .btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }\n  .btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #fcbba5;\n    background-color: transparent; }\n  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #fcbba5;\n    border-color: #fcbba5; }\n    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-info.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(252, 187, 165, 0.5); }\n\n.btn-outline-warning {\n  color: #fad263;\n  border-color: #fad263; }\n  .btn-outline-warning:hover {\n    color: #fff;\n    background-color: #fad263;\n    border-color: #fad263; }\n  .btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }\n  .btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #fad263;\n    background-color: transparent; }\n  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #fad263;\n    border-color: #fad263; }\n    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-warning.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(250, 210, 99, 0.5); }\n\n.btn-outline-danger {\n  color: #ef9fc4;\n  border-color: #ef9fc4; }\n  .btn-outline-danger:hover {\n    color: #fff;\n    background-color: #ef9fc4;\n    border-color: #ef9fc4; }\n  .btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }\n  .btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #ef9fc4;\n    background-color: transparent; }\n  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #ef9fc4;\n    border-color: #ef9fc4; }\n    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-danger.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(239, 159, 196, 0.5); }\n\n.btn-outline-light {\n  color: #FAFAFA;\n  border-color: #FAFAFA; }\n  .btn-outline-light:hover {\n    color: #212529;\n    background-color: #FAFAFA;\n    border-color: #FAFAFA; }\n  .btn-outline-light:focus, .btn-outline-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }\n  .btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #FAFAFA;\n    background-color: transparent; }\n  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-light.dropdown-toggle {\n    color: #212529;\n    background-color: #FAFAFA;\n    border-color: #FAFAFA; }\n    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-light.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(250, 250, 250, 0.5); }\n\n.btn-outline-dark {\n  color: #01041b;\n  border-color: #01041b; }\n  .btn-outline-dark:hover {\n    color: #fff;\n    background-color: #01041b;\n    border-color: #01041b; }\n  .btn-outline-dark:focus, .btn-outline-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }\n  .btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #01041b;\n    background-color: transparent; }\n  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #01041b;\n    border-color: #01041b; }\n    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-dark.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(1, 4, 27, 0.5); }\n\n.btn-outline-orange {\n  color: #fd7e14;\n  border-color: #fd7e14; }\n  .btn-outline-orange:hover {\n    color: #fff;\n    background-color: #fd7e14;\n    border-color: #fd7e14; }\n  .btn-outline-orange:focus, .btn-outline-orange.focus {\n    box-shadow: 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }\n  .btn-outline-orange.disabled, .btn-outline-orange:disabled {\n    color: #fd7e14;\n    background-color: transparent; }\n  .btn-outline-orange:not(:disabled):not(.disabled):active, .btn-outline-orange:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-orange.dropdown-toggle {\n    color: #fff;\n    background-color: #fd7e14;\n    border-color: #fd7e14; }\n    .btn-outline-orange:not(:disabled):not(.disabled):active:focus, .btn-outline-orange:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-orange.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(253, 126, 20, 0.5); }\n\n.btn-outline-purple {\n  color: #4731b6;\n  border-color: #4731b6; }\n  .btn-outline-purple:hover {\n    color: #fff;\n    background-color: #4731b6;\n    border-color: #4731b6; }\n  .btn-outline-purple:focus, .btn-outline-purple.focus {\n    box-shadow: 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }\n  .btn-outline-purple.disabled, .btn-outline-purple:disabled {\n    color: #4731b6;\n    background-color: transparent; }\n  .btn-outline-purple:not(:disabled):not(.disabled):active, .btn-outline-purple:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-purple.dropdown-toggle {\n    color: #fff;\n    background-color: #4731b6;\n    border-color: #4731b6; }\n    .btn-outline-purple:not(:disabled):not(.disabled):active:focus, .btn-outline-purple:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-purple.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(71, 49, 182, 0.5); }\n\n.btn-outline-pink {\n  color: #FFE0E0;\n  border-color: #FFE0E0; }\n  .btn-outline-pink:hover {\n    color: #212529;\n    background-color: #FFE0E0;\n    border-color: #FFE0E0; }\n  .btn-outline-pink:focus, .btn-outline-pink.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }\n  .btn-outline-pink.disabled, .btn-outline-pink:disabled {\n    color: #FFE0E0;\n    background-color: transparent; }\n  .btn-outline-pink:not(:disabled):not(.disabled):active, .btn-outline-pink:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-pink.dropdown-toggle {\n    color: #212529;\n    background-color: #FFE0E0;\n    border-color: #FFE0E0; }\n    .btn-outline-pink:not(:disabled):not(.disabled):active:focus, .btn-outline-pink:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-pink.dropdown-toggle:focus {\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 224, 224, 0.5); }\n\n.btn-link {\n  font-weight: 400;\n  color: #8f93f6;\n  text-decoration: none; }\n  .btn-link:hover {\n    color: #484ff0;\n    text-decoration: none; }\n  .btn-link:focus, .btn-link.focus {\n    text-decoration: none; }\n  .btn-link:disabled, .btn-link.disabled {\n    color: #6c757d;\n    pointer-events: none; }\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 8px; }\n\n.btn-block {\n  display: block;\n  width: 100%; }\n  .btn-block + .btn-block {\n    margin-top: 0.5rem; }\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n\n.iq-progress-bar {\n  background: #FAFAFA;\n  box-shadow: 0 0 0;\n  height: 6px;\n  margin: 0;\n  position: relative;\n  width: 100%;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n  .iq-progress-bar > span {\n    background: #8f93f6 none repeat scroll 0 0;\n    position: relative;\n    display: block;\n    height: 100%;\n    width: 0;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px; }\n  .iq-progress-bar .progress-text {\n    position: absolute;\n    right: -10px;\n    top: -25px;\n    font-size: 13px;\n    font-weight: 500; }\n\n.iq-progress-bar.iq-progress-bar-icon > span:after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  background: #fff;\n  border: 3px solid transparent;\n  position: absolute;\n  bottom: -3px;\n  right: 0;\n  z-index: 1; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-primary:after {\n  border-color: #8f93f6; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-danger:after {\n  border-color: #ef9fc4; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-success:after {\n  border-color: #7fdd85; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-warning:after {\n  border-color: #fad263; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-info:after {\n  border-color: #fcbba5; }\n\n.iq-progress-bar.iq-progress-bar-icon > span.bg-dark:after {\n  border-color: #01041b; }\n\n.progress-round.heatmap-progress {\n  height: 97px;\n  width: 97px; }\n  .progress-round.heatmap-progress .progress-bar {\n    border-width: 10px; }\n  .progress-round.heatmap-progress::after {\n    border: 10px solid #ff9273; }\n\n.progress-round.income-progress .progress-bar {\n  border-width: 10px; }\n\n.progress-round.income-progress::after {\n  border: 10px solid #ff9273; }\n\n.progress-round.alarams-progress {\n  height: 110px;\n  width: 110px; }\n\n.iq-progress-bar .progress-text-one {\n  position: absolute;\n  right: -20px;\n  top: -33px;\n  font-size: 13px;\n  font-weight: 500;\n  background: #ef9fc4;\n  color: #fff;\n  padding: 0px 5px; }\n\n.iq-progress-bar > span.bg-primary .progress-text-one:after {\n  border-color: #8f93f6 transparent transparent transparent; }\n\n.iq-progress-bar > span.bg-success .progress-text-one:after {\n  border-color: #7fdd85 transparent transparent transparent; }\n\n.iq-progress-bar > span.bg-warning .progress-text-one:after {\n  border-color: #fad263 transparent transparent transparent; }\n\n.iq-progress-bar > span.bg-danger .progress-text-one:after {\n  border-color: #ef9fc4 transparent transparent transparent; }\n\n.iq-progress-bar > span.bg-dark .progress-text-one:after {\n  border-color: #01041b transparent transparent transparent; }\n\n.iq-progress-bar > span.bg-info .progress-text-one:after {\n  border-color: #fcbba5 transparent transparent transparent; }\n\n.progress-text-one {\n  position: relative; }\n  .progress-text-one:after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid; }\n\n.iq-circle-progressbar {\n  margin: 0 auto;\n  width: 100px !important;\n  height: 100px !important; }\n  .iq-circle-progressbar .percent {\n    font-size: 1.3rem !important; }\n  .iq-circle-progressbar svg {\n    width: 100px !important;\n    height: 100px !important; }\n\n.progress-round {\n  width: 50px;\n  height: 50px;\n  background: none;\n  position: relative; }\n  .progress-round::after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    border: 3px solid #f1f1f1;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  .progress-round > span {\n    width: 50%;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    z-index: 1; }\n  .progress-round .progress-left {\n    left: 0; }\n    .progress-round .progress-left .progress-bar {\n      left: 100%;\n      border-top-right-radius: 80px;\n      border-bottom-right-radius: 80px;\n      border-left: 0;\n      -webkit-transform-origin: center left;\n      transform-origin: center left; }\n  .progress-round .progress-bar {\n    width: 100%;\n    height: 100%;\n    background: none;\n    border-width: 3px;\n    border-style: solid;\n    position: absolute;\n    top: 0; }\n  .progress-round .progress-right {\n    right: 0; }\n    .progress-round .progress-right .progress-bar {\n      left: -100%;\n      border-top-left-radius: 80px;\n      border-bottom-left-radius: 80px;\n      border-right: 0;\n      -webkit-transform-origin: center right;\n      transform-origin: center right; }\n  .progress-round .progress-value {\n    position: absolute;\n    top: 0;\n    left: 0; }\n\n.progress-round.income-progress {\n  height: 78px;\n  width: 78px; }\n  .progress-round.income-progress .progress-bar {\n    border-width: 10px; }\n  .progress-round.income-progress::after {\n    border: 10px solid #ff9273; }\n\n.progress-round.alarams-progress {\n  height: 110px;\n  width: 110px; }\n\n.progress-round.goal-progress {\n  width: 130px;\n  height: 130px; }\n\n.progress-round.goal-progress .progress-bar {\n  border-width: 10px; }\n\n.progress-round.goal-progress::after {\n  border: 10px solid #f4f4f4; }\n\n@keyframes progress-loading-1 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg); } }\n\n@keyframes progress-loading-2 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(80deg);\n    -moz-transform: rotate(80deg);\n    -ms-transform: rotate(80deg);\n    -o-transform: rotate(80deg);\n    transform: rotate(80deg); } }\n\n.progress.progress-round {\n  width: 60px;\n  height: 60px;\n  line-height: 60px;\n  background: none;\n  margin: 0 auto;\n  box-shadow: none;\n  position: relative; }\n  .progress.progress-round > span {\n    width: 50%;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    z-index: 1; }\n  .progress.progress-round .progress-left {\n    left: 0; }\n    .progress.progress-round .progress-left .progress-bar {\n      left: 100%;\n      border-top-right-radius: 80px;\n      border-bottom-right-radius: 80px;\n      border-left: 0;\n      -webkit-transform-origin: center left;\n      transform-origin: center left;\n      animation: progress-loading-2 1.5s linear forwards 1.8s; }\n  .progress.progress-round .progress-bar {\n    border-width: 5px; }\n  .progress.progress-round .progress-right {\n    right: 0; }\n    .progress.progress-round .progress-right .progress-bar {\n      left: -100%;\n      border-top-left-radius: 80px;\n      border-bottom-left-radius: 80px;\n      border-right: 0;\n      -webkit-transform-origin: center right;\n      transform-origin: center right;\n      animation: progress-loading-1 1.8s linear forwards; }\n  .progress.progress-round:after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 5px solid #FAFAFA;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  .progress.progress-round .progress-value {\n    font-size: 16px;\n    left: 18px; }\n\n.progress.danger .progress-bar {\n  border-color: #ef9fc4; }\n\n.progress.warning .progress-bar {\n  border-color: #fad263; }\n\n.progress.success .progress-bar {\n  border-color: #7fdd85; }\n\n.progress.info .progress-bar {\n  border-color: #fcbba5; }\n\n.progress.primary .progress-bar {\n  border-color: #8f93f6; }\n\n.fc-unthemed .fc-toolbar .fc-button {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border: none;\n  text-transform: capitalize;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n  .fc-unthemed .fc-toolbar .fc-button:active {\n    color: #fff;\n    background-color: #8f93f6; }\n  .fc-unthemed .fc-toolbar .fc-button:focus {\n    color: #fff;\n    background-color: #8f93f6; }\n\n.fc-unthemed .fc-toolbar .fc-button.fc-button-active {\n  color: #fff;\n  background-color: #8f93f6; }\n\n.job-classification li {\n  list-style-type: none;\n  margin-bottom: 10px; }\n  .job-classification li > i {\n    margin-right: 10px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    color: #fff; }\n\n.today-schedule li {\n  list-style-type: none;\n  margin-bottom: 10px; }\n  .today-schedule li i {\n    margin-right: 10px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    color: #fff; }\n\n.schedule-text span {\n  display: block; }\n\n.calender-small .flatpickr-calendar.animate.inline {\n  width: 100%;\n  box-shadow: none; }\n\n.calender-small .dayContainer {\n  width: 100%;\n  min-width: auto; }\n\n.calender-small .flatpickr-days {\n  width: 100%; }\n\n.calender-small .flatpickr-day.today {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n  .calender-small .flatpickr-day.today:hover {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n  .calender-small .flatpickr-day.today:focus {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n\n.calender-small .flatpickr-months {\n  margin-bottom: 10px; }\n  .calender-small .flatpickr-months .flatpickr-prev-month {\n    padding: 7px 10px; }\n  .calender-small .flatpickr-months .flatpickr-next-month {\n    padding: 7px 10px; }\n\n.calender-small .flatpickr-current-month .flatpickr-monthDropdown-months {\n  font-size: 12px; }\n  .calender-small .flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n    background: transparent;\n    color: #8f93f6; }\n\n.calender-small .flatpickr-current-month input.cur-year {\n  font-size: 12px; }\n\n.calender-small .numInputWrapper:hover {\n  background: transparent; }\n\n.calender-small .flatpickr-day.selected {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n  .calender-small .flatpickr-day.selected:focus {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n  .calender-small .flatpickr-day.selected:hover {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n\n.calender-small .flatpickr-day.startRange {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n  .calender-small .flatpickr-day.startRange:focus {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n  .calender-small .flatpickr-day.startRange:hover {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n\n.calender-small .flatpickr-day.endRange {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n  .calender-small .flatpickr-day.endRange:focus {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n  .calender-small .flatpickr-day.endRange:hover {\n    color: #fff;\n    border-color: #8f93f6;\n    background: #8f93f6; }\n\n.calender-small .flatpickr-day.selected.inRange {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.startRange.inRange {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.endRange.inRange {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.selected.prevMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.startRange.prevMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.endRange.prevMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.selected.nextMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.startRange.nextMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.endRange.nextMonthDay {\n  color: #fff;\n  border-color: #8f93f6;\n  background: #8f93f6; }\n\n.calender-small .flatpickr-day.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.prevMonthDay.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.nextMonthDay.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.today.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.prevMonthDay.today.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.nextMonthDay.today.inRange {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day:hover {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day:focus {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.prevMonthDay:hover {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.prevMonthDay:focus {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.nextMonthDay:hover {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-day.nextMonthDay:focus {\n  background: #c6c8f7;\n  color: #8f93f6;\n  border-color: transparent; }\n\n.calender-small .flatpickr-current-month .numInputWrapper {\n  width: 3ch; }\n\n.smaill-calender-home .flatpickr-calendar.animate.inline {\n  margin: 0 auto;\n  width: 100%;\n  box-shadow: none;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.smaill-calender-home .flatpickr-day.selected {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.selected:focus {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.selected:hover {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.startRange {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.startRange:focus {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.startRange:hover {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.endRange {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.endRange:focus {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n  .smaill-calender-home .flatpickr-day.endRange:hover {\n    color: #fff;\n    text-decoration: none;\n    background: #8f93f6;\n    text-decoration: none;\n    border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.selected.inRange {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.startRange.inRange {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.endRange.inRange {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.selected.prevMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.startRange.prevMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.endRange.prevMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.selected.nextMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.startRange.nextMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-day.endRange.nextMonthDay {\n  color: #fff;\n  text-decoration: none;\n  background: #8f93f6;\n  text-decoration: none;\n  border-color: #8f93f6; }\n\n.smaill-calender-home .flatpickr-days {\n  width: 100%; }\n\n.smaill-calender-home .dayContainer {\n  width: 100%; }\n\n.smaill-calender-home .flatpickr-innerContainer {\n  justify-content: space-around; }\n\n@media (max-width: 479px) {\n  .fc-toolbar.fc-header-toolbar {\n    overflow-x: scroll; } }\n\n.page-link {\n  border-color: #8f93f6; }\n\n.br-theme-bars-1to10 .br-widget {\n  height: 50px;\n  white-space: nowrap; }\n  .br-theme-bars-1to10 .br-widget a {\n    display: block;\n    width: 12px;\n    padding: 5px 0;\n    height: 28px;\n    float: left;\n    background-color: #ddd;\n    margin: 1px;\n    text-align: center; }\n  .br-theme-bars-1to10 .br-widget a.br-active {\n    background-color: #8f93f6; }\n  .br-theme-bars-1to10 .br-widget a.br-selected {\n    background-color: #8f93f6; }\n  .br-theme-bars-1to10 .br-widget .br-current-rating {\n    font-size: 20px;\n    line-height: 2;\n    float: right;\n    color: #8f93f6;\n    font-weight: 400; }\n\n.br-theme-bars-1to10 .br-readonly a {\n  cursor: default; }\n\n.br-theme-bars-1to10 .br-readonly a.br-active {\n  background-color: #f2cd95; }\n\n.br-theme-bars-1to10 .br-readonly a.br-selected {\n  background-color: #f2cd95; }\n\n.br-theme-bars-1to10 .br-readonly .br-current-rating {\n  color: #f2cd95; }\n\n.br-theme-bars-pill .br-widget {\n  white-space: nowrap; }\n  .br-theme-bars-pill .br-widget a {\n    padding: 7px 15px;\n    background-color: #ddd;\n    color: #535f6b;\n    text-decoration: none;\n    font-size: 13px;\n    line-height: 3;\n    text-align: center;\n    font-weight: 400; }\n    .br-theme-bars-pill .br-widget a:first-child {\n      -webkit-border-top-left-radius: 999px;\n      -webkit-border-bottom-left-radius: 999px;\n      -moz-border-radius-topleft: 999px;\n      -moz-border-radius-bottomleft: 999px;\n      border-top-left-radius: 999px;\n      border-bottom-left-radius: 999px; }\n    .br-theme-bars-pill .br-widget a:last-child {\n      -webkit-border-top-right-radius: 999px;\n      -webkit-border-bottom-right-radius: 999px;\n      -moz-border-radius-top-right: 999px;\n      -moz-border-radius-bottom-right: 999px;\n      border-top-right-radius: 999px !important;\n      border-bottom-right-radius: 999px !important; }\n  .br-theme-bars-pill .br-widget a.br-active {\n    background-color: #8f93f6;\n    color: white; }\n  .br-theme-bars-pill .br-widget a.br-selected {\n    background-color: #8f93f6;\n    color: white; }\n\n.br-theme-bars-pill .br-readonly a {\n  cursor: default; }\n\n.br-theme-bars-pill .br-readonly a.br-active {\n  background-color: #7cead1; }\n\n.br-theme-bars-pill .br-readonly a.br-selected {\n  background-color: #7cead1; }\n\n.br-theme-fontawesome-stars .br-widget a {\n  margin-right: 8px !important; }\n  .br-theme-fontawesome-stars .br-widget a:after {\n    font-family: \"Font Awesome 5 Free\";\n    font-weight: 900; }\n\ni.amber-text {\n  color: #8f93f6 !important; }\n\n#rateMe1 i {\n  font-size: 18px; }\n\n.mdb-rating .rate-popover {\n  color: #808080; }\n\n.mdb-rating .live {\n  color: #000; }\n\n.mdb-rating .oneStar {\n  color: #44370f; }\n\n.mdb-rating .twoStars {\n  color: #96781e; }\n\n.mdb-rating .threeStars {\n  color: #e2b52e; }\n\n.mdb-rating .fourStars {\n  color: #f1ba12; }\n\n.mdb-rating .fiveStars {\n  color: #f3cb06; }\n\n.mdb-rating .amber-text {\n  color: #ffc107; }\n\n.rating-faces i {\n  font-size: 21px; }\n\n.br-theme-bars-movie .br-widget {\n  white-space: nowrap; }\n  .br-theme-bars-movie .br-widget a {\n    display: block;\n    width: 60px;\n    height: 10px;\n    float: left;\n    background-color: transparent;\n    border: 1px solid #8f93f6;\n    margin: 1px; }\n  .br-theme-bars-movie .br-widget a.br-active {\n    background-color: #8f93f6; }\n  .br-theme-bars-movie .br-widget a.br-selected {\n    background-color: #8f93f6; }\n  .br-theme-bars-movie .br-widget .br-current-rating {\n    clear: both;\n    width: 240px;\n    text-align: center;\n    font-weight: 600;\n    display: block;\n    padding-top: .5em;\n    color: #8f93f6;\n    font-weight: 400; }\n\n.br-theme-bars-movie .br-readonly a {\n  cursor: default; }\n\n.br-theme-bars-movie .br-readonly a.br-active {\n  background-color: #729bf8; }\n\n.br-theme-bars-movie .br-readonly a.br-selected {\n  background-color: #729bf8; }\n\n.br-theme-bars-movie .br-readonly .br-current-rating {\n  color: #729bf8; }\n\n.br-theme-fontawesome-stars .br-widget {\n  height: 28px;\n  white-space: nowrap; }\n  .br-theme-fontawesome-stars .br-widget a {\n    text-rendering: auto;\n    -webkit-font-smoothing: antialiased;\n    text-decoration: none;\n    margin-right: 2px; }\n    .br-theme-fontawesome-stars .br-widget a:after {\n      content: '\\f005';\n      color: #d2d2d2; }\n  .br-theme-fontawesome-stars .br-widget a.br-active:after {\n    color: #edb867; }\n  .br-theme-fontawesome-stars .br-widget a.br-selected:after {\n    color: #edb867; }\n  .br-theme-fontawesome-stars .br-widget .br-current-rating {\n    display: none; }\n\n.br-theme-fontawesome-stars .br-readonly a {\n  cursor: default; }\n\n/*------------ Basic Tree -------------------------------------*/\n/*-------------------- Checkbox Tree ----------------------------*/\n.basic-tree li {\n  list-style-type: none;\n  margin: 0;\n  padding: 10px 5px 0 5px;\n  position: relative;\n  color: #303030; }\n  .basic-tree li::before {\n    content: '';\n    left: -20px;\n    position: absolute;\n    right: auto;\n    border-left: 1px solid #999;\n    bottom: 50px;\n    height: 100%;\n    top: 0;\n    width: 1px; }\n  .basic-tree li::after {\n    content: '';\n    left: -20px;\n    position: absolute;\n    right: auto;\n    border-top: 1px solid #999;\n    height: 20px;\n    top: 25px;\n    width: 25px; }\n  .basic-tree li:last-child::before {\n    height: 30px; }\n\n.basic-tree li.t-parent > span {\n  cursor: pointer; }\n  .basic-tree li.t-parent > span:hover {\n    color: #8f93f6;\n    color: #8f93f6; }\n\n.basic-tree > ul > li::before {\n  border: 0; }\n\n.basic-tree > ul > li::after {\n  border: 0; }\n\n.flex-tree li {\n  position: relative;\n  list-style: none;\n  margin: 0; }\n  .flex-tree li::before {\n    content: '';\n    left: -20px;\n    position: absolute;\n    right: auto;\n    border-left: 1px solid #999;\n    bottom: 50px;\n    height: 100%;\n    top: 0;\n    width: 1px;\n    left: -25px; }\n  .flex-tree li::after {\n    content: '';\n    left: -20px;\n    position: absolute;\n    right: auto;\n    border-top: 1px solid #999;\n    height: 20px;\n    top: 25px;\n    width: 25px;\n    top: 12px;\n    left: -25px; }\n  .flex-tree li:last-child::before {\n    height: 25px; }\n  .flex-tree li label {\n    cursor: pointer; }\n  .flex-tree li span {\n    cursor: pointer; }\n    .flex-tree li span label {\n      cursor: pointer; }\n  .flex-tree li span.open:after {\n    content: \"\\025BE\";\n    display: inline-block;\n    font: 400 16px/1 Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n    width: 20px;\n    margin-top: 4px;\n    padding-left: 3px;\n    color: #ababab; }\n  .flex-tree li span.closed:after {\n    content: \"\\025BE\";\n    display: inline-block;\n    font: 400 16px/1 Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n    width: 20px;\n    margin-top: 4px;\n    padding-left: 3px;\n    color: #ababab;\n    content: \"\\025B4\"; }\n\n.flex-tree > ul > li::before {\n  border: 0; }\n\n.flex-tree > ul > li::after {\n  border: 0; }\n\n.flex-tree label {\n  font-weight: normal; }\n\n.flex-tree label.node {\n  font-weight: bold; }\n\n.flex-tree input[type=\"checkbox\"] {\n  border: 1px solid #b4b9be;\n  background: #fff;\n  color: #555;\n  clear: none;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 0;\n  height: 16px;\n  margin: -4px 4px 0 0;\n  outline: 0;\n  padding: 0;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n  min-width: 16px;\n  -webkit-appearance: none;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  transition: 0.05s border-color ease-in-out; }\n  .flex-tree input[type=\"checkbox\"]:focus {\n    border-color: #5b9dd9;\n    box-shadow: 0 0 2px rgba(30, 140, 190, 0.8); }\n  .flex-tree input[type=\"checkbox\"]:checked {\n    background: #8f93f6;\n    border: none; }\n    .flex-tree input[type=\"checkbox\"]:checked:before {\n      float: left;\n      display: inline-block;\n      vertical-align: middle;\n      width: 16px;\n      font: 400 20px/1 Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n      -webkit-font-smoothing: antialiased;\n      content: \"\\02713\";\n      color: var(--white);\n      margin: 1px 0 0 0;\n      font-size: 17px !important; }\n  .flex-tree input[type=\"checkbox\"]:indeterminate:before {\n    float: left;\n    display: inline-block;\n    vertical-align: middle;\n    width: 16px;\n    font: 400 20px/1 Arial, \"Helvetica Neue\", Helvetica, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    content: \"\\02043\";\n    color: #8f93f6;\n    margin: -4px 0 0 -1px; }\n\n.flex-tree input[type=\"checkbox\"].indeterminate {\n  background-color: #eee; }\n\n.ic-square {\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: 1px solid #535f6b;\n  text-align: center;\n  line-height: 19px;\n  font-size: 12px; }\n\n.tree-box {\n  margin: 0; }\n\n.iq-footer {\n  padding: 15px;\n  margin-left: 260px;\n  width: calc(100vw - 264px);\n  background: #fff;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n  .iq-footer ul li a {\n    color: #535f6b; }\n    .iq-footer ul li a:hover {\n      color: #8f93f6;\n      text-decoration: none; }\n\nbody.tab-horizontal .iq-footer {\n  margin-left: 0;\n  width: 100%; }\n\n.iq-mt--70 {\n  margin-top: -70px; }\n\n.banner-main-text {\n  position: absolute;\n  left: 15%;\n  bottom: 13%; }\n\n.nav.nav-pills.style-three {\n  margin-top: 10px; }\n  .nav.nav-pills.style-three .nav-link.active:before {\n    display: inline-block;\n    width: 100%;\n    height: 3px;\n    background: #8f93f6;\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0px; }\n  .nav.nav-pills.style-three .nav-link:hover:before {\n    display: inline-block;\n    width: 100%;\n    height: 3px;\n    background: #8f93f6;\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0px; }\n  .nav.nav-pills.style-three .nav-link:before {\n    width: 0;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    height: 3px;\n    background: #8f93f6;\n    content: \"\";\n    position: absolute;\n    right: 0;\n    bottom: 0px; }\n  .nav.nav-pills.style-three a {\n    background: transparent;\n    position: relative;\n    margin-right: 30px;\n    padding: 10px 0px; }\n    .nav.nav-pills.style-three a:last-child {\n      margin-right: 0px; }\n\n.iq-card-body.banner-box {\n  padding-bottom: 0; }\n\n@media (min-width: 1300px) {\n  body.sidebar-main .iq-footer {\n    margin-left: 80px;\n    width: calc(100vw - 85px); } }\n\n@media (max-width: 1299px) {\n  .iq-footer {\n    padding: 15px 10px;\n    margin-left: 0;\n    width: 100%; }\n  body.sidebar-main .iq-footer {\n    padding: 15px 10px;\n    margin-left: 0;\n    width: 100%; }\n  .without-right-sidebar .iq-footer {\n    width: 100%; } }\n\n@media (max-width: 991px) {\n  .iq-footer {\n    text-align: center !important; }\n    .iq-footer .col-lg-6.text-right {\n      text-align: center !important; } }\n\n.clear {\n  clear: both; }\n\n@media (min-width: 1300px) {\n  .iq-menu-horizontal .iq-sidebar-menu li .iq-submenu.iq-submenu-data {\n    position: static; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-sidebar-logo {\n    display: none !important; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:first-child a {\n    padding-left: 0px; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a:hover {\n    color: #8f93f6; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li .iq-arrow-right {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li ul {\n    display: block;\n    position: absolute;\n    top: 100%;\n    padding: 10px 0px;\n    min-width: 200px;\n    background: #fff;\n    z-index: 9;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    display: none;\n    animation: fade-in-bottom 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n    -webkit-transform: translateY(100%);\n    -moz-transform: translateY(100%);\n    -ms-transform: translateY(100%);\n    -o-transform: translateY(100%);\n    transform: translateY(100%);\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px;\n    -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n    -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n    -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n    -o-box-shadow: 0px 16px 40px 0px #0000000A;\n    box-shadow: 0px 16px 40px 0px #0000000A; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu .iq-submenu li a {\n    padding: 12px 13px 12px 15px; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li:hover > a {\n    color: #8f93f6; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li.menu-open .iq-arrow-right {\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    transform: rotate(90deg); }\n  .iq-menu-horizontal .iq-sidebar-menu li:hover > .iq-submenu {\n    display: block;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n  .iq-menu-horizontal .iq-sidebar-menu li:hover > .iq-submenu.iq-submenu-data {\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n  .iq-menu-horizontal .iq-sidebar-menu li > .iq-submenu.iq-submenu-data {\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    visibility: visible;\n    left: 100%;\n    top: 0;\n    transform-origin: left center 0; }\n  .iq-menu-horizontal .iq-sidebar-menu li > .iq-submenu .iq-arrow-right {\n    margin-right: 0px; }\n  .iq-menu-horizontal .sub-scrll {\n    max-height: 315px;\n    overflow-y: scroll;\n    overflow-x: hidden; }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:hover .iq-arrow-right {\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    transform: rotate(90deg); }\n  .iq-menu-horizontal .iq-sidebar-menu .iq-menu li:hover li .iq-arrow-right {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); } }\n\n@media (max-width: 1299px) {\n  .iq-menu-horizontal {\n    position: fixed;\n    left: 0;\n    right: 0;\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0;\n    top: 0;\n    width: 0;\n    background: #fff;\n    height: 100vh;\n    z-index: 9;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n    .iq-menu-horizontal ul.iq-menu {\n      display: block !important;\n      background: #fff; }\n    .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a {\n      padding: 15px 20px 15px 30px; }\n      .iq-menu-horizontal .iq-sidebar-menu .iq-menu li a:hover {\n        color: #8f93f6; }\n    .iq-menu-horizontal .iq-sidebar-menu .iq-menu li ul {\n      position: static;\n      box-shadow: none; }\n  .iq-menu-horizontal ul.iq-menu li a[aria-expanded=true] .iq-arrow-right {\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    transform: rotate(90deg); }\n  .sidebar-main .iq-menu-horizontal {\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1;\n    width: 260px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; } }\n\n.tab-container .nav-pills .nav-item a {\n  padding: 20px 10px;\n  font-size: 14px;\n  color: #fff;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  margin-bottom: 0;\n  margin-left: 1px; }\n\n.tab-container .nav-pills .nav-item a.nav-link.active {\n  color: #fff;\n  background: #6c71e3; }\n\n.tab-container .nav-pills .nav-item:hover a {\n  color: #fff; }\n\n.tab-details .tab-pane.fade {\n  display: none; }\n\n.tab-details .tab-pane.fade.active.show {\n  display: block; }\n\n.tab-scrollbar-data {\n  width: 270px;\n  height: 100%;\n  position: fixed;\n  z-index: 99;\n  top: 0;\n  right: 0;\n  background: #fff;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  display: flex;\n  display: -webkit-flex;\n  display: -moz-flex;\n  display: -ms-flex;\n  flex-direction: column;\n  -webkit-flex-direction: column;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column; }\n\n.tab-scrollbar-data.tab-sidebar-close {\n  right: -270px; }\n\na.iq-tab-toggle {\n  height: 40px;\n  width: 40px;\n  line-height: 35px;\n  font-size: 18px;\n  color: #fff;\n  padding: 2px 12px;\n  padding-right: 10px;\n  display: block !important;\n  background: #8f93f6;\n  -webkit-box-shadow: 0px 16px 40px 0px #0000000A;\n  -moz-box-shadow: 0px 16px 40px 0px #0000000A;\n  -ms-box-shadow: 0px 16px 40px 0px #0000000A;\n  -o-box-shadow: 0px 16px 40px 0px #0000000A;\n  box-shadow: 0px 16px 40px 0px #0000000A;\n  position: absolute;\n  -webkit-border-radius: 8px 0 0 8px;\n  -moz-border-radius: 8px 0 0 8px;\n  -ms-border-radius: 8px 0 0 8px;\n  -o-border-radius: 8px 0 0 8px;\n  border-radius: 8px 0 0 8px;\n  top: 50%;\n  left: -40px; }\n  a.iq-tab-toggle .aerrow-icon-right {\n    display: none; }\n  a.iq-tab-toggle .arr-next {\n    position: relative;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n    a.iq-tab-toggle .arr-next:before {\n      content: '\\f053';\n      font-family: \"Font Awesome 5 Free\";\n      font-weight: 900;\n      position: absolute;\n      left: 0;\n      top: 0;\n      color: #fff;\n      transform: rotate(0deg);\n      animation-name: bounceArrowLeft;\n      animation-duration: 1.4s;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear; }\n  a.iq-tab-toggle .arr-next.arr-two:before {\n    left: 10px;\n    animation-delay: 0.2s; }\n\na.iq-tab-toggle.active .aerrow-icon-left {\n  display: none; }\n\na.iq-tab-toggle.active .aerrow-icon-right {\n  display: inline-block; }\n\na.iq-tab-toggle.active .arr-next:before {\n  transform: rotate(180deg);\n  animation-name: bounceArrow; }\n\n.tab-scrollbar-data .setting-info .setting-title {\n  border-bottom: 1px solid #f1f1f1;\n  padding-bottom: 10px;\n  margin-top: 25px; }\n  .tab-scrollbar-data .setting-info .setting-title:first-child {\n    margin-top: 0px; }\n  .tab-scrollbar-data .setting-info .setting-title h5 i {\n    font-size: 20px; }\n\n.tab-scrollbar-data .setting-info .set-swtich {\n  margin-top: 15px; }\n  .tab-scrollbar-data .setting-info .set-swtich h6 {\n    font-weight: 400; }\n  .tab-scrollbar-data .setting-info .set-swtich .custom-control-input:focus ~ .custom-control-label:before {\n    box-shadow: none; }\n\n@keyframes bounceArrow {\n  0% {\n    opacity: 1;\n    transform: translateX(0px) scale(1) rotate(-180deg); }\n  25% {\n    opacity: 0;\n    transform: translateX(10px) scale(0.9) rotate(-180deg); }\n  26% {\n    opacity: 0;\n    transform: translateX(-10px) scale(0.9) rotate(-180deg); }\n  55% {\n    opacity: 1;\n    transform: translateX(0px) scale(1) rotate(-180deg); } }\n\n@keyframes bounceArrowLeft {\n  0% {\n    opacity: 1;\n    transform: translateX(10px) scale(0.9) rotate(0deg); }\n  25% {\n    opacity: 0;\n    transform: translateX(0px) scale(1) rotate(0deg); }\n  26% {\n    opacity: 0;\n    transform: translateX(0px) scale(1) rotate(0deg); }\n  55% {\n    opacity: 1;\n    transform: translateX(-10px) scale(0.9) rotate(0deg); } }\n\n/*\n * Background color \n */\n.bg-blue {\n  color: #fff !important;\n  background-color: #8f93f6 !important; }\n\na.bg-blue:hover, a.bg-blue:focus,\nbutton.bg-blue:hover,\nbutton.bg-blue:focus {\n  color: #fff !important;\n  background-color: #6065f2 !important; }\n\n.bg-indigo {\n  color: #fff !important;\n  background-color: #6610f2 !important; }\n\na.bg-indigo:hover, a.bg-indigo:focus,\nbutton.bg-indigo:hover,\nbutton.bg-indigo:focus {\n  color: #fff !important;\n  background-color: #510bc4 !important; }\n\n.bg-purple {\n  color: #fff !important;\n  background-color: #4731b6 !important; }\n\na.bg-purple:hover, a.bg-purple:focus,\nbutton.bg-purple:hover,\nbutton.bg-purple:focus {\n  color: #fff !important;\n  background-color: #37268e !important; }\n\n.bg-pink {\n  color: #212529 !important;\n  background-color: #FFE0E0 !important; }\n\na.bg-pink:hover, a.bg-pink:focus,\nbutton.bg-pink:hover,\nbutton.bg-pink:focus {\n  color: #fff !important;\n  background-color: #ffadad !important; }\n\n.bg-red {\n  color: #fff !important;\n  background-color: #ef9fc4 !important; }\n\na.bg-red:hover, a.bg-red:focus,\nbutton.bg-red:hover,\nbutton.bg-red:focus {\n  color: #fff !important;\n  background-color: #e873a9 !important; }\n\n.bg-orange {\n  color: #fff !important;\n  background-color: #fd7e14 !important; }\n\na.bg-orange:hover, a.bg-orange:focus,\nbutton.bg-orange:hover,\nbutton.bg-orange:focus {\n  color: #fff !important;\n  background-color: #dc6502 !important; }\n\n.bg-yellow {\n  color: #fff !important;\n  background-color: #fad263 !important; }\n\na.bg-yellow:hover, a.bg-yellow:focus,\nbutton.bg-yellow:hover,\nbutton.bg-yellow:focus {\n  color: #fff !important;\n  background-color: #f8c432 !important; }\n\n.bg-green {\n  color: #fff !important;\n  background-color: #7fdd85 !important; }\n\na.bg-green:hover, a.bg-green:focus,\nbutton.bg-green:hover,\nbutton.bg-green:focus {\n  color: #fff !important;\n  background-color: #57d25f !important; }\n\n.bg-teal {\n  color: #fff !important;\n  background-color: #20c997 !important; }\n\na.bg-teal:hover, a.bg-teal:focus,\nbutton.bg-teal:hover,\nbutton.bg-teal:focus {\n  color: #fff !important;\n  background-color: #199d76 !important; }\n\n.bg-cyan {\n  color: #fff !important;\n  background-color: #fcbba5 !important; }\n\na.bg-cyan:hover, a.bg-cyan:focus,\nbutton.bg-cyan:hover,\nbutton.bg-cyan:focus {\n  color: #fff !important;\n  background-color: #fa9674 !important; }\n\n.bg-white {\n  color: #212529 !important;\n  background-color: #fff !important; }\n\na.bg-white:hover, a.bg-white:focus,\nbutton.bg-white:hover,\nbutton.bg-white:focus {\n  color: #fff !important;\n  background-color: #e6e6e6 !important; }\n\n.bg-gray {\n  color: #fff !important;\n  background-color: #6c757d !important; }\n\na.bg-gray:hover, a.bg-gray:focus,\nbutton.bg-gray:hover,\nbutton.bg-gray:focus {\n  color: #fff !important;\n  background-color: #545b62 !important; }\n\n.bg-gray-dark {\n  color: #fff !important;\n  background-color: #01041b !important; }\n\na.bg-gray-dark:hover, a.bg-gray-dark:focus,\nbutton.bg-gray-dark:hover,\nbutton.bg-gray-dark:focus {\n  color: #fff !important;\n  background-color: black !important; }\n\n.bg-gradient-blue {\n  background: #8f93f6 linear-gradient(180deg, #9fa3f7, #8f93f6) repeat-x !important; }\n\n.bg-gradient-indigo {\n  background: #6610f2 linear-gradient(180deg, #7c33f4, #6610f2) repeat-x !important; }\n\n.bg-gradient-purple {\n  background: #4731b6 linear-gradient(180deg, #624fc1, #4731b6) repeat-x !important; }\n\n.bg-gradient-pink {\n  background: #FFE0E0 linear-gradient(180deg, #fee4e5, #FFE0E0) repeat-x !important; }\n\n.bg-gradient-red {\n  background: #ef9fc4 linear-gradient(180deg, #f1adcd, #ef9fc4) repeat-x !important; }\n\n.bg-gradient-orange {\n  background: #fd7e14 linear-gradient(180deg, #fd9137, #fd7e14) repeat-x !important; }\n\n.bg-gradient-yellow {\n  background: #fad263 linear-gradient(180deg, #fad87a, #fad263) repeat-x !important; }\n\n.bg-gradient-green {\n  background: #7fdd85 linear-gradient(180deg, #91e297, #7fdd85) repeat-x !important; }\n\n.bg-gradient-teal {\n  background: #20c997 linear-gradient(180deg, #41d1a6, #20c997) repeat-x !important; }\n\n.bg-gradient-cyan {\n  background: #fcbba5 linear-gradient(180deg, #fcc5b2, #fcbba5) repeat-x !important; }\n\n.bg-gradient-white {\n  background: #fff linear-gradient(180deg, #fefeff, #fff) repeat-x !important; }\n\n.bg-gradient-gray {\n  background: #6c757d linear-gradient(180deg, #818990, #6c757d) repeat-x !important; }\n\n.bg-gradient-gray-dark {\n  background: #01041b linear-gradient(180deg, #26293d, #01041b) repeat-x !important; }\n\n.bg-gradient-primary {\n  background: #8f93f6 linear-gradient(180deg, #9fa3f7, #8f93f6) repeat-x !important; }\n\n.bg-gradient-secondary {\n  background: #6c757d linear-gradient(180deg, #818990, #6c757d) repeat-x !important; }\n\n.bg-gradient-success {\n  background: #7fdd85 linear-gradient(180deg, #91e297, #7fdd85) repeat-x !important; }\n\n.bg-gradient-info {\n  background: #fcbba5 linear-gradient(180deg, #fcc5b2, #fcbba5) repeat-x !important; }\n\n.bg-gradient-warning {\n  background: #fad263 linear-gradient(180deg, #fad87a, #fad263) repeat-x !important; }\n\n.bg-gradient-danger {\n  background: #ef9fc4 linear-gradient(180deg, #f1adcd, #ef9fc4) repeat-x !important; }\n\n.bg-gradient-light {\n  background: #FAFAFA linear-gradient(180deg, #fafafb, #FAFAFA) repeat-x !important; }\n\n.bg-gradient-dark {\n  background: #01041b linear-gradient(180deg, #26293d, #01041b) repeat-x !important; }\n\n.bg-gradient-orange {\n  background: #fd7e14 linear-gradient(180deg, #fd9137, #fd7e14) repeat-x !important; }\n\n.bg-gradient-purple {\n  background: #4731b6 linear-gradient(180deg, #624fc1, #4731b6) repeat-x !important; }\n\n.bg-gradient-pink {\n  background: #FFE0E0 linear-gradient(180deg, #fee4e5, #FFE0E0) repeat-x !important; }\n\n.bg-primary {\n  color: #fff !important;\n  background-color: #8f93f6 !important; }\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  color: #fff !important;\n  background-color: #6065f2 !important; }\n\n.badge-primary {\n  color: #fff !important;\n  background-color: #8f93f6 !important; }\n\na.badge-primary:hover, a.badge-primary:focus,\nbutton.badge-primary:hover,\nbutton.badge-primary:focus {\n  color: #fff !important;\n  background-color: #6065f2 !important; }\n\n.bg-secondary {\n  color: #fff !important;\n  background-color: #6c757d !important; }\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  color: #fff !important;\n  background-color: #545b62 !important; }\n\n.badge-secondary {\n  color: #fff !important;\n  background-color: #6c757d !important; }\n\na.badge-secondary:hover, a.badge-secondary:focus,\nbutton.badge-secondary:hover,\nbutton.badge-secondary:focus {\n  color: #fff !important;\n  background-color: #545b62 !important; }\n\n.bg-success {\n  color: #fff !important;\n  background-color: #7fdd85 !important; }\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  color: #fff !important;\n  background-color: #57d25f !important; }\n\n.badge-success {\n  color: #fff !important;\n  background-color: #7fdd85 !important; }\n\na.badge-success:hover, a.badge-success:focus,\nbutton.badge-success:hover,\nbutton.badge-success:focus {\n  color: #fff !important;\n  background-color: #57d25f !important; }\n\n.bg-info {\n  color: #fff !important;\n  background-color: #fcbba5 !important; }\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  color: #fff !important;\n  background-color: #fa9674 !important; }\n\n.badge-info {\n  color: #fff !important;\n  background-color: #fcbba5 !important; }\n\na.badge-info:hover, a.badge-info:focus,\nbutton.badge-info:hover,\nbutton.badge-info:focus {\n  color: #fff !important;\n  background-color: #fa9674 !important; }\n\n.bg-warning {\n  color: #fff !important;\n  background-color: #fad263 !important; }\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  color: #fff !important;\n  background-color: #f8c432 !important; }\n\n.badge-warning {\n  color: #fff !important;\n  background-color: #fad263 !important; }\n\na.badge-warning:hover, a.badge-warning:focus,\nbutton.badge-warning:hover,\nbutton.badge-warning:focus {\n  color: #fff !important;\n  background-color: #f8c432 !important; }\n\n.bg-danger {\n  color: #fff !important;\n  background-color: #ef9fc4 !important; }\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  color: #fff !important;\n  background-color: #e873a9 !important; }\n\n.badge-danger {\n  color: #fff !important;\n  background-color: #ef9fc4 !important; }\n\na.badge-danger:hover, a.badge-danger:focus,\nbutton.badge-danger:hover,\nbutton.badge-danger:focus {\n  color: #fff !important;\n  background-color: #e873a9 !important; }\n\n.bg-light {\n  color: #212529 !important;\n  background-color: #FAFAFA !important; }\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  color: #fff !important;\n  background-color: #e1e1e1 !important; }\n\n.badge-light {\n  color: #212529 !important;\n  background-color: #FAFAFA !important; }\n\na.badge-light:hover, a.badge-light:focus,\nbutton.badge-light:hover,\nbutton.badge-light:focus {\n  color: #fff !important;\n  background-color: #e1e1e1 !important; }\n\n.bg-dark {\n  color: #fff !important;\n  background-color: #01041b !important; }\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  color: #fff !important;\n  background-color: black !important; }\n\n.badge-dark {\n  color: #fff !important;\n  background-color: #01041b !important; }\n\na.badge-dark:hover, a.badge-dark:focus,\nbutton.badge-dark:hover,\nbutton.badge-dark:focus {\n  color: #fff !important;\n  background-color: black !important; }\n\n.bg-orange {\n  color: #fff !important;\n  background-color: #fd7e14 !important; }\n\na.bg-orange:hover, a.bg-orange:focus,\nbutton.bg-orange:hover,\nbutton.bg-orange:focus {\n  color: #fff !important;\n  background-color: #dc6502 !important; }\n\n.badge-orange {\n  color: #fff !important;\n  background-color: #fd7e14 !important; }\n\na.badge-orange:hover, a.badge-orange:focus,\nbutton.badge-orange:hover,\nbutton.badge-orange:focus {\n  color: #fff !important;\n  background-color: #dc6502 !important; }\n\n.bg-purple {\n  color: #fff !important;\n  background-color: #4731b6 !important; }\n\na.bg-purple:hover, a.bg-purple:focus,\nbutton.bg-purple:hover,\nbutton.bg-purple:focus {\n  color: #fff !important;\n  background-color: #37268e !important; }\n\n.badge-purple {\n  color: #fff !important;\n  background-color: #4731b6 !important; }\n\na.badge-purple:hover, a.badge-purple:focus,\nbutton.badge-purple:hover,\nbutton.badge-purple:focus {\n  color: #fff !important;\n  background-color: #37268e !important; }\n\n.bg-pink {\n  color: #212529 !important;\n  background-color: #FFE0E0 !important; }\n\na.bg-pink:hover, a.bg-pink:focus,\nbutton.bg-pink:hover,\nbutton.bg-pink:focus {\n  color: #fff !important;\n  background-color: #ffadad !important; }\n\n.badge-pink {\n  color: #212529 !important;\n  background-color: #FFE0E0 !important; }\n\na.badge-pink:hover, a.badge-pink:focus,\nbutton.badge-pink:hover,\nbutton.badge-pink:focus {\n  color: #fff !important;\n  background-color: #ffadad !important; }\n\n.bg-primary-light {\n  color: #171da7 !important;\n  background-color: #c6c8f7 !important; }\n\na.bg-primary-light:hover, a.bg-primary-light:focus,\nbutton.bg-primary-light:hover,\nbutton.bg-primary-light:focus {\n  color: #171da7 !important;\n  background-color: #999df1 !important; }\n\n.bg-secondary-light {\n  color: #4b4e54 !important;\n  background-color: #ccced2 !important; }\n\na.bg-secondary-light:hover, a.bg-secondary-light:focus,\nbutton.bg-secondary-light:hover,\nbutton.bg-secondary-light:focus {\n  color: #4b4e54 !important;\n  background-color: #b1b4ba !important; }\n\n.bg-success-light {\n  color: #2d6c32 !important;\n  background-color: #b7e1ba !important; }\n\na.bg-success-light:hover, a.bg-success-light:focus,\nbutton.bg-success-light:hover,\nbutton.bg-success-light:focus {\n  color: #2d6c32 !important;\n  background-color: #93d298 !important; }\n\n.bg-info-light {\n  color: #de3600 !important;\n  background-color: #ffe6de !important; }\n\na.bg-info-light:hover, a.bg-info-light:focus,\nbutton.bg-info-light:hover,\nbutton.bg-info-light:focus {\n  color: #de3600 !important;\n  background-color: #ffbfab !important; }\n\n.bg-warning-light {\n  color: #df5400 !important;\n  background-color: #ffebdf !important; }\n\na.bg-warning-light:hover, a.bg-warning-light:focus,\nbutton.bg-warning-light:hover,\nbutton.bg-warning-light:focus {\n  color: #df5400 !important;\n  background-color: #ffcbac !important; }\n\n.bg-danger-light {\n  color: #da0064 !important;\n  background-color: #ffdaeb !important; }\n\na.bg-danger-light:hover, a.bg-danger-light:focus,\nbutton.bg-danger-light:hover,\nbutton.bg-danger-light:focus {\n  color: #da0064 !important;\n  background-color: #ffa7cf !important; }\n\n.bg-light-light {\n  color: #7b7b7b !important;\n  background-color: #FAFAFA !important; }\n\na.bg-light-light:hover, a.bg-light-light:focus,\nbutton.bg-light-light:hover,\nbutton.bg-light-light:focus {\n  color: #7b7b7b !important;\n  background-color: #e1e1e1 !important; }\n\n.bg-dark-light {\n  color: rgba(68, 74, 87, 0.1) !important;\n  background-color: rgba(199, 203, 211, 0.1) !important; }\n\na.bg-dark-light:hover, a.bg-dark-light:focus,\nbutton.bg-dark-light:hover,\nbutton.bg-dark-light:focus {\n  color: rgba(68, 74, 87, 0.1) !important;\n  background-color: rgba(170, 176, 189, 0.1) !important; }\n\n.bg-orange-light {\n  color: #d81600 !important;\n  background-color: #ffdcd8 !important; }\n\na.bg-orange-light:hover, a.bg-orange-light:focus,\nbutton.bg-orange-light:hover,\nbutton.bg-orange-light:focus {\n  color: #d81600 !important;\n  background-color: #ffaea5 !important; }\n\n.bg-purple-light {\n  color: #2200c0 !important;\n  background-color: #cbc0ff !important; }\n\na.bg-purple-light:hover, a.bg-purple-light:focus,\nbutton.bg-purple-light:hover,\nbutton.bg-purple-light:focus {\n  color: #2200c0 !important;\n  background-color: #a18dff !important; }\n\n.bg-pink-light {\n  color: #f10000 !important;\n  background-color: #fff1f1 !important; }\n\na.bg-pink-light:hover, a.bg-pink-light:focus,\nbutton.bg-pink-light:hover,\nbutton.bg-pink-light:focus {\n  color: #f10000 !important;\n  background-color: #ffbebe !important; }\n\n/*** Sections backgrounds ***/\n/*** Background colors with transparency ***/\n.avatar-30 {\n  height: 30px;\n  width: 30px;\n  line-height: 30px;\n  min-width: 30px; }\n\n.avatar-35 {\n  height: 35px;\n  width: 35px;\n  line-height: 35px;\n  min-width: 35px; }\n\n.avatar-40 {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  min-width: 40px; }\n\n.avatar-45 {\n  height: 45px;\n  width: 45px;\n  line-height: 45px;\n  min-width: 45px; }\n\n.avatar-50 {\n  height: 50px;\n  width: 50px;\n  line-height: 50px;\n  min-width: 50px; }\n\n.avatar-60 {\n  height: 60px;\n  width: 60px;\n  line-height: 60px;\n  min-width: 60px; }\n\n.avatar-70 {\n  height: 70px;\n  width: 70px;\n  line-height: 70px;\n  min-width: 70px; }\n\n.avatar-80 {\n  height: 80px;\n  width: 80px;\n  line-height: 80px;\n  min-width: 80px; }\n\n.avatar-90 {\n  height: 90px;\n  width: 90px;\n  line-height: 90px;\n  min-width: 90px; }\n\n.avatar-100 {\n  height: 100px;\n  width: 100px;\n  line-height: 100px;\n  min-width: 100px; }\n\n.avatar-110 {\n  height: 110px;\n  width: 110px;\n  line-height: 110px;\n  min-width: 110px; }\n\n.avatar-120 {\n  height: 120px;\n  width: 120px;\n  line-height: 120px;\n  min-width: 120px; }\n\n.avatar-130 {\n  height: 130px;\n  width: 130px;\n  line-height: 130px;\n  min-width: 130px; }\n\n.avatar-155 {\n  height: 155px;\n  width: 155px;\n  line-height: 155px;\n  min-width: 155px; }\n\n.avatar-235 {\n  height: 235px;\n  width: 235px;\n  line-height: 235px;\n  min-width: 235px; }\n\n/*\n * Font Helper\n */\n.font-size-12 {\n  font-size: 12px !important; }\n\n.font-size-14 {\n  font-size: 14px !important; }\n\n.font-size-16 {\n  font-size: 16px !important; }\n\n.font-size-18 {\n  font-size: 18px !important; }\n\n.font-size-20 {\n  font-size: 20px !important; }\n\n.font-size-32 {\n  font-size: 32px !important; }\n\n.font-size-40 {\n  font-size: 40px !important; }\n\n/*** Weight and italics ***/\n.font-weight-300 {\n  font-weight: 300 !important; }\n\n.font-weight-400 {\n  font-weight: 400 !important; }\n\n.font-weight-500 {\n  font-weight: 500 !important; }\n\n.font-weight-600 {\n  font-weight: 600 !important; }\n\n.font-weight-700 {\n  font-weight: 700 !important; }\n\n.font-weight-800 {\n  font-weight: 800 !important; }\n\n.font-weight-900 {\n  font-weight: 900 !important; }\n\n/*** Text decorations ***/\n.text-underline {\n  text-decoration: underline; }\n\n.text-through {\n  text-decoration: line-through; }\n\n/*** Text size ***/\n.text-sm {\n  font-size: 12 !important; }\n\n.text-lg {\n  font-size: 12 !important; }\n\n.text-xl {\n  font-size: 12 !important; }\n\n/*** Line heights ***/\n.line-height-100 {\n  line-height: 1; }\n\n.line-height-110 {\n  line-height: 1.1; }\n\n.line-height-120 {\n  line-height: 1.2; }\n\n.line-height-130 {\n  line-height: 1.3; }\n\n.line-height-140 {\n  line-height: 1.4; }\n\n.line-height-150 {\n  line-height: 1.5; }\n\n.line-height-160 {\n  line-height: 1.6; }\n\n.line-height-170 {\n  line-height: 1.7; }\n\n.line-height-180 {\n  line-height: 1.8; }\n\n/*** Letter spacings ***/\n.letter-spacing-1 {\n  letter-spacing: .0625rem; }\n\n.letter-spacing-15 {\n  letter-spacing: .09375rem; }\n\n.letter-spacing-2 {\n  letter-spacing: 0.125rem; }\n\n/*** Text color variations ***/\n.text-blue {\n  color: #8f93f6 !important; }\n\na.text-blue:hover, a.text-blue:focus {\n  color: #484ff0 !important; }\n\n.text-indigo {\n  color: #6610f2 !important; }\n\na.text-indigo:hover, a.text-indigo:focus {\n  color: #4709ac !important; }\n\n.text-purple {\n  color: #4731b6 !important; }\n\na.text-purple:hover, a.text-purple:focus {\n  color: #2f217a !important; }\n\n.text-pink {\n  color: #FFE0E0 !important; }\n\na.text-pink:hover, a.text-pink:focus {\n  color: #ff9494 !important; }\n\n.text-red {\n  color: #ef9fc4 !important; }\n\na.text-red:hover, a.text-red:focus {\n  color: #e45d9c !important; }\n\n.text-orange {\n  color: #fd7e14 !important; }\n\na.text-orange:hover, a.text-orange:focus {\n  color: #c35a02 !important; }\n\n.text-yellow {\n  color: #fad263 !important; }\n\na.text-yellow:hover, a.text-yellow:focus {\n  color: #f8bd19 !important; }\n\n.text-green {\n  color: #7fdd85 !important; }\n\na.text-green:hover, a.text-green:focus {\n  color: #43cd4b !important; }\n\n.text-teal {\n  color: #20c997 !important; }\n\na.text-teal:hover, a.text-teal:focus {\n  color: #158765 !important; }\n\n.text-cyan {\n  color: #fcbba5 !important; }\n\na.text-cyan:hover, a.text-cyan:focus {\n  color: #fa835b !important; }\n\n.text-white {\n  color: #fff !important; }\n\na.text-white:hover, a.text-white:focus {\n  color: #d9d9d9 !important; }\n\n.text-gray {\n  color: #6c757d !important; }\n\na.text-gray:hover, a.text-gray:focus {\n  color: #494f54 !important; }\n\n.text-gray-dark {\n  color: #01041b !important; }\n\na.text-gray-dark:hover, a.text-gray-dark:focus {\n  color: black !important; }\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license\n\nCopyright (c) 2013 Daniel Eden\n\nPermission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the \"Software\"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n*/\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both; }\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s; }\n\n@-webkit-keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  40% {\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px); }\n  60% {\n    -webkit-transform: translateY(-15px);\n    transform: translateY(-15px); } }\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  40% {\n    -webkit-transform: translateY(-30px);\n    -ms-transform: translateY(-30px);\n    transform: translateY(-30px); }\n  60% {\n    -webkit-transform: translateY(-15px);\n    -ms-transform: translateY(-15px);\n    transform: translateY(-15px); } }\n\n.bounce {\n  -webkit-animation-name: bounce;\n  animation-name: bounce; }\n\n@-webkit-keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1; }\n  25%, 75% {\n    opacity: 0; } }\n\n@keyframes flash {\n  0%, 50%, 100% {\n    opacity: 1; }\n  25%, 75% {\n    opacity: 0; } }\n\n.flash {\n  -webkit-animation-name: flash;\n  animation-name: flash; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1); }\n  50% {\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1); }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1); } }\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); }\n  50% {\n    -webkit-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    transform: scale(1.1); }\n  100% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); } }\n\n.pulse {\n  -webkit-animation-name: pulse;\n  animation-name: pulse; }\n\n@-webkit-keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translateX(-10px);\n    transform: translateX(-10px); }\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px); } }\n\n@keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translateX(-10px);\n    -ms-transform: translateX(-10px);\n    transform: translateX(-10px); }\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translateX(10px);\n    -ms-transform: translateX(10px);\n    transform: translateX(10px); } }\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake; }\n\n@-webkit-keyframes swing {\n  20% {\n    -webkit-transform: rotate(15deg);\n    transform: rotate(15deg); }\n  40% {\n    -webkit-transform: rotate(-10deg);\n    transform: rotate(-10deg); }\n  60% {\n    -webkit-transform: rotate(5deg);\n    transform: rotate(5deg); }\n  80% {\n    -webkit-transform: rotate(-5deg);\n    transform: rotate(-5deg); }\n  100% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); } }\n\n@keyframes swing {\n  20% {\n    -webkit-transform: rotate(15deg);\n    -ms-transform: rotate(15deg);\n    transform: rotate(15deg); }\n  40% {\n    -webkit-transform: rotate(-10deg);\n    -ms-transform: rotate(-10deg);\n    transform: rotate(-10deg); }\n  60% {\n    -webkit-transform: rotate(5deg);\n    -ms-transform: rotate(5deg);\n    transform: rotate(5deg); }\n  80% {\n    -webkit-transform: rotate(-5deg);\n    -ms-transform: rotate(-5deg);\n    transform: rotate(-5deg); }\n  100% {\n    -webkit-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    transform: rotate(0deg); } }\n\n.swing {\n  -webkit-transform-origin: top center;\n  -ms-transform-origin: top center;\n  transform-origin: top center;\n  -webkit-animation-name: swing;\n  animation-name: swing; }\n\n@-webkit-keyframes tada {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1); }\n  10%, 20% {\n    -webkit-transform: scale(0.9) rotate(-3deg);\n    transform: scale(0.9) rotate(-3deg); }\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale(1.1) rotate(3deg);\n    transform: scale(1.1) rotate(3deg); }\n  40%, 60%, 80% {\n    -webkit-transform: scale(1.1) rotate(-3deg);\n    transform: scale(1.1) rotate(-3deg); }\n  100% {\n    -webkit-transform: scale(1) rotate(0);\n    transform: scale(1) rotate(0); } }\n\n@keyframes tada {\n  0% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); }\n  10%, 20% {\n    -webkit-transform: scale(0.9) rotate(-3deg);\n    -ms-transform: scale(0.9) rotate(-3deg);\n    transform: scale(0.9) rotate(-3deg); }\n  30%, 50%, 70%, 90% {\n    -webkit-transform: scale(1.1) rotate(3deg);\n    -ms-transform: scale(1.1) rotate(3deg);\n    transform: scale(1.1) rotate(3deg); }\n  40%, 60%, 80% {\n    -webkit-transform: scale(1.1) rotate(-3deg);\n    -ms-transform: scale(1.1) rotate(-3deg);\n    transform: scale(1.1) rotate(-3deg); }\n  100% {\n    -webkit-transform: scale(1) rotate(0);\n    -ms-transform: scale(1) rotate(0);\n    transform: scale(1) rotate(0); } }\n\n.tada {\n  -webkit-animation-name: tada;\n  animation-name: tada; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes wobble {\n  0% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%); }\n  15% {\n    -webkit-transform: translateX(-25%) rotate(-5deg);\n    transform: translateX(-25%) rotate(-5deg); }\n  30% {\n    -webkit-transform: translateX(20%) rotate(3deg);\n    transform: translateX(20%) rotate(3deg); }\n  45% {\n    -webkit-transform: translateX(-15%) rotate(-3deg);\n    transform: translateX(-15%) rotate(-3deg); }\n  60% {\n    -webkit-transform: translateX(10%) rotate(2deg);\n    transform: translateX(10%) rotate(2deg); }\n  75% {\n    -webkit-transform: translateX(-5%) rotate(-1deg);\n    transform: translateX(-5%) rotate(-1deg); }\n  100% {\n    -webkit-transform: translateX(0%);\n    transform: translateX(0%); } }\n\n@keyframes wobble {\n  0% {\n    -webkit-transform: translateX(0%);\n    -ms-transform: translateX(0%);\n    transform: translateX(0%); }\n  15% {\n    -webkit-transform: translateX(-25%) rotate(-5deg);\n    -ms-transform: translateX(-25%) rotate(-5deg);\n    transform: translateX(-25%) rotate(-5deg); }\n  30% {\n    -webkit-transform: translateX(20%) rotate(3deg);\n    -ms-transform: translateX(20%) rotate(3deg);\n    transform: translateX(20%) rotate(3deg); }\n  45% {\n    -webkit-transform: translateX(-15%) rotate(-3deg);\n    -ms-transform: translateX(-15%) rotate(-3deg);\n    transform: translateX(-15%) rotate(-3deg); }\n  60% {\n    -webkit-transform: translateX(10%) rotate(2deg);\n    -ms-transform: translateX(10%) rotate(2deg);\n    transform: translateX(10%) rotate(2deg); }\n  75% {\n    -webkit-transform: translateX(-5%) rotate(-1deg);\n    -ms-transform: translateX(-5%) rotate(-1deg);\n    transform: translateX(-5%) rotate(-1deg); }\n  100% {\n    -webkit-transform: translateX(0%);\n    -ms-transform: translateX(0%);\n    transform: translateX(0%); } }\n\n.wobble {\n  -webkit-animation-name: wobble;\n  animation-name: wobble; }\n\n@-webkit-keyframes bounceIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.3);\n    transform: scale(0.3); }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(1.05);\n    transform: scale(1.05); }\n  70% {\n    -webkit-transform: scale(0.9);\n    transform: scale(0.9); }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1); } }\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.3);\n    -ms-transform: scale(0.3);\n    transform: scale(0.3); }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(1.05);\n    -ms-transform: scale(1.05);\n    transform: scale(1.05); }\n  70% {\n    -webkit-transform: scale(0.9);\n    -ms-transform: scale(0.9);\n    transform: scale(0.9); }\n  100% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); } }\n\n.bounceIn {\n  -webkit-animation-name: bounceIn;\n  animation-name: bounceIn; }\n\n@-webkit-keyframes bounceInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateY(30px);\n    transform: translateY(30px); }\n  80% {\n    -webkit-transform: translateY(-10px);\n    transform: translateY(-10px); }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes bounceInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateY(30px);\n    -ms-transform: translateY(30px);\n    transform: translateY(30px); }\n  80% {\n    -webkit-transform: translateY(-10px);\n    -ms-transform: translateY(-10px);\n    transform: translateY(-10px); }\n  100% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.bounceInDown {\n  -webkit-animation-name: bounceInDown;\n  animation-name: bounceInDown; }\n\n@-webkit-keyframes bounceInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(30px);\n    transform: translateX(30px); }\n  80% {\n    -webkit-transform: translateX(-10px);\n    transform: translateX(-10px); }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes bounceInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(30px);\n    -ms-transform: translateX(30px);\n    transform: translateX(30px); }\n  80% {\n    -webkit-transform: translateX(-10px);\n    -ms-transform: translateX(-10px);\n    transform: translateX(-10px); }\n  100% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.bounceInLeft {\n  -webkit-animation-name: bounceInLeft;\n  animation-name: bounceInLeft; }\n\n@-webkit-keyframes bounceInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-30px);\n    transform: translateX(-30px); }\n  80% {\n    -webkit-transform: translateX(10px);\n    transform: translateX(10px); }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes bounceInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-30px);\n    -ms-transform: translateX(-30px);\n    transform: translateX(-30px); }\n  80% {\n    -webkit-transform: translateX(10px);\n    -ms-transform: translateX(10px);\n    transform: translateX(10px); }\n  100% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.bounceInRight {\n  -webkit-animation-name: bounceInRight;\n  animation-name: bounceInRight; }\n\n@-webkit-keyframes bounceInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    transform: translateY(2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateY(-30px);\n    transform: translateY(-30px); }\n  80% {\n    -webkit-transform: translateY(10px);\n    transform: translateY(10px); }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes bounceInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    -ms-transform: translateY(2000px);\n    transform: translateY(2000px); }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateY(-30px);\n    -ms-transform: translateY(-30px);\n    transform: translateY(-30px); }\n  80% {\n    -webkit-transform: translateY(10px);\n    -ms-transform: translateY(10px);\n    transform: translateY(10px); }\n  100% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp; }\n\n@-webkit-keyframes bounceOut {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1); }\n  25% {\n    -webkit-transform: scale(0.95);\n    transform: scale(0.95); }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.3);\n    transform: scale(0.3); } }\n\n@keyframes bounceOut {\n  0% {\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    transform: scale(1); }\n  25% {\n    -webkit-transform: scale(0.95);\n    -ms-transform: scale(0.95);\n    transform: scale(0.95); }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    transform: scale(1.1); }\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(0.3);\n    -ms-transform: scale(0.3);\n    transform: scale(0.3); } }\n\n.bounceOut {\n  -webkit-animation-name: bounceOut;\n  animation-name: bounceOut; }\n\n@-webkit-keyframes bounceOutDown {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    transform: translateY(2000px); } }\n\n@keyframes bounceOutDown {\n  0% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(-20px);\n    -ms-transform: translateY(-20px);\n    transform: translateY(-20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    -ms-transform: translateY(2000px);\n    transform: translateY(2000px); } }\n\n.bounceOutDown {\n  -webkit-animation-name: bounceOutDown;\n  animation-name: bounceOutDown; }\n\n@-webkit-keyframes bounceOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    transform: translateX(20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n@keyframes bounceOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    transform: translateX(20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n.bounceOutLeft {\n  -webkit-animation-name: bounceOutLeft;\n  animation-name: bounceOutLeft; }\n\n@-webkit-keyframes bounceOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    transform: translateX(-20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n@keyframes bounceOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    transform: translateX(-20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n.bounceOutRight {\n  -webkit-animation-name: bounceOutRight;\n  animation-name: bounceOutRight; }\n\n@-webkit-keyframes bounceOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(20px);\n    transform: translateY(20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n@keyframes bounceOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  20% {\n    opacity: 1;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n.bounceOutUp {\n  -webkit-animation-name: bounceOutUp;\n  animation-name: bounceOutUp; }\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn; }\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n    -ms-transform: translateY(-20px);\n    transform: translateY(-20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown; }\n\n@-webkit-keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes fadeInDownBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.fadeInDownBig {\n  -webkit-animation-name: fadeInDownBig;\n  animation-name: fadeInDownBig; }\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-20px);\n    transform: translateX(-20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    transform: translateX(-20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft; }\n\n@-webkit-keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes fadeInLeftBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.fadeInLeftBig {\n  -webkit-animation-name: fadeInLeftBig;\n  animation-name: fadeInLeftBig; }\n\n@-webkit-keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(20px);\n    transform: translateX(20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    transform: translateX(20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.fadeInRight {\n  -webkit-animation-name: fadeInRight;\n  animation-name: fadeInRight; }\n\n@-webkit-keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes fadeInRightBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.fadeInRightBig {\n  -webkit-animation-name: fadeInRightBig;\n  animation-name: fadeInRightBig; }\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n    transform: translateY(20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp; }\n\n@-webkit-keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    transform: translateY(2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes fadeInUpBig {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    -ms-transform: translateY(2000px);\n    transform: translateY(2000px); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.fadeInUpBig {\n  -webkit-animation-name: fadeInUpBig;\n  animation-name: fadeInUpBig; }\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut; }\n\n@-webkit-keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n    transform: translateY(20px); } }\n\n@keyframes fadeOutDown {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n    -ms-transform: translateY(20px);\n    transform: translateY(20px); } }\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown; }\n\n@-webkit-keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    transform: translateY(2000px); } }\n\n@keyframes fadeOutDownBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(2000px);\n    -ms-transform: translateY(2000px);\n    transform: translateY(2000px); } }\n\n.fadeOutDownBig {\n  -webkit-animation-name: fadeOutDownBig;\n  animation-name: fadeOutDownBig; }\n\n@-webkit-keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-20px);\n    transform: translateX(-20px); } }\n\n@keyframes fadeOutLeft {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    transform: translateX(-20px); } }\n\n.fadeOutLeft {\n  -webkit-animation-name: fadeOutLeft;\n  animation-name: fadeOutLeft; }\n\n@-webkit-keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n@keyframes fadeOutLeftBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n.fadeOutLeftBig {\n  -webkit-animation-name: fadeOutLeftBig;\n  animation-name: fadeOutLeftBig; }\n\n@-webkit-keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(20px);\n    transform: translateX(20px); } }\n\n@keyframes fadeOutRight {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    transform: translateX(20px); } }\n\n.fadeOutRight {\n  -webkit-animation-name: fadeOutRight;\n  animation-name: fadeOutRight; }\n\n@-webkit-keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n@keyframes fadeOutRightBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n.fadeOutRightBig {\n  -webkit-animation-name: fadeOutRightBig;\n  animation-name: fadeOutRightBig; }\n\n@-webkit-keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px); } }\n\n@keyframes fadeOutUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n    -ms-transform: translateY(-20px);\n    transform: translateY(-20px); } }\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp; }\n\n@-webkit-keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n@keyframes fadeOutUpBig {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n.fadeOutUpBig {\n  -webkit-animation-name: fadeOutUpBig;\n  animation-name: fadeOutUpBig; }\n\n@-webkit-keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(0) scale(1);\n    transform: perspective(400px) translateZ(0) rotateY(0) scale(1);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  40% {\n    -webkit-transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);\n    transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  50% {\n    -webkit-transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);\n    transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  80% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);\n    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  100% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);\n    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; } }\n\n@keyframes flip {\n  0% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(0) scale(1);\n    -ms-transform: perspective(400px) translateZ(0) rotateY(0) scale(1);\n    transform: perspective(400px) translateZ(0) rotateY(0) scale(1);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  40% {\n    -webkit-transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);\n    -ms-transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);\n    transform: perspective(400px) translateZ(150px) rotateY(170deg) scale(1);\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out; }\n  50% {\n    -webkit-transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);\n    -ms-transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);\n    transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  80% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);\n    -ms-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);\n    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(0.95);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; }\n  100% {\n    -webkit-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);\n    -ms-transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);\n    transform: perspective(400px) translateZ(0) rotateY(360deg) scale(1);\n    -webkit-animation-timing-function: ease-in;\n    animation-timing-function: ease-in; } }\n\n.animated.flip {\n  -webkit-backface-visibility: visible;\n  -ms-backface-visibility: visible;\n  backface-visibility: visible;\n  -webkit-animation-name: flip;\n  animation-name: flip; }\n\n@-webkit-keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-10deg);\n    transform: perspective(400px) rotateX(-10deg); }\n  70% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg); }\n  100% {\n    -webkit-transform: perspective(400px) rotateX(0deg);\n    transform: perspective(400px) rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes flipInX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    -ms-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotateX(-10deg);\n    -ms-transform: perspective(400px) rotateX(-10deg);\n    transform: perspective(400px) rotateX(-10deg); }\n  70% {\n    -webkit-transform: perspective(400px) rotateX(10deg);\n    -ms-transform: perspective(400px) rotateX(10deg);\n    transform: perspective(400px) rotateX(10deg); }\n  100% {\n    -webkit-transform: perspective(400px) rotateX(0deg);\n    -ms-transform: perspective(400px) rotateX(0deg);\n    transform: perspective(400px) rotateX(0deg);\n    opacity: 1; } }\n\n.flipInX {\n  -webkit-backface-visibility: visible !important;\n  -ms-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInX;\n  animation-name: flipInX; }\n\n@-webkit-keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotateY(-10deg);\n    transform: perspective(400px) rotateY(-10deg); }\n  70% {\n    -webkit-transform: perspective(400px) rotateY(10deg);\n    transform: perspective(400px) rotateY(10deg); }\n  100% {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n    opacity: 1; } }\n\n@keyframes flipInY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    -ms-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0; }\n  40% {\n    -webkit-transform: perspective(400px) rotateY(-10deg);\n    -ms-transform: perspective(400px) rotateY(-10deg);\n    transform: perspective(400px) rotateY(-10deg); }\n  70% {\n    -webkit-transform: perspective(400px) rotateY(10deg);\n    -ms-transform: perspective(400px) rotateY(10deg);\n    transform: perspective(400px) rotateY(10deg); }\n  100% {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n    opacity: 1; } }\n\n.flipInY {\n  -webkit-backface-visibility: visible !important;\n  -ms-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipInY;\n  animation-name: flipInY; }\n\n@-webkit-keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(0deg);\n    transform: perspective(400px) rotateX(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0; } }\n\n@keyframes flipOutX {\n  0% {\n    -webkit-transform: perspective(400px) rotateX(0deg);\n    -ms-transform: perspective(400px) rotateX(0deg);\n    transform: perspective(400px) rotateX(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotateX(90deg);\n    -ms-transform: perspective(400px) rotateX(90deg);\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0; } }\n\n.flipOutX {\n  -webkit-animation-name: flipOutX;\n  animation-name: flipOutX;\n  -webkit-backface-visibility: visible !important;\n  -ms-backface-visibility: visible !important;\n  backface-visibility: visible !important; }\n\n@-webkit-keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0; } }\n\n@keyframes flipOutY {\n  0% {\n    -webkit-transform: perspective(400px) rotateY(0deg);\n    -ms-transform: perspective(400px) rotateY(0deg);\n    transform: perspective(400px) rotateY(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: perspective(400px) rotateY(90deg);\n    -ms-transform: perspective(400px) rotateY(90deg);\n    transform: perspective(400px) rotateY(90deg);\n    opacity: 0; } }\n\n.flipOutY {\n  -webkit-backface-visibility: visible !important;\n  -ms-backface-visibility: visible !important;\n  backface-visibility: visible !important;\n  -webkit-animation-name: flipOutY;\n  animation-name: flipOutY; }\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0; }\n  60% {\n    -webkit-transform: translateX(-20%) skewX(30deg);\n    transform: translateX(-20%) skewX(30deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: translateX(0%) skewX(-15deg);\n    transform: translateX(0%) skewX(-15deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1; } }\n\n@keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    -ms-transform: translateX(100%) skewX(-30deg);\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0; }\n  60% {\n    -webkit-transform: translateX(-20%) skewX(30deg);\n    -ms-transform: translateX(-20%) skewX(30deg);\n    transform: translateX(-20%) skewX(30deg);\n    opacity: 1; }\n  80% {\n    -webkit-transform: translateX(0%) skewX(-15deg);\n    -ms-transform: translateX(0%) skewX(-15deg);\n    transform: translateX(0%) skewX(-15deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    -ms-transform: translateX(0%) skewX(0deg);\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1; } }\n\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out; }\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0; } }\n\n@keyframes lightSpeedOut {\n  0% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    -ms-transform: translateX(0%) skewX(0deg);\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1; }\n  100% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    -ms-transform: translateX(100%) skewX(-30deg);\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0; } }\n\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in; }\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(-200deg);\n    transform: rotate(-200deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center center;\n    -ms-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(-200deg);\n    -ms-transform: rotate(-200deg);\n    transform: rotate(-200deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: center center;\n    -ms-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn; }\n\n@-webkit-keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n@keyframes rotateInDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n.rotateInDownLeft {\n  -webkit-animation-name: rotateInDownLeft;\n  animation-name: rotateInDownLeft; }\n\n@-webkit-keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n@keyframes rotateInDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n.rotateInDownRight {\n  -webkit-animation-name: rotateInDownRight;\n  animation-name: rotateInDownRight; }\n\n@-webkit-keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n@keyframes rotateInUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n.rotateInUpLeft {\n  -webkit-animation-name: rotateInUpLeft;\n  animation-name: rotateInUpLeft; }\n\n@-webkit-keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n@keyframes rotateInUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; } }\n\n.rotateInUpRight {\n  -webkit-animation-name: rotateInUpRight;\n  animation-name: rotateInUpRight; }\n\n@-webkit-keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(200deg);\n    transform: rotate(200deg);\n    opacity: 0; } }\n\n@keyframes rotateOut {\n  0% {\n    -webkit-transform-origin: center center;\n    -ms-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: center center;\n    -ms-transform-origin: center center;\n    transform-origin: center center;\n    -webkit-transform: rotate(200deg);\n    -ms-transform: rotate(200deg);\n    transform: rotate(200deg);\n    opacity: 0; } }\n\n.rotateOut {\n  -webkit-animation-name: rotateOut;\n  animation-name: rotateOut; }\n\n@-webkit-keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; } }\n\n@keyframes rotateOutDownLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; } }\n\n.rotateOutDownLeft {\n  -webkit-animation-name: rotateOutDownLeft;\n  animation-name: rotateOutDownLeft; }\n\n@-webkit-keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; } }\n\n@keyframes rotateOutDownRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; } }\n\n.rotateOutDownRight {\n  -webkit-animation-name: rotateOutDownRight;\n  animation-name: rotateOutDownRight; }\n\n@-webkit-keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; } }\n\n@keyframes rotateOutUpLeft {\n  0% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: left bottom;\n    -ms-transform-origin: left bottom;\n    transform-origin: left bottom;\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    opacity: 0; } }\n\n.rotateOutUpLeft {\n  -webkit-animation-name: rotateOutUpLeft;\n  animation-name: rotateOutUpLeft; }\n\n@-webkit-keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; } }\n\n@keyframes rotateOutUpRight {\n  0% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    opacity: 1; }\n  100% {\n    -webkit-transform-origin: right bottom;\n    -ms-transform-origin: right bottom;\n    transform-origin: right bottom;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    opacity: 0; } }\n\n.rotateOutUpRight {\n  -webkit-animation-name: rotateOutUpRight;\n  animation-name: rotateOutUpRight; }\n\n@-webkit-keyframes slideInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); } }\n\n@keyframes slideInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); }\n  100% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); } }\n\n.slideInDown {\n  -webkit-animation-name: slideInDown;\n  animation-name: slideInDown; }\n\n@-webkit-keyframes slideInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes slideInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); }\n  100% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.slideInLeft {\n  -webkit-animation-name: slideInLeft;\n  animation-name: slideInLeft; }\n\n@-webkit-keyframes slideInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); } }\n\n@keyframes slideInRight {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); }\n  100% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); } }\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight; }\n\n@-webkit-keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n@keyframes slideOutLeft {\n  0% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(-2000px);\n    -ms-transform: translateX(-2000px);\n    transform: translateX(-2000px); } }\n\n.slideOutLeft {\n  -webkit-animation-name: slideOutLeft;\n  animation-name: slideOutLeft; }\n\n@-webkit-keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n@keyframes slideOutRight {\n  0% {\n    -webkit-transform: translateX(0);\n    -ms-transform: translateX(0);\n    transform: translateX(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(2000px);\n    -ms-transform: translateX(2000px);\n    transform: translateX(2000px); } }\n\n.slideOutRight {\n  -webkit-animation-name: slideOutRight;\n  animation-name: slideOutRight; }\n\n@-webkit-keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n@keyframes slideOutUp {\n  0% {\n    -webkit-transform: translateY(0);\n    -ms-transform: translateY(0);\n    transform: translateY(0); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-2000px);\n    -ms-transform: translateY(-2000px);\n    transform: translateY(-2000px); } }\n\n.slideOutUp {\n  -webkit-animation-name: slideOutUp;\n  animation-name: slideOutUp; }\n\n@-webkit-keyframes hinge {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  20%, 60% {\n    -webkit-transform: rotate(80deg);\n    transform: rotate(80deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  40% {\n    -webkit-transform: rotate(60deg);\n    transform: rotate(60deg);\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  80% {\n    -webkit-transform: rotate(60deg) translateY(0);\n    transform: rotate(60deg) translateY(0);\n    opacity: 1;\n    -webkit-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  100% {\n    -webkit-transform: translateY(700px);\n    transform: translateY(700px);\n    opacity: 0; } }\n\n@keyframes hinge {\n  0% {\n    -webkit-transform: rotate(0);\n    -ms-transform: rotate(0);\n    transform: rotate(0);\n    -webkit-transform-origin: top left;\n    -ms-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  20%, 60% {\n    -webkit-transform: rotate(80deg);\n    -ms-transform: rotate(80deg);\n    transform: rotate(80deg);\n    -webkit-transform-origin: top left;\n    -ms-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  40% {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg);\n    -webkit-transform-origin: top left;\n    -ms-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  80% {\n    -webkit-transform: rotate(60deg) translateY(0);\n    -ms-transform: rotate(60deg) translateY(0);\n    transform: rotate(60deg) translateY(0);\n    opacity: 1;\n    -webkit-transform-origin: top left;\n    -ms-transform-origin: top left;\n    transform-origin: top left;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out; }\n  100% {\n    -webkit-transform: translateY(700px);\n    -ms-transform: translateY(700px);\n    transform: translateY(700px);\n    opacity: 0; } }\n\n.hinge {\n  -webkit-animation-name: hinge;\n  animation-name: hinge; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100%) rotate(-120deg);\n    transform: translateX(-100%) rotate(-120deg); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0px) rotate(0deg);\n    transform: translateX(0px) rotate(0deg); } }\n\n@keyframes rollIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100%) rotate(-120deg);\n    -ms-transform: translateX(-100%) rotate(-120deg);\n    transform: translateX(-100%) rotate(-120deg); }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0px) rotate(0deg);\n    -ms-transform: translateX(0px) rotate(0deg);\n    transform: translateX(0px) rotate(0deg); } }\n\n.rollIn {\n  -webkit-animation-name: rollIn;\n  animation-name: rollIn; }\n\n/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */\n@-webkit-keyframes rollOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0px) rotate(0deg);\n    transform: translateX(0px) rotate(0deg); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(100%) rotate(120deg);\n    transform: translateX(100%) rotate(120deg); } }\n\n@keyframes rollOut {\n  0% {\n    opacity: 1;\n    -webkit-transform: translateX(0px) rotate(0deg);\n    -ms-transform: translateX(0px) rotate(0deg);\n    transform: translateX(0px) rotate(0deg); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(100%) rotate(120deg);\n    -ms-transform: translateX(100%) rotate(120deg);\n    transform: translateX(100%) rotate(120deg); } }\n\n.rollOut {\n  -webkit-animation-name: rollOut;\n  animation-name: rollOut; }\n\n.swal2-popup.swal2-toast {\n  flex-direction: column;\n  align-items: stretch;\n  width: auto;\n  padding: 1.25em;\n  overflow-y: hidden;\n  background: #fff;\n  box-shadow: 0 0 0.625em #d9d9d9; }\n  .swal2-popup.swal2-toast .swal2-header {\n    flex-direction: row;\n    padding: 0; }\n  .swal2-popup.swal2-toast .swal2-title {\n    flex-grow: 1;\n    justify-content: flex-start;\n    margin: 0 0.625em;\n    font-size: 1em; }\n  .swal2-popup.swal2-toast .swal2-loading {\n    justify-content: center; }\n  .swal2-popup.swal2-toast .swal2-input {\n    height: 2em;\n    margin: .3125em auto;\n    font-size: 1em; }\n  .swal2-popup.swal2-toast .swal2-validation-message {\n    font-size: 1em; }\n  .swal2-popup.swal2-toast .swal2-footer {\n    margin: 0.5em 0 0;\n    padding: 0.5em 0 0;\n    font-size: 0.8em; }\n  .swal2-popup.swal2-toast .swal2-close {\n    position: static;\n    width: 0.8em;\n    height: 0.8em;\n    line-height: 0.8; }\n  .swal2-popup.swal2-toast .swal2-content {\n    justify-content: flex-start;\n    margin: 0 0.625em;\n    padding: 0;\n    font-size: 1em;\n    text-align: initial; }\n  .swal2-popup.swal2-toast .swal2-html-container {\n    padding: .625em 0 0; }\n    .swal2-popup.swal2-toast .swal2-html-container:empty {\n      padding: 0; }\n  .swal2-popup.swal2-toast .swal2-icon {\n    width: 2em;\n    min-width: 2em;\n    height: 2em;\n    margin: 0 .5em 0 0; }\n    .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {\n      display: flex;\n      align-items: center;\n      font-size: 1.8em;\n      font-weight: bold; }\n      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {\n          font-size: .25em; } }\n    .swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {\n      width: 2em;\n      height: 2em; }\n    .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n      top: .875em;\n      width: 1.375em; }\n      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='left'] {\n        left: .3125em; }\n      .swal2-popup.swal2-toast .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='right'] {\n        right: .3125em; }\n  .swal2-popup.swal2-toast .swal2-actions {\n    flex: 1;\n    flex-basis: auto !important;\n    align-self: stretch;\n    width: auto;\n    height: 2.2em;\n    height: auto;\n    margin: 0 .3125em;\n    margin-top: .3125em;\n    padding: 0; }\n  .swal2-popup.swal2-toast .swal2-styled {\n    margin: .125em .3125em;\n    padding: .3125em .625em;\n    font-size: 1em; }\n    .swal2-popup.swal2-toast .swal2-styled:focus {\n      box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(100, 150, 200, 0.5); }\n  .swal2-popup.swal2-toast .swal2-success {\n    border-color: #a5dc86; }\n    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'] {\n      position: absolute;\n      width: 1.6em;\n      height: 3em;\n      transform: rotate(45deg);\n      border-radius: 50%; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n        top: -.8em;\n        left: -.5em;\n        transform: rotate(-45deg);\n        transform-origin: 2em 2em;\n        border-radius: 4em 0 0 4em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n        top: -.25em;\n        left: .9375em;\n        transform-origin: 0 1.5em;\n        border-radius: 0 4em 4em 0; }\n    .swal2-popup.swal2-toast .swal2-success .swal2-success-ring {\n      width: 2em;\n      height: 2em; }\n    .swal2-popup.swal2-toast .swal2-success .swal2-success-fix {\n      top: 0;\n      left: .4375em;\n      width: .4375em;\n      height: 2.6875em; }\n    .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'] {\n      height: .3125em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='tip'] {\n        top: 1.125em;\n        left: .1875em;\n        width: .75em; }\n      .swal2-popup.swal2-toast .swal2-success [class^='swal2-success-line'][class$='long'] {\n        top: .9375em;\n        right: .1875em;\n        width: 1.375em; }\n    .swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip {\n      animation: swal2-toast-animate-success-line-tip .75s; }\n    .swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long {\n      animation: swal2-toast-animate-success-line-long .75s; }\n  .swal2-popup.swal2-toast.swal2-show {\n    animation: swal2-toast-show 0.5s; }\n  .swal2-popup.swal2-toast.swal2-hide {\n    animation: swal2-toast-hide 0.1s forwards; }\n\n.swal2-container {\n  display: flex;\n  position: fixed;\n  z-index: 1060;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.625em;\n  overflow-x: hidden;\n  transition: background-color 0.1s;\n  -webkit-overflow-scrolling: touch; }\n  .swal2-container.swal2-backdrop-show, .swal2-container.swal2-noanimation {\n    background: rgba(0, 0, 0, 0.4); }\n  .swal2-container.swal2-backdrop-hide {\n    background: transparent !important; }\n  .swal2-container.swal2-top {\n    align-items: flex-start; }\n  .swal2-container.swal2-top-start, .swal2-container.swal2-top-left {\n    align-items: flex-start;\n    justify-content: flex-start; }\n  .swal2-container.swal2-top-end, .swal2-container.swal2-top-right {\n    align-items: flex-start;\n    justify-content: flex-end; }\n  .swal2-container.swal2-center {\n    align-items: center; }\n  .swal2-container.swal2-center-start, .swal2-container.swal2-center-left {\n    align-items: center;\n    justify-content: flex-start; }\n  .swal2-container.swal2-center-end, .swal2-container.swal2-center-right {\n    align-items: center;\n    justify-content: flex-end; }\n  .swal2-container.swal2-bottom {\n    align-items: flex-end; }\n  .swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {\n    align-items: flex-end;\n    justify-content: flex-start; }\n  .swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {\n    align-items: flex-end;\n    justify-content: flex-end; }\n  .swal2-container.swal2-bottom > :first-child,\n  .swal2-container.swal2-bottom-start > :first-child,\n  .swal2-container.swal2-bottom-left > :first-child,\n  .swal2-container.swal2-bottom-end > :first-child,\n  .swal2-container.swal2-bottom-right > :first-child {\n    margin-top: auto; }\n  .swal2-container.swal2-grow-fullscreen > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-self: stretch;\n    justify-content: center; }\n  .swal2-container.swal2-grow-row > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-content: center;\n    justify-content: center; }\n  .swal2-container.swal2-grow-column {\n    flex: 1;\n    flex-direction: column; }\n    .swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {\n      align-items: center; }\n    .swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {\n      align-items: flex-start; }\n    .swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {\n      align-items: flex-end; }\n    .swal2-container.swal2-grow-column > .swal2-modal {\n      display: flex !important;\n      flex: 1;\n      align-content: center;\n      justify-content: center; }\n  .swal2-container.swal2-no-transition {\n    transition: none !important; }\n  .swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen) > .swal2-modal {\n    margin: auto; }\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    .swal2-container .swal2-modal {\n      margin: 0 !important; } }\n\n.swal2-popup {\n  display: none;\n  position: relative;\n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  width: 32em;\n  max-width: 100%;\n  padding: 1.25em;\n  border: none;\n  border-radius: 5px;\n  background: #fff;\n  font-family: inherit;\n  font-size: 1rem; }\n  .swal2-popup:focus {\n    outline: none; }\n  .swal2-popup.swal2-loading {\n    overflow-y: hidden; }\n\n.swal2-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 1.8em; }\n\n.swal2-title {\n  position: relative;\n  max-width: 100%;\n  margin: 0 0 0.4em;\n  padding: 0;\n  color: #595959;\n  font-size: 1.875em;\n  font-weight: 600;\n  text-align: center;\n  text-transform: none;\n  word-wrap: break-word; }\n\n.swal2-actions {\n  display: flex;\n  z-index: 1;\n  box-sizing: border-box;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 1.25em auto 0;\n  padding: 0; }\n  .swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {\n    opacity: .4; }\n  .swal2-actions:not(.swal2-loading) .swal2-styled:hover {\n    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)); }\n  .swal2-actions:not(.swal2-loading) .swal2-styled:active {\n    background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)); }\n\n.swal2-loader {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 2.2em;\n  height: 2.2em;\n  margin: 0 1.875em;\n  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n  border-width: 0.25em;\n  border-style: solid;\n  border-radius: 100%;\n  border-color: #2778c4 transparent #2778c4 transparent; }\n\n.swal2-styled {\n  margin: 0.3125em;\n  padding: 0.625em 1.1em;\n  box-shadow: none;\n  font-weight: 500; }\n  .swal2-styled:not([disabled]) {\n    cursor: pointer; }\n  .swal2-styled.swal2-confirm {\n    border: 0;\n    border-radius: 0.25em;\n    background: initial;\n    background-color: #2778c4;\n    color: #fff;\n    font-size: 1em; }\n  .swal2-styled.swal2-deny {\n    border: 0;\n    border-radius: 0.25em;\n    background: initial;\n    background-color: #d14529;\n    color: #fff;\n    font-size: 1em; }\n  .swal2-styled.swal2-cancel {\n    border: 0;\n    border-radius: 0.25em;\n    background: initial;\n    background-color: #757575;\n    color: #fff;\n    font-size: 1em; }\n  .swal2-styled:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(100, 150, 200, 0.5); }\n  .swal2-styled::-moz-focus-inner {\n    border: 0; }\n\n.swal2-footer {\n  justify-content: center;\n  margin: 1.25em 0 0;\n  padding: 1em 0 0;\n  border-top: 1px solid #eee;\n  color: #545454;\n  font-size: 1em; }\n\n.swal2-timer-progress-bar-container {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 0.25em;\n  overflow: hidden;\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px; }\n\n.swal2-timer-progress-bar {\n  width: 100%;\n  height: 0.25em;\n  background: rgba(0, 0, 0, 0.2); }\n\n.swal2-image {\n  max-width: 100%;\n  margin: 1.25em auto; }\n\n.swal2-close {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  align-items: center;\n  justify-content: center;\n  width: 1.2em;\n  height: 1.2em;\n  padding: 0;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  border: none;\n  border-radius: 5px;\n  background: transparent;\n  color: #cccccc;\n  font-family: serif;\n  font-size: 2.5em;\n  line-height: 1.2;\n  cursor: pointer; }\n  .swal2-close:hover {\n    transform: none;\n    background: transparent;\n    color: #f27474; }\n  .swal2-close:focus {\n    outline: none;\n    box-shadow: inset 0 0 0 3px rgba(100, 150, 200, 0.5); }\n  .swal2-close::-moz-focus-inner {\n    border: 0; }\n\n.swal2-content {\n  z-index: 1;\n  justify-content: center;\n  margin: 0;\n  padding: 0 1.6em;\n  color: #545454;\n  font-size: 1.125em;\n  font-weight: normal;\n  line-height: normal;\n  text-align: center;\n  word-wrap: break-word; }\n\n.swal2-input,\n.swal2-file,\n.swal2-textarea,\n.swal2-select,\n.swal2-radio,\n.swal2-checkbox {\n  margin: 1em auto; }\n\n.swal2-input,\n.swal2-file,\n.swal2-textarea {\n  box-sizing: border-box;\n  width: 100%;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  border: 1px solid #d9d9d9;\n  border-radius: 0.1875em;\n  background: inherit;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n  color: inherit;\n  font-size: 1.125em; }\n  .swal2-input.swal2-inputerror,\n  .swal2-file.swal2-inputerror,\n  .swal2-textarea.swal2-inputerror {\n    border-color: #f27474 !important;\n    box-shadow: 0 0 2px #f27474 !important; }\n  .swal2-input:focus,\n  .swal2-file:focus,\n  .swal2-textarea:focus {\n    border: 1px solid #b4dbed;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(100, 150, 200, 0.5); }\n  .swal2-input::placeholder,\n  .swal2-file::placeholder,\n  .swal2-textarea::placeholder {\n    color: #cccccc; }\n\n.swal2-range {\n  margin: 1em auto;\n  background: #fff; }\n  .swal2-range input {\n    width: 80%; }\n  .swal2-range output {\n    width: 20%;\n    color: inherit;\n    font-weight: 600;\n    text-align: center; }\n  .swal2-range input,\n  .swal2-range output {\n    height: 2.625em;\n    padding: 0;\n    font-size: 1.125em;\n    line-height: 2.625em; }\n\n.swal2-input {\n  height: 2.625em;\n  padding: 0 0.75em; }\n  .swal2-input[type='number'] {\n    max-width: 10em; }\n\n.swal2-file {\n  background: inherit;\n  font-size: 1.125em; }\n\n.swal2-textarea {\n  height: 6.75em;\n  padding: 0.75em; }\n\n.swal2-select {\n  min-width: 50%;\n  max-width: 100%;\n  padding: .375em .625em;\n  background: inherit;\n  color: inherit;\n  font-size: 1.125em; }\n\n.swal2-radio,\n.swal2-checkbox {\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: inherit; }\n  .swal2-radio label,\n  .swal2-checkbox label {\n    margin: 0 .6em;\n    font-size: 1.125em; }\n  .swal2-radio input,\n  .swal2-checkbox input {\n    flex-shrink: 0;\n    margin: 0 .4em; }\n\n.swal2-input-label {\n  display: flex;\n  justify-content: center;\n  margin: 1em auto; }\n\n.swal2-validation-message {\n  align-items: center;\n  justify-content: center;\n  margin: 0 -2.7em;\n  padding: 0.625em;\n  overflow: hidden;\n  background: #f0f0f0;\n  color: #666666;\n  font-size: 1em;\n  font-weight: 300; }\n  .swal2-validation-message::before {\n    content: '!';\n    display: inline-block;\n    width: 1.5em;\n    min-width: 1.5em;\n    height: 1.5em;\n    margin: 0 .625em;\n    border-radius: 50%;\n    background-color: #f27474;\n    color: #fff;\n    font-weight: 600;\n    line-height: 1.5em;\n    text-align: center; }\n\n.swal2-icon {\n  position: relative;\n  box-sizing: content-box;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: 1.25em auto 1.875em;\n  border: 0.25em solid transparent;\n  border-radius: 50%;\n  border-color: #000;\n  font-family: inherit;\n  line-height: 5em;\n  cursor: default;\n  user-select: none; }\n  .swal2-icon .swal2-icon-content {\n    display: flex;\n    align-items: center;\n    font-size: 3.75em; }\n  .swal2-icon.swal2-error {\n    border-color: #f27474;\n    color: #f27474; }\n    .swal2-icon.swal2-error .swal2-x-mark {\n      position: relative;\n      flex-grow: 1; }\n    .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n      display: block;\n      position: absolute;\n      top: 2.3125em;\n      width: 2.9375em;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: #f27474; }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='left'] {\n        left: 1.0625em;\n        transform: rotate(45deg); }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='right'] {\n        right: 1em;\n        transform: rotate(-45deg); }\n    .swal2-icon.swal2-error.swal2-icon-show {\n      animation: swal2-animate-error-icon .5s; }\n      .swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark {\n        animation: swal2-animate-error-x-mark .5s; }\n  .swal2-icon.swal2-warning {\n    border-color: #facea8;\n    color: #f8bb86; }\n  .swal2-icon.swal2-info {\n    border-color: #9de0f6;\n    color: #3fc3ee; }\n  .swal2-icon.swal2-question {\n    border-color: #c9dae1;\n    color: #87adbd; }\n  .swal2-icon.swal2-success {\n    border-color: #a5dc86;\n    color: #a5dc86; }\n    .swal2-icon.swal2-success [class^='swal2-success-circular-line'] {\n      position: absolute;\n      width: 3.75em;\n      height: 7.5em;\n      transform: rotate(45deg);\n      border-radius: 50%; }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n        top: -.4375em;\n        left: -2.0635em;\n        transform: rotate(-45deg);\n        transform-origin: 3.75em 3.75em;\n        border-radius: 7.5em 0 0 7.5em; }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n        top: -.6875em;\n        left: 1.875em;\n        transform: rotate(-45deg);\n        transform-origin: 0 3.75em;\n        border-radius: 0 7.5em 7.5em 0; }\n    .swal2-icon.swal2-success .swal2-success-ring {\n      position: absolute;\n      z-index: 2;\n      top: -.25em;\n      left: -.25em;\n      box-sizing: content-box;\n      width: 100%;\n      height: 100%;\n      border: 0.25em solid rgba(165, 220, 134, 0.3);\n      border-radius: 50%; }\n    .swal2-icon.swal2-success .swal2-success-fix {\n      position: absolute;\n      z-index: 1;\n      top: .5em;\n      left: 1.625em;\n      width: .4375em;\n      height: 5.625em;\n      transform: rotate(-45deg); }\n    .swal2-icon.swal2-success [class^='swal2-success-line'] {\n      display: block;\n      position: absolute;\n      z-index: 2;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: #a5dc86; }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='tip'] {\n        top: 2.875em;\n        left: .8125em;\n        width: 1.5625em;\n        transform: rotate(45deg); }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='long'] {\n        top: 2.375em;\n        right: .5em;\n        width: 2.9375em;\n        transform: rotate(-45deg); }\n    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {\n      animation: swal2-animate-success-line-tip .75s; }\n    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {\n      animation: swal2-animate-success-line-long .75s; }\n    .swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {\n      animation: swal2-rotate-success-circular-line 4.25s ease-in; }\n\n.swal2-progress-steps {\n  flex-wrap: wrap;\n  align-items: center;\n  max-width: 100%;\n  margin: 0 0 1.25em;\n  padding: 0;\n  background: inherit;\n  font-weight: 600; }\n  .swal2-progress-steps li {\n    display: inline-block;\n    position: relative; }\n  .swal2-progress-steps .swal2-progress-step {\n    z-index: 20;\n    flex-shrink: 0;\n    width: 2em;\n    height: 2em;\n    border-radius: 2em;\n    background: #2778c4;\n    color: #fff;\n    line-height: 2em;\n    text-align: center; }\n    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n      background: #2778c4; }\n      .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {\n        background: #add8e6;\n        color: #fff; }\n      .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {\n        background: #add8e6; }\n  .swal2-progress-steps .swal2-progress-step-line {\n    z-index: 10;\n    flex-shrink: 0;\n    width: 2.5em;\n    height: .4em;\n    margin: 0 -1px;\n    background: #2778c4; }\n\n[class^='swal2'] {\n  -webkit-tap-highlight-color: transparent; }\n\n.swal2-show {\n  animation: swal2-show 0.3s; }\n\n.swal2-hide {\n  animation: swal2-hide 0.15s forwards; }\n\n.swal2-noanimation {\n  transition: none; }\n\n.swal2-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n.swal2-rtl .swal2-close {\n  right: auto;\n  left: 0; }\n\n.swal2-rtl .swal2-timer-progress-bar {\n  right: 0;\n  left: auto; }\n\n@supports (-ms-accelerator: true) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n@keyframes swal2-toast-show {\n  0% {\n    transform: translateY(-0.625em) rotateZ(2deg); }\n  33% {\n    transform: translateY(0) rotateZ(-2deg); }\n  66% {\n    transform: translateY(0.3125em) rotateZ(2deg); }\n  100% {\n    transform: translateY(0) rotateZ(0deg); } }\n\n@keyframes swal2-toast-hide {\n  100% {\n    transform: rotateZ(1deg);\n    opacity: 0; } }\n\n@keyframes swal2-toast-animate-success-line-tip {\n  0% {\n    top: .5625em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: .125em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: .625em;\n    left: -.25em;\n    width: 1.625em; }\n  84% {\n    top: 1.0625em;\n    left: .75em;\n    width: .5em; }\n  100% {\n    top: 1.125em;\n    left: .1875em;\n    width: .75em; } }\n\n@keyframes swal2-toast-animate-success-line-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0; }\n  65% {\n    top: 1.25em;\n    right: .9375em;\n    width: 0; }\n  84% {\n    top: .9375em;\n    right: 0;\n    width: 1.125em; }\n  100% {\n    top: .9375em;\n    right: .1875em;\n    width: 1.375em; } }\n\n@keyframes swal2-show {\n  0% {\n    transform: scale(0.7); }\n  45% {\n    transform: scale(1.05); }\n  80% {\n    transform: scale(0.95); }\n  100% {\n    transform: scale(1); } }\n\n@keyframes swal2-hide {\n  0% {\n    transform: scale(1);\n    opacity: 1; }\n  100% {\n    transform: scale(0.5);\n    opacity: 0; } }\n\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: .0625em;\n    width: 0; }\n  54% {\n    top: 1.0625em;\n    left: .125em;\n    width: 0; }\n  70% {\n    top: 2.1875em;\n    left: -.375em;\n    width: 3.125em; }\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em; }\n  100% {\n    top: 2.8125em;\n    left: .8125em;\n    width: 1.5625em; } }\n\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0; }\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em; }\n  100% {\n    top: 2.375em;\n    right: .5em;\n    width: 2.9375em; } }\n\n@keyframes swal2-rotate-success-circular-line {\n  0% {\n    transform: rotate(-45deg); }\n  5% {\n    transform: rotate(-45deg); }\n  12% {\n    transform: rotate(-405deg); }\n  100% {\n    transform: rotate(-405deg); } }\n\n@keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0; }\n  50% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0; }\n  80% {\n    margin-top: -.375em;\n    transform: scale(1.15); }\n  100% {\n    margin-top: 0;\n    transform: scale(1);\n    opacity: 1; } }\n\n@keyframes swal2-animate-error-icon {\n  0% {\n    transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    transform: rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes swal2-rotate-loading {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\nbody.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {\n  overflow: hidden; }\n\nbody.swal2-height-auto {\n  height: auto !important; }\n\nbody.swal2-no-backdrop .swal2-container {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  max-width: calc(100% - 0.625em * 2);\n  background-color: transparent !important; }\n  body.swal2-no-backdrop .swal2-container > .swal2-modal {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4); }\n  body.swal2-no-backdrop .swal2-container.swal2-top {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%); }\n  body.swal2-no-backdrop .swal2-container.swal2-top-start, body.swal2-no-backdrop .swal2-container.swal2-top-left {\n    top: 0;\n    left: 0; }\n  body.swal2-no-backdrop .swal2-container.swal2-top-end, body.swal2-no-backdrop .swal2-container.swal2-top-right {\n    top: 0;\n    right: 0; }\n  body.swal2-no-backdrop .swal2-container.swal2-center {\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  body.swal2-no-backdrop .swal2-container.swal2-center-start, body.swal2-no-backdrop .swal2-container.swal2-center-left {\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%); }\n  body.swal2-no-backdrop .swal2-container.swal2-center-end, body.swal2-no-backdrop .swal2-container.swal2-center-right {\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%); }\n  body.swal2-no-backdrop .swal2-container.swal2-bottom {\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%); }\n  body.swal2-no-backdrop .swal2-container.swal2-bottom-start, body.swal2-no-backdrop .swal2-container.swal2-bottom-left {\n    bottom: 0;\n    left: 0; }\n  body.swal2-no-backdrop .swal2-container.swal2-bottom-end, body.swal2-no-backdrop .swal2-container.swal2-bottom-right {\n    right: 0;\n    bottom: 0; }\n\n@media print {\n  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {\n    overflow-y: scroll !important; }\n    body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) > [aria-hidden='true'] {\n      display: none; }\n    body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {\n      position: static !important; } }\n\nbody.swal2-toast-shown .swal2-container {\n  background-color: transparent; }\n  body.swal2-toast-shown .swal2-container.swal2-top {\n    top: 0;\n    right: auto;\n    bottom: auto;\n    left: 50%;\n    transform: translateX(-50%); }\n  body.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {\n    top: 0;\n    right: 0;\n    bottom: auto;\n    left: auto; }\n  body.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {\n    top: 0;\n    right: auto;\n    bottom: auto;\n    left: 0; }\n  body.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {\n    top: 50%;\n    right: auto;\n    bottom: auto;\n    left: 0;\n    transform: translateY(-50%); }\n  body.swal2-toast-shown .swal2-container.swal2-center {\n    top: 50%;\n    right: auto;\n    bottom: auto;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n  body.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {\n    top: 50%;\n    right: 0;\n    bottom: auto;\n    left: auto;\n    transform: translateY(-50%); }\n  body.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {\n    top: auto;\n    right: auto;\n    bottom: 0;\n    left: 0; }\n  body.swal2-toast-shown .swal2-container.swal2-bottom {\n    top: auto;\n    right: auto;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%); }\n  body.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: auto; }\n\n.scroller {\n  overflow-y: auto;\n  scrollbar-color: #8f93f6 #c6c8f7;\n  scrollbar-width: thin; }\n  .scroller::-webkit-scrollbar-thumb {\n    background-color: #8f93f6; }\n  .scroller::-webkit-scrollbar-track {\n    background-color: #c6c8f7; }\n  .scroller::-moz-scrollbar-thumb {\n    background-color: #8f93f6; }\n  .scroller::-moz-scrollbar-track {\n    background-color: #c6c8f7; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  border-radius: 20px; }\n\n::-moz-scrollbar {\n  width: 8px;\n  height: 8px;\n  border-radius: 20px; }\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 20px; }\n\n::-webkit-scrollbar-thumb {\n  background: #6c757d;\n  border-radius: 20px; }\n  ::-webkit-scrollbar-thumb:hover {\n    background: #01041b;\n    border-radius: 20px; }\n\n::-moz-scrollbar-thumb {\n  background: #6c757d;\n  border-radius: 20px; }\n  ::-moz-scrollbar-thumb:hover {\n    background: #01041b;\n    border-radius: 20px; }\n\n::-webkit-scrollbar {\n  width: 4px;\n  height: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n::-moz-scrollbar {\n  width: 4px;\n  height: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.scrollbar-thumb {\n  width: 4px !important; }\n\n.scrollbar-track-y {\n  width: 4px !important; }\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: normal;\n  padding: 0;\n  margin: 0;\n  color: #535f6b;\n  background: #fafbfe; }\n\na:hover {\n  text-decoration: none; }\n\n.btn i {\n  margin-right: 5px; }\n\n.iq-mb-3 {\n  margin-bottom: 30px !important; }\n\nh1 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1;\n  color: #303030;\n  font-size: 2.488rem; }\n  h1 a {\n    color: inherit; }\n\nh2 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1.5;\n  color: #303030;\n  font-size: 2.074rem; }\n  h2 a {\n    color: inherit; }\n\nh3 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1.5;\n  color: #303030;\n  font-size: 1.728rem a;\n    font-size-color: inherit; }\n\nh4 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1;\n  color: #303030;\n  font-size: 1.44rem; }\n  h4 a {\n    color: inherit; }\n\nh5 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1.5;\n  color: #303030;\n  font-size: 1.2rem; }\n  h5 a {\n    color: inherit; }\n\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  margin: 0px;\n  line-height: 1.5;\n  color: #303030;\n  font-size: 1rem; }\n  h6 a {\n    color: inherit; }\n\nbutton:focus {\n  outline: none; }\n\n.line-height {\n  line-height: normal; }\n\n.rounded-normal, .rounded-small {\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n:focus {\n  outline: none; }\n\n.text-break {\n  word-break: break-all; }\n\n.border-none {\n  border: none !important; }\n\n.breadcrumb-item + .breadcrumb-item::before {\n  margin-top: 5px; }\n\n.user-list-files {\n  justify-content: flex-end; }\n  .user-list-files a {\n    padding: 10px 15px;\n    margin: 0 0 0 10px;\n    border-radius: 5px;\n    line-height: normal; }\n\ncode {\n  color: #ef9fc4; }\n\n.slick-loading .slick-list {\n  background: transparent !important; }\n\nul.iq-edit-profile li a {\n  padding: 1rem 1rem !important;\n  text-align: center; }\n\n.change-mode {\n  margin-right: 9px; }\n  .change-mode .custom-switch.custom-switch-icon .custom-control-input {\n    height: 100%; }\n    .change-mode .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label:after {\n      transform: translateX(1.6rem); }\n    .change-mode .custom-switch.custom-switch-icon .custom-control-input:checked ~ .custom-control-label:before {\n      background-color: #1D1D1F;\n      border-color: #1D1D1F; }\n  .change-mode .custom-switch.custom-switch-icon label.custom-control-label {\n    height: 21px; }\n    .change-mode .custom-switch.custom-switch-icon label.custom-control-label:after {\n      top: 3px;\n      left: 4px;\n      width: 17px;\n      height: 17px;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      border-radius: 8px;\n      background-color: #535f6b; }\n    .change-mode .custom-switch.custom-switch-icon label.custom-control-label:before {\n      width: 3.1rem;\n      height: 23px;\n      top: 0;\n      left: 1px;\n      background-color: #fff;\n      border-color: #535f6b;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      border-radius: 8px; }\n    .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-left {\n      top: 1px; }\n      .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-left i {\n        font-size: 12px; }\n    .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-right {\n      right: -2px;\n      top: 2px;\n      line-height: 20px; }\n      .change-mode .custom-switch.custom-switch-icon label.custom-control-label .switch-icon-right i {\n        font-size: 12px; }\n\n.custom-control-input:focus ~ .custom-control-label:before {\n  box-shadow: none !important; }\n\ng[aria-describedby=\"id-22-description\"] {\n  stroke: none; }\n\n@media (min-width: 1400px) {\n  .container {\n    max-width: 1300px; }\n  .container-lg {\n    max-width: 1300px; }\n  .container-md {\n    max-width: 1300px; }\n  .container-sm {\n    max-width: 1300px; }\n  .container-xl {\n    max-width: 1300px; } }\n\n@media (max-width: 1300px) {\n  .flatpickr-rContainer {\n    padding-right: 40px; }\n  .flatpickr-months .flatpickr-next-month {\n    padding-right: 40px; }\n  .flatpickr-months .flatpickr-prev-month {\n    padding-right: 40px; }\n  .flatpickr-current-month {\n    left: 7.5%; } }\n\n@media (max-width: 767px) {\n  .table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 1rem;\n    display: block;\n    overflow-x: auto; }\n  .tree {\n    display: inline-table; } }\n\n@media (max-width: 575px) {\n  .user-list-files {\n    justify-content: center;\n    margin-top: 15px; } }\n\n.content-page {\n  overflow: hidden;\n  padding: 110px 15px 0px;\n  min-height: 100vh;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n\n@media (min-width: 1300px) {\n  body.sidebar-main .content-page {\n    margin-left: 80px; }\n  body.sidebar-main .iq-menu-bt-sidebar {\n    display: block;\n    margin-left: auto;\n    margin-right: auto; } }\n\n@media (max-width: 1299px) {\n  .content-page {\n    margin-left: 0;\n    padding: 100px 15px 0; } }\n\n@media (max-width: 991px) {\n  .content-page {\n    padding: 90px 0 0; } }\n\nlabel {\n  color: #01041b; }\n\n.table td {\n  vertical-align: middle; }\n\n.table th {\n  vertical-align: middle; }\n\n.form-control {\n  height: 45px;\n  line-height: 45px;\n  background: #fafbfe;\n  border: 1px solid #f1f1f1;\n  font-size: 14px;\n  color: #535f6b;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  box-shadow: none; }\n  .form-control:focus {\n    color: #01041b;\n    border-color: #8f93f6;\n    box-shadow: none; }\n\n.form-control-sm {\n  height: 30px;\n  line-height: 30px; }\n\n.form-control-lg {\n  height: 50px;\n  line-height: 50px; }\n\n.spin {\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear; }\n\n.input-group .input-group-prepend .input-group-text {\n  border: 1px solid #bfc9d4;\n  background-color: #fafbfe; }\n\n.input-group .input-group-append .input-group-text {\n  border: 1px solid #bfc9d4;\n  background-color: #fafbfe; }\n\ntextarea.form-control {\n  background-color: #fafbfe; }\n\n#editor {\n  height: 375px; }\n\n.uploader-file {\n  display: block;\n  clear: both;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 600px; }\n  .uploader-file label {\n    float: left;\n    clear: both;\n    width: 100%;\n    padding: 2rem 1.5rem;\n    text-align: center;\n    background: #fff;\n    border-radius: 7px;\n    border: 3px solid #eee;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    user-select: none; }\n  .uploader-file label.hover {\n    border: 3px solid;\n    box-shadow: inset 0 0 0 6px #eee; }\n    .uploader-file label.hover #start-one i.fa {\n      -webkit-transform: scale(0.8);\n      -moz-transform: scale(0.8);\n      -ms-transform: scale(0.8);\n      -o-transform: scale(0.8);\n      transform: scale(0.8);\n      -webkit-opacity: 0.3;\n      -moz-opacity: 0.3;\n      -ms-opacity: 0.3;\n      -o-opacity: 0.3;\n      opacity: 0.3; }\n  .uploader-file #start-one {\n    float: left;\n    clear: both;\n    width: 100%; }\n    .uploader-file #start-one i.fa {\n      font-size: 50px;\n      margin-bottom: 1rem;\n      -webkit-transition: all 0.3s ease-in-out;\n      -moz-transition: all 0.3s ease-in-out;\n      -ms-transition: all 0.3s ease-in-out;\n      -o-transition: all 0.3s ease-in-out;\n      transition: all 0.3s ease-in-out; }\n  .uploader-file #start-one.hidden {\n    display: none; }\n  .uploader-file #response {\n    float: left;\n    clear: both;\n    width: 100%; }\n    .uploader-file #response #messages {\n      margin-bottom: 0.5rem; }\n  .uploader-file #response.hidden {\n    display: none; }\n  .uploader-file #file-image {\n    display: inline;\n    margin: 0 auto 0.5rem auto;\n    width: auto;\n    height: auto;\n    max-width: 180px; }\n  .uploader-file #file-image.hidden {\n    display: none; }\n  .uploader-file #notimage {\n    display: block;\n    float: left;\n    clear: both;\n    width: 100%; }\n  .uploader-file #notimage.hidden {\n    display: none; }\n  .uploader-file progress {\n    display: inline;\n    clear: both;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 180px;\n    height: 8px;\n    border: 0;\n    border-radius: 4px;\n    background-color: #eee;\n    overflow: hidden; }\n  .uploader-file .progress {\n    display: inline;\n    clear: both;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 180px;\n    height: 8px;\n    border: 0;\n    border-radius: 4px;\n    background-color: #eee;\n    overflow: hidden; }\n  .uploader-file input[type=\"file\"] {\n    display: none; }\n  .uploader-file div {\n    margin: 0 0 0.5rem 0;\n    color: #5f6982; }\n\n.spin {\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear; }\n\n.input-group .input-group-prepend .input-group-text {\n  border: 1px solid #f1f1f1;\n  background-color: #fafbfe; }\n\n.input-group .input-group-append .input-group-text {\n  border: 1px solid #f1f1f1;\n  background-color: #fafbfe; }\n\n.custom-select {\n  height: 46px;\n  border: 1px solid #f1f1f1; }\n\n.dropone.dropdown-toggle:after {\n  display: none; }\n\n.input-group-sm > .custom-select {\n  height: 30px; }\n\n.input-group-sm > .form-control:not(textarea) {\n  height: 30px; }\n\n.input-group-lg > .custom-select {\n  height: 50px; }\n\n.input-group-lg > .form-control:not(textarea) {\n  height: 50px; }\n\n.input-group-text.text-area {\n  padding: 1.9rem .75rem; }\n\n.custom-file-label::after {\n  background-color: #fafbfe;\n  color: #535f6b; }\n\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: #8f93f6;\n  box-shadow: none; }\n\n.btn-outline-primary.disabled {\n  color: #8f93f6;\n  background-color: transparent; }\n\n.btn-outline-primary:disabled {\n  color: #8f93f6;\n  background-color: transparent; }\n\ntable.dataTable thead td {\n  padding: 10px 10px !important; }\n\ntable.dataTable thead th {\n  padding: 10px 10px !important; }\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #fafbfe; }\n\n.table-bordered {\n  border: 1px solid #f1f1f1; }\n  .table-bordered td {\n    border: 1px solid #f1f1f1; }\n  .table-bordered th {\n    border: 1px solid #f1f1f1; }\n\n.dataTables_wrapper .dataTables_filter {\n  color: #535f6b; }\n\n.dataTables_wrapper .dataTables_info {\n  color: #535f6b; }\n\n.dataTables_wrapper .dataTables_length {\n  color: #535f6b; }\n\n.dataTables_wrapper .dataTables_paginate {\n  color: #535f6b; }\n\n.dataTables_wrapper .dataTables_processing {\n  color: #535f6b; }\n\n.dataTables_wrapper .dataTables_paginate span .paginate_button.current {\n  padding: 3px 10px;\n  color: #8f93f6 !important;\n  border: 1px solid #8f93f6 !important;\n  background: #c6c8f7 !important;\n  border-radius: 8px; }\n  .dataTables_wrapper .dataTables_paginate span .paginate_button.current:hover {\n    color: #8f93f6 !important;\n    border: 1px solid #8f93f6 !important;\n    background: #c6c8f7 !important; }\n\n.dataTables_wrapper .dataTables_filter input {\n  border-color: #f1f1f1;\n  background-color: transparent;\n  border-style: solid;\n  border-width: 1px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\ntable.dataTable thead td {\n  padding: 10px 18px;\n  border-bottom: 1px solid #f1f1f1 !important; }\n\ntable.dataTable thead th {\n  padding: 10px 18px;\n  border-bottom: 1px solid #f1f1f1 !important;\n  color: #303030 !important; }\n\ntable.dataTable.no-footer {\n  border-bottom: 1px solid #f1f1f1 !important; }\n\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n  box-shadow: none !important;\n  outline: none !important; }\n\n.dataTables_wrapper .dataTables_info {\n  padding-top: 15px !important; }\n\n.dataTables_wrapper .dataTables_length label {\n  border-color: #f1f1f1 !important; }\n\n.dataTables_wrapper .dataTables_length select {\n  border-color: #f1f1f1 !important; }\n\n.custom-control-label:after {\n  top: .25rem; }\n\n.custom-control-label:before {\n  top: .25rem; }\n\n.custom-switch .custom-control-label::after {\n  top: calc(.25rem + 2px); }\n\n.select2-container--default .select2-selection--multiple {\n  height: 45px;\n  line-height: 34px;\n  background: #fafbfe;\n  border: 1px solid #f1f1f1;\n  font-size: 14px;\n  color: #535f6b;\n  border-radius: 5px; }\n\n.iq-error {\n  width: 100%;\n  overflow: hidden;\n  display: inline-block; }\n  .iq-error h1.text-in-box {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    font-size: 8em;\n    font-weight: 700; }\n\n.iq-error-img {\n  position: static;\n  display: inline-block;\n  margin-bottom: 20px; }\n\n.error-500 .iq-error-img {\n  width: 100%; }\n\n.height-self-center {\n  height: 100vh;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.iq-maintenance img {\n  width: 20%; }\n\n@media (max-width: 767px) {\n  .iq-error h1.text-in-box {\n    font-size: 5em; } }\n\n@media (max-width: 479px) {\n  .iq-error h1.text-in-box {\n    font-size: 4em; }\n  .iq-error h2 {\n    font-size: 1.5em; } }\n\n.pricing .table th {\n  border-top: none;\n  border-bottom: 1px solid #dee2e6; }\n\n.pricing .table td {\n  border-top: none !important; }\n\n.pricing .table tr {\n  border-bottom: 1px solid #dee2e6; }\n  .pricing .table tr:last-child {\n    border-bottom: 0; }\n\n.prc-box {\n  background: #c6c8f7;\n  padding: 15px;\n  position: relative;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.type {\n  position: absolute;\n  background: #8f93f6;\n  padding: 9px 25px;\n  color: #fff;\n  top: -15px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  transform: translateX(-50%);\n  font-weight: 500; }\n  .type:before {\n    position: absolute;\n    content: '';\n    width: 0;\n    height: 0;\n    right: -15px;\n    top: 0px;\n    border-left: 15px solid #6c71e3;\n    border-top: 15px solid transparent; }\n  .type:after {\n    position: absolute;\n    content: '';\n    width: 0;\n    height: 0;\n    left: -15px;\n    top: 0px;\n    border-right: 15px solid #6c71e3;\n    border-top: 15px solid transparent; }\n\n.prc-box.active {\n  background: #8f93f6; }\n  .prc-box.active .h3 {\n    color: #fff; }\n  .prc-box.active .type {\n    background: #c6c8f7;\n    color: #01041b; }\n    .prc-box.active .type:before {\n      border-left: 16px solid #6c71e3;\n      right: -16px; }\n    .prc-box.active .type:after {\n      border-right: 16px solid #6c71e3;\n      left: -16px; }\n\n.prc-wrap {\n  border-bottom: none !important; }\n\n.i_close {\n  font-size: 22px; }\n\n.p-image {\n  position: absolute;\n  top: auto;\n  right: 6px;\n  bottom: 10px;\n  transition: all .3s ease;\n  background: #8f93f6;\n  color: #fff;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  height: 30px;\n  width: 30px;\n  line-height: 28px;\n  text-align: center;\n  font-size: 12px;\n  cursor: pointer; }\n\n.upload-button {\n  font-size: 1.5em; }\n\n.file-upload {\n  display: none; }\n\n.upload_profile {\n  position: relative; }\n\n.child-cell.active {\n  color: #8f93f6; }\n\n.iq-social ul li a {\n  display: block;\n  text-align: center;\n  font-size: 16px;\n  line-height: 43px; }\n\n.card .pricing-radius-box {\n  -webkit-border-radius: 60px 0 60px 0;\n  -moz-border-radius: 60px 0 60px 0;\n  -ms-border-radius: 60px 0 60px 0;\n  -o-border-radius: 60px 0 60px 0;\n  border-radius: 60px 0 60px 0; }\n\n.pricing-header {\n  padding: 20px 0;\n  background: #f5f6f9;\n  -webkit-border-radius: 10px 10px 50% 50%;\n  -moz-border-radius: 10px 10px 50% 50%;\n  -ms-border-radius: 10px 10px 50% 50%;\n  -o-border-radius: 10px 10px 50% 50%;\n  border-radius: 10px 10px 50% 50%;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  margin-bottom: 20px; }\n\n.pricing-details .icon-data {\n  font-size: 50px; }\n\n.pricing-custom-tab .tab-pane.fade.active.show {\n  display: block; }\n\n.pricing-custom-tab .tab-pane.fade {\n  display: none; }\n\n.pricing-custom-tab li.nav-item .nav-link {\n  border: 1px solid #f1f1f1;\n  color: #01041b;\n  font-size: 16px;\n  padding: 12px 35px;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  -ms-border-radius: 0;\n  -o-border-radius: 0;\n  border-radius: 0; }\n\n.pricing-custom-tab li.nav-item .nav-link.active {\n  color: #fff;\n  background: #8f93f6; }\n\n.pricing-custom-tab li.nav-item .star-circle {\n  background-color: #8f93f6;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  -moz-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  -ms-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  -o-box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.5);\n  color: #fff;\n  display: block;\n  font-size: 13px;\n  height: 25px;\n  padding: 0;\n  line-height: 23px;\n  text-align: center;\n  width: 20px;\n  position: absolute;\n  top: -14px;\n  left: -14px;\n  z-index: 1; }\n\n.nav-pills li {\n  position: relative; }\n\nul.pricing-list li {\n  line-height: 45px; }\n\n.login-content {\n  position: relative;\n  height: 100vh;\n  z-index: 99; }\n  .login-content .floating-label label {\n    color: #535f6b;\n    font-size: 14px;\n    font-weight: 400;\n    position: absolute;\n    pointer-events: none;\n    left: 12px;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    -o-transform: translateY(-50%);\n    transform: translateY(-50%);\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n  .login-content .form-control {\n    border-color: #f1f1f1; }\n    .login-content .form-control:focus {\n      border-width: 2px;\n      border-color: #8f93f6; }\n  .login-content .custom-control-label::before {\n    background-color: #fafbfe; }\n  .login-content .sign-user_card {\n    padding: 30px;\n    border: 1px solid #f1f1f1;\n    text-align: center;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px; }\n    .login-content .sign-user_card .logo {\n      max-height: 50px;\n      margin: 0 auto 20px; }\n    .login-content .sign-user_card .custom-control-label {\n      color: #535f6b; }\n\n.floating-label {\n  position: relative;\n  margin-bottom: 20px; }\n\n.floating-input:focus ~ label {\n  color: #8f93f6;\n  top: 0;\n  left: 6px;\n  font-size: 10px;\n  background: #fafbfe;\n  padding: 5px 8px; }\n\n.floating-input:not(:placeholder-shown) {\n  color: #535f6b;\n  border: 1px solid #FAFAFA; }\n  .floating-input:not(:placeholder-shown) ~ label {\n    top: 0;\n    font-size: 10px;\n    left: 6px;\n    background: #fafbfe;\n    padding: 5px 8px; }\n\n@media (min-width: 992px) {\n  .lb-img {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 213px; }\n  .rb-img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 194px; }\n  .cnf-mail {\n    width: 80%; } }\n\n@media (max-width: 991px) {\n  .lb-img {\n    display: none; }\n  .rb-img {\n    display: none; } }\n\n.profile-icon.iq-icon-box {\n  height: 58px;\n  width: 58px;\n  line-height: 58px;\n  text-align: center;\n  margin-right: 10px;\n  font-size: 26px;\n  text-decoration: none; }\n\n.profile-overly {\n  position: absolute;\n  left: auto;\n  bottom: 0;\n  right: 0;\n  background: #fff;\n  padding: 10px 30px;\n  text-align: center;\n  border-radius: 10px 10px 0 0; }\n\nul.iq-contact-rest li a p {\n  word-break: break-all; }\n\n.crm-profile-img-edit .file-upload {\n  display: none; }\n\n.crm-p-image {\n  position: absolute;\n  top: auto;\n  left: 69px;\n  bottom: -9px;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  height: 35px;\n  width: 35px;\n  text-align: center;\n  font-size: 12px;\n  cursor: pointer;\n  border: 5px solid #fff; }\n  .crm-p-image .upload-button {\n    font-size: 13px;\n    line-height: 26px; }\n\n@media (max-width: 479px) {\n  .profile-overly h3 {\n    font-size: 14px; } }\n\n#loading {\n  background-color: #fafbfe;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  margin-top: 0px;\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  overflow: hidden !important;\n  right: 0px;\n  z-index: 999999; }\n\n#loading-center {\n  background-size: 20%;\n  width: 100%;\n  height: 100%;\n  position: relative; }\n\n.loader {\n  width: 3em;\n  height: 3em;\n  margin: auto;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute; }\n\n/*------------------*/\n@keyframes loader1 {\n  0%, 100% {\n    box-shadow: 0em -2.6em 0em 0em #4788ff, 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.5), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7); }\n  12.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.7), 1.8em -1.8em 0 0em #4788ff, 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5); }\n  25% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.5), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7), 2.5em 0em 0 0em #4788ff, 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  37.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5), 2.5em 0em 0 0em rgba(71, 136, 255, 0.7), 1.75em 1.75em 0 0em #4788ff, 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  50% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.5), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.7), 0em 2.5em 0 0em #4788ff, -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  62.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.5), 0em 2.5em 0 0em rgba(71, 136, 255, 0.7), -1.8em 1.8em 0 0em #4788ff, -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  75% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.5), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.7), -2.6em 0em 0 0em #4788ff, -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  87.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.5), -2.6em 0em 0 0em rgba(71, 136, 255, 0.7), -1.8em -1.8em 0 0em #4788ff; } }\n\n@-webkit-keyframes loader1 {\n  0%, 100% {\n    box-shadow: 0em -2.6em 0em 0em #4788ff, 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.5), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7); }\n  12.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.7), 1.8em -1.8em 0 0em #4788ff, 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5); }\n  25% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.5), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.7), 2.5em 0em 0 0em #4788ff, 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  37.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.5), 2.5em 0em 0 0em rgba(71, 136, 255, 0.7), 1.75em 1.75em 0 0em #4788ff, 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  50% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.5), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.7), 0em 2.5em 0 0em #4788ff, -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.2), -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  62.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.5), 0em 2.5em 0 0em rgba(71, 136, 255, 0.7), -1.8em 1.8em 0 0em #4788ff, -2.6em 0em 0 0em rgba(71, 136, 255, 0.2), -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  75% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.5), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.7), -2.6em 0em 0 0em #4788ff, -1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2); }\n  87.5% {\n    box-shadow: 0em -2.6em 0em 0em rgba(71, 136, 255, 0.2), 1.8em -1.8em 0 0em rgba(71, 136, 255, 0.2), 2.5em 0em 0 0em rgba(71, 136, 255, 0.2), 1.75em 1.75em 0 0em rgba(71, 136, 255, 0.2), 0em 2.5em 0 0em rgba(71, 136, 255, 0.2), -1.8em 1.8em 0 0em rgba(71, 136, 255, 0.5), -2.6em 0em 0 0em rgba(71, 136, 255, 0.7), -1.8em -1.8em 0 0em #4788ff; } }\n\n@-webkit-keyframes loader2 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader2 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loader-3-outter {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader-3-outter {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loader-3-inner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    -moz-transform: rotate(-360deg);\n    -ms-transform: rotate(-360deg);\n    -o-transform: rotate(-360deg);\n    transform: rotate(-360deg); } }\n\n@keyframes loader-3-inner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    -moz-transform: rotate(-360deg);\n    -ms-transform: rotate(-360deg);\n    -o-transform: rotate(-360deg);\n    transform: rotate(-360deg); } }\n\n@-webkit-keyframes loader4 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader4 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader5 {\n  0%, 100% {\n    -webkit-transform: translateX(0px);\n    -moz-transform: translateX(0px);\n    -ms-transform: translateX(0px);\n    -o-transform: translateX(0px);\n    transform: translateX(0px); }\n  75% {\n    -webkit-transform: translateX(30px);\n    -moz-transform: translateX(30px);\n    -ms-transform: translateX(30px);\n    -o-transform: translateX(30px);\n    transform: translateX(30px); } }\n\n@keyframes loader5_1 {\n  0%, 100% {\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  75% {\n    -webkit-transform: translateY(30px);\n    -moz-transform: translateY(30px);\n    -ms-transform: translateY(30px);\n    -o-transform: translateY(30px);\n    transform: translateY(30px); } }\n\n@keyframes loader5_2 {\n  0%, 100% {\n    -webkit-transform: translate(0px, 0px);\n    -moz-transform: translate(0px, 0px);\n    -ms-transform: translate(0px, 0px);\n    -o-transform: translate(0px, 0px);\n    transform: translate(0px, 0px); }\n  75% {\n    -webkit-transform: translate(30px, 30px);\n    -moz-transform: translate(30px, 30px);\n    -ms-transform: translate(30px, 30px);\n    -o-transform: translate(30px, 30px);\n    transform: translate(30px, 30px); } }\n\n@keyframes inner1 {\n  0% {\n    -webkit-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n    -moz-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n    -ms-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n    -o-transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg); }\n  100% {\n    -webkit-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n    -moz-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n    -ms-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n    -o-transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg); } }\n\n@keyframes inner2 {\n  0% {\n    -webkit-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n    -moz-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n    -ms-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n    -o-transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg); }\n  100% {\n    -webkit-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n    -moz-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n    -ms-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n    -o-transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg); } }\n\n@keyframes inner3 {\n  0% {\n    -webkit-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n    -moz-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n    -ms-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n    -o-transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg); }\n  100% {\n    -webkit-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n    -moz-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n    -ms-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n    -o-transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg); } }\n\n@keyframes loader7 {\n  0% {\n    -webkit-transform: rotate(0);\n    -moz-transform: rotate(0);\n    -ms-transform: rotate(0);\n    -o-transform: rotate(0);\n    transform: rotate(0); }\n  50% {\n    -webkit-transform: rotateY(180deg);\n    -moz-transform: rotateY(180deg);\n    -ms-transform: rotateY(180deg);\n    -o-transform: rotateY(180deg);\n    transform: rotateY(180deg); }\n  100% {\n    -webkit-transform: rotateY(180deg) rotateX(180deg);\n    -moz-transform: rotateY(180deg) rotateX(180deg);\n    -ms-transform: rotateY(180deg) rotateX(180deg);\n    -o-transform: rotateY(180deg) rotateX(180deg);\n    transform: rotateY(180deg) rotateX(180deg); } }\n\n@-webkit-keyframes loader8 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader8 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loader9 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader9 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader10 {\n  0%, 100% {\n    -webkit-transform: translate(0, 0) rotate(0);\n    -moz-transform: translate(0, 0) rotate(0);\n    -ms-transform: translate(0, 0) rotate(0);\n    -o-transform: translate(0, 0) rotate(0);\n    transform: translate(0, 0) rotate(0); }\n  25% {\n    -webkit-transform: translate(40px, 40px) rotate(45deg);\n    -moz-transform: translate(40px, 40px) rotate(45deg);\n    -ms-transform: translate(40px, 40px) rotate(45deg);\n    -o-transform: translate(40px, 40px) rotate(45deg);\n    transform: translate(40px, 40px) rotate(45deg); }\n  50% {\n    -webkit-transform: translate(0px, 80px) rotate(0deg);\n    -moz-transform: translate(0px, 80px) rotate(0deg);\n    -ms-transform: translate(0px, 80px) rotate(0deg);\n    -o-transform: translate(0px, 80px) rotate(0deg);\n    transform: translate(0px, 80px) rotate(0deg); }\n  75% {\n    -webkit-transform: translate(-40px, 40px) rotate(45deg);\n    -moz-transform: translate(-40px, 40px) rotate(45deg);\n    -ms-transform: translate(-40px, 40px) rotate(45deg);\n    -o-transform: translate(-40px, 40px) rotate(45deg);\n    transform: translate(-40px, 40px) rotate(45deg); } }\n\n@keyframes loader11 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader12 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%; }\n  50% {\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    transform: rotate(90deg);\n    border-radius: 0%; }\n  100% {\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n    transform: rotate(180deg);\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%; } }\n\n@-webkit-keyframes loader13 {\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader13 {\n  to {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loader14 {\n  0% {\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n    transform: scale(0);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; }\n  50% {\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; } }\n\n@keyframes loader14 {\n  0% {\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n    transform: scale(0);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; }\n  50% {\n    -webkit-opacity: 1;\n    -moz-opacity: 1;\n    -ms-opacity: 1;\n    -o-opacity: 1;\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n    -webkit-opacity: 0;\n    -moz-opacity: 0;\n    -ms-opacity: 0;\n    -o-opacity: 0;\n    opacity: 0; } }\n\n@-webkit-keyframes loader15-inner {\n  0% {\n    -webkit-transform: scale(0);\n    -moz-transform: scale(0);\n    -ms-transform: scale(0);\n    -o-transform: scale(0);\n    transform: scale(0); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    -moz-transform: rotate(-360deg);\n    -ms-transform: rotate(-360deg);\n    -o-transform: rotate(-360deg);\n    transform: rotate(-360deg); } }\n\n@keyframes loader15-inner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    -moz-transform: rotate(-360deg);\n    -ms-transform: rotate(-360deg);\n    -o-transform: rotate(-360deg);\n    transform: rotate(-360deg); } }\n\n@-webkit-keyframes loader15 {\n  0% {\n    border-width: 0px; }\n  100% {\n    border-width: 10px; } }\n\n@keyframes loader15 {\n  0% {\n    border-width: 0px; }\n  100% {\n    border-width: 10px; } }\n\n@-webkit-keyframes loader16 {\n  0% {\n    -webkit-transform: rotate(-360deg);\n    -moz-transform: rotate(-360deg);\n    -ms-transform: rotate(-360deg);\n    -o-transform: rotate(-360deg);\n    transform: rotate(-360deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes loader16 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n.iq-loader-box {\n  height: 150px;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  vertical-align: middle;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center; }\n  .iq-loader-box [class*=\"loader-\"] {\n    display: inline-block;\n    width: 60px;\n    height: 60px;\n    color: inherit;\n    vertical-align: middle;\n    position: relative;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%; }\n  .iq-loader-box .iq-loader-1 {\n    width: 1em;\n    height: 1em;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    position: relative;\n    text-indent: -9999em;\n    -webkit-animation: loader1 1.1s infinite ease;\n    animation: loader1 1.1s infinite ease;\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0); }\n  .iq-loader-box .iq-loader-2 {\n    border: 7px double #37e6b0;\n    -webkit-animation: loader2 1s linear infinite;\n    animation: loader2 1s linear infinite; }\n    .iq-loader-box .iq-loader-2:before {\n      content: \"\";\n      position: absolute;\n      width: 12px;\n      height: 12px;\n      background: #37e6b0;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      bottom: 0;\n      right: 37px; }\n    .iq-loader-box .iq-loader-2:after {\n      content: \"\";\n      position: absolute;\n      width: 12px;\n      height: 12px;\n      background: #37e6b0;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      bottom: 0;\n      right: 37px;\n      left: 37px;\n      top: 0; }\n  .iq-loader-box .iq-loader-3 {\n    position: relative;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    display: inline-block;\n    vertical-align: middle; }\n    .iq-loader-box .iq-loader-3 .loader-outter {\n      position: absolute;\n      border: 4px solid #f50057;\n      border-left-color: transparent;\n      border-bottom: 0;\n      width: 100%;\n      height: 100%;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      -webkit-animation: loader-3-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;\n      animation: loader-3-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite; }\n    .iq-loader-box .iq-loader-3 .loader-inner {\n      position: absolute;\n      border: 4px solid #f50057;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      left: calc(50% - 20px);\n      top: calc(50% - 20px);\n      border-right: 0;\n      border-top-color: transparent;\n      -webkit-animation: loader-3-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;\n      animation: loader-3-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite; }\n  .iq-loader-box .iq-loader-4 {\n    border: .2em solid transparent;\n    border-top-color: #fe721c;\n    border-bottom-color: #fe721c;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    position: relative;\n    -webkit-animation: 1s loader4 linear infinite;\n    animation: 1s loader4 linear infinite; }\n    .iq-loader-box .iq-loader-4:before {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      border: .2em solid transparent;\n      border-bottom-color: #fe721c;\n      -webkit-transform: rotate(135deg);\n      transform: rotate(135deg);\n      right: -.3em;\n      top: -.05em; }\n    .iq-loader-box .iq-loader-4:after {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      border: .2em solid transparent;\n      border-bottom-color: #fe721c;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      left: -.3em;\n      bottom: -.05em; }\n  .iq-loader-box .iq-loader-5 {\n    width: 100px;\n    height: 100px;\n    border-radius: 100%;\n    position: relative;\n    margin: 0 auto; }\n    .iq-loader-box .iq-loader-5 span {\n      display: block;\n      position: absolute;\n      left: calc(50% - 20px);\n      top: calc(50% - 20px);\n      width: 20px;\n      height: 20px;\n      background-color: var(--info); }\n      .iq-loader-box .iq-loader-5 span:nth-child(1) {\n        animation: loader5 1s ease-in-out infinite; }\n      .iq-loader-box .iq-loader-5 span:nth-child(2) {\n        animation: loader5_1 1s ease-in-out infinite; }\n      .iq-loader-box .iq-loader-5 span:nth-child(3) {\n        animation: loader5_2 1s ease-in-out infinite; }\n  .iq-loader-box .iq-loader-6 .inner {\n    position: absolute;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%; }\n  .iq-loader-box .iq-loader-6 .inner1 {\n    left: 0%;\n    top: 0%;\n    animation: inner1 1s linear infinite;\n    border-bottom: 3px solid #ff4b4b; }\n  .iq-loader-box .iq-loader-6 .inner2 {\n    right: 0%;\n    top: 0%;\n    animation: inner2 1s linear infinite;\n    border-right: 3px solid #ff4b4b; }\n  .iq-loader-box .iq-loader-6 .inner3 {\n    right: 0%;\n    bottom: 0%;\n    animation: inner3 1s linear infinite;\n    border-top: 3px solid #ff4b4b; }\n  .iq-loader-box .iq-loader-7:before {\n    content: \"\";\n    position: absolute;\n    left: 0px;\n    width: 50px;\n    height: 50px;\n    background-color: #3498db;\n    animation: loader7 1s infinite; }\n  .iq-loader-box .iq-loader-8 {\n    border: 1.2em solid transparent;\n    border-left-color: #d0bac2;\n    border-right-color: #d0bac2;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    -webkit-animation: 1s loader8 linear infinite;\n    animation: 1s loader8 linear infinite; }\n  .iq-loader-box .iq-loader-9 {\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    width: 7em;\n    height: 7em;\n    margin: 60px auto;\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 1.1em solid rgba(255, 107, 208, 0.2);\n    border-right: 1.1em solid rgba(255, 107, 208, 0.2);\n    border-bottom: 1.1em solid rgba(255, 107, 208, 0.2);\n    border-left: 1.1em solid #ff6bd0;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: loader9 1.1s infinite linear;\n    animation: loader9 1.1s infinite linear; }\n    .iq-loader-box .iq-loader-9:after {\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: 7em;\n      height: 7em; }\n  .iq-loader-box .iq-loader-10:before {\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: -10px;\n    left: calc(50% - 10px);\n    background-color: #3450db;\n    animation: loader10 1s ease-in-out infinite; }\n  .iq-loader-box .iq-loader-10:after {\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: -10px;\n    left: calc(50% - 10px);\n    background-color: #3450db;\n    animation: loader10 1s ease-in-out infinite;\n    bottom: 0;\n    animation-delay: 0.5s; }\n  .iq-loader-box .iq-loader-11 {\n    background: #000000; }\n    .iq-loader-box .iq-loader-11:before {\n      content: '';\n      position: absolute;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: 25px;\n      height: 25px;\n      margin: 0 0 0 -12px;\n      background-color: white;\n      top: auto;\n      bottom: 0;\n      left: 50%;\n      transform-origin: 50% 0%;\n      animation: loader11 1s infinite linear; }\n  .iq-loader-box .iq-loader-12 {\n    animation: loader12 1s infinite linear;\n    background: #6dca5c; }\n  .iq-loader-box .iq-loader-13 {\n    border-top: 0.2em solid #a7a4ca;\n    border-right: .2em solid transparent;\n    -webkit-animation: loader13 1s linear infinite;\n    animation: loader13 1s linear infinite;\n    border-radius: 100%;\n    position: relative; }\n  .iq-loader-box .iq-loader-14 {\n    border: 0 solid transparent;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%;\n    position: relative; }\n    .iq-loader-box .iq-loader-14:before {\n      content: '';\n      border: 1em solid #13d7eb;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: inherit;\n      height: inherit;\n      position: absolute;\n      top: 0;\n      left: 0;\n      -webkit-animation: loader14 1s linear infinite;\n      animation: loader14 1s linear infinite;\n      -webkit-opacity: 0;\n      -moz-opacity: 0;\n      -ms-opacity: 0;\n      -o-opacity: 0;\n      opacity: 0;\n      -webkit-animation-delay: 1s;\n      animation-delay: 1s; }\n    .iq-loader-box .iq-loader-14:after {\n      content: '';\n      border: 1em solid #13d7eb;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: inherit;\n      height: inherit;\n      position: absolute;\n      top: 0;\n      left: 0;\n      -webkit-animation: loader14 1s linear infinite;\n      animation: loader14 1s linear infinite;\n      -webkit-opacity: 0;\n      -moz-opacity: 0;\n      -ms-opacity: 0;\n      -o-opacity: 0;\n      opacity: 0;\n      -webkit-animation-delay: .5s;\n      animation-delay: .5s; }\n  .iq-loader-box .iq-loader-15 {\n    border: 6px groove #7e57c2;\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n    -webkit-transition: all 1s ease;\n    transition: all 1s ease;\n    -webkit-animation: loader15-inner 1s ease-out alternate infinite;\n    animation: loader15-inner 1s ease-out alternate infinite; }\n    .iq-loader-box .iq-loader-15 .loader-inner {\n      border: 0px inset #9575cd;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      border-radius: 50%;\n      width: 100%;\n      height: 100%;\n      -webkit-animation: loader15 1s ease-out alternate infinite;\n      animation: loader15 1s ease-out alternate infinite; }\n  .iq-loader-box .iq-loader-16 {\n    width: 70px;\n    height: 70px;\n    border: 5px dashed #b3a57c;\n    -webkit-animation: loader16 2s linear both infinite;\n    animation: loader16 2s linear both infinite; }\n\n.iq-avatars .iq-avatar {\n  margin-right: 10px;\n  margin-bottom: 10px;\n  position: relative;\n  display: inline-block; }\n\n.icon-small {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center; }\n\n.drive-select {\n  font: inherit;\n  border: 0; }\n  .drive-select option {\n    font-size: inherit;\n    padding: 10px 0;\n    border-bottom: 1px solid #f1f1f1;\n    line-height: normal;\n    color: inherit;\n    display: inline-block;\n    width: 100%; }\n\n.icon-statistic {\n  height: 45px;\n  width: 45px;\n  line-height: 45px;\n  text-align: center; }\n\n.dashboard1-info {\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  font-size: 23px;\n  text-align: center;\n  padding-bottom: 0 !important;\n  background: #fff;\n  position: relative;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n  -moz-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n  -ms-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n  -o-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n  box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05); }\n  .dashboard1-info a {\n    color: #01041b; }\n  .dashboard1-info .iq-dropdown {\n    opacity: 0;\n    position: absolute;\n    top: 50px !important;\n    right: 0;\n    width: 50px;\n    padding: 15px 4px !important;\n    z-index: 99;\n    background: #fff;\n    color: #01041b;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    -webkit-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n    -moz-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n    -ms-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n    -o-box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05);\n    box-shadow: 0 0px 40px 0 rgba(0, 0, 0, 0.05); }\n    .dashboard1-info .iq-dropdown.show {\n      opacity: 1;\n      top: 30px; }\n\n.search-query.dropdown-toggle:after {\n  border: 0; }\n\n.select-dropdown .btn-group .search-query.dropdown-toggle {\n  font-size: 24px;\n  font-weight: 500; }\n\n.new-create {\n  padding-top: 25px;\n  border-top: 1px solid #f1f1f1;\n  margin: 0 20px; }\n  .new-create.select-dropdown {\n    font-size: 15px;\n    width: 220px; }\n    .new-create.select-dropdown .btn-group .dropdown-menu {\n      width: 220px; }\n    .new-create.select-dropdown .selet-caption {\n      width: 220px;\n      display: inline-block;\n      padding: 10px 20px;\n      text-align: center;\n      font-weight: normal !important;\n      font-size: inherit;\n      color: #01041b;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      border-radius: 8px;\n      background: #f3f3f3; }\n\n.select-dropdown {\n  position: relative; }\n  .select-dropdown .btn-group .dropdown-toggle {\n    box-shadow: none !important;\n    font-size: 1.2em; }\n  .select-dropdown .btn-group .dropdown-menu {\n    position: absolute;\n    background: #fff;\n    width: 220px;\n    border: 0;\n    z-index: 9;\n    padding: 0;\n    height: auto;\n    text-align: left !important;\n    -webkit-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n    -ms-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n    -o-box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.1); }\n  .select-dropdown .btn-group li:last-child .item {\n    border: 0; }\n  .select-dropdown .btn-group li .item {\n    padding: 10px 20px;\n    border-bottom: 1px solid #f1f1f1;\n    color: #535f6b; }\n    .select-dropdown .btn-group li .item:hover {\n      background-color: #f3f3f3; }\n    .select-dropdown .btn-group li .item i {\n      vertical-align: middle; }\n  .select-dropdown .btn-group .search-replace .item {\n    display: none; }\n\n.tbl-server-info .dropdown-toggle:after {\n  display: none; }\n\n.files-table .table-responsive {\n  overflow-x: unset; }\n\n.files-table .tbl-server-info tr {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n  .files-table .tbl-server-info tr:hover {\n    -webkit-box-shadow: 0 0 13px 10px #fafafa;\n    -moz-box-shadow: 0 0 13px 10px #fafafa;\n    -ms-box-shadow: 0 0 13px 10px #fafafa;\n    -o-box-shadow: 0 0 13px 10px #fafafa;\n    box-shadow: 0 0 13px 10px #fafafa;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px; }\n\n.files-table .tbl-server-info tr.active {\n  -webkit-box-shadow: 0 0 13px 10px #fafafa;\n  -moz-box-shadow: 0 0 13px 10px #fafafa;\n  -ms-box-shadow: 0 0 13px 10px #fafafa;\n  -o-box-shadow: 0 0 13px 10px #fafafa;\n  box-shadow: 0 0 13px 10px #fafafa;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  border-radius: 8px; }\n\n.folder p {\n  color: #535f6b; }\n\n.dropdown-menu .dropdown-item {\n  color: #535f6b; }\n  .dropdown-menu .dropdown-item:active {\n    color: #fff; }\n  .dropdown-menu .dropdown-item i {\n    vertical-align: middle; }\n\n.tbl-server-info th {\n  font-weight: 500; }\n\n#layout-1-chart {\n  min-height: 280px !important; }\n\n#layout-1-chart2 {\n  min-height: 225px !important; }\n\n.go-white {\n  margin-top: 70px; }\n  .go-white .btn {\n    background: #fff; }\n    .go-white .btn:hover {\n      background: #6c71e3;\n      color: #fff; }\n\n.breadcrumb-item + .breadcrumb-item:before {\n  content: \"\\f104\";\n  font-family: 'Line Awesome Free';\n  font-size: 14px;\n  vertical-align: sub;\n  color: #535f6b;\n  font-weight: 900; }\n\n.welcome-content h4 {\n  font-size: 24px; }\n\n.plan-bg {\n  background: #8f93f6; }\n  .plan-bg p {\n    color: #fff; }\n\n@media (max-width: 1366px) {\n  .icon-statistic {\n    height: 30px;\n    width: 30px;\n    line-height: 30px;\n    text-align: center; } }\n\n@media (max-width: 1300px) {\n  .card-block.iq-welcome {\n    background-size: 50% !important; } }\n\n@media (max-width: 1299px) {\n  .skill-details p {\n    font-size: 14px; } }\n\n@media (max-width: 576px) {\n  .card-block.iq-welcome {\n    background: none !important; } }\n\n.image-thumb .iq-thumb {\n  position: relative;\n  overflow: hidden;\n  z-index: 9; }\n  .image-thumb .iq-thumb img {\n    max-height: 100px; }\n  .image-thumb .iq-thumb .iq-image-overlay {\n    background: #fafafa;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    opacity: 1;\n    z-index: -1;\n    -webkit-transition: all 0.4s ease-in-out;\n    -moz-transition: all 0.4s ease-in-out;\n    -ms-transition: all 0.4s ease-in-out;\n    -o-transition: all 0.4s ease-in-out;\n    transition: all 0.4s ease-in-out; }\n  .image-thumb .iq-thumb .overlay-img-icon {\n    position: absolute;\n    top: 42%;\n    left: 42%;\n    opacity: 0;\n    height: 35px;\n    width: 35px;\n    background: #fff;\n    -webkit-transition: all 0.4s ease-in-out;\n    -moz-transition: all 0.4s ease-in-out;\n    -ms-transition: all 0.4s ease-in-out;\n    -o-transition: all 0.4s ease-in-out;\n    transition: all 0.4s ease-in-out;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    border-radius: 50%; }\n    .image-thumb .iq-thumb .overlay-img-icon i {\n      font-size: 24px;\n      line-height: 37px;\n      color: #000; }\n\n.image-thumb:hover .iq-thumb .overlay-img-icon {\n  opacity: 1; }\n\n.list-grid-toggle .icon.i-grid {\n  display: none; }\n\n.list-grid-toggle .icon.icon-grid.i-grid {\n  display: block;\n  height: 20px;\n  width: 20px;\n  font-size: 20px;\n  color: #01041b; }\n\n.list-grid-toggle .icon.icon-grid.i-list {\n  display: none; }\n\n.list-grid-toggle .icon.i-list {\n  display: block;\n  height: 20px;\n  width: 20px;\n  font-size: 20px;\n  color: #01041b; }\n\n.list-grid-toggle .label.label-list {\n  display: none; }\n\n.icon.i-grid {\n  display: none; }\n\n.icon.icon-grid.i-grid {\n  display: block; }\n\n.icon.icon-grid.i-list {\n  display: none; }\n\n.icon.i-list {\n  display: block; }\n\n.dark {\n  background: #1D1D1F;\n  color: #A6A6A6;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out; }\n  .dark .bg-primary-light {\n    background-color: rgba(71, 136, 255, 0.1) !important; }\n  .dark a.bg-primary-light:hover, .dark a.bg-primary-light:focus,\n  .dark button.bg-primary-light:hover,\n  .dark button.bg-primary-light:focus {\n    background-color: rgba(20, 103, 255, 0.1) !important; }\n  .dark .bg-secondary-light {\n    background-color: rgba(108, 117, 125, 0.1) !important; }\n  .dark a.bg-secondary-light:hover, .dark a.bg-secondary-light:focus,\n  .dark button.bg-secondary-light:hover,\n  .dark button.bg-secondary-light:focus {\n    background-color: rgba(84, 91, 98, 0.1) !important; }\n  .dark .bg-success-light {\n    background-color: rgba(55, 230, 178, 0.1) !important; }\n  .dark a.bg-success-light:hover, .dark a.bg-success-light:focus,\n  .dark button.bg-success-light:hover,\n  .dark button.bg-success-light:focus {\n    background-color: rgba(26, 208, 154, 0.1) !important; }\n  .dark .bg-info-light {\n    background-color: rgba(135, 108, 254, 0.1) !important; }\n  .dark a.bg-info-light:hover, .dark a.bg-info-light:focus,\n  .dark button.bg-info-light:hover,\n  .dark button.bg-info-light:focus {\n    background-color: rgba(94, 57, 254, 0.1) !important; }\n  .dark .bg-warning-light {\n    background-color: rgba(254, 114, 28, 0.1) !important; }\n  .dark a.bg-warning-light:hover, .dark a.bg-warning-light:focus,\n  .dark button.bg-warning-light:hover,\n  .dark button.bg-warning-light:focus {\n    background-color: rgba(230, 88, 1, 0.1) !important; }\n  .dark .bg-danger-light {\n    background-color: rgba(255, 75, 75, 0.1) !important; }\n  .dark a.bg-danger-light:hover, .dark a.bg-danger-light:focus,\n  .dark button.bg-danger-light:hover,\n  .dark button.bg-danger-light:focus {\n    background-color: rgba(255, 24, 24, 0.1) !important; }\n  .dark .bg-light-light {\n    background-color: rgba(199, 203, 211, 0.1) !important; }\n  .dark a.bg-light-light:hover, .dark a.bg-light-light:focus,\n  .dark button.bg-light-light:hover,\n  .dark button.bg-light-light:focus {\n    background-color: rgba(170, 176, 189, 0.1) !important; }\n  .dark .bg-dark-light {\n    background-color: rgba(1, 4, 27, 0.1) !important; }\n  .dark a.bg-dark-light:hover, .dark a.bg-dark-light:focus,\n  .dark button.bg-dark-light:hover,\n  .dark button.bg-dark-light:focus {\n    background-color: rgba(0, 0, 0, 0.1) !important; }\n  .dark .bg-orange-light {\n    background-color: rgba(253, 126, 20, 0.1) !important; }\n  .dark a.bg-orange-light:hover, .dark a.bg-orange-light:focus,\n  .dark button.bg-orange-light:hover,\n  .dark button.bg-orange-light:focus {\n    background-color: rgba(220, 101, 2, 0.1) !important; }\n  .dark .bg-purple-light {\n    background-color: rgba(71, 49, 182, 0.1) !important; }\n  .dark a.bg-purple-light:hover, .dark a.bg-purple-light:focus,\n  .dark button.bg-purple-light:hover,\n  .dark button.bg-purple-light:focus {\n    background-color: rgba(55, 38, 142, 0.1) !important; }\n  \n  .dark h1, .dark h2, .dark h3, .dark h4, .dark h5, .dark h6 {\n    color: #ffffff; }\n  .dark hr {\n    border-color: #27272A; }\n  .dark span, .dark p, .dark label {\n    color: #A6A6A6; }\n  .dark .btn {\n    color: #A6A6A6; }\n    .dark .btn span {\n      color: inherit; }\n  .dark .prc-box .h3 {\n    color: #ffffff; }\n  .dark #loading {\n    background-color: #1D1D1F; }\n  .dark ::-webkit-scrollbar-track {\n    background: #27272A; }\n  .dark .btn-primary, .dark .btn-success, .dark .btn-danger, .dark .btn-warning, .dark .btn-info {\n    color: #fff; }\n  .dark span.btn-outline-primary, .dark span.btn-outline-success, .dark span.btn-outline-danger, .dark span.btn-outline-warning, .dark span.btn-outline-info {\n    color: #fff; }\n  .dark .border.border-primary, .dark .border.border-success, .dark .border.border-danger, .dark .border.border-warning, .dark .border.border-info {\n    border-color: inherit !important; }\n  .dark .btn-outline-primary.view-more {\n    color: #8f93f6; }\n    .dark .btn-outline-primary.view-more:hover {\n      background: transparent; }\n  .dark .bg-primary-light span {\n    color: inherit; }\n  .dark .bg-warning-light span {\n    color: inherit; }\n  .dark .bg-danger-light span {\n    color: inherit; }\n  .dark .bg-success-light span {\n    color: inherit; }\n  .dark .bg-info-light span {\n    color: inherit; }\n  .dark span.apexcharts-legend-text {\n    color: #A6A6A6 !important; }\n  .dark .apexcharts-yaxis text {\n    fill: #A6A6A6; }\n  .dark .fc-toolbar .fc-button span {\n    color: #8f93f6; }\n  .dark .fc-toolbar .fc-button:focus span {\n    color: #fff; }\n  .dark .fc-unthemed td.fc-today {\n    background: #1D1D1F; }\n  .dark .fc-unthemed .fc-toolbar .fc-button {\n    background: rgba(71, 136, 255, 0.1); }\n    .dark .fc-unthemed .fc-toolbar .fc-button:hover {\n      color: #fff;\n      background: #8f93f6; }\n      .dark .fc-unthemed .fc-toolbar .fc-button:hover span {\n        color: #fff; }\n  .dark .fc-unthemed th, .dark .fc-unthemed td, .dark .fc-unthemed thead, .dark .fc-unthemed tbody, .dark .fc-unthemed .fc-divider, .dark .fc-unthemed .fc-row, .dark .fc-unthemed .fc-content, .dark .fc-unthemed .fc-popover, .dark .fc-unthemed .fc-list-view {\n    border-color: #27272A; }\n  .dark .fc-unthemed .fc-list-heading td {\n    border-color: #27272A; }\n  .dark span.flatpickr-day:hover {\n    color: #8f93f6 !important; }\n  .dark .calendar-s td[data-date=\"2020-11-13\"] {\n    background: rgba(255, 75, 75, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-11-02\"] {\n    background: rgba(254, 114, 28, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-11-12\"] {\n    background: rgba(55, 230, 178, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-12-07\"] {\n    background: rgba(135, 108, 254, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-12-10\"] {\n    background: rgba(71, 136, 255, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-11-16\"] {\n    background: rgba(1, 4, 27, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-11-28\"] {\n    background: rgba(71, 49, 182, 0.1); }\n  .dark .calendar-s td[data-date=\"2020-12-16\"] {\n    background: rgba(55, 230, 178, 0.1); }\n  .dark .calendar-s .fc-unthemed td.fc-today {\n    background: rgba(71, 136, 255, 0.1) !important;\n    color: #fff; }\n  .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {\n    cursor: default;\n    color: #A6A6A6 !important; }\n    .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {\n      cursor: default;\n      color: #A6A6A6 !important; }\n    .dark .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover {\n      cursor: default;\n      color: #A6A6A6 !important; }\n  .dark .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n    background-color: #2b343b !important; }\n  .dark .iq-sidebar {\n    background: #121212; }\n  .dark .iq-sidebar-menu .iq-menu li a {\n    color: #A6A6A6; }\n    .dark .iq-sidebar-menu .iq-menu li a span {\n      color: #A6A6A6; }\n  .dark .iq-sidebar-menu .iq-menu li:hover > a {\n    color: #8f93f6; }\n    .dark .iq-sidebar-menu .iq-menu li:hover > a span {\n      color: #8f93f6; }\n  .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active > a {\n    color: #8f93f6; }\n    .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active > a span {\n      color: #8f93f6; }\n  .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active .iq-submenu li.active > a {\n    color: #8f93f6; }\n    .dark .sidebar-default .iq-sidebar-menu .iq-menu > li.active .iq-submenu li.active > a span {\n      color: #8f93f6; }\n  .dark .iq-top-navbar {\n    background: #121212; }\n    .dark .iq-top-navbar .iq-sub-dropdown {\n      background: #121212; }\n  .dark .navbar-list li .iq-sub-dropdown .iq-sub-card {\n    color: #A6A6A6; }\n  .dark .navbar-list li > a {\n    color: #A6A6A6; }\n  .dark .iq-search-bar .search-input {\n    border-color: #27272A;\n    background: #1D1D1F;\n    color: #A6A6A6; }\n  .dark .cust-title {\n    border-color: #27272A; }\n  .dark .iq-footer {\n    background: #121212; }\n    .dark .iq-footer ul li a {\n      color: #A6A6A6; }\n      .dark .iq-footer ul li a:hover {\n        color: #8f93f6; }\n  .dark .card {\n    background-color: #121212;\n    -webkit-transition: all 0.3s ease-in-out;\n    -moz-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    -o-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out; }\n    .dark .card .card-header {\n      border-color: #27272A; }\n  .dark .card-transparent {\n    background: transparent; }\n  .dark .text-dark- {\n    color: #fff !important; }\n  .dark .text-body {\n    color: #A6A6A6 !important; }\n  .dark .text-muted {\n    color: #A6A6A6 !important; }\n  .dark .breadcrumb-item.active {\n    color: #A6A6A6; }\n  .dark .table {\n    color: #A6A6A6; }\n  .dark .tab-content .table tbody tr {\n    color: #A6A6A6; }\n  .dark .table-data .table tbody tr {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_paginate span .paginate_button.current {\n    background: rgba(71, 136, 255, 0.1) !important; }\n  .dark table.dataTable thead td {\n    border-color: #27272A !important; }\n  .dark table.dataTable thead th {\n    border-color: #27272A !important; }\n  .dark table.dataTable.no-footer {\n    border-color: #27272A !important; }\n  .dark .iq-top-navbar .navbar-toggler {\n    background: #1D1D1F; }\n  .dark .iq-alert-text p, .dark .iq-alert-text h1, .dark .iq-alert-text h2, .dark .iq-alert-text h3, .dark .iq-alert-text h4, .dark .iq-alert-text h5, .dark .iq-alert-text h6 {\n    color: inherit; }\n  .dark .border {\n    border-color: #27272A !important; }\n  .dark .border-bottom {\n    border-color: #27272A !important; }\n  .dark .breadcrumb {\n    background: #1D1D1F; }\n  .dark .list-group-item {\n    background: #121212; }\n  .dark .blockquote-footer {\n    color: #A6A6A6; }\n  .dark pre {\n    color: #A6A6A6; }\n  .dark .modal-content {\n    background: #121212; }\n  .dark .page-link {\n    background-color: #121212; }\n  .dark .page-item.disabled .page-link {\n    background-color: #121212;\n    border-color: #8f93f6; }\n  .dark .popover {\n    background-color: #121212; }\n    .dark .popover .popover-header {\n      background-color: #121212;\n      color: #A6A6A6;\n      border-color: #27272A; }\n    .dark .popover .popover-body {\n      color: #A6A6A6; }\n  .dark .dropdown-menu {\n    background-color: #1D1D1F; }\n    .dark .dropdown-menu .dropdown-item {\n      color: #A6A6A6; }\n      .dark .dropdown-menu .dropdown-item:hover {\n        background-color: #8f93f6;\n        color: #fff; }\n      .dark .dropdown-menu .dropdown-item:focus {\n        background-color: #8f93f6; }\n    .dark .dropdown-menu .dropdown-divider {\n      border-top-color: #27272A; }\n  .dark .nav-tabs .nav-item a {\n    color: #A6A6A6; }\n  .dark .nav-tabs .nav-item.show .nav-link {\n    color: #8f93f6; }\n  .dark .nav-tabs .nav-link.active {\n    color: #8f93f6; }\n  .dark .nav-pills .nav-item a {\n    color: #A6A6A6; }\n  .dark .nav-pills .nav-link.active {\n    color: #8f93f6; }\n  .dark .nav-pills .show > .nav-link {\n    color: #8f93f6; }\n  .dark .table-bordered {\n    border-color: #27272A; }\n    .dark .table-bordered td {\n      border-color: #27272A; }\n    .dark .table-bordered th {\n      border-color: #27272A; }\n  .dark .table-striped tbody tr:nth-of-type(odd) {\n    background-color: #1D1D1F; }\n  .dark .iq-example-row .row > .col {\n    color: #A6A6A6; }\n  .dark .iq-example-row .row > [class^=col-] {\n    color: #A6A6A6; }\n  .dark table.dataTable tbody tr {\n    background-color: #121212; }\n  .dark table.dataTable thead th {\n    color: #ffffff !important; }\n  .dark .table-hover tbody tr:hover {\n    color: #fff; }\n  .dark .dataTables_wrapper .dataTables_filter {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_info {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_length {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_paginate {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_processing {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_filter input {\n    color: #A6A6A6; }\n  .dark .dataTables_wrapper .dataTables_paginate .paginate_button {\n    color: #A6A6A6 !important; }\n  .dark .form-control {\n    color: #A6A6A6;\n    background: #1D1D1F;\n    border-color: #27272A; }\n  .dark .custom-file-label {\n    background: #121212;\n    border-color: #27272A; }\n  .dark .input-group .input-group-append .input-group-text {\n    border-color: #27272A;\n    background-color: #1D1D1F; }\n  .dark .input-group .input-group-prepend .input-group-text {\n    border-color: #27272A;\n    background-color: #1D1D1F; }\n  .dark .custom-select {\n    color: #A6A6A6;\n    border-color: #27272A;\n    background-color: #1D1D1F; }\n  .dark .custom-file-label:after {\n    background-color: #1D1D1F;\n    color: #A6A6A6; }\n  .dark ::placeholder {\n    color: #A6A6A6; }\n  .dark .form-control::placeholder {\n    color: #A6A6A6; }\n  .dark .select2-container--default .select2-selection--multiple {\n    background-color: #1D1D1F;\n    border-color: #27272A; }\n  .dark .select2-container--default .select2-selection--multiple .select2-selection__choice {\n    background-color: #121212;\n    border-color: #27272A; }\n  .dark .select2-container--default .select2-results__option[aria-selected=true] {\n    background-color: #1D1D1F; }\n  .dark .select2-results__options {\n    background-color: #121212; }\n  .dark .uploader-file label {\n    background-color: #1D1D1F;\n    border-color: #27272A; }\n  .dark .ql-snow .ql-stroke {\n    stroke: #fff; }\n  .dark form.form-border .form-control {\n    border-color: #27272A; }\n  .dark .ic-square {\n    border-color: #27272A; }\n  .dark .swal2-popup {\n    background: #121212; }\n    .dark .swal2-popup .swal2-content {\n      color: #A6A6A6; }\n  .dark .flatpickr-calendar.inline {\n    background: transparent; }\n  .dark .flatpickr-calendar {\n    background: #121212; }\n  .dark .flatpickr-months .flatpickr-month {\n    background: transparent;\n    color: #fff;\n    fill: #fff; }\n  .dark .flatpickr-months .flatpickr-next-month svg {\n    color: #fff;\n    fill: #fff; }\n  .dark .flatpickr-months .flatpickr-prev-month svg {\n    color: #fff;\n    fill: #fff; }\n  .dark span.flatpickr-weekday {\n    color: #fff; }\n  .dark .stepwizard-row .wizard-step a.btn {\n    background: #1D1D1F; }\n  .dark #top-tabbar-vertical li a {\n    background: #1D1D1F;\n    color: #A6A6A6; }\n  .dark .g-box {\n    background: #1D1D1F; }\n  .dark .g-desc {\n    border-color: #27272A; }\n  .dark .blog-left .blog-description {\n    background: #121212; }\n  .dark .blog-detail .blog-meta {\n    background: #1D1D1F;\n    color: #A6A6A6; }\n  .dark .profile-box {\n    background: #1D1D1F; }\n  .dark .pro-content {\n    background: #121212; }\n  .dark .social-ic {\n    background: #1D1D1F; }\n    .dark .social-ic a i {\n      color: #A6A6A6; }\n  .dark .timeline-page .iq-timeline0 li .timeline-dots1 {\n    background: #121212; }\n  .dark .timeline-page .iq-timeline0 li .timeline-dots {\n    background: #121212 !important; }\n  .dark .timeline-page .iq-timeline1 li .timeline-dots {\n    background: #121212; }\n  .dark .prc-box.active .type {\n    background: #8f93f6;\n    color: #fff; }\n  .dark .pricing-header {\n    background-color: #1D1D1F; }\n  .dark .print .table thead {\n    background: #1D1D1F; }\n  .dark .or-detail {\n    background: #1D1D1F;\n    border-color: #27272A; }\n    .dark .or-detail .ttl-amt {\n      border-color: #27272A; }\n  .dark .subscriber-detail .iq-card-btn {\n    border-color: #121212; }\n  .dark .iq-accordion.career-style .iq-accordion-block .accordion-title span {\n    color: #A6A6A6; }\n  .dark .iq-accordion.career-style .iq-accordion-block .accordion-title:before {\n    color: #A6A6A6; }\n  .dark .iq-progress-bar.progress-bar-vertical > span:after {\n    background: #121212; }\n  .dark .chat-data {\n    background: #121212; }\n  .dark span.iq-start-icon {\n    background: #1D1D1F; }\n  .dark .chat-button {\n    background: #1D1D1F;\n    color: #A6A6A6; }\n  .dark .chat-head .bg-white {\n    background: #121212 !important;\n    color: #A6A6A6 !important; }\n  .dark .chat-footer.bg-white {\n    background: #121212 !important;\n    color: #A6A6A6 !important; }\n  .dark .chat-content .chat-left .chat-message {\n    background: #1D1D1F; }\n  .dark .iq-chat-ui .nav-pills li a.active {\n    background-color: #1D1D1F; }\n  .dark ul.todo-task-lists li.active-task {\n    background: #1D1D1F; }\n  .dark ul.todo-task-lists li:hover {\n    background: #1D1D1F; }\n  .dark .iq-todo-page ul li a {\n    color: #A6A6A6; }\n  .dark .add-new-project > a {\n    color: #A6A6A6; }\n  .dark .chat-sidebar-channel h5 {\n    border-color: #27272A; }\n  .dark .iq-chat-ui li a {\n    border-color: #27272A; }\n  .dark .iq-email-listbox .iq-email-sender-list > li {\n    border-color: #27272A; }\n    .dark .iq-email-listbox .iq-email-sender-list > li:hover {\n      background: #1D1D1F; }\n  .dark .iq-email-listbox .iq-email-sender-list .iq-social-media {\n    background: #1D1D1F; }\n  .dark .email-app-details {\n    background-color: #121212; }\n  .dark .profile-overly {\n    background: #1D1D1F; }\n  .dark .light-title .card-title {\n    color: #8f93f6; }\n  .dark .view-crm a {\n    color: #fff; }\n  .dark .crm2 .feature-list {\n    background-color: #1D1D1F; }\n  .dark .crm2 .title-text {\n    color: #fff; }\n  .dark .crm2 .card-score {\n    background: #1D1D1F; }\n  .dark .crm2 .crm-p-image {\n    border-color: #121212; }\n  .dark .crm3 .calender-box li {\n    background: #1D1D1F; }\n  .dark .iq-social-icon a {\n    color: #A6A6A6; }\n  .dark .iq-acivity span {\n    background: #121212; }\n  .dark .iq-acivity:after {\n    border-top-color: #27272A; }\n  .dark .search-menu-options .form-control {\n    background: #121212; }\n  .dark .search-menu-options .iq-search-bar .search-input {\n    background: #121212; }\n  .dark .floating-input:focus ~ label {\n    background: #1D1D1F; }\n  .dark .floating-input:not(:placeholder-shown) ~ label {\n    background: #1D1D1F;\n    color: #A6A6A6; }\n  .dark svg tspan {\n    fill: #A6A6A6; }\n  .dark .highcharts-background {\n    fill: #121212; }\n  .dark .jvectormap-container {\n    background: #121212 !important; }\n  .dark .card.iq-welcome {\n    background-color: #121212 !important; }\n  .dark .image-thumb .iq-thumb .iq-image-overlay {\n    background: rgba(255, 255, 255, 0.1); }\n  .dark .select-dropdown .btn-group .dropdown-menu {\n    background: #1D1D1F; }\n  .dark .select-dropdown .btn-group li .item {\n    border-color: #27272A; }\n    .dark .select-dropdown .btn-group li .item:hover {\n      background-color: #1D1D1F; }\n  .dark .select-dropdown .selet-caption {\n    color: #FAFAFA; }\n  .dark .select-dropdown > .selet-caption .arrow-down {\n    color: #FAFAFA; }\n  .dark .select-dropdown.list-item {\n    background: #1D1D1F; }\n    .dark .select-dropdown.list-item .item {\n      border-color: #27272A; }\n      .dark .select-dropdown.list-item .item:hover {\n        background-color: #121212; }\n  .dark .iq-search-bar .btn-group .dropdown-menu {\n    background-color: #121212; }\n  .dark .iq-search-bar .btn-group li .item {\n    border-color: #27272A; }\n  .dark .iq-search-bar .btn-group li:hover .item {\n    background: #1D1D1F; }\n  .dark .list-grid-toggle .icon.icon-grid.i-grid {\n    color: #FAFAFA; }\n  .dark .list-grid-toggle .icon.i-list {\n    color: #FAFAFA; }\n  .dark .new-create {\n    border-color: #27272A; }\n    .dark .new-create .selet-caption {\n      background-color: #1D1D1F; }\n  .dark .sidebar-bottom {\n    border-color: #27272A; }\n  .dark .dashboard1-info {\n    background: #121212; }\n    .dark .dashboard1-info .iq-dropdown {\n      background: #1D1D1F; }\n    .dark .dashboard1-info a {\n      color: #FAFAFA; }\n  .dark .iq-search-bar .searchbox .select-dropdown .selet-caption {\n    color: #FAFAFA; }\n  .dark .darkmode-logo {\n    display: block !important; }\n  .dark .profile-details {\n    border-color: #27272A !important; }\n  .dark .files-table .tbl-server-info tr.active {\n    -webkit-box-shadow: 0 0 13px 10px #202023;\n    -moz-box-shadow: 0 0 13px 10px #202023;\n    -ms-box-shadow: 0 0 13px 10px #202023;\n    -o-box-shadow: 0 0 13px 10px #202023;\n    box-shadow: 0 0 13px 10px #202023;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px; }\n  .dark .files-table .tbl-server-info tr:hover {\n    -webkit-box-shadow: 0 0 13px 10px #202023;\n    -moz-box-shadow: 0 0 13px 10px #202023;\n    -ms-box-shadow: 0 0 13px 10px #202023;\n    -o-box-shadow: 0 0 13px 10px #202023;\n    box-shadow: 0 0 13px 10px #202023;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border-radius: 8px; }\n  .dark .plan-bg {\n    background: #121212; }\n  .dark .dropdown-bg.btn.bg-white {\n    background: #121212 !important;\n    color: #ffffff !important; }\n  .dark .go-white .btn {\n    background: #1D1D1F; }\n    .dark .go-white .btn:hover {\n      background: #6c71e3;\n      color: #ffffff; }\n  .dark .icon-statistic.bg-light {\n    color: #ffffff !important;\n    background: #1D1D1F !important; }\n  .dark .profile-icon.bg-light {\n    color: #ffffff !important;\n    background: #1D1D1F !important; }\n  .dark .badge-light.iq-number {\n    color: #ffffff !important;\n    background: #1D1D1F !important; }\n  .dark .crm-p-image {\n    border: 5px solid #27272A; }\n\n@media (min-width: 1300px) {\n  .dark .white-bg-menu {\n    background: #121212; }\n  .dark .header-style-4 .bg-pay-horizontal {\n    background: transparent; }\n  .dark .header-style-1 .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li > a {\n    color: #fff; }\n    .dark .header-style-1 .iq-menu-horizontal .iq-sidebar-menu .iq-menu > li > a > span {\n      color: #fff; }\n  .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li > a {\n    color: #fff; }\n    .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li > a > span {\n      color: #fff; }\n  .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li:hover > a {\n    color: #7fdd85; }\n    .dark.salon-2-saidbar-main .iq-menu-horizontal .iq-sidebar-menu .iq-menu li li:hover > a > span {\n      color: #7fdd85; }\n  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li > a {\n    color: #fff; }\n    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li > a > span {\n      color: #fff; }\n  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li:hover > a {\n    color: #fff; }\n    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu > li:hover > a > span {\n      color: #fff; }\n  .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu li.active > a {\n    color: #fff; }\n    .dark.tab-horizontal .top-menu .iq-sidebar-menu .iq-menu li.active > a > span {\n      color: #fff; }\n  .login-content .sign-user_card {\n    border-color: #27272A; } }\n\n@media (max-width: 1299px) {\n  .dark .iq-menu-horizontal {\n    background: #121212; }\n    .dark .iq-menu-horizontal ul.iq-menu {\n      background: #121212; } }\n\n@media (max-width: 991px) {\n  .dark .navbar-collapse {\n    background: #121212; } }\n\n  .login-content .pf-sign-user_card {\n      padding: 30px;\n      border: none !important;\n      text-align: center;\n      border-radius: 8px;\n  }\n\n  .pf-shadow {\n    -ms-box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);\n    -o-box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);\n    box-shadow: 0 16px 40px 0 rgba(0, 0, 0, .0392157);\n}\n\n.header-logo{\n  padding: 0px!important\n}\n\n.profile-logout{\n  border-radius: 28px!important;\n}\n.profile-logout-tooltip .tooltip-inner, .profile-logout-tooltip .tooltip-arrow, .accordion-button:not(.collapsed){\n  background-color: #fff;\n  box-shadow: none;\n}\n#accordionUploadedBills .collapse, #accordionGSTR .collapse {\n  visibility: visible;\n}\n\n.custom-switch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 150px; /* Adjust width for the larger switch */\n}\n\n.custom-switch .form-check-input {\n  width: 60px; /* Adjust width for the larger switch slider */\n  height: 34px; /* Adjust height for the larger switch slider */\n  margin-right: 10px;\n}\n\n.custom-switch .form-check-label {\n  position: absolute;\n  width: 100%;\n  text-align: center;\n}\n\n.custom-switch .form-check-input:checked + .form-check-label::before {\n  content: \"Approve\";\n  color: #28a745; /* Green color for 'Approve' */\n}\n\n.custom-switch .form-check-input:not(:checked) + .form-check-label::before {\n  content: \"Reject\";\n  color: #dc3545; /* Red color for 'Reject' */\n}\n\n/*override*/\n.collapse{\n  visibility: visible;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
